(function ()
{
    'use strict';

    angular
        .module('app.scrumboard',
            [
                // 3rd Party Dependencies
                'moment-picker',
                'ui.calendar',
                'ui.sortable',
                'ui.mask',
                'ui.utils.masks',
                'md.data.table',
                'xeditable',
                'datatables'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, config)
    {
        $stateProvider
            .state('app.scrumboard', {
                abstract : true,
                url      : '',
                resolve  : {
                    role  : function ()
                    {
                        var roles = JSON.parse(localStorage.getItem('roles'));
                        if( roles )
                        {
                            var role = roles.filter(function ( obj ) {
                                return obj.url === '/boards/:id';
                            })[0];
                            
                            return role;
                        }
                    }
                },
                bodyClass: 'scrumboard'
            })

            // Home
            .state('app.scrumboard.boards', {
                url  : '/boards',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/scrumboard/views/boards/boards-view.html',
                        controller : 'BoardsViewController as vm'
                    }
                }
            })

            // Board
            .state('app.scrumboard.boards.board', {
                    url    : '/:id',
                    params: { isNew: false, newLeadId: null },
                    views  : {
                        'content@app'                                  : {
                            templateUrl: 'app/main/apps/scrumboard/scrumboard.html',
                            controller : 'ScrumboardController as vm'
                        },
                        'scrumboardContent@app.scrumboard.boards.board': {
                            templateUrl: 'app/main/apps/scrumboard/views/board/board-view.html',
                            controller : 'BoardViewController as vm'
                        }
                    },
                    resolve: {
                        BoardData: function ($stateParams, BoardService, User, role)
                        {
                            var boards = ( !role.permissions.write )
                                         ? User.data.board_group
                                         : User.data.company.board;
                                         
                            return BoardService.getBoardData($stateParams.id, boards, User.data.groups);
                        },
                        role  : function ()
                        {
                            var roles = JSON.parse(localStorage.getItem('roles'));
                            if( roles )
                            {
                                var role = roles.filter(function ( obj ) {
                                    return obj.url === '/boards/:id';
                                })[0];

                                return role;
                            }
                        }
                    },
                    role: {
                        url: '/boards'
                    },
                    bodyClass: 'invoice printable'
                }
            )

            // Add board
            .state('app.scrumboard.boards.addBoard', {
                    url    : '/:template',
                    views  : {
                        'content@app'                                     : {
                            templateUrl: 'app/main/apps/scrumboard/scrumboard.html',
                            controller : 'ScrumboardController as vm'
                        },
                        'scrumboardContent@app.scrumboard.boards.addBoard': {
                            templateUrl: 'app/main/apps/scrumboard/views/board/board-view.html',
                            controller : 'BoardViewController as vm'
                        }
                    },
                    resolve: {
                        BoardData: function ($stateParams, BoardService, User, role)
                        {
                            var param = {};
                            if ( !role.permissions.write ) // no authorize of managing
                            {
                                param['type'] = 'user_id';
                                param['id']   = User.data.id;
                            }
                            else
                            {
                                param['type'] = 'company_id';
                                param['id']   = User.data.company.id;
                            }

                            return BoardService.addNewBoard($stateParams.template, param);
                        }
                    },
                    role: {
                        url: '/boards'
                    }
                }
            )

            // Calendar
            .state('app.scrumboard.boards.board.calendar', {
                    url  : '/calendar',
                    views: {
                        'scrumboardContent@app.scrumboard.boards.board': {
                            templateUrl: 'app/main/apps/scrumboard/views/calendar/calendar-view.html',
                            controller : 'CalendarViewController as vm'
                        }
                    },
                    role: {
                        url: '/boards'
                    }
            })

// <!--NICOLE -->
            //Assignment Rules
            .state('app.scrumboard.boards.board.rules', {
                url  : '/rules',
                views  : {
                        'content@app'                                  : {
                            templateUrl: 'app/main/apps/scrumboard/scrumboard.html',
                            controller : 'ScrumboardController as vm'
                        },
                        'scrumboardContent@app.scrumboard.boards.board.rules': {
                            templateUrl: 'app/main/apps/scrumboard/views/assignment-rule/assignment-rule.html',
                            controller : 'AssignmentRuleController as vm'
                        }
                }
            })
            .state('app.scrumboard.boards.board.rules.rule', {
                url  : '/:ruleId',
                views: {
                    'content@app':{
                        templateUrl: 'app/main/apps/scrumboard/scrumboard.html',
                        controller : 'ScrumboardController as vm'
                    },
                    'scrumboardContent@app.scrumboard.boards.board.rules.rule': {
                        templateUrl: 'app/main/apps/scrumboard/views/assignment-rule/rule-entries/rule-entries.html',
                        controller : 'RuleEntriesController as vm'
                    }
                },
                resolve: {
                    RuleData: function($stateParams, RuleService) {
                        return RuleService.getRuleData($stateParams.ruleId);
                    }
                }
            })
            .state('app.scrumboard.boards.board.rules.createUpdate', {
                    url    : '/add',
                    params: {
                        boardId: null,
                        userId: null,
                        boardStatusId: null
                    },
                    views  : {
                        'content@app'                                     : {
                            templateUrl: 'app/main/apps/scrumboard/scrumboard.html',
                            controller : 'ScrumboardController as vm'
                        },
                        'scrumboardContent@app.scrumboard.boards.board.rules': {
                            templateUrl: 'app/main/apps/scrumboard/views/assignment-rule/assignment-rule.html',
                            controller : 'AssignmentRuleController as vm'
                        }
                    },
                    resolve: {
                        rule: function($stateParams,RuleService){
                            return RuleService.createUpdate($stateParams.boardId , $stateParams.userId, $stateParams.boardStatusId);
                        }
                    }
                }
            )
            .state('app.scrumboard.boards.board.rules.rule.add-entry', {
                    url    : '/entry/:entryId',
                    params: {
                        ruleId: null
                    },
                    views  : {
                        'content@app'                                     : {
                            templateUrl: 'app/main/apps/scrumboard/scrumboard.html',
                            controller : 'ScrumboardController as vm'
                        },
                        'scrumboardContent@app.scrumboard.boards.board.rules.rule.add-entry': {
                            templateUrl: 'app/main/apps/scrumboard/views/assignment-rule/add-entry/add-entry.html',
                            controller : 'AddEntryController as vm'
                        }
                    }
                }
            )
// NICOLE </-->
            ;

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/scrumboard');

        // Api
        msApiProvider.register('scrumboard.board', [config.apiUrl + 'board/:id.json']);
        msApiProvider.register('scrumboard.board.rule', [config.apiUrl + 'rule/:id']);
        msApiProvider.register('project.project', [config.apiUrl + 'project/:id.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('apps.sales', {
            title : 'Sales',
//            icon  : 'icon-chart-line',
            group : true,
            weight: 5
        });
        msNavigationServiceProvider.saveItem('apps.sales.leads', {
            title : 'Leads',
            icon  : 'icon-filter',
            state : 'app.scrumboard.boards',
            weight: 6,
            hidden: function ()
            {
                var roles = JSON.parse(localStorage.getItem('roles'));
                if( roles )
                {
                    var role = roles.filter(function ( obj ) {
                        return obj.url === '/boards';
                    })[0];

                    return !role.permissions.write;
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('ScrumboardCalendarEventDialogController', ScrumboardCalendarEventDialogController);

    /** @ngInject */
    function ScrumboardCalendarEventDialogController($mdDialog, dueDate, BoardService, msUtils)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.dueDate = dueDate;
        vm.newLead = {
            name  : '',
            stageId: ''
        };
        vm.selectedLeads = [];

        // Methods
        vm.exists = msUtils.exists;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.closeDialog = closeDialog;
        vm.addNewLead = addNewLead;
        vm.assignDueDate = assignDueDate;

        //////////

        /**
         * Close Dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

        /**
         * Add New Lead
         */
        function addNewLead()
        {
            var newLeadId = msUtils.guidGenerator();

            vm.board.leads.push({
                'id'               : newLeadId,
                'name'             : vm.newLead.name,
                'description'      : '',
                'idAttachmentCover': '',
                'idMembers'        : [],
                'idLabels'         : [],
                'attachments'      : [],
                'subscribed'       : false,
                'activity_type'         : [],
                'activity_items'       : 0,
                'activity_itemsChecked': 0,
                'comments'         : [],
                'activities'       : [],
                'due'              : vm.dueDate
            });

            vm.board.stages.getById(vm.newLead.stageId).idLeads.push(newLeadId);

            // Reset the newLead object
            vm.newLead = {
                name: '',
                stageId: ''
            };

            closeDialog();
        }

        /**
         * Assign Due Date
         */
        function assignDueDate()
        {
            angular.forEach(vm.selectedLeads, function (leadId)
            {
                vm.board.leads.getById(leadId).due = vm.dueDate;
            });

            vm.selectedLeads = [];

            closeDialog();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('StagesMenuController', StagesMenuController);

    /** @ngInject */
    function StagesMenuController($document, $mdColorPalette, $mdDialog, $http, config, fuseGenerator, msUtils, BoardService, $mdToast)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.stages = vm.board.stages;
        
        // Methods
        vm.addNewStage = addNewStage;
        vm.deleteDataConfirm = deleteDataConfirm;

        ////////

        /**
         * Add New Stage
         */
        function addNewStage(type)
        {
            if ( vm.newStageName === '' )
            {
                return;
            }

            var newStage = {
                'id'        : 0,
                'value'     : vm.newStageName
            };
            
            vm.stages.push(newStage);
            vm.saveUser(newStage);
            
            vm.newStageName = '';
        }
        
        /**
         * saveUser
         */
        vm.saveUser = function(newStage)
        {
            $http({
                url: config.apiUrl + 'board/update',
                method: 'POST',
                data: {board: vm.board}
            }).then(function (response) {
                // this callback will be called asynchronously
                // when the response is available
                if( newStage )
                {
                    var newLeadId = response.data.changes.stages.id;
                    var lastId = (vm.stages.length - 1);
                    vm.stages[lastId].id = newLeadId;
                }
                
//                console.log(response, " response is available!");
                $mdToast.show({
                    template:
                        '<md-toast>' +
                            '<div class="md-toast-content">' +
                                '<strong class="md-accent-fg">Success!</strong>&nbsp;&nbsp;'+
                                'Board has been saved.' +
                            '</div>' +
                        '</md-toast>',
                    hideDelay: 3000,
                    position: 'top right'
                });
                
            }, function (response) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
                console.log(response, " error occurs!");
            });
        };

        /**
         * Delete Contact Confirm Dialog
         */
        function deleteDataConfirm(ev, data, type)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the stage?')
                .htmlContent('<b>' + data.value + '</b>' + ' will be deleted.')
                .ariaLabel('delete stage')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {
                vm.onDelete({model: type, checked: [data.id]});
                vm['stages'].splice(vm['stages'].indexOf(data), 1);
                
            }, function ()
            {

            });
        }
        
        /**
         * onDelete
         */
        vm.onDelete = function(data)
        {
            $http({
                url: config.apiUrl + 'model/delete',
                method: 'DELETE',
                headers: {'Content-Type': 'application/json'},
                data: data
            }).then(function (response) {
                // this callback will be called asynchronously
                // when the response is available
//                console.log(response, " response is available!");
            }, function (response) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
                console.log(response, " error occurs!");
            });
        };

        vm.sortableOptions = {
            handle        : '.handle',
            draggable     : '.data-item',
            forceFallback : true,
            ghostClass    : 'data-item-placeholder',
            fallbackClass : 'data-item-ghost',
            fallbackOnBody: true,
            sort          : true,
            dropBubble: true,
            dragoverBubble: true,
            dataIdAttr : 'data-id',
            // Changed sorting within stage
            onSort: function (evt) {
                var setting = evt.models;
                var type = evt.originalEvent.from.id;
                
                vm[type] = setting;
                
                vm.saveUser();
            }
        };

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('MembersMenuController', MembersMenuController);

    /** @ngInject */
    function MembersMenuController($document, $mdDialog, BoardService)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.newMemberSearchInput = '';

        // Methods
        vm.addNewMember = addNewMember;
        vm.removeMember = removeMember;

        ////////

        /**
         * Add New Member
         */
        function addNewMember()
        {
            // Add new member
        }

        /**
         * Remove member
         *
         * @param ev
         * @param memberId
         */
        function removeMember(ev, memberId)
        {
            var confirm = $mdDialog.confirm({
                title              : 'Remove Member',
                parent             : $document.find('#scrumboard'),
                textContent        : 'Are you sure want to remove member?',
                ariaLabel          : 'remove member',
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                ok                 : 'Remove',
                cancel             : 'Cancel'
            });

            $mdDialog.show(confirm).then(function ()
            {
                var arr = vm.board.members;
                arr.splice(arr.indexOf(arr.getById(memberId)), 1);

                angular.forEach(vm.board.leads, function (lead)
                {
                    if ( lead.idMembers && lead.idMembers.indexOf(memberId) > -1 )
                    {
                        lead.idMembers.splice(lead.idMembers.indexOf(memberId), 1);
                    }
                });
            }, function ()
            {
                // Canceled
            });
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('LabelsMenuController', LabelsMenuController);

    /** @ngInject */
    function LabelsMenuController($document, $mdColorPalette, $mdDialog, fuseGenerator, msUtils, BoardService)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.palettes = $mdColorPalette;
        vm.rgba = fuseGenerator.rgba;
        vm.hue = 500;
        vm.newLabelColor = 'red';
        vm.newLabelName = '';

        // Methods
        vm.addNewLabel = addNewLabel;
        vm.removeLabel = removeLabel;

        ////////

        /**
         * Add New Label
         */
        function addNewLabel()
        {
            vm.board.labels.push({
                id   : msUtils.guidGenerator(),
                name : vm.newLabelName,
                color: vm.newLabelColor
            });
            vm.newLabelName = '';
        }

        /**
         * Remove label
         *
         * @param ev
         * @param labelId
         */
        function removeLabel(ev, labelId)
        {
            var confirm = $mdDialog.confirm({
                title              : 'Remove Label',
                parent             : $document.find('#scrumboard'),
                textContent        : 'Are you sure want to remove label?',
                ariaLabel          : 'remove label',
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                ok                 : 'Remove',
                cancel             : 'Cancel'
            });

            $mdDialog.show(confirm).then(function ()
            {
                var arr = vm.board.labels;
                arr.splice(arr.indexOf(arr.getById(labelId)), 1);

                angular.forEach(vm.board.leads, function (lead)
                {
                    if ( lead.idLabels && lead.idLabels.indexOf(labelId) > -1 )
                    {
                        lead.idLabels.splice(lead.idLabels.indexOf(labelId), 1);
                    }
                });
            }, function ()
            {
                // Canceled
            });
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('GroupsMenuController', GroupsMenuController);

    /** @ngInject */
    function GroupsMenuController($document, $scope, $filter, $http, config, $mdDialog, BoardService)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.newGroupSearchInput = '';
        vm.groups = vm.board.group_permission;
        vm.groups.push({
            'id': -1,
            'name'  : 'Everyone'
        });
        vm.permissions = {
            'modify': 'Modify',
            'view'  : 'View',
            'none'  : 'No access'
        };
        
        // Methods
        vm.addNewGroup = addNewGroup;
        vm.removeGroup = removeGroup;

        ////////

        /**
         * Add New Group
         */
        function addNewGroup(group_id, permission, elem)
        {
            // Add new group
            vm.pivotBoardGroup('attach', group_id, permission, elem);
        }
        
        /**
         * detach attach
         */
        vm.pivotBoardGroup = function(type, group_id, permission, elem)
        {   
            $http({
                url: config.apiUrl + 'board_group/pivot',
                method: 'POST',
                data: {type: type, board_id: vm.board.id, group_id: group_id, permission: permission}
            }).then(function (response) {
                
                if(type == 'attach' && elem == 'add' && group_id != -1)
                {
                    vm.board.groups.push( vm.groups.getById(group_id) );
                }
                
            }, function (response) {
                console.log(response, " error occurs!");
            });
        };

        /**
         * Remove group
         *
         * @param ev
         * @param groupId
         */
        function removeGroup(ev, groupId)
        {
            var confirm = $mdDialog.confirm({
                title              : 'Remove Group',
                parent             : $document.find('#scrumboard'),
                textContent        : 'Are you sure want to remove group?',
                ariaLabel          : 'remove group',
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                ok                 : 'Remove',
                cancel             : 'Cancel'
            });

            $mdDialog.show(confirm).then(function ()
            {
                var arr = vm.board.groups;
                arr.splice(arr.indexOf(arr.getById(groupId)), 1);
                vm.pivotBoardGroup('detach', groupId);

                angular.forEach(vm.board.leads, function (lead)
                {
                    if ( lead.idGroups && lead.idGroups.indexOf(groupId) > -1 )
                    {
                        lead.idGroups.splice(lead.idGroups.indexOf(groupId), 1);
                    }
                });
            }, function ()
            {
                // Canceled
            });
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('ColorMenuController', ColorMenuController);

    /** @ngInject */
    function ColorMenuController($mdColorPalette, BoardService)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.palettes = $mdColorPalette;

        // Methods

        ////////

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('RuleEntriesController', RuleEntriesController);

    /** @ngInject */
    function RuleEntriesController($scope, $http, config, $mdToast, $mdDialog, BoardService, RuleService, User, $state, role, $rootScope, $timeout)
    {
        var vm = this;
        $scope.role = role;
        
        vm.dtOptions = {
            dom       : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            columnDefs: [
                {
                    // Target the actions column
                    targets           : 3,
                    responsivePriority: 1,
                    filterable        : false,
                    sortable          : false
                }
            ],
            pagingType: 'simple',
            lengthMenu: [10, 20, 30, 50, 100],
            pageLength  : 20,
            autoWidth : false,
            responsive: true,
            scrollY     : 'auto',
            processing : true
        };

        //Data
        vm.user = User.data;
        vm.rule = RuleService.data;
        vm.board = BoardService.data;
        vm.action = [
            {
                id: 1,
                name: "On create record"
            },
            {
                id: 2,
                name: "On update record"
            },
            {
                id: 3,
                name: "On both create/update"
            }
        ];
        vm.ruleEntries = vm.rule.rule_entries;
        if(vm.rule.action == 0)
            vm.ruleAction = "On create record";
        else if(vm.rule.action == 1)
            vm.ruleAction = "On update record";
        if(vm.rule.action == 2)
            vm.ruleAction = "On both create/update";

        //Parse the data to be usable to the markup
        angular.forEach(vm.ruleEntries, function(ruleEntry){
            ruleEntry.is_active = ruleEntry.is_active.toString();
            if(ruleEntry.groups != "" && typeof ruleEntry.groups == "string"){
                ruleEntry.groups = JSON.parse(ruleEntry.groups);
            }
        });

        // if permission == 'write' && board.user_id is not for user && permission == 'none' || permission == 'view' not allowed
        vm.isDisabled = (!role.permissions.write && vm.board.user_id === null && vm.board.permission != 'modify');

        if( vm.isDisabled )
        {
            $mdToast.show({
                template:
                    '<md-toast>' +
                        '<div class="md-toast-content">' +
                            '<strong class="md-warn-fg">Sorry! </strong>&nbsp;&nbsp;' +
                            'You don\'t have permission to access that settings' +
                        '</div>' +
                    '</md-toast>',
                hideDelay: 3000,
                position: 'top right'
            });
            $state.go('app.scrumboard.boards.board');
        }

        //Methods
        vm.updateRule = updateRule;
        vm.showConfirm = showConfirm;
        vm.changeStatus = changeStatus;
        var originatorEv;
        vm.openMenu = function($mdOpenMenu, ev){
          originatorEv = ev;
          $mdOpenMenu(ev);
        };

        function updateRule(){
            var updateRule = {
                'id': vm.rule.id,
                'user_id': vm.rule.user_id,
                'name': vm.rule.name,
                'action': vm.rule.action
            };
            if(vm.rule.name != null){
                $http({
                url: config.apiUrl + 'rule/update',
                method: 'POST',
                data: {rule: updateRule}
                }).then(function (response) {
                    vm.rule = response.data.saveRule;
                    $mdToast.show({
                        template:
                            '<md-toast>' +
                                '<div class="md-toast-content">' +
                                    '<strong class="md-accent-fg">Success!</strong>&nbsp;&nbsp;'+
                                    'Rule has been updated.' +
                                '</div>' +
                            '</md-toast>',
                        hideDelay: 3000,
                        position: 'top right'
                    });
                }, function (response) {
                    console.log('rejected');
                });
            }
        }

        function showConfirm(ev,index, entryId){
            var confirm = $mdDialog.confirm()
              .title('Are you sure you want to delete this Rule Entry?')
              .ariaLabel('Confirm Deletion')
              .targetEvent(ev)
              .clickOutsideToClose(true)
              .parent(angular.element(document.body))
              .ok('Yes')
              .cancel('Cancel');

            $mdDialog.show(confirm).then(function() {
                //DELETE RULE ENTRY
                RuleService.remove(entryId, "RuleEntry")
                .then(function(response) {
                    if(response) {
                        $mdToast.show({
                            template:
                                '<md-toast>' +
                                    '<div class="md-toast-content">' +
                                        '<strong class="md-accent-fg">Success!</strong>&nbsp;&nbsp;'+
                                        'Rule Entry has been deleted' +
                                    '</div>' +
                                '</md-toast>',
                            hideDelay: 3000,
                            position: 'top right'
                        });
                    }
                }, function (response){
                    $mdToast.show({
                            template:
                                '<md-toast>' +
                                    '<div class="md-toast-content">' +
                                        '<strong class="md-accent-fg">Failed!</strong>&nbsp;&nbsp;'+
                                        'There seems to be a problem deleting the rule entry' +
                                    '</div>' +
                                '</md-toast>',
                            hideDelay: 3000,
                            position: 'top right'
                        });
                });
                $state.reload();
            });
        }

        function changeStatus(id){
             $http({
                url: config.apiUrl + 'rule/entry/activate',
                method: 'POST',
                data: {id: id}
                }).then(function (response) {
                    var status = response.data.rule_entry.is_active == "1" ? "Activated":"Deactivated" ;
                    $mdToast.show({
                        template:
                            '<md-toast>' +
                                '<div class="md-toast-content">' +
                                    '<strong class="md-accent-fg">Success!</strong>&nbsp;&nbsp;'+
                                    'Rule Entry has been ' + status +
                                '</div>' +
                            '</md-toast>',
                        hideDelay: 3000,
                        position: 'top right'
                    });
                }, function (response) {
                    console.log('rejected');
                });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('AddEntryController', AddEntryController);

    /** @ngInject */
    function AddEntryController($stateParams, $scope, $http, msUtils,$mdMedia, config, BoardService, DialogService, RuleService, User, role, $mdToast, $compile, $state, $mdDialog)
    {
        var vm = this;
        $scope.role = role;
        $scope.parseInt = parseInt;
        $scope.$mdMedia = $mdMedia;
        vm.crmUrl = config.crmUrl;

        //Data
        vm.rule = RuleService.data;
        vm.board = BoardService.data;
        vm.boards = BoardService.boards;
        vm.user = User.data;
        vm.employee = vm.user.company.employee;
        vm.relationalOperators = vm.user.relational_operator;
        vm.fields = vm.user.fields;

        //Variables
        var entryId = parseInt($stateParams.entryId);
        vm.ruleEntry = angular.copy(vm.rule.rule_entries.getById(entryId), vm.ruleEntry);

        

        vm.criteria_property = vm.user.fields;
        vm.listEmployee = angular.copy(vm.employee,vm.listEmployee);
        vm.entryCriterias = [];
        vm.addedUsersId = [];
        vm.stringifyGroup="";
        vm.groupId = 0;
        vm.logicalOperatorDirty = 0;

        //variables ni Jimbo
        vm.exists = msUtils.exists;

        //My variables
        vm.groups = vm.board.groups;
        if(entryId != 0){
            vm.entryCriterias = vm.ruleEntry.rule_criterias;
            vm.is_active = vm.ruleEntry.is_active.toString();
            if(vm.ruleEntry.groups != "" && typeof vm.ruleEntry.groups == "string"){
                vm.ruleEntry.groups = JSON.parse(vm.ruleEntry.groups);
            }
            if(vm.ruleEntry.groups.length > 0){
                vm.assignTo = "group";
                vm.groupId = angular.copy(vm.ruleEntry.groups,vm.groupId);
            }
            else{
                vm.assignTo = "users";
                
                angular.forEach(vm.ruleEntry.users, function(user){
                    vm.addedUsersId.push(user.id);
                });
                vm.tempUsersId = angular.copy(vm.addedUsersId,vm.tempUsersId);
            }
            

        }
        else{
            vm.entryCriterias.push({
            'id': 0,
            'field_id': 1,
            'relational_operator_id':7,
            'logical_operator_id':1,
            'value': ''});
            vm.assignTo = "users";
            vm.is_active = '1';
        }
   
        // if permission == 'write' && board.user_id is not for user && permission == 'none' || permission == 'view' not allowed
        vm.isDisabled = (!role.permissions.write && vm.board.user_id === null && vm.board.permission != 'modify');

        if( vm.isDisabled )
        {
            $mdToast.show({
                template:
                    '<md-toast>' +
                        '<div class="md-toast-content">' +
                            '<strong class="md-warn-fg">Sorry! </strong>&nbsp;&nbsp;' +
                            'You don\'t have permission to access that settings' +
                        '</div>' +
                    '</md-toast>',
                hideDelay: 3000,
                position: 'top right'
            });
            $state.go('app.scrumboard.boards.board');
        }

        //Methods
        vm.addCriteriaForm = addCriteriaForm;
        vm.removeCriteriaForm = removeCriteriaForm;
        vm.saveCriteria = saveCriteria;
        vm.changeLogicalOperatorId = changeLogicalOperatorId;
        vm.changeProperty = changeProperty;
        vm.leadOwnershipChanged = leadOwnershipChanged;
        vm.changeSelectedGroup = changeSelectedGroup;
        vm.employeeQuerySearch = employeeQuerySearch;

        function addCriteriaForm(){
            vm.entryCriterias.push(
                {'id': 0,
                'field_id': 1,
                'relational_operator_id':7,
                'logical_operator_id':2,
                'value': ''});
        }

        function removeCriteriaForm(index){
            if(vm.entryCriterias.length > 1){
                vm.entryCriterias.splice(index,1);
                if(index == 0){
                    vm.entryCriterias[0].logical_operator_id = 1;
                }
            }

            else{
                vm.entryCriterias.splice(index,1);
                vm.entryCriterias.push(
                {'id': 0,
                'rule_entry_id': entryId,
                'field_id': 1,
                'relational_operator_id':7,
                'logical_operator_id':1,
                'value': ''});
            }
        }

        function changeProperty(index){
            if(vm.entryCriterias[index].field_id == 1)
                vm.entryCriterias[index].relational_operator_id = 7;
            else
                vm.entryCriterias[index].relational_operator_id = 1;
            vm.entryCriterias[index].value = "";
        }

        function changeLogicalOperatorId(criteria){
            if(criteria.logical_operator_id == 2){
                criteria.logical_operator_id = 3;
            }
            else{
                criteria.logical_operator_id = 2;
            }
            $scope.addEntryForm.$setDirty();
        }

        function employeeQuerySearch(query)
        {
            return query ? vm.listEmployee.filter(createFilterFor(query)) : [];
        }

        vm.setFocus = function () {
            setTimeout(function () {
                document.querySelector('#autoCompleteId').focus();
            }, 0);
        };

        function createFilterFor(query, email)
        {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(item)
            {
                var search = (email) ? item.email : item.first_name;
                return angular.lowercase(search).indexOf(lowercaseQuery) >= 0;
            };
        }

        function leadOwnershipChanged(){
            vm.groupId = [];
            vm.addedUsersId = [];
            vm.stringifyGroup="";
        }

        function changeSelectedGroup(){
            vm.addedUsersId.length = 0;
            angular.forEach(vm.groupId,  function(id){
                angular.forEach(vm.employee, function(item){
                    if(item.user.groups[0].id == id){
                        vm.addedUsersId.push(item.id);
                    }
                });
            });
            vm.stringifyGroup = JSON.stringify(vm.groupId);
        }

        function saveCriteria(ev){

            var confirm = $mdDialog.confirm()
                .title('Are you sure.....?')
                .htmlContent('Criteries will be applied to all your leads.')
                .ariaLabel('update criteria')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {
                $scope.addEntryForm.$setPristine();
                $scope.addEntryForm.$setUntouched();
                var entries = {
                    'rule_id': parseInt($stateParams.ruleId),
                    'id': entryId,
                    'board_status_id' : vm.selectedStage,
                    // 'assignment_type_id': vm.distributionType, DISTRIBUTION TYPE available is only Round Robin
                    'assignment_type_id': 1,
                    'groups':vm.stringifyGroup,
                    'is_active': vm.is_active
                };
                $http({
                    url: config.apiUrl + 'rule/entries/update',
                    method: 'POST',
                    data: {entries: entries, criteria: vm.entryCriterias, users: vm.addedUsersId}
                }).then(function (response) {
                    
                    $state.go('app.scrumboard.boards.board.rules.rule', {ruleId:vm.rule.id}, {reload: true});
                    
                    $mdToast.show({
                        template:
                            '<md-toast>' +
                                '<div class="md-toast-content">' +
                                    '<strong class="md-accent-fg">Success!</strong>&nbsp;&nbsp;'+
                                    'Criteria has been created/updated.' +
                                '</div>' +
                            '</md-toast>',
                        hideDelay: 3000,
                        position: 'top right'
                    });
                }, function (response) {
                    console.log('rejected');
                });
            }, function ()
            {
                
            });
        }



    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.employee.project',
            [
                // 3rd Party Dependencies
                'datatables',
                'flow',
                'nvd3',
                'xeditable'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, config)
    {
        // State
        $stateProvider
            .state('app.employee_project', {
                url      : '/employee/project',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/employees/project/views/projects/projects.html',
                        controller : 'EmployeeProjectsController as vm'
                    }
                },
                resolve  : {
                    Projects : function (msApi)
                    {
                        return msApi.resolve('projects.employee@get');
                    }
                },
                bodyClass: 'project'
            })
            .state('app.employee_project.detail', {
                url      : '/add',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/employees/project/views/project/project.html',
                        controller : 'CompanyProjectController as vm'
                    }
                },
                resolve  : {
                    Project : function (msApi)
                    {
                        return msApi.resolve('project.project@get');
                    }
                },
                bodyClass: 'project'
            });

        // Api
        msApiProvider.register('projects.employee', [config.apiUrl + 'projects/employee.json']);
        msApiProvider.register('project.project', [config.apiUrl + 'project/add.json']);
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.employee.project')
        .controller('EmployeeProjectsController', EmployeeProjectsController);

    /** @ngInject */
    function EmployeeProjectsController($state, $rootScope, $mdDialog, $filter, $http, config, User, Projects)
    {
        var vm = this;
        
        // Data
        vm.crmUrl = config.crmUrl;
        vm.user = User.data;
        vm.projects = Projects.data;

        vm.dtInstance = {};
        vm.dtOptions = {
            dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            columnDefs  : [
                {
                    // Target the id column
                    targets: 0,
                    width  : '72px'
                },
                {
                    // Target the actions column
                    targets           : 3,
                    responsivePriority: 1,
                    filterable        : false,
                    sortable          : false
                }
            ],
            initComplete: function ()
            {
                var api = this.api(),
                    searchBox = angular.element('body').find('#project-properties-search');

                // Bind an external input as a table wide search box
                if ( searchBox.length > 0 )
                {
                    searchBox.on('keyup', function (event)
                    {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType  : 'simple',
            lengthMenu  : [10, 20, 30, 50, 100],
            pageLength  : 20,
            scrollY     : 'auto',
            responsive  : true
        };

        // Methods
        vm.deleteDataConfirm = deleteDataConfirm;
        vm.addProject = addProject;
        vm.filterProject = filterProject;

        //////////
        
        /**
         * Project filter
         *
         * @param member
         * @returns {boolean}
         */
        function filterProject(project)
        {
            if ( !vm.projectSearchText || vm.projectSearchText === '' )
            {
                return true;
            }

            return angular.lowercase(project.name).indexOf(angular.lowercase(vm.projectSearchText)) >= 0;
        }

        /**
         * Delete Contact Confirm Dialog
         */
        function deleteDataConfirm(ev, data, type)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the property?')
                .htmlContent('<b>' + data.name + '</b>' + ' will be deleted.')
                .ariaLabel('delete setting')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {
                vm[type].splice(vm[type].indexOf(data), 1);
                vm.pivotProject('detach', data);
                
            }, function ()
            {

            });
        }

        /**
         * Add Selected Project
         */
        function addProject(project)
        {
            vm.projects.push(project);
            vm.pivotProject('attach', project);
        }
        
        /**
         * detach attach
         */
        vm.pivotProject = function(type, project)
        {
            $http({
                url: config.apiUrl + 'project/pivot',
                method: 'POST',
                data: {type: type, project:project, employee_id:vm.user.employee.id}
            }).then(function (response) {
                
            }, function (response) {
                
            });
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.employees',
            [
                // 3rd Party Dependencies,
                'app.employee.project',
                'xeditable',
                'ngFileUpload'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, config)
    {

        $stateProvider.state('app.employees', {
            url    : '/employees',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/employees/employees.html',
                    controller : 'EmployeesController as vm'
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/employees');

        // Navigation
        msNavigationServiceProvider.saveItem('apps.pages.settings.employees', {
            title : 'Users',
            state : 'app.employees',
            weight: 13,
            hidden: function ()
            {
                var roles = JSON.parse(localStorage.getItem('roles'));
                if( roles )
                {
                    var role = roles.filter(function ( obj ) {
                        return obj.url === '/employees';
                    })[0];

                    return !role.permissions.read;
                }
            }
        });
        
        msNavigationServiceProvider.saveItem('apps.sales.project', {
            title : 'My Projects',
            icon  : 'icon-dns',
            state : 'app.employee_project',
            weight: 9
        });

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.employees')
        .controller('PropertyDialogController', PropertyDialogController);

    /** @ngInject */
    function PropertyDialogController($http, $mdDialog, User, Properties, Project_id, msUtils, config, $mdToast)
    {
        var vm = this;
        vm.user = User;
        vm.data = [];
        vm.properties = Properties;
        vm.project_id = Project_id;

        // Data
        vm.property = {
            'id'       : 0,
            'name'     : '',
            'price'    : '',
            'discount' : '',
            'image'    : 'assets/images/theme-options/content-with-toolbar.jpg',
            'user_id'  : vm.user.id,
            'project_id' : vm.project_id
        };

        vm.title = 'New Property';
        vm.newProperty = true;

        // Methods
        vm.addNewProperty = addNewProperty;
        vm.deletePropertyConfirm = deletePropertyConfirm;
        vm.closeDialog = closeDialog;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;

        //////////

        /**
         * Add new property use signup function but with company_id
         */
        function addNewProperty()
        {
            vm.user['project'] = {'id': vm.project_id, 'property' : [vm.property]};

            $http({
                url: config.apiUrl + 'project/update',
                method: 'POST',
                data: vm.user
            }).then(function (response) {
                // this callback will be called asynchronously
                // when the response is available
                
                vm.property.id = response.data.changes.property.id;
                vm.properties.unshift(vm.property);
                        
                closeDialog();
                
//                console.log(response, " response is available!");
                
                $mdToast.show({
                    template:
                        '<md-toast>' +
                            '<div class="md-toast-content">' +
                                '<strong class="md-accent-fg">Success!</strong>&nbsp;&nbsp;'+
                                'Property has been saved.' +
                            '</div>' +
                        '</md-toast>',
                    hideDelay: 3000,
                    position: 'top right'
                });
                
            }, function (response) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
                console.log(response, " error occurs!");
            });
        }

        /**
         * Delete Property Confirm Dialog
         */
        function deletePropertyConfirm(ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the property?')
                .htmlContent('<b>' + vm.property.name + ' ' + vm.property.lastName + '</b>' + ' will be deleted.')
                .ariaLabel('delete property')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {

                vm.properties.splice(vm.properties.indexOf(Property), 1);

            });
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.company.project',
            [
                // 3rd Party Dependencies
                'datatables',
                'flow',
                'nvd3',
                'xeditable',
                'ngFileUpload'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, config)
    {
        // State
        $stateProvider
            .state('app.company_project', {
                url      : '/company/project',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/company/project/views/projects/projects.html',
                        controller : 'CompanyProjectsController as vm'
                    }
                },
                resolve  : {
                    Projects : function (ProjectsService)
                    {
                        return ProjectsService.getData();
                    }
                },
                bodyClass: 'project'
            })
            .state('app.company_project.detail', {
                url      : '/:id',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/company/project/views/project/project.html',
                        controller : 'CompanyProjectController as vm'
                    }
                },
                resolve  : {
                    Project   : function (msApi, $stateParams)
                    {
                        if($stateParams.id != 'add')
                            return msApi.resolve('project.project@get', {'id': $stateParams.id});
                        else
                            return [];
                    }
                },
                bodyClass: 'project',
                role: {
                    url: '/company/project'
                }
            })
            .state('app.company_project.property', {
                url      : '/property/:id',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/company/project/views/property/property.html',
                        controller : 'CompanyPropertyController as vm'
                    }
                },
                resolve  : {
                    Property: function (msApi, $stateParams)
                    {
                        return msApi.resolve('project.property@get', {'id': $stateParams.id});
                    }
                },
                bodyClass: 'property',
                role: {
                    url: '/company/project'
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/company/project');

        // Api
        msApiProvider.register('project.property', [config.apiUrl + 'property/:id.json']);
        msApiProvider.register('project.projects', [config.apiUrl + 'projects.json']);
        msApiProvider.register('project.project', [config.apiUrl + 'project/:id.json']);
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.company.project')
        .controller('CompanyPropertyController', CompanyPropertyController);

    /** @ngInject */
    function CompanyPropertyController($document, $scope, $mdToast, $state, $http, config, Property, Upload)
    {
        var vm = this;

        // Data
        vm.property = Property.data;
        vm.crmUrl = config.crmUrl;
        vm.categoriesSelectFilter = '';

        // Methods
        vm.saveProject = saveProject;
        vm.gotoProperties = gotoProperties;
        vm.onCategoriesSelectorOpen = onCategoriesSelectorOpen;
        vm.onCategoriesSelectorClose = onCategoriesSelectorClose;

        //////////

        /**
         * Save property use signup function but with company_id
         */
        function saveProject()
        {
            vm.data = {'project' : {'id': vm.property.project_id, 'property' : [vm.property]}};

            $http({
                url: config.apiUrl + 'project/update',
                method: 'POST',
                data: vm.data
            }).then(function (response) {
                // this callback will be called asynchronously
                // when the response is available
                
                $mdToast.show({
                    template:
                        '<md-toast>' +
                            '<div class="md-toast-content">' +
                                '<strong class="md-accent-fg">Success!</strong>&nbsp;&nbsp;'+
                                'Project has been saved.' +
                            '</div>' +
                        '</md-toast>',
                    hideDelay: 3000,
                    position: 'top right'
                });
                        
            }, function (response) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
                console.log(response, " error occurs!");
            });
        }

        /**
         * Go to properties page
         */
        function gotoProperties(id)
        {
            $state.go('app.company_project.detail', {id: id});
        }

        /**
         * On categories selector open
         */
        function onCategoriesSelectorOpen()
        {
            // The md-select directive eats keydown events for some quick select
            // logic. Since we have a search input here, we don't need that logic.
            $document.find('md-select-header input[type="search"]').on('keydown', function (e)
            {
                e.stopPropagation();
            });
        }

        /**
         * On categories selector close
         */
        function onCategoriesSelectorClose()
        {
            // Clear the filter
            vm.categoriesSelectFilter = '';

            // Unbind the input event
            $document.find('md-select-header input[type="search"]').unbind('keydown');
        }
        
        // upload later on form submit or something similar
        vm.uploadFiles = function (files, attachment_id) {
            $scope.files = files;
            if (files && files.length) {
                        Upload.upload({
                    url: config.apiUrl + 'file/create',
                    data: {
                        files: files,
                        field: 'photos',
                        attachment_id: attachment_id,
                        attachment_type: 'Property\\Crm\\Models\\Property'
                    }
                }).then(function (response) {
                    
                    var photos = response.data.return;
                    for (var p in photos)
                        vm.property.photos.push(photos[p]);

                }, function (response) {
                    //                    // called asynchronously if an error occurs
                    //                    // or server returns response with an error status.
                    console.log(response, " error occurs!");
                });
            }
        };
        
        //////////
        /**
         * onDelete
         */
        vm.deleteFile = function(data)
        {
            $http({
                url: config.apiUrl + 'file/delete',
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                data: {
                    field: 'photos',
                    attachment_id: data.id,
                    attachment_type: 'Property\\Crm\\Models\\Property'
                }
            }).then(function (response) {
                // this callback will be called asynchronously
                // when the response is available
                
                vm.property.photos.splice(vm.property.photos.indexOf(data), 1);
                
            }, function (response) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
                console.log(response, " error occurs!");
            });
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.company.project')
        .controller('CompanyProjectsController', CompanyProjectsController);

    /** @ngInject */
    function CompanyProjectsController($state, $mdDialog, $http, config, User, ProjectsService)
    {
        var vm = this;
        
        // Data
        vm.user = User.data;
        vm.projects = ProjectsService.data;
        vm.crmUrl = config.crmUrl;
        
        vm.dtInstance = {};
        vm.dtOptions = {
            dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            columnDefs  : [
                {
                    // Target the id column
                    targets: 0,
                    width  : '72px'
                },
                {
                    // Target the actions column
                    targets           : 4,
                    responsivePriority: 1,
                    filterable        : false,
                    sortable          : false
                }
            ],
            initComplete: function ()
            {
                var api = this.api(),
                    searchBox = angular.element('body').find('#project-properties-search');

                // Bind an external input as a table wide search box
                if ( searchBox.length > 0 )
                {
                    searchBox.on('keyup', function (event)
                    {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType  : 'simple',
            lengthMenu  : [10, 20, 30, 50, 100],
            pageLength  : 20,
            scrollY     : 'auto',
            responsive  : true
        };

        // Methods
        vm.gotoProjectDetail = gotoProjectDetail;
        vm.deleteDataConfirm = deleteDataConfirm;

        //////////

        /**
         * Delete Contact Confirm Dialog
         */
        function deleteDataConfirm(ev, data, type)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the property?')
                .htmlContent('<b>' + data.name + '</b>' + ' will be deleted.')
                .ariaLabel('delete property')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {
                vm.onDelete({model: type, checked: [data.id]});
                vm[type].splice(vm[type].indexOf(data), 1);
                
            }, function ()
            {

            });
        }
        
        //////////
        /**
         * onDelete
         */
        vm.onDelete = function(data)
        {
            $http({
                url: config.apiUrl + 'model/delete',
                method: 'DELETE',
                headers: {'Content-Type': 'application/json'},
                data: data
            }).then(function (response) {
                // this callback will be called asynchronously
                // when the response is available
                console.log(response, " response is available!");
            }, function (response) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
                console.log(response, " error occurs!");
            });
        };

        /**
         * Go to property detail
         *
         * @param id
         */
        function gotoProjectDetail(id)
        {
            $state.go('app.company_project.detail', {id: id});
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.company.project')
        .controller('CompanyProjectController', CompanyProjectController);

    /** @ngInject */
    function CompanyProjectController($scope, $state, $mdDialog, $document, $rootScope, $mdToast, $http, config, User, Project, Upload, ProjectsService)
    {
        var vm = this;

        // Data
        vm.user = User.data;
        vm.company = vm.user.company;
        
        vm.crmUrl = config.crmUrl;
        
        if ( angular.isObject(Project.data) )
        {
            vm.project = Project.data;
            vm.properties = vm.project.property;
        }
        else
        {
            vm.project = {
                'id'          : 0,
                'name'        : '',
                'description' : '',
                'company_id'  : vm.company.id,
                'idEmployees' : []
            };
            vm.properties = [];
        }
        
        vm.dtInstance = {};
        vm.dtOptions = {
            dom       : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            columnDefs: [
//                {
//                    // Target the id column
//                    targets: 0,
//                    width  : '72px'
//                },
                {
                    // Target the image column
                    targets   : 0,
                    filterable: false,
                    sortable  : false
                },
                {
                    // Target the actions column
                    targets           : 4,
                    responsivePriority: 1,
                    filterable        : false,
                    sortable          : false
                }
            ],
            pagingType: 'simple',
            lengthMenu: [10, 20, 30, 50, 100],
            pageLength: 20,
            responsive: true
        };

        // Methods
        vm.saveProject = saveProject;
        vm.deleteDataConfirm = deleteDataConfirm;
        vm.gotoProjects = gotoProjects;
        vm.gotoPropertyDetail = gotoPropertyDetail;
        vm.openPropertyDialog = openPropertyDialog;
        /* Members */
        vm.employeeQuerySearch = employeeQuerySearch;
        vm.employees = vm.company.employee;


        //////////

        /**
         * Save property use signup function but with company_id
         */
        function saveProject()
        {
            vm.data = {'project' : vm.project};
            
            $http({
                url: config.apiUrl + 'project/update',
                method: 'POST',
                data: vm.data
            }).then(function (response) {
                // this callback will be called asynchronously
                // when the response is available
                
                if( response.data.changes.new )
                {
                    vm.project.id = response.data.changes.new.id;
                    
                    ProjectsService.addProject(vm.project);
                    
                    $state.go('app.company_project.detail', {id: vm.project.id});
                }
                else
                {
                    $mdToast.show({
                        template:
                            '<md-toast>' +
                                '<div class="md-toast-content">' +
                                    '<strong class="md-accent-fg">Success!</strong>&nbsp;&nbsp;'+
                                    'Project has been saved.' +
                                '</div>' +
                            '</md-toast>',
                        hideDelay: 3000,
                        position: 'top right'
                    });
                }
                        
            }, function (response) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
                console.log(response, " error occurs!");
            });
        }

        /**
         * Delete Contact Confirm Dialog
         */
        function deleteDataConfirm(ev, data, type)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the property?')
                .htmlContent('<b>' + data.name + '</b>' + ' will be deleted.')
                .ariaLabel('delete property')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {
                vm.onDelete({model: type, checked: [data.id]});
                vm[type].splice(vm[type].indexOf(data), 1);
                
            }, function ()
            {

            });
        }
        
        //////////
        /**
         * onDelete
         */
        vm.onDelete = function(data)
        {
            $http({
                url: config.apiUrl + 'model/delete',
                method: 'DELETE',
                headers: {'Content-Type': 'application/json'},
                data: data
            }).then(function (response) {
                // this callback will be called asynchronously
                // when the response is available
//                console.log(response, " response is available!");
            }, function (response) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
                console.log(response, " error occurs!");
            });
        };
        
        // upload later on form submit or something similar
        vm.uploadFiles = function (files, attachment_id) {
            $scope.files = files;
            if (files && files.length) {
                Upload.upload({
                    url: config.apiUrl + 'file/update',
                    data: {
                        files: files,
                        field: 'photo',
                        attachment_id: attachment_id,
                        attachment_type: 'Property\\Crm\\Models\\Project'
                    }
                }).then(function (response) {
                    
                    $scope.$evalAsync(function ()
                    {
                        var avatar = response.data.return[0];
                        
                        vm.project.photo = avatar;
                        // apply also in the ProjectsService by id;
                        ProjectsService.data.getById(vm.project.id).photo = avatar;
                    });
                    
                }, function (response) {
//                    // called asynchronously if an error occurs
//                    // or server returns response with an error status.
                    console.log(response, " error occurs!");
                });
            }
        };

        /**
         * Open new property dialog
         *
         * @param ev
         * @param employee
         */
        function openPropertyDialog(ev)
        {
            $mdDialog.show({
                controller         : 'PropertyDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/company/project/dialogs/property/property-dialog.html',
                parent             : angular.element($document.find('#content-container')),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    User       : $rootScope.currentUser,
                    Properties : vm.properties,
                    Project_id : vm.project.id
                }
            });
        }

        /**
         * Go to projects page
         */
        function gotoProjects()
        {
            $state.go('app.company_project');
        }

        /**
         * Go to property page
         * @param id
         */
        function gotoPropertyDetail(id)
        {
            $state.go('app.company_project.property', {id: id});
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        };

        /**
         * Add member chips
         *
         * @param query
         * @returns {Array}
         */
        function employeeQuerySearch(query)
        {
            return query ? vm.employees.filter(createFilterFor(query)) : [];
        }

        /**
         * Filter for chips
         *
         * @param query
         * @returns {filterFn}
         */
        function createFilterFor(query)
        {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(item)
            {
                return angular.lowercase(item.user.name).indexOf(lowercaseQuery) >= 0;
            };
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.company.project')
        .controller('PropertyDialogController', PropertyDialogController);

    /** @ngInject */
    function PropertyDialogController($http, $mdDialog, User, Properties, Project_id, msUtils, config, $mdToast)
    {
        var vm = this;
        vm.user = User;
        vm.data = [];
        vm.properties = Properties;
        vm.project_id = Project_id;

        // Data
        vm.property = {
            'id'       : 0,
            'name'     : '',
            'price'    : '',
            'discount' : '',
            'image'    : 'assets/images/theme-options/content-with-toolbar.jpg',
            'user_id'  : vm.user.id,
            'project_id' : vm.project_id
        };

        vm.title = 'New Property';
        vm.newProperty = true;

        // Methods
        vm.addNewProperty = addNewProperty;
        vm.deletePropertyConfirm = deletePropertyConfirm;
        vm.closeDialog = closeDialog;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;

        //////////

        /**
         * Add new property use signup function but with company_id
         */
        function addNewProperty()
        {
            vm.user['project'] = {'id': vm.project_id, 'property' : [vm.property]};

            $http({
                url: config.apiUrl + 'project/update',
                method: 'POST',
                data: vm.user
            }).then(function (response) {
                // this callback will be called asynchronously
                // when the response is available
                
                vm.property.id = response.data.changes.property.id;
                vm.properties.unshift(vm.property);
                        
                closeDialog();
                
//                console.log(response, " response is available!");
                
                $mdToast.show({
                    template:
                        '<md-toast>' +
                            '<div class="md-toast-content">' +
                                '<strong class="md-accent-fg">Success!</strong>&nbsp;&nbsp;'+
                                'Property has been saved.' +
                            '</div>' +
                        '</md-toast>',
                    hideDelay: 3000,
                    position: 'top right'
                });
                
            }, function (response) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
                console.log(response, " error occurs!");
            });
        }

        /**
         * Delete Property Confirm Dialog
         */
        function deletePropertyConfirm(ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the property?')
                .htmlContent('<b>' + vm.property.name + ' ' + vm.property.lastName + '</b>' + ' will be deleted.')
                .ariaLabel('delete property')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {

                vm.properties.splice(vm.properties.indexOf(Property), 1);

            });
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.todo',
            [
                // 3rd Party Dependencies
                'ng-sortable'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, config)
    {
        // State
        $stateProvider.state('app.to-do', {
            url      : '/to-do',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/todo/todo.html',
                    controller : 'TodoController as vm'
                }
            },
            resolve  : {
                Tasks: function (msApi)
                {
                    return msApi.resolve('todo.tasks@get');
                },
                ActivityType  : function (msApi)
                {
                    return msApi.resolve('api.activity_type@get');
                }
            },
            bodyClass: 'todo'
        });
        $stateProvider.state('app.to-do.type', {
            url      : '/:id',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/todo/todo.html',
                    controller : 'TodoController as vm'
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/todo');

        // Api
        msApiProvider.register('user.user', [config.apiUrl + 'user.json']);
        msApiProvider.register('todo.tasks', [config.apiUrl + 'tasks.json']);
        msApiProvider.register('api.activity_type', [config.apiUrl + 'activity_type.json']);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.todo')
        .controller('TaskDialogController', TaskDialogController);

    /** @ngInject */
    function TaskDialogController($state, $mdDialog, Task, Index, Tasks, ActivityType, ActivityStatus, Priority, user_id, completed_id, cancelled_id, event, msApi, $http, config, $mdToast)
    {
        var vm = this;

        // Data
        vm.title = 'Edit Task';
        vm.task = angular.copy(Task);
        vm.tasks = Tasks;
        vm.activity_type = ActivityType;
        vm.activity_status = ActivityStatus;
        vm.priority = Priority;
        vm.newTask = false;
        
        if ( !vm.task )
        {
            vm.task = {
                'id'                : '',
                'subject'           : '',
                'user_id'           : user_id,
                // default val always select 0
                'status_id'         : vm.activity_status[0].id,
                'priority_id'       : vm.priority[0].id,
                'date_deadline'     : new Date()
            };
            vm.title = 'New Task';
            vm.newTask = true;
        }

        // Methods
        vm.addNewTask = addNewTask;
        vm.saveTask = saveTask;
        vm.deleteTask = deleteTask;
        vm.closeDialog = closeDialog;

        //////////

        /**
         * Add new task
         */
        function addNewTask()
        {
//            vm.task.date_deadline = (vm.task.date_deadline) ? moment(vm.task.date_deadline).format('YYYY-MM-DD') : null;
            vm.tasks.unshift(vm.task);
            
            vm.saveActivity();
            
            closeDialog();
        }

        /**
         * Save task
         */
        function saveTask()
        {
            // Dummy save action
            for ( var i = 0; i < vm.tasks.length; i++ )
            {
                if ( vm.tasks[i].id === vm.task.id )
                {
                    vm.task.completed = (vm.task.status_id == completed_id) ? true : false;
                    vm.task.cancelled = (vm.task.status_id == cancelled_id) ? true : false;
                    vm.task.important = (vm.task.priority_id === 1) ? true : false;
                    
                    vm.tasks[i] = angular.copy(vm.task);
                    break;
                }
            }
            
            vm.saveActivity();

            closeDialog();
        }
        
        /**
         * saveActivity
         */
        vm.saveActivity = function()
        {
            $http({
                url: config.apiUrl + 'activity/update',
                method: 'POST',
                data: {tasks: vm.tasks}
            }).then(function (response) {
//                console.log(response);
                if( response.data.return.activity && response.data.return.activity.id )
                    $state.go('app.to-do', {}, {reload: true});
                
                $mdToast.show({
                    template:
                        '<md-toast>' +
                            '<div class="md-toast-content">' +
                                '<strong class="md-accent-fg">Success!</strong>&nbsp;&nbsp;'+
                                'ToDo has been saved.' +
                            '</div>' +
                        '</md-toast>',
                    hideDelay: 3000,
                    position: 'top right'
                });
                
            }, function (response) {
                console.log(response, " error occurs!");
            });
        };

        /**
         * Delete task
         */
        function deleteTask(event, type)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure?')
                .content('The Task will be deleted.')
                .ariaLabel('Delete Task')
                .ok('Delete')
                .cancel('Cancel')
                .targetEvent(event);

            $mdDialog.show(confirm).then(function ()
            {
                vm.onDelete({model: type, checked: [vm.task.id]});
                vm.tasks.splice(Index, 1);
            }, function ()
            {
                // Cancel Action
            });
        }
        
        /**
         * onDelete
         */
        vm.onDelete = function(data)
        {
            $http({
                url: config.apiUrl + 'model/delete',
                method: 'DELETE',
                headers: {'Content-Type': 'application/json'},
                data: data
            }).then(function (response) {
                // this callback will be called asynchronously
                // when the response is available
//                console.log(response, " response is available!");
            }, function (response) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
                console.log(response, " error occurs!");
            });
        };

        /**
         * Close dialog
         */
        function closeDialog()
        {   
            $mdDialog.hide();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('CalendarViewController', CalendarViewController);

    /** @ngInject */
    function CalendarViewController($scope, $document, $mdDialog, $mdSidenav, BoardService, DialogService)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.eventSources = [];

        vm.calendarUiConfig = {
            calendar: {
                editable                 : true,
                eventLimit               : true,
                header                   : '',
                handleWindowResize       : false,
                aspectRatio              : 1,
                dayNames                 : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                dayNamesShort            : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                timezone                 : 'local',
                eventDurationEditable    : false,
                defaultTimedEventDuration: '01:00:00',
                viewRender               : function (view)
                {
                    vm.calendarView = view;
                    vm.calendar = vm.calendarView.calendar;
                    vm.currentMonthShort = vm.calendar.getDate().format('MMM');
                },
                columnFormat             : {
                    month: 'ddd',
                    week : 'ddd D',
                    day  : 'ddd D'
                },
                eventClick               : function eventDetail(calendarEvent, ev)
                {
                    vm.openLeadDialog(ev, calendarEvent.idLead);
                },
                eventDrop                : function (event)
                {
                    vm.board.leads.getById(event.idLead).due = moment.utc(event.start).format('x');
                },
                selectable               : true,
                selectHelper             : true,
                dayClick                 : function (date, ev)
                {
                    var offset = moment().utcOffset();
                    var corrDate = '';

                    if ( offset < 0 )
                    {
                        corrDate = moment.utc(date).subtract(offset, 'm').format('x');
                    }
                    else
                    {
                        corrDate = moment.utc(date).add(offset, 'm').format('x');
                    }

                    eventDialog(corrDate, ev);
                }
            }
        };

        // Methods
        vm.next = next;
        vm.prev = prev;
        vm.goToDate = goToDate;
        vm.openLeadDialog = DialogService.openLeadDialog;
        vm.toggleSidenav = toggleSidenav;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            vm.leads = getScheduledLeads();
            vm.eventSources[0] = vm.leads;
        }

        /**
         * Get scheduled leads and prepare
         * them to show on the calendar
         *
         * @returns {Array}
         */
        function getScheduledLeads()
        {
            var leads = [];

            angular.forEach(vm.board.leads, function (lead)
            {
                if ( lead.due )
                {
                    leads.push({
                        idLead         : lead.id,
                        title          : lead.name,
                        start          : moment.utc(lead.due, 'x'),
                        due            : lead.due,
                        backgroundColor: getEventBgColor(lead.due)
                    });
                }
            });

            return leads;
        }

        /**
         * Get background color
         *
         * @param leadDue
         * @returns {*}
         */
        function getEventBgColor(leadDue)
        {
            if ( moment() > moment(leadDue, 'x') )
            {
                return '#F44336';
            }

            return '#4CAF50';
        }

        /**
         * Watch board changes
         */
        $scope.$watch('vm.board', function (current, old)
        {
            if ( angular.equals(current, old) )
            {
                return;
            }

            init();

        }, true);

        /**
         * Go to Date
         *
         * @param date
         */
        function goToDate(date)
        {
            vm.calendarView.calendar.gotoDate(date);
            $mdSidenav('scheduled-tasks-sidenav').close();
        }

        /**
         * Go to next on current view (week, month etc.)
         */
        function next()
        {
            vm.calendarView.calendar.next();
        }

        /**
         * Go to previous on current view (week, month etc.)
         */
        function prev()
        {
            vm.calendarView.calendar.prev();
        }

        /**
         * Event Dialog
         */
        function eventDialog(date, ev)
        {
            $mdDialog.show({
                templateUrl        : 'app/main/apps/scrumboard/views/calendar/dialogs/event/event-dialog.html',
                controller         : 'ScrumboardCalendarEventDialogController',
                controllerAs       : 'vm',
                parent             : $document.find('#scrumboard'),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    dueDate: date
                }
            });
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('BoardsViewController', BoardsViewController);

    /** @ngInject */
    function BoardsViewController(User, role, BoardService)
    {
        var vm = this;

        // Data
        vm.user = User.data;
        vm.company = vm.user.company;
//        vm.boards = vm.user.board_group; // always get the board group
        vm.boards = ( !role.permissions.write ) // no authorize of managing
                   ? vm.user.board_group
                   : vm.company.board;
                   
        vm.boardsTemplate = vm.company.boards;
        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('BoardViewController', BoardViewController);

    /** @ngInject */
    function BoardViewController($scope, $stateParams, $document, $window, $timeout, $mdDialog, msUtils, $filter, $http, config, User, BoardService, Regions, Provinces, Cities, Priority, LeadFilters, DialogService, RemarkService, role, $state, $mdToast)
    {
        var vm = this;

        // Data
        vm.currentView = 'board';
        vm.board = BoardService.data;
        vm.boards = BoardService.boards;
        vm.stages = vm.board.stages;
        vm.user = User.data;
        vm.company = vm.user.company;
        vm.leadFilters = LeadFilters;
        vm.lead = {};
        vm.leadOptions = {};
        vm.newStageName = '';
        vm.customfields = vm.board.customfields;

        // if permission == 'write' && board.user_id is not for user && permission == 'none' || permission == 'view' not allowed
        vm.isDisabled = (!role.permissions.write && vm.board.user_id === null && vm.board.permission != 'modify');

        if( vm.user.company.id !== vm.board.company_id && vm.user.id !== vm.board.user_id || vm.board.permission == 'none' )
        {
            $mdToast.show({
                template:
                    '<md-toast>' +
                        '<div class="md-toast-content">' +
                            '<strong class="md-warn-fg">Sorry!</strong>&nbsp;&nbsp;' +
                            'You don\'t have permission to access that board.' +
                        '</div>' +
                    '</md-toast>',
                hideDelay: 3000,
                position: 'top right'
            });

            $state.go('app.scrumboard.boards');
        }

        vm.data = {
            Regions:         Regions.data,
            Provinces:       Provinces.data,
            Cities:          Cities.data,
            Boards:          vm.boards,
            Stages:          vm.stages,
            company:         vm.company,
            Priority:        Priority.data,
            Projects:        vm.user.employee.project,
            role:            role,
            Contacts:        vm.company.contact,
            groups:          vm.user.groups,
            user_id:         vm.user.id
        };

        vm.sortableLeadOptions = {
            appendTo            : 'body',
            connectWith         : '.stage-leads',
            delay               : 75,
            distance            : 7,
            forceHelperSize     : true,
            forcePlaceholderSize: true,
            handle              : msUtils.isMobile() ? '.stage-lead-sort-handle' : false,
            helper              : function (event, el)
            {
                return el.clone().addClass('stage-lead-sort-helper');
            },
            placeholder         : 'stage-lead lead-sortable-placeholder',
            tolerance           : 'pointer',
            scroll              : true,
            sort                : function (event, ui)
            {
                var stageContentEl = ui.placeholder.closest('.stage-content');
                var boardContentEl = ui.placeholder.closest('#board');

                if ( stageContentEl )
                {
                    var stageContentElHeight = stageContentEl[0].clientHeight,
                        stageContentElScrollHeight = stageContentEl[0].scrollHeight;

                    if ( stageContentElHeight !== stageContentElScrollHeight )
                    {
                        var itemTop = ui.position.top,
                            itemBottom = itemTop + ui.item.height(),
                            stageTop = stageContentEl.offset().top,
                            stageBottom = stageTop + stageContentElHeight;

                        if ( itemTop < stageTop + 25 )
                        {
                            stageContentEl.scrollTop(stageContentEl.scrollTop() - 25);
                        }

                        if ( itemBottom > stageBottom - 25 )
                        {
                            stageContentEl.scrollTop(stageContentEl.scrollTop() + 25);
                        }
                    }
                }

                if ( boardContentEl )
                {
                    var boardContentElWidth = boardContentEl[0].clientWidth;
                    var boardContentElScrollWidth = boardContentEl[0].scrollWidth;

                    if ( boardContentElWidth !== boardContentElScrollWidth )
                    {
                        var itemLeft = ui.position.left,
                            itemRight = itemLeft + ui.item.width(),
                            boardLeft = boardContentEl.offset().left,
                            boardRight = boardLeft + boardContentElWidth;

                        if ( itemLeft < boardLeft + 25 )
                        {
                            boardContentEl.scrollLeft(boardContentEl.scrollLeft() - 25);
                        }

                        if ( itemRight > boardRight )
                        {
                            boardContentEl.scrollLeft(boardContentEl.scrollLeft() + 25);
                        }
                    }
                }
            },
            stop: function(e, ui){
//                var $list=ui.item.parent();
////                $scope.sortableOrder = $list.sortable('toArray');
//                console.log($list.sortable('toArray'));

                // this callback has the changed model
//                var logEntry = vm.stages.map(function (i) {
//                    return i.value;
//                }).join(', ');
//                console.log(logEntry);
//                var sortingLog = [];
                var lead = $filter('filter')(vm.board.leads, {id: ui.item.sortable.model})[0];
                var key_lead = vm.board.leads.indexOf(lead);
                var stage_id = '';
                for (var i = 0; i < vm.stages.length; i++) {
                    vm.stages[i].idLeads = vm.stages[i].idLeads.map(function (x) {
                        if( lead.id == x )
                            stage_id = vm.board.stages[i].id;
                        return x;
                    });
//                    logEntry = 'container ' + (i + 1) + ': ' + logEntry;
//                    sortingLog.push(logEntry);
                }
                vm.board.leads[key_lead].status_id = stage_id;

                vm.updateStatus();
            },
            disabled: vm.isDisabled
        };

        /**
         * detach attach
         */
        vm.updateStatus = function()
        {
            $http({
                url: config.apiUrl + 'board_status/update',
                method: 'POST',
                data: vm.stages
            }).then(function (response) {

            }, function (response) {
                console.log(response, " error occurs!");
            });
        };

        // Methods
        vm.openLeadDialog = DialogService.openLeadDialog;
        vm.openRemarkDialog = RemarkService.openRemarkDialog;
        vm.addNewStage = addNewStage;
        vm.removeStage = removeStage;
        vm.leadFilter = leadFilter;
        vm.isOverdue = isOverdue;
        vm.clickEditRule = clickEditRule;

        //////////
        if( $stateParams.isNew )
        {
            $timeout(function ()
            {
                angular.element('#scrumboard').find('.header-board-name span.editable').trigger('click');
                angular.element(document.querySelectorAll("#title")).focus();
            });
        }
        else if( $stateParams.newLeadId )
        {
            vm.openLeadDialog([], $stateParams.newLeadId, vm.data, []);
        }

        init();

        /**
         * Initialize
         */
        function init()
        {

            $timeout(function ()
            {
                // IE stage-content max-height hack
                if ( angular.element('html').hasClass('explorer') )
                {
                    // Calculate the height for the first time
                    calculateStageContentHeight();

                    // Attach calculateStageContentHeight function to window resize
                    $window.onresize = function ()
                    {
                        calculateStageContentHeight();
                    };
                }
            }, 0);

        }

        /**
         * IE ONLY
         * Calculate the stage-content height
         * IE ONLY
         */
        function calculateStageContentHeight()
        {
            var boardEl = angular.element('#board');
            var boardElHeight = boardEl.height();

            boardEl.find('.stage-wrapper').each(function (index, el)
            {
                // Get the required heights for calculations
                var stageWrapperEl = angular.element(el),
                    stageHeaderElHeight = stageWrapperEl.find('.stage-header').height(),
                    stageFooterElHeight = stageWrapperEl.find('.stage-footer').height();

                // Calculate the max height
                var maxHeight = boardElHeight - stageHeaderElHeight - stageFooterElHeight;

                // Add the max height
                stageWrapperEl.find('.stage-content').css({'max-height': maxHeight});
            });
        }

        vm.priorityValue = function(id) {
            return $filter('filter')(vm.data.Priority, {id: id })[0]['value'];
        }

        /**
         * Add new stage
         */
        function addNewStage(type)
        {
            if ( vm.newStageName === '' )
            {
                return;
            }

            vm.stages.push({
                id      : 0,
                board_id: vm.board.id,
                value   : vm.newStageName,
                idLeads : []
            });
            vm.saveUser();

            vm.newStageName = '';
        }

        /**
         * saveUser
         */
        vm.saveUser = function()
        {
            $http({
                url: config.apiUrl + 'board/update',
                method: 'POST',
                data: {board: vm.board}
            }).then(function (response) {
                // this callback will be called asynchronously
                // when the response is available
//                console.log(response, " response is available!");
                var stage_id = (response.data.changes.stages) ? response.data.changes.stages.id : null; // best condition
                if( response.data.changes.stages )
                {
                    var index = vm.stages.map(function(o) { return o.id; }).indexOf(0);
                    vm.stages[index].id = parseInt(stage_id);
                    var key = vm.boards.map(function(o) { return o.id; }).indexOf(vm.board.id);
                    vm.boards[key].stages = vm.board.stages;
                }
                $mdToast.show({
                    template:
                        '<md-toast>' +
                            '<div class="md-toast-content">' +
                                '<strong class="md-accent-fg">Success!</strong>&nbsp;&nbsp;'+
                                'Board has been saved.' +
                            '</div>' +
                        '</md-toast>',
                    hideDelay: 3000,
                    position: 'top right'
                });

            }, function (response) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
                console.log(response, " error occurs!");
            });
        };

        /**
         * Remove stage
         *
         * @param ev
         * @param stage
         */
        function removeStage(ev, data, type)
        {
            var confirm = $mdDialog.confirm({
                title              : 'Remove Stage',
                parent             : $document.find('#scrumboard'),
                textContent        : 'Are you sure want to remove stage?',
                ariaLabel          : 'remove stage',
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                ok                 : 'Remove',
                cancel             : 'Cancel'
            });
            $mdDialog.show(confirm).then(function ()
            {
                vm.onDelete({model: type, checked: [data.id]});
                vm.stages.splice(vm.stages.indexOf(data), 1);

            }, function ()
            {
                // Canceled
            });

        }

        /**
         * onDelete
         */
        vm.onDelete = function(data)
        {
            $http({
                url: config.apiUrl + 'model/delete',
                method: 'DELETE',
                headers: {'Content-Type': 'application/json'},
                data: data
            }).then(function (response) {
                // this callback will be called asynchronously
                // when the response is available
//                console.log(response, " response is available!");
                var key = vm.boards.map(function(o) { return o.id; }).indexOf(vm.board.id);
                vm.boards[key].stages = vm.board.stages;
            }, function (response) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
                console.log(response, " error occurs!");
            });
        };

        /**
         * Lead filter
         *
         * @param leadId
         * @returns {*}
         */
        function leadFilter(leadId)
        {
            var lead = vm.board.leads.getById(leadId);

            try
            {
                if ( angular.lowercase(lead.name).indexOf(angular.lowercase(vm.leadFilters.name)) < 0 )
                {
                    throw false;
                }

                angular.forEach(vm.leadFilters.labels, function (label)
                {
                    if ( !msUtils.exists(label, lead.idLabels) )
                    {
                        throw false;
                    }
                });

                angular.forEach(vm.leadFilters.members, function (member)
                {
                    if ( !msUtils.exists(member, lead.idMembers) )
                    {
                        throw false;
                    }
                });


            } catch ( err )
            {
                return err;
            }

            return true;
        }

        /**
         * Is the lead overdue?
         *
         * @param leadDate
         * @returns {boolean}
         */
        function isOverdue(leadDate)
        {
            return moment() > moment(leadDate, 'x');
        }

        function clickEditRule(action,id)
        {
            if(action == 'edit')
                $state.go('app.scrumboard.boards.board.rules.rule', {ruleId:id});
            else
                $state.go('app.scrumboard.boards.board.rules.createUpdate',{ boardId: vm.board.id, userId: vm.user.id , boardStatusId:id});
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('AssignmentRuleController', AssignmentRuleController);

    /** @ngInject */
    function AssignmentRuleController($scope, $http, config, $state, User, BoardService, DialogService, RuleService, $mdToast, role)
    {
        var vm = this;
        
        //Init
        vm.dtOptions = {
            dom       : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            columnDefs: [
                {
                    targets           : 0,
                    responsivePriority: 2,
                    filterable        : false,
                    sortable          : false,
                },
                {
                    // Target the actions column
                    targets           : 2,
                    responsivePriority: 1,
                    filterable        : false,
                    sortable          : false,
                }
            ],
            pagingType: 'simple',
            lengthMenu: [10, 20, 30, 50, 100],
            pageLength: 20,
            autoWidth: false,
            responsive: true,
            scrollY     : 'auto',
            order: false, // This fixed the issue
        };

        // Data
        vm.data = User.data;
        vm.board = BoardService.data;
        vm.rules = vm.board.board_rules;
        
        // if permission == 'write' && board.user_id is not for user && permission == 'none' || permission == 'view' not allowed
        vm.isDisabled = (!role.permissions.write && vm.board.user_id === null && vm.board.permission != 'modify');

        if( vm.isDisabled )
        {
            $mdToast.show({
                template:
                    '<md-toast>' +
                        '<div class="md-toast-content">' +
                            '<strong class="md-warn-fg">Sorry! </strong>&nbsp;&nbsp;' +
                            'You don\'t have permission to access that settings' +
                        '</div>' +
                    '</md-toast>',
                hideDelay: 3000,
                position: 'top right'
            });
            $state.go('app.scrumboard.boards.board');
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('SettingsSidenavController', SettingsSidenavController);

    /** @ngInject */
    function SettingsSidenavController($mdColorPalette, $http, $mdDialog, $state, config, BoardService)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.boards = BoardService.boards;
        vm.palettes = $mdColorPalette;
        vm.selectedMenu = 'Settings';
        vm.deleteDataConfirm = deleteDataConfirm;

        // Methods

        /**
         * Delete Board Confirm Dialog
         */
        function deleteDataConfirm(ev, data, type)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the board?')
                .htmlContent('<b>' + data.title + '</b>' + ' will be deleted.')
                .ariaLabel('delete board')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {
                var index = vm[type].findIndex(function(v) {
                    if(v.id === data.id)
                        return v.id;
                });
                vm.onDelete({model: type, checked: [data.id]});
                vm[type].splice(index, 1);
                $state.go('app.scrumboard.boards', {}, {reload: true});
            }, function ()
            {

            });
        }
        
        /**
         * saveUser
         */
        vm.saveUser = function()
        {
            $http({
                url: config.apiUrl + 'board/update',
                method: 'POST',
                data: {board: vm.board}
            }).then(function (response) {
                // this callback will be called asynchronously
                // when the response is available
                if( response.data.changes.board.customfields && response.data.changes.board.customfields.length > vm.board.customfields.length )
                    $state.go('app.scrumboard.boards.board', {id: vm.board.id}, {reload: true});
//                console.log(response, " response is available!");
            }, function (response) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
                console.log(response, " error occurs!");
            });
        };
        
        //////////
        /**
         * onDelete
         */
        vm.onDelete = function(data)
        {
            $http({
                url: config.apiUrl + 'model/delete',
                method: 'DELETE',
                headers: {'Content-Type': 'application/json'},
                data: data
            }).then(function (response) {
                // this callback will be called asynchronously
                // when the response is available
//                console.log(response, " response is available!");
                
                $state.go('app.scrumboard.boards');
            }, function (response) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
                console.log(response, " error occurs!");
            });
        };

        ////////

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('FiltersSidenavController', FiltersSidenavController);

    /** @ngInject */
    function FiltersSidenavController(msUtils, BoardService, LeadFilters)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.leadFilters = LeadFilters;
        vm.labels = vm.board.labels;
        vm.members = vm.board.members;
        vm.selectedMenu = 'Settings';

        // Methods
        vm.exists = msUtils.exists;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.clearFilters = LeadFilters.clear;
        vm.filteringIsOn = LeadFilters.isOn;

        ////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('msSbAddLeadController', msSbAddLeadController)
        .directive('msSbAddLead', msSbAddLeadDirective);

    /** @ngInject */
    function msSbAddLeadController($scope, $rootScope, $http, config, $timeout, $document, BoardService, msUtils)
    {
        var vm = this;

        vm.newLeadName = '';
        vm.stageId = $scope.msStageId;
        vm.board = BoardService.data;
        vm.leads = vm.board.leads;
        vm.stage = vm.board.stages.getById(vm.stageId);
        
        // Methods
        vm.addNewLead = addNewLead;

        /////

        /**
         * Add New Lead
         */
        function addNewLead()
        {
            if ( vm.newLeadName === '' )
            {
                return;
            }

            var newCardId = 0;

            vm.leads.push({
                id          : newCardId,
                name        : vm.newLeadName,
                description : '',
                status_id   : vm.stageId,
                user_id     : $rootScope.currentUser.id,
                idMembers   : [$rootScope.currentUser.id]
            });

            vm.saveUser();
            
            $timeout(function ()
            {
                $scope.scrollStageContentBottom();
            });

            vm.newLeadName = '';
        }
        
        /**
         * saveUser
         */
        vm.saveUser = function()
        {
            $http({
                url: config.apiUrl + 'board/update',
                method: 'POST',
                data: {board: vm.board}
            }).then(function (response) {
                var newLeadId = response.data.changes.leads.id;
                var lastId = (vm.leads.length - 1);
                
                vm.leads[lastId].id = newLeadId;
                vm.stage.idLeads.push(newLeadId);

                $timeout(function() {
                    angular.element('.ms-sb-add-lead-button').trigger('click');
                }, 0);
            }, function (response) {
                console.log(response, " error occurs!");
            });
        };
    }

    /** @ngInject */
    function msSbAddLeadDirective($document, $window, $timeout)
    {
        return {
            restrict   : 'E',
            controller : 'msSbAddLeadController as vm',
            templateUrl: 'app/main/apps/scrumboard/directives/ms-sb-add-lead/ms-sb-add-lead.html',
            scope      : {
                msStageId: '='
            },
            link       : function (scope, iElement)
            {
                scope.formActive = false;
                scope.toggleForm = toggleForm;
                scope.scrollStageContentBottom = scrollStageContentBottom;

                var buttonEl = $document.find('.ms-sb-add-lead-button'),
                    formEl = iElement.find('.ms-sb-add-lead-form'),
                    stageLeads = $document.first('.stage-leads');
            
                /**
                 * Click Event
                 */
                buttonEl.on('click', toggleForm);

                /**
                 * Toggle Form
                 */
                function toggleForm()
                {
                    scope.$evalAsync(function ()
                    {
                        scope.formActive = !scope.formActive;

                        if ( scope.formActive )
                        {
                            $timeout(function ()
                            {
                                formEl.find('input').focus();

                                scrollStageContentBottom();
                            });

                            $document.on('click', outSideClick);
                        }
                        else
                        {
//                            PerfectScrollbar.update(stageLeads[0]);
                            $document.off('click', outSideClick);
                        }

                        $timeout(function ()
                        {
                            // IE stage-content max-height hack
                            if ( angular.element('html').hasClass('explorer') )
                            {
                                angular.element($window).trigger('resize');
                            }
                        });

                    });
                }

                /**
                 * Scroll Stage to the Bottom
                 */
                function scrollStageContentBottom()
                {
                    stageLeads[0].scrollTop = stageLeads[0].scrollHeight;
                }

                /**
                 * Click Outside Event Handler
                 * @param event
                 */
                var outSideClick = function (event)
                {
                    var isChild = formEl.has(event.target).length > 0;
                    var isSelf = formEl[0] === event.target;
                    var isInside = isChild || isSelf;

                    if ( !isInside )
                    {
                        toggleForm();
                    }
                };
            }
        };
    }
})();
(function () {
  'use strict';

  angular
    .module('app.scrumboard')
    .controller('ScrumboardLeadDialogController', ScrumboardLeadDialogController);

  /** @ngInject */
  function ScrumboardLeadDialogController($scope, $state, $rootScope, $document, $mdDialog, $timeout, $filter, $http, config, fuseTheming, fuseGenerator, $q, msApi, msUtils, BoardService, leadId, data, remarks, $mdToast) {
    var vm = this;
    $scope.role = data.role;
    // Data
    vm.board = BoardService.data;
    vm.user_id = data.user_id;
    vm.company = data.company;

    vm.newLabelColor = 'red';
    vm.members = vm.board.members;
    vm.labels = vm.board.labels;

    // vm.sources = data.Sources;
    vm.sources = vm.company.lead_source;
    console.log( vm.board);
    if (leadId) {
      vm.lead = vm.board.leads.getById(leadId);
    }
    else {
      vm.lead = {
        'id': 0,
        'user_id': vm.user_id,
        'creator_id': vm.user_id,
        idContact: [],
        'source_id':  vm.board.leads_source_default
      };
    }
    vm.leadUser = [
      vm.lead.user_id
    ];
    vm.lead.phone_number = (vm.lead.phone_number) ? vm.lead.phone_number.replace(/^(0|63|\+63)+/, '') : "";
    vm.property = (vm.lead.opportunity && vm.lead.opportunity.property) ? vm.lead.opportunity.property : [];
    vm.priority = data.Priority;
    vm.phoneCode = '+63';
    vm.crmUrl = config.crmUrl;
    $scope.selectedIndex = 0;
    $scope.btnSave = 'yes0';

    // project property
    vm.projects = data.Projects;
    vm.projectCompany = data.company.project;
    vm.projectName = projectName;
    vm.projectQuerySearch = projectQuerySearch;
    vm.filterProject = filterProject;
    vm.project = {};
    vm.widgetProperty = true;
    vm.widgetProject = false;
    vm.toggleWidget = toggleWidget;
    vm.isSelected = isSelected;

    vm.priorityValue = function (id) {
      return $filter('filter')(vm.priority, {id: id})[0];
    }

//        vm.remarks = remarks;
    vm.customfields = vm.board.customfields;

    // disabled fieldset
//        .attr('disabled', true);
//        .css({background: 'red'});

    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleWidget(button, id) {
      if (button == 'property') {
        vm.project = {};
        vm.widgetProperty = true;
        vm.widgetProject = false;
      }
      else if (button == 'project') {
        vm.widgetProject = true;
        vm.widgetProperty = false;

        // get all property from project key
        if (id)
          vm.promise = getProjectData(id);
      }
    }

    /**
     * Get board data from the server
     *
     * @param boardId
     * @returns {*}
     */
    function getProjectData(id) {
      // Create a new deferred object
      var deferred = $q.defer();

      // Show loader
      vm.loadingProgress = true;

      msApi.request('project.project@get', {id: id},

        // SUCCESS
        function (response) {
          // Attach the data
          vm.project = response.data;
          vm.project.property = response.data.property;

          // Resolve the promise
          deferred.resolve(response);

          // Hide loader
          vm.loadingProgress = false;
        },

        // ERROR
        function (response) {
          // Reject the promise
          deferred.reject(response);
        }
      );

      return deferred.promise;
    }

    vm.selectedProperty = [];
    vm.limitOptions = undefined;
    vm.addSelectedProperties = addSelectedProperties;
    vm.deleteProperty = deleteProperty;
    vm.deleteSelectedProperties = deleteSelectedProperties;

    vm.options = {
      rowSelection: true,
      multiSelect: true,
      autoSelect: true,
      decapitate: false,
      largeEditDialog: false,
      boundaryLinks: false,
      limitSelect: false,
      pageSelect: true
    };

    vm.query = {
      order: '-id',
      limit: 5,
      page: 1
    };

    /**
     * Add Selected Property
     */
    function addSelectedProperties(ev) {
      vm.selectedProperty.forEach(function (property) {
        // add to vm.property
        property.pivot = {property_id: property.id, price: property.price, discount: property.discount};
        vm.property.push(property);

        vm.pivotProperty('attach', property);
      });

      vm.selectedProperty = [];
    }

    /**
     * Delete Property
     */
    function deleteProperty(property) {
      vm.property.splice(vm.property.indexOf(property), 1);

      vm.pivotProperty('detach', property);
    }

    /**
     * Delete Selected Property
     */
    function deleteSelectedProperties(ev) {
      var confirm = $mdDialog.confirm({
        title: 'Are you sure want to delete the selected property?',
        parent: $document.find('#scrumboard'),
        htmlContent: '<b>' + vm.selectedProperty.length + ' selected</b>' + ' will be deleted.',
        ariaLabel: 'delete property',
        targetEvent: ev,
        clickOutsideToClose: true,
        preserveScope: true,
        autoWrap: true,
        skipHide: true,
        ok: 'OK',
        cancel: 'CANCEL'
      });
      ;

      $mdDialog.show(confirm).then(function () {

        vm.selectedProperty.forEach(function (property) {
          deleteProperty(property);
        });

        vm.selectedProperty = [];

      });

    }

    // board options
    if (leadId == null) {
      vm.lead.board_id = vm.board.id;
      vm.lead.status_id = vm.board.stages[0].id;
    }

    vm.getBoard = function (getAll) {
      if (getAll)
        return;
      else
        return (vm.lead.board_id) ? ($filter('filter')(data.Boards, {id: vm.lead.board_id}))[0]['title'] : null;
    };
    vm.getStage = function (getAll) {
      if (getAll)
        return (vm.lead.board_id) ? ($filter('filter')(vm.board.stages, {board_id: vm.lead.board_id})) : [];
      else
        return (vm.lead.status_id) ? ($filter('filter')(data.Stages, {id: vm.lead.status_id}))[0] : null;
    };

    vm.boards = data.Boards;
    vm.stagesOptions = vm.getStage(true);
    vm.stages = vm.board.stages;

    vm.stage = vm.board.stages;
    vm.stage = vm.getStage();

//        vm.opportunity_status = data.OppStatus;
    vm.opportunity_status = vm.company.opportunity_status;
//        vm.acitivity_status = data.AcitivityStatus;
    vm.acitivity_status = vm.company.activity_status;
    console.log(vm.acitivity_status);
    vm.incompleted_id = ($filter('filter')(vm.acitivity_status, {value: 'Not started'}))[0]['id'];
    vm.completed_id = ($filter('filter')(vm.acitivity_status, {value: 'Completed'}))[0]['id'];

    // location
    vm.getRegion = function (getAll) {
      if (getAll)
        return;
      else
        return (vm.lead.region_id) ? ($filter('filter')(data.Regions, {id: vm.lead.region_id}))[0]['short_name'] : null;
    };
    vm.getProvince = function (getAll) {
      if (getAll)
        return (vm.lead.region_id) ? ($filter('filter')(data.Provinces, {region_id: vm.lead.region_id})) : [];
      else
        return (vm.lead.province_id) ? ($filter('filter')(data.Provinces, {id: vm.lead.province_id}))[0]['value'] : null;
    };
    vm.getCity = function (getAll) {
      if (getAll)
        return (vm.lead.province_id) ? ($filter('filter')(data.Cities, {province_id: vm.lead.province_id})) : [];
      else
        return (vm.lead.city_id) ? ($filter('filter')(data.Cities, {id: vm.lead.city_id}))[0]['value'] : null;
    };
    vm.getRegionProvinces = function () {
      vm.provinces = vm.getProvince(true);
      vm.cities = [];
      vm.lead.province_id = null;
      vm.lead.city_id = null;
    };
    vm.getProvinceCities = function () {
      vm.cities = vm.getCity(true);
    };
    vm.regions = data.Regions;
    vm.region = vm.getRegion();
    vm.provinces = vm.getProvince(true);
    vm.province = vm.getProvince();
    vm.cities = vm.getCity(true);
    vm.city = vm.getCity();

    // Methods
    vm.palettes = fuseTheming.getRegisteredPalettes();
    vm.rgba = fuseGenerator.rgba;
    vm.toggleInArray = msUtils.toggleInArray;
    vm.exists = msUtils.exists;
    vm.closeDialog = closeDialog;
    vm.getLeadStage = getLeadStage;
    vm.removeLead = removeLead;
    vm.addActivity = addActivity;
    /* Attachment */
    vm.toggleCoverImage = toggleCoverImage;
    vm.removeAttachment = removeAttachment;
    /* Labels */
    vm.labelQuerySearch = labelQuerySearch;
    vm.filterLabel = filterLabel;
    vm.addNewLabel = addNewLabel;
    vm.removeLabel = removeLabel;
    /* Members */
    vm.memberQuerySearch = memberQuerySearch;
    vm.filterMember = filterMember;
    /* Checklist */
    vm.updateCheckedCount = updateCheckedCount;
    vm.addCheckItem = addCheckItem;
    vm.removeChecklist = removeChecklist;
    vm.removeChecklistItem = removeChecklistItem;
    vm.createCheckList = createCheckList;
    /* Comment */
    vm.addNewComment = addNewComment;

    //////////

    vm.updateBoard = function (stage_id) {
      console.log($scope.leadForm);
      vm.lead.board = $filter('filter')(vm.boards, {id: vm.lead.board_id})[0];
      vm.stagesOptions = vm.lead.board.stages;
        console.log(vm.stagesOptions);
      vm.lead.status_id = (stage_id) ? stage_id : vm.stagesOptions[0].id;
    };

    var board_id = vm.lead.board_id;
    var status_id = vm.lead.status_id;
    var change_board, change_stage = false;
    $scope.$watch('vm.lead.board_id', function (newValue, oldValue) {
      change_board = (newValue != board_id) ? true : false;
    }, true);
    $scope.$watch('vm.lead.status_id', function (newValue, oldValue) {
      change_stage = (newValue != status_id) ? true : false;
    }, true);

    /**
     * saveLead
     */
    vm.saveLead = function () {
      vm.lead.permission = vm.board.permission;

      $http({
        url: config.apiUrl + 'lead/update',
        method: 'POST',
        data: {lead: vm.lead}
      }).then(function (response) {
//                var newLeadId = response.data.changes.leads.id;
//                var lastId = (vm.leads.length - 1);
//
//                vm.leads[lastId].id = newLeadId;
//                vm.stage.idLeads.push(newLeadId);
        var newLead = response.data.changes.new;
        if (newLead) {
          vm.lead.id = newLead.id; // change the vm.lead.id from 0 to newId

//                    // check if in diff board
//                    vm.board.leads.push(newLead);
//                    vm.stage = vm.board.stages.getById(newLead.status_id);
//                    vm.stage.idLeads.push(newLead.id);
          // changed to reload then trigger click
          $state.go('app.scrumboard.boards.board', {id: vm.lead.board_id, newLeadId: vm.lead.id, isNew: false});
        }
        else {
          if ($scope.selectedIndex == 1) {
            vm.lead.opportunity.price = response.data.changes.lead.opportunity.price;

            if (!$scope.leadForm.$pristine) {
              $scope.leadForm.price.$pristine = true;
              $scope.leadForm.status_id.$pristine = true;
              $scope.leadForm.reason.$pristine = true;
              $scope.leadForm.description.$pristine = true;
            }
          }
          else {
            // set if board_id change from distribution
            if (vm.lead.board_id != response.data.changes.lead.board_id) {
              change_board = true;
              vm.lead.board_id = response.data.changes.lead.board_id;
            }
            if (vm.lead.status_id != response.data.changes.lead.status_id) {
              vm.updateBoard(response.data.changes.lead.status_id);
              change_stage = true;
            }

//                        $scope.leadForm.$pristine = true;

            // if the user of the lead != to user then remove that lead
            var change_user = (vm.lead.user_id != vm.user_id);

            // remove in the board only, no need to move to another board coz it is already getting by api
            if (change_board || change_user)
              vm.board.leads.splice(vm.board.leads.indexOf(vm.lead), 1);

            // remove in the stages to another stages
            if (change_stage || change_user) {
              var leadStage = getLeadStage();
              leadStage.idLeads.splice(leadStage.idLeads.indexOf(vm.lead.id), 1);

              // remove in the stages to another stages
              if (!change_board && !change_user) {
                vm.stage = vm.board.stages.getById(vm.lead.status_id);
                vm.stage.idLeads.push(vm.lead.id);
              }
            }

            if (vm.board.id != vm.lead.board_id) {
              $state.go('app.scrumboard.boards.board', {id: vm.lead.board_id, newLeadId: vm.lead.id, isNew: false});
            }
          }
        }

        $mdToast.show({
          template:
          '<md-toast>' +
          '<div class="md-toast-content">' +
          '<strong class="md-accent-fg">Success!</strong>&nbsp;&nbsp;' +
          'Lead has been saved.' +
          '</div>' +
          '</md-toast>',
          hideDelay: 3000,
          position: 'top right'
        });

      }, function (response) {
//                console.log(response, " error occurs!");
        if (response.data.error)
          $mdToast.show({
            template:
            '<md-toast>' +
            '<div class="md-toast-content">' +
            '<strong class="md-warn-fg">Sorry!</strong>&nbsp;&nbsp;' +
            response.data.error +
            '</div>' +
            '</md-toast>',
            hideDelay: 3000,
            position: 'top right'
          });
      });
    };

    /**
     * detach attach
     */
    vm.pivotProperty = function (type, property) {
      $http({
        url: config.apiUrl + 'property/pivot',
        method: 'POST',
        data: {
          type: type,
          property: property,
          user_id: $rootScope.currentUser.id,
          opportunity_id: vm.lead.opportunity.id
        }
      }).then(function (response) {
        vm.lead.opportunity.price = response.data.return.price;
        $scope.leadForm.price.$setDirty();

        if (type == 'attach') {
          vm.toggleWidget('property');
        }

      }, function (response) {
        console.log(response, " error occurs!");
      });
    };

    /**
     * Close Dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }

    /**
     * Get Lead Stage
     */
    function getLeadStage() {
      var response;
      for (var i = 0, len = vm.board.stages.length; i < len; i++) {
        if (vm.board.stages[i].idLeads.indexOf(vm.lead.id) > -1) {
          response = vm.board.stages[i];
          break;
        }
      }
      return response;
    }

    /**
     * Remove lead
     *
     * @param ev
     */
    function removeLead(ev, type) {
      var confirm = $mdDialog.confirm({
        title: 'Remove Lead',
        parent: $document.find('#scrumboard'),
        textContent: 'Are you sure want to remove lead?',
        ariaLabel: 'remove lead',
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        ok: 'Remove',
        cancel: 'Cancel'
      });

      $mdDialog.show(confirm).then(function () {
        var leadStage = getLeadStage();

        leadStage.idLeads.splice(leadStage.idLeads.indexOf(vm.lead.id), 1);

        vm.board.leads.splice(vm.board.leads.indexOf(vm.lead), 1);

        vm.onDelete({model: type, checked: [vm.lead.id]});

      }, function () {
        // Canceled
      });
    }

    /**
     * onDelete
     */
    vm.onDelete = function (data) {
      $http({
        url: config.apiUrl + 'model/delete',
        method: 'DELETE',
        headers: {'Content-Type': 'application/json'},
        data: data
      }).then(function (response) {
        // this callback will be called asynchronously
        // when the response is available
//                console.log(response, " response is available!");
      }, function (response) {
        // called asynchronously if an error occurs
        // or server returns response with an error status.
        console.log(response, " error occurs!");
      });
    };

    /**
     * Toggle cover image
     *
     * @param attachmentId
     */
    function toggleCoverImage(attachmentId) {
      if (attachmentId === vm.lead.idAttachmentCover) {
        vm.lead.idAttachmentCover = null;
      }
      else {
        vm.lead.idAttachmentCover = attachmentId;
      }
    }

    /**
     * Remove attachment
     *
     * @param item
     */
    function removeAttachment(item) {
      if (vm.lead.idAttachmentCover === item.id) {
        vm.lead.idAttachmentCover = '';
      }
      vm.lead.attachments.splice(vm.lead.attachments.indexOf(item), 1);
    }

    /**
     * Add label chips
     *
     * @param query
     * @returns {filterFn}
     */
    function labelQuerySearch(query) {
      return query ? vm.labels.filter(createFilterFor(query)) : [];
    }

    /**
     * Label filter
     *
     * @param label
     * @returns {boolean}
     */
    function filterLabel(label) {
      if (!vm.labelSearchText || vm.labelSearchText === '') {
        return true;
      }

      return angular.lowercase(label.name).indexOf(angular.lowercase(vm.labelSearchText)) >= 0;
    }

    /**
     * Add new label
     */
    function addNewLabel() {
      vm.board.labels.push({
        id: msUtils.guidGenerator(),
        name: vm.newLabelName,
        color: vm.newLabelColor
      });

      vm.newLabelName = '';
    }

    /**
     * Remove label
     */
    function removeLabel() {
      var arr = vm.board.labels;
      arr.splice(arr.indexOf(arr.getById(vm.editLabelId)), 1);

      angular.forEach(vm.board.leads, function (lead) {
        if (lead.idLabels && lead.idLabels.indexOf(vm.editLabelId) > -1) {
          lead.idLabels.splice(lead.idLabels.indexOf(vm.editLabelId), 1);
        }
      });

      vm.newLabelName = '';
    }

    /**
     * Add member chips
     *
     * @param query
     * @returns {Array}
     */
    function memberQuerySearch(query) {
      return query ? vm.members.filter(createFilterFor(query)) : [];
    }

    /**
     * Member filter
     *
     * @param member
     * @returns {boolean}
     */
    function filterMember(member) {
      if (!vm.memberSearchText || vm.memberSearchText === '') {
        return true;
      }

      return angular.lowercase(member.name).indexOf(angular.lowercase(vm.memberSearchText)) >= 0;
    }

    function projectName(project_id) {
      return ($filter('filter')(vm.projectCompany, {id: project_id}))[0]['name'];
    }

    function isSelected(property_id) {
      return ($filter('filter')(vm.property, {id: property_id})).length > 0;
    }

    /**
     * Add member chips
     *
     * @param query
     * @returns {Array}
     */
    function projectQuerySearch(query) {
      return query ? vm.projects.filter(createFilterFor(query)) : [];
    }

    /**
     * Member filter
     *
     * @param member
     * @returns {boolean}
     */
    function filterProject(project) {
      if (!vm.projectSearchText || vm.projectSearchText === '') {
        return true;
      }

      return angular.lowercase(project.name).indexOf(angular.lowercase(vm.projectSearchText)) >= 0;
    }

    /**
     * Update check list stats
     * @param list
     */
    function updateCheckedCount(list) {
      var activity_items = list.activity_items;
      var checkedItems = 0;
      var allCheckedItems = 0;
      var allCheckItems = 0;

      angular.forEach(activity_items, function (checkItem) {
        if (checkItem.checked) {
          checkedItems++;
        }
      });

      list.activity_itemsChecked = checkedItems;

      angular.forEach(vm.lead.activity_type, function (item) {
        allCheckItems += item.activity_items.length;
        allCheckedItems += item.activity_itemsChecked;
      });

      vm.lead.activity_items = allCheckItems;
      vm.lead.activity_itemsChecked = allCheckedItems;
    }

    /**
     * Add checklist item
     *
     * @param text
     * @param checkList
     */
    function addCheckItem(text, checkList, item) {
      if (!text || text === '') {
        return;
      }

      var newCheckItem = {
        'id': 0,
        'user_id': $rootScope.currentUser.id,
        'lead_id': vm.lead.id,
        'type_id': vm.lead.activity_type[checkList].id,
        'subject': text,
        'status_id': vm.board.activity_source_default,
        'priority_id': 1
      };
      if (item) {
        newCheckItem['date_deadline'] = (item.date_deadline) ? item.date_deadline : null;
      }

      vm.lead.activity_type[checkList].activity_items.push(newCheckItem);
      var new_key = (vm.lead.activity_type[checkList].activity_items.length - 1);

      vm.saveActivity(checkList, new_key);
    }

    /**
     * saveActivity
     */
    vm.saveActivity = function (checkList, new_key) {
      $http({
        url: config.apiUrl + 'activity/update',
        method: 'POST',
        data: {activity_type: vm.lead.activity_type}
      }).then(function (response) {
        if (typeof new_key !== 'undefined')
          vm.lead.activity_type[checkList].activity_items[new_key].id = response.data.return.activity.id;

        $mdToast.show({
          template:
          '<md-toast>' +
          '<div class="md-toast-content">' +
          '<strong class="md-accent-fg">Success!</strong>&nbsp;&nbsp;' +
          'Activity has been saved.' +
          '</div>' +
          '</md-toast>',
          hideDelay: 3000,
          position: 'top right'
        });

      }, function (response) {
        console.log(response, " error occurs!");
      });
    };

    /**
     * saveRemark
     */
    vm.saveRemark = function (remark) {
      $http({
        url: config.apiUrl + 'remark/update',
        method: 'POST',
        data: {lead_id: vm.lead.id, board_id: vm.lead.board_id, status_id: vm.lead.status_id, data: remark}
      }).then(function (response) {
        vm.board.leads[vm.board.leads.indexOf(vm.lead)].remarks_count = parseInt(vm.board.leads[vm.board.leads.indexOf(vm.lead)].remarks_count) + 1;
        vm.board.leads[vm.board.leads.indexOf(vm.lead)].remarks = response.data.return;
        // clear all values in customfields
        vm.remark = '';

        $mdToast.show({
          template:
          '<md-toast>' +
          '<div class="md-toast-content">' +
          '<strong class="md-accent-fg">Success!</strong>&nbsp;&nbsp;' +
          'Remark has been saved.' +
          '</div>' +
          '</md-toast>',
          hideDelay: 3000,
          position: 'top right'
        });

      }, function (response) {
        console.log(response, " error occurs!");
      });
    };

    /**
     * Remove checklist
     *
     * @param item
     */
    function removeChecklist(item) {
      vm.lead.activity_type.splice(vm.lead.activity_type.indexOf(item), 1);

      angular.forEach(vm.lead.activity_type, function (list) {
        updateCheckedCount(list);
      });
    }

    /**
     * Remove checklist Item
     *
     * @param item
     */
    function removeChecklistItem(item, list, type) {
      list.splice(list.indexOf(item), 1);

      angular.forEach(vm.lead.activity_type, function (list) {
        updateCheckedCount(list);
      });

      vm.onDelete({model: type, checked: [item.id]});
    }

    /**
     * onDelete
     */
    vm.onDelete = function (data) {
      $http({
        url: config.apiUrl + 'model/delete',
        method: 'DELETE',
        headers: {'Content-Type': 'application/json'},
        data: data
      }).then(function (response) {
        // this callback will be called asynchronously
        // when the response is available
//                console.log(response, " response is available!");
      }, function (response) {
        // called asynchronously if an error occurs
        // or server returns response with an error status.
        console.log(response, " error occurs!");
      });
    };

    /**
     * Create checklist
     */
    function createCheckList() {
      vm.lead.activity_type.push({
        id: msUtils.guidGenerator(),
        name: vm.newCheckListTitle,
        activity_itemsChecked: 0,
        activity_items: []
      });

      vm.newCheckListTitle = '';
    }

    /**
     * Add new comment
     *
     * @param newCommentText
     */
    function addNewComment(newCommentText) {
      var newComment = {
        idMember: '36027j1930450d8bf7b10158',
        message: newCommentText,
        time: 'now'
      };

      vm.lead.comments.unshift(newComment);
    }

    /**
     * Filter for chips
     *
     * @param query
     * @returns {filterFn}
     */
    function createFilterFor(query, email) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(item) {
        var search = (email) ? item.email : item.name;
        return angular.lowercase(search).indexOf(lowercaseQuery) >= 0;
      };
    }

    /**
     * Filter for chips
     *
     * @param query
     * @returns {filterFn}
     */
    function employeeFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(item) {
        return angular.lowercase(item.user.name).indexOf(lowercaseQuery) >= 0;
      };
    }

    /**
     * Add Activity
     *
     * @param ev
     */
    function addActivity(ev, btnSave) {
      if (btnSave == "yes1") {
        $mdDialog.show({
          clickOutsideToClose: false,
          controller: function ($mdDialog) {
            // Save the clicked item
            this.item = btnSave;

            this.activity_type = vm.lead.activity_type;
            this.acitivity_status = vm.acitivity_status;

            // Setup some handlers
            this.close = function () {
              $mdDialog.cancel();
            };
            this.submit = function (text, checkList, item) {
              $mdDialog.hide();

              vm.addCheckItem(text, checkList, item);

              $scope.selectedIndex = 2;
              $scope.btnSave = '';
            };
          },
          controllerAs: 'dialog',
          templateUrl: 'dialog.html',
          targetEvent: ev,
          parent: $document.find('#scrumboard'),
          skipHide: true
        });
      }
    };

    /* Members */
    vm.employeeQuerySearch = employeeQuerySearch;
    vm.employees = vm.company.employee;

    /**
     * Add member chips
     *
     * @param query
     * @returns {Array}
     */
    function employeeQuerySearch(query) {
      return query ? vm.employees.filter(employeeFilterFor(query)) : [];
    }

    vm.setFocus = function () {
      setTimeout(function () {
        document.querySelector('#autoCompleteId').focus();
      }, 0);
    };

    /* Contacts */
    vm.contactQuerySearch = contactQuerySearch;
    vm.contacts = data.Contacts || [];

    /**
     * Add member chips
     *
     * @param query
     * @returns {Array}
     */
    function contactQuerySearch(query) {
      return query ? vm.contacts.filter(createFilterFor(query, true)) : [];
    }

    vm.closeList = function (e) {
      var autoChild = document.getElementById('contactId').firstElementChild;
      var el = angular.element(autoChild);
      el.scope().$mdAutocompleteCtrl.hidden = true;

      var virtual = angular.element(document.querySelector('md-virtual-repeat-container'));
      virtual.removeClass('md-not-found');
    };

    /**
     * Add Contact
     *
     * @param ev
     */
    vm.addContact = function (ev, contact) {
      contact.id = 0;
//            $mdAutocompleteCtrl.listLeave()
//            document.querySelector('md-virtual-repeat-container').classList.add('ng-hide');
//            document.querySelector('md-virtual-repeat-container').addClass('ng-hide');
//            var virtual = angular.element( document.querySelector( 'md-virtual-repeat-container' ) );
//            virtual.addClass('ng-hide');

//            var autoChild = document.getElementById('contactId').firstElementChild;
//            var el = angular.element(autoChild);
//            el.scope().$mdAutocompleteCtrl.listLeave();
//            el.scope().$mdAutocompleteCtrl.hidden = true;

      $mdDialog.show({
        clickOutsideToClose: false,
        controller: ContactController,
        controllerAs: 'contact',
        templateUrl: 'contact.html',
        targetEvent: ev,
        parent: $document.find('#scrumboard'),
        locals: {
          contact: contact,
          user_id: vm.user_id,
          phoneCode: vm.phoneCode
        },
        skipHide: true
      });
    };

    function ContactController($scope, $mdDialog, contact, user_id, phoneCode) {
      var _contact = vm.contactQuerySearch(contact.email)[0];
      if (_contact) {
        if (contact.phone_number !== _contact.mobile_phone1 && contact.phone_number !== _contact.mobile_phone2) {
          if (_contact.mobile_phone1)
            _contact.mobile_phone2 = contact.phone_number;
        }

        contact = _contact;
      }
      else {
        if (contact.email.lastIndexOf("@") !== -1)
          contact.name = contact.email.substring(0, contact.email.lastIndexOf("@"));
        else {
          contact.name = contact.email;
          contact.email = '';
        }

        contact.mobile_phone1 = contact.phone_number;
      }

      this.dContact = {
        id: contact.id,
        user_id: user_id,
        company_id: vm.company.id,
        first_name: contact.name,
        email: contact.email,
        mobile_phone1: contact.mobile_phone1,
        mobile_phone2: contact.mobile_phone2
      };

      this.phoneCode = phoneCode;

      // Setup some handlers
      this.close = function () {
        $mdDialog.cancel();
      };

      this.submit = function (item) {
        $mdDialog.hide();
        var data = {model: 'contact', data: [this.dContact]};

        $http({
          url: config.apiUrl + 'model/update',
          method: 'POST',
          data: data
        }).then(function (response) {
          var new_contact = response.data.updated.new;

          if (new_contact) {
            vm.lead.idContact.push(new_contact.id);
            vm.contacts.unshift(new_contact);

            vm.searchContact = "";
            setTimeout(function () {
              document.querySelector('#contactId').focus();
            }, 0);
          }
          else {
            vm.contactKey = vm.contacts.indexOf(vm.contacts.getById(contact.id));
            item.name = $.grep([item.first_name, item.last_name], Boolean).join(" "); // foo, bar
            vm.contacts[vm.contactKey] = item;
            vm.lead.idContact.push(contact.id);
          }
          // this callback will be called asynchronously
          // when the response is available
//                    console.log(response, " response is available!");
        }, function (response) {
          // called asynchronously if an error occurs
          // or server returns response with an error status.
          console.log(response, " error occurs!");
        });
      };
    }

    // OPPORTUNITIES
    if (vm.lead.opportunity) {
      vm.invoice = {
        "from": {
          "title": vm.company.name,
          "address": vm.company.address,
          "phone": vm.company.telephone,
          "email": vm.company.email,
          "website": vm.company.website
        },
        "client": {
          "title": vm.lead.first_name + " " + vm.lead.last_name,
          "address": vm.lead.address,
          "phone": vm.lead.telephone,
          "email": vm.lead.email
        },
        "number": vm.lead.name,
        "date": moment().format('MMM DD YYYY'),
        "dueDate": moment(new Date(vm.lead.opportunity.date_close)).format('MMM DD YYYY'),
        "services": [
          {
            "title": "Prototype & Design",
            "detail": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus accumsan, quam sed eleifend imperdiet.",
            "unit": "Hour",
            "unitPrice": "12.00",
            "quantity": "240",
            "total": "2880"
          },
          {
            "title": "Coding",
            "detail": "Vestibulum ligula sem, rutrum et libero id, porta vehicula metus. Cras dapibus neque sit amet laoreet vestibulum.",
            "unit": "Hour",
            "unitPrice": "10.50",
            "quantity": "350",
            "total": "3675"
          },
          {
            "title": "Testing",
            "detail": "Pellentesque luctus efficitur neque in finibus. Integer ut nunc in augue maximus porttitor id id nulla. In vitae erat.",
            "unit": "Hour",
            "unitPrice": "4.00",
            "quantity": "50",
            "total": "200"
          },
          {
            "title": "Documentation & Training",
            "detail": "Pellentesque luctus efficitur neque in finibus. Integer ut nunc in augue maximus porttitor id id nulla. In vitae erat.",
            "unit": "Hour",
            "unitPrice": "6.50",
            "quantity": "260",
            "total": "1690"
          }
        ],
        "subtotal": vm.lead.opportunity.price,
        "tax": "0",
        "discount": "0",
        "total": vm.lead.opportunity.price
      };
    }

    vm.printDiv = function () {
      printElement(document.getElementById("invoice"));

      window.print();
    }

    function printElement(elem) {
      var domClone = elem.cloneNode(true);

      var $printSection = document.getElementById("printSection");

      if (!$printSection) {
        var $printSection = document.createElement("div");
        $printSection.id = "printSection";
        document.body.appendChild($printSection);
      }

      $printSection.innerHTML = "";

      $printSection.appendChild(domClone);
    }

    // if permission == 'none' || permission == 'view' not allowed
    vm.isDisabled = (vm.board.permission != 'modify');
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.employees')
        .controller('EmployeeDialogController', EmployeeDialogController);

    /** @ngInject */
    function EmployeeDialogController($http, $scope, $mdDialog, User, Employee, Employees, msUtils, config, $auth, Upload, role, $mdToast)
    {
        var vm = this;

        // Data
        vm.title = 'Edit Employee';
        vm.employee = angular.copy(Employee);
        vm.employees = Employees;
        vm.crmUrl = config.crmUrl;
        
        $scope.role = role;
        
        vm.newEmployee = false;
        vm.allFields = false;

        vm.user = User.data;
        
        if ( !vm.employee )
        {   
            vm.employee = {
                'id'         : msUtils.guidGenerator(),
                'first_name' : '',
                'last_name'  : '',
                'avatar'     : 'assets/images/avatars/profile.jpg',
                'company_id' : vm.user.company.id,
                'creator_id' : vm.user.id,
                'job_title'  : '',
                'email'      : '',
                'telephone'  : '',
                'address'    : '',
                'date_birth' : null,
                'user'       : {}
            };

            vm.title = 'New Employee';
            vm.newEmployee = true;
        }
        else
        {
            vm.employee.date_birth = (vm.employee.date_birth) ? new Date(vm.employee.date_birth) : null;
        }

        // Methods
        vm.addNewEmployee = addNewEmployee;
        vm.saveEmployee = saveEmployee;
        vm.groupEmployee = groupEmployee;
        vm.deleteEmployeeConfirm = deleteEmployeeConfirm;
        vm.closeDialog = closeDialog;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        vm.phoneCode = '+63';
        
        //////////
        
        // upload later on form submit or something similar
        vm.uploadFiles = function (files, attachment_id) {
            $scope.files = files;
            if (files && files.length) {
                Upload.upload({
                    url: config.apiUrl + 'file/update',
                    data: {
                        files: files,
                        field: 'avatar',
                        attachment_id: attachment_id,
                        attachment_type: 'RainLab\\User\\Models\\User'
                    }
                }).then(function (response) {
                    
                    $scope.$evalAsync(function ()
                    {
                        var avatar = response.data.return[0];
                        vm.employee.user.avatar = avatar;
                        
                        // for employees
                        var key = vm.employees.indexOf(Employee);
                        vm.employees[key].user.avatar = avatar;
                        
                        // for toolbar
//                        vm.user.employee.user.avatar = avatar;
                    });
                    
                }, function (response) {
//                    // called asynchronously if an error occurs
//                    // or server returns response with an error status.
                    console.log(response, " error occurs!");
                });
            }
        };

        /**
         * Add new employee use signup function but with company_id
         */
        function addNewEmployee()
        {
            vm.employee.username = vm.employee.email; // use email = username
            vm.employee.name = vm.employee.first_name; // use name = first_name
            
            vm.form = vm.employee;
            
            $auth.signup(vm.form)
                .then(function (response) {
                        // Redirect user here to login page or perhaps some other intermediate page
                        // that requires email address verification before any other part of the site
                        // can be accessed.
                        // if with token
                        vm.employee.id = parseInt(response.data.token.id);
                        vm.employee.user.groups = response.data.token.groups;
                        vm.employees.unshift(vm.employee);

                        var index = vm.user.groups.map(function(o) { return o.id; }).indexOf(vm.employee.user.groups[0].id);
                        vm.user.groups[index].users_id.push(vm.employee.id);
                        
                        closeDialog();
                })
                .catch(function (error) {
                    /*
                     *  TODO: validations
                     */
                    // Handle errors here.
                    vm.errors = error.data;
                    console.log(vm.errors);
                });
        }

        /**
         * Save employee
         */
        function saveEmployee()
        {
            // Dummy save action
            for ( var i = 0; i < vm.employees.length; i++ )
            {
                if ( vm.employees[i].id === vm.employee.id )
                {
                    vm.employees[i] = angular.copy(vm.employee);
                    delete vm.employees[i].name;
                    vm.saveUser(vm.employees[i]);
                    break;
                }
            }
            closeDialog();
        }

        /**
         * Group employee
         */
        function groupEmployee(type, group)
        {
//            vm.employee.user.groups.push(group);
            $http({
                url: config.apiUrl + 'group/update',
                method: 'POST',
                data: {type: type, employee_id: vm.employee.id, group: group}
            }).then(function (response) {
                // this callback will be called asynchronously
                // when the response is available
//                console.log(response, " response is available!");
                vm.user.groups = response.data.data.groups;
                
                $mdToast.show({
                    template:
                        '<md-toast>' +
                            '<div class="md-toast-content">' +
                                '<strong class="md-accent-fg">Success!</strong>&nbsp;&nbsp;'+
                                'Employee has been saved.' +
                            '</div>' +
                        '</md-toast>',
                    hideDelay: 3000,
                    position: 'top right'
                });
                
            }, function (response) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
                console.log(response, " error occurs!");
            });
        }
        
        //////////
        /**
         * saveProfile
         */
        vm.saveUser = function(employees)
        {
            vm.user['employee'] = employees;
            
            $http({
                url: config.apiUrl + 'user/update',
                method: 'POST',
                data: vm.user
            }).then(function (response) {
                // this callback will be called asynchronously
                // when the response is available
                console.log(response, " response is available!");
                
                $mdToast.show({
                    template:
                        '<md-toast>' +
                            '<div class="md-toast-content">' +
                                '<strong class="md-accent-fg">Success!</strong>&nbsp;&nbsp;'+
                                'Employee has been saved.' +
                            '</div>' +
                        '</md-toast>',
                    hideDelay: 3000,
                    position: 'top right'
                });
                
            }, function (response) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
                console.log(response, " error occurs!");
            });
        };

        /**
         * Delete Employee Confirm Dialog
         */
        function deleteEmployeeConfirm(ev, data, type)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the employee?')
                .htmlContent('<b>' + data.first_name + ' ' + (data.last_name ? data.last_name : '') + '</b>' + ' will be deleted.')
                .ariaLabel('delete employee')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {
                vm.onDelete({model: type, checked: [data.id]});

                vm.employees.splice(vm.employees.indexOf(Employee), 1);
                
                vm.selectedEmployees = [];

            });
        }
        
        //////////
        /**
         * onDelete
         */
        vm.onDelete = function(data)
        {
            $http({
                url: config.apiUrl + 'model/delete',
                method: 'DELETE',
                headers: {'Content-Type': 'application/json'},
                data: data
            }).then(function (response) {
                // this callback will be called asynchronously
                // when the response is available
//                console.log(response, " response is available!");
            }, function (response) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
                console.log(response, " error occurs!");
            });
        };

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.contacts',
            [
                // 3rd Party Dependencies
                'xeditable'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        $stateProvider.state('app.contacts', {
            url    : '/contacts',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/contacts/contacts.html',
                    controller : 'ContactsController as vm'
                }
            },
            resolve: {
                Contacts: function (msApi)
                {
                    return msApi.resolve('contacts.contacts@get');
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/contacts');

        // Api
        msApiProvider.register('contacts.contacts', ['app/data/contacts/contacts.json']);
        msApiProvider.register('contacts.user', ['app/data/contacts/user.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('apps.contacts.contacts', {
            title : 'Contacts',
            state : 'app.contacts',
            icon  : 'icon-account-box',
            weight: 3
        });

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.contacts')
        .controller('ContactDialogController', ContactDialogController);

    /** @ngInject */
    function ContactDialogController($http, $scope, $mdDialog, Contact, User, data, $filter, config, msUtils, Upload, $mdToast)
    {
        var vm = this;

        // Data
        vm.title = 'Edit Contact';
        vm.user = User;
        vm.company = vm.user.company;
        vm.contacts = vm.company.contact;
        // or ???
//        vm.contacts = vm.user.contact;
        vm.contact = angular.copy(Contact);
        vm.newContact = false;
        vm.allFields = false;
        vm.crmUrl = config.crmUrl;
        vm.contactCompany = [];
        
        if ( !vm.contact )
        {
            vm.contact = {
                'id'         : 0,
                'first_name' : '',
                'last_name'  : '',
                'company_id' : vm.user.company.id,
                'user_id'    : vm.user.id,
                'date_birth' : null
            };

            vm.title = 'New Contact';
            vm.newContact = true;
        }
        else
        {
            vm.contact.date_birth = (vm.contact.date_birth) ? new Date(vm.contact.date_birth) : null;
            if( vm.contact.associate_id )
                vm.contactCompany = [
                    vm.contact.associate_id
                ];
        }

        // Methods
        vm.addNewContact = addNewContact;
        vm.saveContact = saveContact;
        vm.deleteContactConfirm = deleteContactConfirm;
        vm.closeDialog = closeDialog;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        
        vm.phoneCode = '+63';
        
        // location
        vm.getRegion = function(getAll) {
            if (getAll)
                return;
            else
                return (vm.contact.region_id) ? ($filter('filter')(data.Regions, {id: vm.contact.region_id}))[0]['short_name'] : null;
        };
        vm.getProvince = function(getAll) {
            if (getAll)
                return (vm.contact.region_id) ? ($filter('filter')(data.Provinces, {region_id: vm.contact.region_id})) : [];
            else
                return (vm.contact.province_id) ? ($filter('filter')(data.Provinces, {id: vm.contact.province_id}))[0]['value'] : null;
        };
        vm.getCity = function(getAll) {
            if (getAll)
                return (vm.contact.province_id) ? ($filter('filter')(data.Cities, {province_id: vm.contact.province_id})) : [];
            else
                return (vm.contact.city_id) ? ($filter('filter')(data.Cities, {id: vm.contact.city_id}))[0]['value'] : null;
        };
        vm.getRegionProvinces = function() {
            vm.provinces = vm.getProvince(true);
            vm.cities = [];
            vm.contact.province_id = null;
            vm.contact.city_id = null;
        };
        vm.getProvinceCities = function() {
            vm.cities = vm.getCity(true);
        };
        vm.regions = data.Regions;
        vm.region = vm.getRegion();
        vm.provinces = vm.getProvince(true);
        vm.province = vm.getProvince();
        vm.cities = vm.getCity(true);
        vm.city = vm.getCity();

        //////////
        
        // upload later on form submit or something similar
        vm.uploadFiles = function (files, attachment_id) {
            $scope.files = files;
            if (files && files.length) {
                Upload.upload({
                    url: config.apiUrl + 'file/update',
                    data: {
                        files: files,
                        field: 'avatar',
                        attachment_id: attachment_id,
                        attachment_type: 'Property\\Crm\\Models\\Contact'
                    }
                }).then(function (response) {
                    
                    $scope.$evalAsync(function ()
                    {
                        var avatar = response.data.return[0];
                        vm.contact.avatar = avatar;
                        
                        // for employees
                        var key = vm.contacts.indexOf(Contact);
                        vm.contacts[key].avatar = avatar;
                        
                        // for toolbar
//                        vm.user.employee.user.avatar = avatar;
                    });
                    
                }, function (response) {
//                    // called asynchronously if an error occurs
//                    // or server returns response with an error status.
                    console.log(response, " error occurs!");
                });
            }
        };

        /**
         * Add new contact
         */
        function addNewContact()
        {
            vm.onUpdate({model: 'contact', data: [vm.contact]});
        }

        /**
         * Save contact
         */
        function saveContact()
        {
            // Dummy save action
            for ( var i = 0; i < vm.contacts.length; i++ )
            {
                if ( vm.contacts[i].id === vm.contact.id )
                {
                    vm.contacts[i] = angular.copy(vm.contact);
                    vm.onUpdate({model: 'contact', data: [vm.contacts[i]]});
                    break;
                }
            }
        }
        
        /**
         * vm.onUpdate
         */
        vm.onUpdate = function(data)
        {
            $http({
                url: config.apiUrl + 'model/update',
                method: 'POST',
                data: data
            }).then(function (response) {
                var new_contact = response.data.updated.new;
                if( new_contact )
                {
                    vm.contact = new_contact;
                    vm.contacts.unshift(vm.contact);
                }
                // this callback will be called asynchronously
                // when the response is available
//                console.log(response, " response is available!");
                
                $mdToast.show({
                    template:
                        '<md-toast>' +
                            '<div class="md-toast-content">' +
                                '<strong class="md-accent-fg">Success!</strong>&nbsp;&nbsp;'+
                                'Contact has been saved.' +
                            '</div>' +
                        '</md-toast>',
                    hideDelay: 3000,
                    position: 'top right'
                });

                closeDialog();
            }, function (error) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
                console.log(error, " error occurs!");
                vm.errors = error.data;
            });
        };

        /**
         * Delete Contact Confirm Dialog
         */
        function deleteContactConfirm(ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the contact?')
                .htmlContent('<b>' + vm.contact.first_name + ' ' + vm.contact.last_name + '</b>' + ' will be deleted.')
                .ariaLabel('delete contact')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {

                vm.contacts.splice(vm.contacts.indexOf(Contact), 1);
                
                vm.onDelete({model: 'contact', checked: [vm.contact.id]});

            });
        }
        
        /**
         * onDelete
         */
        vm.onDelete = function(data)
        {
            $http({
                url: config.apiUrl + 'model/delete',
                method: 'DELETE',
                headers: {'Content-Type': 'application/json'},
                data: data
            }).then(function (response) {
                // this callback will be called asynchronously
                // when the response is available
//                console.log(response, " response is available!");
            }, function (response) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
                console.log(response, " error occurs!");
            });
        };

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        };
        
        /* Companies */
        vm.companyQuerySearch = companyQuerySearch;
        vm.companies = vm.company.company;
        /**
         * Add member chips
         *
         * @param query
         * @returns {Array}
         */
        function companyQuerySearch(query)
        {
            return query ? vm.companies.filter(createFilterFor(query)) : [];
        }
        
        vm.setFocus = function () {
            setTimeout(function () {
                document.querySelector('#autoCompleteId').focus();
            }, 0);
        };
        
        /**
         * Filter for chips
         *
         * @param query
         * @returns {filterFn}
         */
        function createFilterFor(query)
        {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(item)
            {
                return angular.lowercase(item.name).indexOf(lowercaseQuery) >= 0;
            };
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.companies',
            [
                // 3rd Party Dependencies
                'xeditable'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        $stateProvider.state('app.companies', {
            url    : '/companies',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/companies/companies.html',
                    controller : 'CompaniesController as vm'
                }
            },
            resolve: {
                Companies: function (msApi)
                {
                    return msApi.resolve('companies.companies@get');
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/companies');

        // Api
        msApiProvider.register('companies.companies', ['app/data/companies/companies.json']);
        msApiProvider.register('companies.user', ['app/data/companies/user.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('apps.contacts.companies', {
            title : 'Companies',
            state : 'app.companies',
            icon  : 'icon-city',
            weight: 4
        });

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.companies')
        .controller('CompanyDialogController', CompanyDialogController);

    /** @ngInject */
    function CompanyDialogController($http, $scope, $mdDialog, Company, User, data, $filter, config, msUtils, Upload, $mdToast)
    {
        var vm = this;

        // Data
        vm.title = 'Edit Company';
        vm.user = User;
        vm.company = vm.user.company;
        vm.companies = vm.company.company;
        vm.company = angular.copy(Company);
        vm.newCompany = false;
        vm.allFields = false;
        vm.crmUrl = config.crmUrl;
        vm.companyCompany = [];

        if ( !vm.company )
        {
            vm.company = {
                'id'         : 0,
                'name'       : '',
                'company_id' : vm.user.company.id,
                'user_id'    : vm.user.id,
                'companies'  : 1
            };

            vm.title = 'New Company';
            vm.newCompany = true;
        }

        // Methods
        vm.addNewCompany = addNewCompany;
        vm.saveCompany = saveCompany;
        vm.deleteCompanyConfirm = deleteCompanyConfirm;
        vm.closeDialog = closeDialog;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        
        vm.phoneCode = '+63';
        
        // location
        vm.getRegion = function(getAll) {
            if (getAll)
                return;
            else
                return (vm.company.region_id) ? ($filter('filter')(data.Regions, {id: vm.company.region_id}))[0]['short_name'] : null;
        };
        vm.getProvince = function(getAll) {
            if (getAll)
                return (vm.company.region_id) ? ($filter('filter')(data.Provinces, {region_id: vm.company.region_id})) : [];
            else
                return (vm.company.province_id) ? ($filter('filter')(data.Provinces, {id: vm.company.province_id}))[0]['value'] : null;
        };
        vm.getCity = function(getAll) {
            if (getAll)
                return (vm.company.province_id) ? ($filter('filter')(data.Cities, {province_id: vm.company.province_id})) : [];
            else
                return (vm.company.city_id) ? ($filter('filter')(data.Cities, {id: vm.company.city_id}))[0]['value'] : null;
        };
        vm.getRegionProvinces = function() {
            vm.provinces = vm.getProvince(true);
            vm.cities = [];
            vm.company.province_id = null;
            vm.company.city_id = null;
        };
        vm.getProvinceCities = function() {
            vm.cities = vm.getCity(true);
        };
        vm.regions = data.Regions;
        vm.region = vm.getRegion();
        vm.provinces = vm.getProvince(true);
        vm.province = vm.getProvince();
        vm.cities = vm.getCity(true);
        vm.city = vm.getCity();

        //////////
        
        // upload later on form submit or something similar
        vm.uploadFiles = function (files, attachment_id) {
            $scope.files = files;
            if (files && files.length) {
                Upload.upload({
                    url: config.apiUrl + 'file/update',
                    data: {
                        files: files,
                        field: 'avatar',
                        attachment_id: attachment_id,
                        attachment_type: 'Property\\Crm\\Models\\Company'
                    }
                }).then(function (response) {
                    
                    $scope.$evalAsync(function ()
                    {
                        var avatar = response.data.return[0];
                        vm.company.avatar = avatar;
                        
                        // for employees
                        var key = vm.companies.indexOf(Company);
                        vm.companies[key].avatar = avatar;
                        
                        // for toolbar
//                        vm.user.employee.user.avatar = avatar;
                    });
                    
                }, function (response) {
//                    // called asynchronously if an error occurs
//                    // or server returns response with an error status.
                    console.log(response, " error occurs!");
                });
            }
        };

        /**
         * Add new company
         */
        function addNewCompany()
        {
            vm.onUpdate({model: 'company', data: [vm.company]});

            closeDialog();
        }

        /**
         * Save company
         */
        function saveCompany()
        {
            // Dummy save action
            for ( var i = 0; i < vm.companies.length; i++ )
            {
                if ( vm.companies[i].id === vm.company.id )
                {
                    vm.companies[i] = angular.copy(vm.company);
                    vm.onUpdate({model: 'company', data: [vm.companies[i]]});
                    break;
                }
            }

            closeDialog();
        }
        
        /**
         * vm.onUpdate
         */
        vm.onUpdate = function(data)
        {
            $http({
                url: config.apiUrl + 'model/update',
                method: 'POST',
                data: data
            }).then(function (response) {
                var new_company = response.data.updated.new;
                if( new_company )
                {
                    vm.company = new_company;
                    vm.companies.unshift(vm.company);
                }
                // this callback will be called asynchronously
                // when the response is available
//                console.log(response, " response is available!");

                $mdToast.show({
                    template:
                        '<md-toast>' +
                            '<div class="md-toast-content">' +
                                '<strong class="md-accent-fg">Success!</strong>&nbsp;&nbsp;'+
                                'Company has been saved.' +
                            '</div>' +
                        '</md-toast>',
                    hideDelay: 3000,
                    position: 'top right'
                });
                
            }, function (response) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
                console.log(response, " error occurs!");
            });
        };

        /**
         * Delete Company Confirm Dialog
         */
        function deleteCompanyConfirm(ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the company?')
                .htmlContent('<b>' + vm.company.name + '</b>' + ' will be deleted.')
                .ariaLabel('delete company')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {

                vm.companies.splice(vm.companies.indexOf(Company), 1);
                
                vm.onDelete({model: 'company', checked: [vm.company.id]});

            });
        }
        
        /**
         * onDelete
         */
        vm.onDelete = function(data)
        {
            $http({
                url: config.apiUrl + 'model/delete',
                method: 'DELETE',
                headers: {'Content-Type': 'application/json'},
                data: data
            }).then(function (response) {
                // this callback will be called asynchronously
                // when the response is available
//                console.log(response, " response is available!");
            }, function (response) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
                console.log(response, " error occurs!");
            });
        };

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.calendar',
            [
                // 3rd Party Dependencies
                'moment-picker',
                'ui.calendar'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, msApiProvider, config, momentPickerProvider)
    {
        // State
        $stateProvider.state('app.calendar', {
            url      : '/calendar',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/calendar/calendar.html',
                    controller : 'CalendarController as vm'
                }
            },
            resolve  : {
                Calendar       : function (msApi)
                {
                    return msApi.resolve('calendar.calendar@get');
                }
            },
            bodyClass: 'calendar'
        });
        $stateProvider.state('app.calendar.synced', {
            url      : '',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/calendar/calendar.html',
                    controller : 'CalendarController as vm'
                }
            },
            resolve  : {
                Calendar       : function (msApi)
                {
                    return msApi.resolve('calendar.calendar@get');
                }
            },
            bodyClass: 'calendar'
        });
        
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/calendar');
        msApiProvider.register('calendar.calendar', [config.crmUrl + 'calendar/calendar.json']);
        
        // Navigation
        msNavigationServiceProvider.saveItem('apps.sales.calendar', {
            title : 'Calendar',
            icon  : 'icon-calendar-today',
            state : 'app.calendar',
            weight: 8,
            hidden: function ()
            {
                var roles = JSON.parse(localStorage.getItem('roles'));
                if( roles )
                {
                    var role = roles.filter(function ( obj ) {
                        return obj.url === '/calendar';
                    })[0];

                    return !role.permissions.write;
                }
            }
        });
        
        momentPickerProvider.options({
            minutesStep:   30
        });
    }
})();
(function ()
{
    'use strict';

    angular.module('app.calendar')
        .controller('EventFormDialogController', EventFormDialogController);

    /** @ngInject */
    function EventFormDialogController($mdDialog, dialogData, $scope)
    {
        var vm = this;

        // Data
        vm.dialogData = dialogData;
        vm.notifications = ['15 minutes before', '30 minutes before', '1 hour before'];
        vm.remainder = 30 - moment().minute() % 30;
        vm.today = moment().add(vm.remainder, "minutes");
        
        // Methods
        vm.saveEvent = saveEvent;
        vm.removeEvent = removeEvent;
        vm.closeDialog = closeDialog;
        
        init();

        //////////

        /**
         * Initialize
         */
        function init()
        {
            // Figure out the title
            switch ( vm.dialogData.type )
            {
                case 'add' :
                    vm.dialogTitle = 'Add Event';
                    break;

                case 'edit' :
                    vm.dialogTitle = 'Edit Event';
                    break;

                default:
                    break;
            }
            
            vm.format = 'LLL';
        
            // Edit
            if ( vm.dialogData.calendarEvent )
            {
                vm.calendarEvent = angular.copy(vm.dialogData.calendarEvent);
                
                vm.start = vm.calendarEvent.start;
                vm.end = vm.calendarEvent.end;
                
                vm.today = vm.start;
                
                vm.calendarEvent.all_day_event = (vm.calendarEvent.all_day_event == 1) ? true : false;
                
                if( vm.calendarEvent.end == null )
                    vm.end = vm.calendarEvent.start;
            }
            // Add
            else
            {   
                vm.start_d = moment(vm.dialogData.start);
                vm.end_d = moment(vm.dialogData.end);
                vm.remainder = 30 - vm.start_d.minute() % 30;
                
                vm.start_r = moment(vm.start_d).add(vm.remainder, "minutes");
                vm.end_r = moment(vm.end_d).add(vm.remainder, "minutes").add(1, "hour");
                
                vm.start = vm.start_r.format(vm.format);
                vm.end = vm.end_r.format(vm.format);
                
                vm.calendarEvent = {
                    all_day_event: false
                };
            }
        }

        /**
         * Save the event
         */
        function saveEvent()
        {
            vm.format = 'YYYY-MM-DD HH:mm:ss';
            
            // check if all day then reset all time to 00
            if( vm.calendarEvent.all_day_event )
                vm.format = 'YYYY-MM-DD 00:00:00';
            
            // Convert the javascript date objects back to the moment.js dates
            var dates = {
                start: moment(new Date(vm.calendarEvent.start)).format(vm.format),
                end  : moment(new Date(vm.calendarEvent.end)).format(vm.format)
            };
            
            var response = {
                type         : vm.dialogData.type,
                calendarEvent: angular.extend({}, vm.calendarEvent, dates)
            };

            $mdDialog.hide(response);
        }

        /**
         * Remove the event
         */
        function removeEvent()
        {
            var response = {
                type         : 'remove',
                calendarEvent: vm.calendarEvent
            };

            $mdDialog.hide(response);
        }

        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.calendar')
        .controller('EventDetailDialogController', EventDetailDialogController);

    /** @ngInject */
    function EventDetailDialogController($mdDialog, calendarEvent, showEventFormDialog, event)
    {
        var vm = this;

        // Data
        vm.calendarEvent = calendarEvent;

        // Methods
        vm.editEvent = editEvent;
        vm.closeDialog = closeDialog;

        //////////

        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

        /**
         * Edit the calendar event
         *
         * @param calendarEvent
         */
        function editEvent(calendarEvent)
        {
            showEventFormDialog('edit', calendarEvent, false, false, event);
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .factory('RuleService', RuleService);

    /** @ngInject */
    function RuleService($q, msApi, $state, $http, config)
    {
        var service = {
            data        : {},
            getRuleData: getRuleData,
            createUpdate: createUpdate,
            remove: remove,
        };

        /**
         * Get rule data from the server
         *
         * @param ruleId
         * @returns {*}
         */
        function getRuleData(ruleId)
        {
            // Create a new deferred object
            var deferred = $q.defer();

            msApi.request('scrumboard.board.rule@get', {id: ruleId},

                // SUCCESS
                function (response)
                {
                    service.data = response.rule;
                    // Resolve the promise
                    deferred.resolve(response);
                },

                // ERROR
                function (response)
                {
                    // Reject the promise
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }
        
        function createUpdate(boardId, userId,boardStatusId) {
            var rule = {
                'id': 0,
                'name': "Untitled",
                'board_id': boardId,
                'user_id': userId,
                'board_status_id': boardStatusId,
                'action': 2
            };
            // Create a new deferred object
            var deferred = $q.defer();
            $http({
                url: config.apiUrl + 'rule/update',
                method: 'POST',
                data: {rule: rule}
            }).then(function (response) {
                var data = response.data.saveRule;
                // Attach the data
                service.data = response.data.saveRule;
                // Resolve the promise
                deferred.resolve(response.data.saveRule);
                $state.go('app.scrumboard.boards.board.rules.rule', {ruleId: data.id});
            }, function (response) {
                // Reject the promise
                console.log('rejected');
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function remove(id, model){
            // Create a new deferred object
            var deferred = $q.defer();

            $http({
                url: config.apiUrl + 'rule/delete',
                method: 'POST',
                data: {id: id, model: model}
            }).then(function (response) {
                // Resolve the promise
                return deferred.resolve(response.data.delete);
            }, function (response) {
                // Reject the promise
                console.log('rejected');
                deferred.reject(response);
            });
            return deferred.promise;
        }

        return service;
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .factory('RemarkService', RemarkService);

    /** @ngInject */
    function RemarkService($mdDialog, $document)
    {
        var service = {
            openRemarkDialog: openRemarkDialog
        };

        //////////

        /**
         * Open lead dialog
         *
         * @param ev
         * @param leadId
         */
        function openRemarkDialog(ev, leadId, data, remarks)
        {
            $mdDialog.show({
                templateUrl        : 'app/main/apps/scrumboard/dialogs/lead/remark-dialog.html',
                controller         : 'ScrumboardLeadDialogController',
                controllerAs       : 'vm',
                parent             : $document.find('#scrumboard'),
                targetEvent        : ev,
                clickOutsideToClose: false,
                bindToController: true,
                escapeToClose      : true,
                locals             : {
                    leadId: leadId,
                    data: data,
                    remarks: remarks
                }
            });
        }

        return service;
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .factory('LeadFilters', LeadFiltersService);

    /** @ngInject */
    function LeadFiltersService()
    {
        var service = {
            name   : '',
            labels : [],
            members: [],
            clear  : clear,
            isOn   : isOn
        };

        /**
         * Clear
         */
        function clear()
        {
            service.name = '';
            service.labels = [];
            service.members = [];
        }

        /**
         * Is on
         *
         * @returns {boolean}
         */
        function isOn()
        {
            return (service.name === '' && service.labels.length === 0 && service.members.length === 0 ) ? false : true;
        }

        return service;
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .factory('DialogService', DialogService);

    /** @ngInject */
    function DialogService($mdDialog, $document)
    {
        var service = {
            openLeadDialog: openLeadDialog
        };

        //////////

        /**
         * Open lead dialog
         *
         * @param ev
         * @param leadId
         */
        function openLeadDialog(ev, leadId, data, remarks)
        {
            $mdDialog.show({
                templateUrl        : 'app/main/apps/scrumboard/dialogs/lead/lead-dialog.html',
                controller         : 'ScrumboardLeadDialogController',
                controllerAs       : 'vm',
                parent             : $document.find('#scrumboard'),
                targetEvent        : ev,
                clickOutsideToClose: false,
                bindToController: true,
                escapeToClose      : true,
                locals             : {
                    leadId: leadId,
                    data: data,
                    remarks: remarks
                }
            });
        }

        return service;
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .factory('BoardService', BoardService);

    /** @ngInject */
    function BoardService($q, msApi, $state, $http, config)
    {
        var service = {
            data        : {},
            boards      : {},
            groups      : {},
            addNewBoard : addNewBoard,
            getBoardData: getBoardData
        };

        /**
         * Get board data from the server
         *
         * @param boardId
         * @returns {*}
         */
        function getBoardData(boardId, boards, groups)
        {
            // Create a new deferred object
            var deferred = $q.defer();

            msApi.request('scrumboard.board@get', {id: boardId},

                // SUCCESS
                function (response)
                {
                    // Attach the data
                    service.data = response.data;
                    service.boards = boards;
                    service.groups = service.data.group_permission;
                    
                    // Resolve the promise
                    deferred.resolve(response);
                },

                // ERROR
                function (response)
                {
                    // Reject the promise
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

        /**
         * Get board data from the server
         *
         * @param boardId
         * @returns {*}
         */
        function addNewBoard(template, param)
        {
            // Create a new deferred object
            var deferred = $q.defer();
//            var company_id = company.id;
            
            $http({
                url: config.apiUrl + 'board/add',
                method: 'POST',
                data: {template: template, param: param}
            }).then(function (response) {

                var data = response.data.board;

                // Attach the data
                service.data = response.data.board;

                // Resolve the promise
                deferred.resolve(response.data.board);

                // add to User json
                $state.go('app.scrumboard.boards.board', {id:data.id, isNew:true}, {reload: true});
              

            }, function (response) {
                // Reject the promise
                deferred.reject(response);
            });

            return deferred.promise;
        }

        return service;
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.company.project')
        .factory('ProjectsService', ProjectsService);

    /** @ngInject */
    function ProjectsService(msApi, $q)
    {
        var service = {
            data          : [1, 2],
            addProject    : addProject,
            updateProject : updateProject,
            deleteProject : deleteProject,
            getData       : getData
        };

        /**
         * Add Project
         * @param project
         */
        function addProject(project)
        {
            service.data.push(project);
        }

        /**
         * Update Project
         * @param project
         */
        function updateProject(project)
        {
            for ( var i = 0; i < service.data.length; i++ )
            {
                if ( service.data[i].id === project.id )
                {
                    service.data[i] = project;
                }
            }
        }

        /**
         * Delete Project
         * @param project
         */
        function deleteProject(project)
        {
            for ( var i = 0; i < service.data.length; i++ )
            {
                if ( service.data[i].id === project.id )
                {
                    service.data.splice(i, 1);
                }
            }
        }

        /**
         * Get service data
         * @returns {Array}
         */
        function getData()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            msApi.request('project.projects@get', {},
                // SUCCESS
                function (response)
                {
                    // Attach the data
                    service.data = response.projects;

                    // Resolve the promise
                    deferred.resolve(response);
                },

                // ERROR
                function (response)
                {
                    // Reject the promise
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

        return service;

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.company.dashboard',
            [
                // 3rd Party Dependencies
                'nvd3',
                'datatables',
                'ng-sortable'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, config)
    {
        // State
        $stateProvider.state('app.company_dashboard', {
            url      : '/company/dashboard',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/company/dashboard/company-dashboard.html',
                    controller : 'CompanyDashboardController as vm'
                }
            },
            resolve  : {
                DashboardData: function (msApi)
                {
                    return msApi.resolve('company.dashboard@get');
                }
            },
            bodyClass: 'company-dashboard'
        });

        // Api
        msApiProvider.register('company.dashboard', ['app/data/company/dashboard/data.json']);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.company.dashboard')
        .controller('CompanyDashboardController', CompanyDashboardController);

    /** @ngInject */
    function CompanyDashboardController($scope, $interval, $mdSidenav, DashboardData, User, Regions, Provinces, Cities, Upload, $http, $filter, config, msUtils, $mdDialog, $mdToast)
    {
        var vm = this;
        vm.crmUrl = config.crmUrl;

        // Data
        vm.dashboardData = DashboardData;
        vm.companies = vm.dashboardData.companies;
        
        vm.user = User.data;
        vm.company = vm.user.company;
        vm.groups = vm.user.groups;
        vm.phoneCode = '+63';
        
        // location
        vm.getRegion = function(getAll) {
            if (getAll)
                return;
            else
                return (vm.company.region_id) ? ($filter('filter')(Regions.data, {id: vm.company.region_id}))[0]['short_name'] : null;
        };
        vm.getProvince = function(getAll) {
            if (getAll)
                return (vm.company.region_id) ? ($filter('filter')(Provinces.data, {region_id: vm.company.region_id})) : [];
            else
                return (vm.company.province_id) ? ($filter('filter')(Provinces.data, {id: vm.company.province_id}))[0]['value'] : null;
        };
        vm.getCity = function(getAll) {
            if (getAll)
                return (vm.company.province_id) ? ($filter('filter')(Cities.data, {province_id: vm.company.province_id})) : [];
            else
                return (vm.company.city_id) ? ($filter('filter')(Cities.data, {id: vm.company.city_id}))[0]['value'] : null;
        };
        vm.getRegionProvinces = function() {
            vm.provinces = vm.getProvince(true);
            vm.cities = [];
            vm.company.province_id = null;
            vm.company.city_id = null;
        };
        vm.getProvinceCities = function() {
            vm.cities = vm.getCity(true);
        };
        vm.regions = Regions.data;
        vm.region = vm.getRegion();
        vm.provinces = vm.getProvince(true);
        vm.province = vm.getProvince();
        vm.cities = vm.getCity(true);
        vm.city = vm.getCity();
        
        //////////
        /**
         * saveProfile
         */
        vm.saveUser = function(type, key)
        {
//            console.log(vm[type][key]);
//            return false;
            vm.region = vm.getRegion();
            vm.province = vm.getProvince();
            vm.city = vm.getCity();
            
            $http({
                url: config.apiUrl + 'user/update',
                method: 'POST',
                data: vm.user
            }).then(function (response) {
                
                if( type && key && vm[type][key] && response.data.changes.company[type] )
                    vm[type][key].id = response.data.changes.company[type].id;
                
                // this callback will be called asynchronously
                // when the response is available
//                console.log(response, " response is available!");

                $mdToast.show({
                    template:
                        '<md-toast>' +
                            '<div class="md-toast-content">' +
                                '<strong class="md-accent-fg">Success!</strong>&nbsp;&nbsp;'+
                                'Company has been saved.' +
                            '</div>' +
                        '</md-toast>',
                    hideDelay: 3000,
                    position: 'top right'
                });
                
            }, function (response) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
                console.log(response, " error occurs!");
            });
        };
        
        //////////
        /**
         * onDelete
         */
        vm.onDelete = function(data)
        {
            $http({
                url: config.apiUrl + 'model/delete',
                method: 'DELETE',
                headers: {'Content-Type': 'application/json'},
                data: data
            }).then(function (response) {
                // this callback will be called asynchronously
                // when the response is available
//                console.log(response, " response is available!");
            }, function (response) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
                console.log(response, " error occurs!");
            });
        };
        
        // upload later on form submit or something similar
        vm.uploadFiles = function (files, attachment_id) {
            $scope.files = files;
            if (files && files.length) {
                Upload.upload({
                    url: config.apiUrl + 'file/update',
                    data: {
                        files: files,
                        field: 'avatar',
                        attachment_id: attachment_id,
                        attachment_type: 'Property\\Crm\\Models\\Company'
                    }
                }).then(function (response) {
                    
                    $scope.$evalAsync(function ()
                    {
                        var avatar = response.data.return[0];
                        vm.company.avatar = avatar;
                    });
                    
                }, function (response) {
//                    // called asynchronously if an error occurs
//                    // or server returns response with an error status.
                    console.log(response, " error occurs!");
                });
            }
        };

        // Settings
        vm.lead_source = vm.company.lead_source;
        vm.opportunity_status = vm.company.opportunity_status;
        vm.activity_status = vm.company.activity_status;
        vm.newSettingName = '';
        
        vm.defaultSettingConfirm = defaultSettingConfirm;
        vm.deleteDataConfirm = deleteDataConfirm;
        vm.addNewSetting = addNewSetting;

        vm.sortableOptions = {
            handle        : '.handle',
            draggable     : '.setting-item',
            forceFallback : true,
            ghostClass    : 'setting-item-placeholder',
            fallbackClass : 'setting-item-ghost',
            fallbackOnBody: true,
            sort          : true,
            dropBubble: true,
            dragoverBubble: true,
            dataIdAttr : 'data-id',
            scroll: true,
            // Changed sorting within list
            onSort: function (evt) {
                var setting = evt.models;
                var type = evt.originalEvent.from.id;
                vm[type] = setting;
                vm.saveUser();
            },
            onMove: function(evt) {
                if (evt.related)
                    return !evt.related.classList.contains('ignore');
            }
        };

        /**
         * Delete Contact Confirm Dialog
         */
        function defaultSettingConfirm(ev, setting, key, type)
        {
            // Dummy save action
            for ( var i = 0; i < setting.length; i++ )
            {
                if ( i === key )
                    setting[i]['default'] = 1;
                else
                    setting[i]['default'] = 0;
            }
            vm[type] = setting;
            vm.saveUser();
        }

        /**
         * Delete Contact Confirm Dialog
         */
        function deleteDataConfirm(ev, data, type)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the setting?')
                .htmlContent('<b>' + data.value + '</b>' + ' will be deleted.')
                .ariaLabel('delete setting')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {
                vm.onDelete({model: type, checked: [data.id]});
                vm[type].splice(vm[type].indexOf(data), 1);
                
            }, function ()
            {

            });
        }
        
        vm.type = {};

        /**
         *
         */
        function addNewSetting(type, key)
        {
            if ( vm.newSettingName === '' )
            {
                return;
            }

            var newSetting = {
                'id'        : 0,
                'value'     : vm.newSettingName,
                'company_id': vm.company.id,
                'default'   : 0,
                'initial'   : 0
//                sort_order  : order + 1
            };
            
//            vm[type].push(newSetting);
            // get the key of the enable value
            vm[type].splice(key, 0, newSetting);
            
            vm.saveUser(type, key);
            
            vm.newSettingName = '';
        }
        
        // Widget 8
        vm.widget8 = vm.dashboardData.widget8;
//        vm.widget8 = {
//            title    : vm.dashboardData.widget8.title,
//            mainChart: {
//                options: {
//                    chart: {
//                        type     : 'pieChart',
//                        color    : ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#ffc107'],
//                        height   : 400,
//                        margin   : {
//                            top   : 0,
//                            right : 0,
//                            bottom: 0,
//                            left  : 0
//                        },
//                        labelType: 'percent',
//                        x        : function (d)
//                        {
//                            return d.label;
//                        },
//                        y        : function (d)
//                        {
//                            return d.value;
//                        },
//                        tooltip  : {
//                            gravity: 's',
//                            classes: 'gravity-s'
//                        }
//                    }
//                },
//                data   : vm.dashboardData.widget8.mainChart
//            }
//        };

        // Now widget
        vm.nowWidget = {
            now   : {
                second: '',
                minute: '',
                hour  : '',
                day   : '',
                month : '',
                year  : ''
            },
            ticker: function ()
            {
                var now = moment();
                vm.nowWidget.now = {
                    second : now.format('ss'),
                    minute : now.format('mm'),
                    hour   : now.format('HH'),
                    day    : now.format('D'),
                    weekDay: now.format('dddd'),
                    month  : now.format('MMMM'),
                    year   : now.format('YYYY')
                };
            }
        };

        // Weather widget
//        https://query.yahooapis.com/v1/public/yql?q=select%20*%20from%20weather.forecast%20where%20woeid%20in%20(SELECT%20woeid%20FROM%20geo.places%20WHERE%20text%3D%22(14.5995%2C120.9842)%22)&format=json
        var fixedEncodeURIComponent = function(str) {
            return encodeURIComponent(str).replace(/[!'()]/g, escape).replace(/\*/g, "%2A").replace(/\"/g, "%22");
        };
        var format = '&format=json&env=store%3A%2F%2Fdatatables.org%2Falltableswithkeys&callback=JSON_CALLBACK';
        
        var lat = '14.5995';
        var lng = '120.9842';
        var query = 'select * from weather.forecast where u="c" and woeid in (SELECT woeid FROM geo.places WHERE text="('+ lat +', '+ lng +')") ';
        
        var url = 'https://query.yahooapis.com/v1/public/yql?q=' + fixedEncodeURIComponent(query) + format;

        $http.jsonp(url).success(function(json) {
            vm.weatherWidget = json.query.results.channel;
            
            vm.forecast = [
                vm.weatherWidget.item.forecast[1],
                vm.weatherWidget.item.forecast[2],
                vm.weatherWidget.item.forecast[3]
            ];
        }).error(function(error) {
            console.log(JSON.stringify(error));
        });

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.selectCompany = selectCompany;

        //////////
        vm.selectedCompany = vm.companies[0];

        // Now widget ticker
        vm.nowWidget.ticker();

        var nowWidgetTicker = $interval(vm.nowWidget.ticker, 1000);

        $scope.$on('$destroy', function ()
        {
            $interval.cancel(nowWidgetTicker);
        });

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Select company
         */
        function selectCompany(company)
        {
            vm.selectedCompany = company;
        }

        //////////
        vm.rolesUpdate = function(data)
        {
            $http({
                url: config.apiUrl + 'roles/update',
                method: 'POST',
                data: data
            }).then(function (response) {
                // this callback will be called asynchronously
                // when the response is available

                $mdToast.show({
                    template:
                        '<md-toast>' +
                            '<div class="md-toast-content">' +
                                '<strong class="md-accent-fg">Success!</strong>&nbsp;&nbsp;'+
                                'Roles has been saved.' +
                            '</div>' +
                        '</md-toast>',
                    hideDelay: 3000,
                    position: 'top right'
                });
        
            }, function (response) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
                console.log(response, " error occurs!");
            });
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider, config)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.employees', ['app/data/quick-panel/employees.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
        
        msApiProvider.register('quickPanel.reminder', [config.apiUrl + 'reminder.json']);
        msApiProvider.register('api.priority', [config.apiUrl + 'priority.json']);
        msApiProvider.register('api.activity_status', [config.apiUrl + 'activity_status.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.employees@get', {},
            // Success
            function (response)
            {
                vm.employees = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(employee)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.employee = employee;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.employee.dialog )
            {
                vm.chat.employee.dialog = [];
            }

            vm.chat.employee.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.settings', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, config, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.pages_settings_general', {
                url      : '/settings/general',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/settings/views/general/general.html',
                        controller : 'SettingsController as vm'
                    }
                },
                bodyClass: 'settings printable',
                role: {
                    url: '/settings'
                }
            })
            .state('app.pages_settings_integration', {
                url      : '/settings/integration',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/settings/views/integration/integration.html',
                        controller : 'SettingsController as vm'
                    }
                },
                bodyClass: 'settings printable',
                role: {
                    url: '/settings'
                }
            })
            .state('app.pages_settings_integration.mail', {
                url      : '/mail/:item',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/settings/views/integration/mail.html',
                        controller : 'SettingsController as vm'
                    }
                },
                bodyClass: 'settings printable',
                role: {
                    url: '/settings'
                }
            })
            .state('app.pages_settings_integration.calendar', {
                url      : '/calendar/:item',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/settings/views/integration/calendar.html',
                        controller : 'SettingsController as vm'
                    }
                },
                bodyClass: 'settings printable',
                role: {
                    url: '/settings'
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/settings');
        
        // Navigation
        msNavigationServiceProvider.saveItem('apps.pages.settings', {
            title : 'Settings',
            icon  : 'icon-server-network',
            weight: 10,
            hidden: function ()
            {
                var roles = JSON.parse(localStorage.getItem('roles'));
                if( roles )
                {
                    var role = roles.filter(function ( obj ) {
                        return obj.url === '/settings';
                    })[0];

                    return !role.permissions.write;
                }
            }
        });

        msNavigationServiceProvider.saveItem('apps.pages.settings.general', {
            title : 'General',
            state : 'app.pages_settings_general',
            weight: 12
        });

        msNavigationServiceProvider.saveItem('apps.pages.settings.integration', {
            title : 'Integration',
            state : 'app.pages_settings_integration',
            weight: 15
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.settings')
        .controller('SettingsController', SettingsController);

    /** @ngInject */
    function SettingsController($scope, User, msApi, $http, config, $timeout, $mdToast, $state, $location, $window, $rootScope)
    {
        var vm = this;

        // Data
        vm.user = User.data;
        vm.user.access_btn = (vm.user.access_token != null)
        
        vm.integration = vm.user.integration;
        vm.integration.GAuth = vm.integration.GAuth || false;
        vm.smtp_encryptions = vm.integration.smtp_encryptions;
        vm.mails = vm.integration.mails;
        vm.calendars = vm.integration.calendars;
        vm.gotoOption = gotoOption;
        vm.sendTest = sendTest;
        
        vm.item = $location.path().split('/')[4];
        switch(vm.item) {
            case 'smtp' || 'google': $scope.selectedIndex = 0; break;
            case 'cs1': $scope.selectedIndex = 1; break;
            case 'cs2': $scope.selectedIndex = 2; break;
        }

        // Methods

        //////////
        vm.onUpdate = function(data, send_test)
        {
            if( send_test )
            {
                vm.loaderText2 = "Sending...";
                vm.loader = true;
            }
            else
                vm.loaderText1 = "Saving...";
            
            $http({
                url: config.apiUrl + 'model/update',
                method: 'POST',
                data: data
            }).then(function (response) {
                // this callback will be called asynchronously
                // when the response is available
                
                if( send_test )
                    vm.sendTest();
                else
                {
                    vm.loaderText1 = "";
                
                    $mdToast.show({
                        template:
                            '<md-toast>' +
                                '<div class="md-toast-content">' +
                                    '<strong class="md-accent-fg">Success!</strong>&nbsp;&nbsp;'+
                                    'Settings has been saved.' +
                                '</div>' +
                            '</md-toast>',
                        hideDelay: 3000,
                        position: 'top right'
                    });

                }
                
        
            }, function (response) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
                console.log(response, " error occurs!");
            });
        };

        /**
         * Go to properties page
         */
        function gotoOption(type, item)
        {
            $state.go('app.pages_settings_integration.'+ type, {item: item});
        }
        
        function sendTest()
        {   
            var data = {
                'name': 'Test name',
                'var1': 'Variable 1',
                'var2': 'Variable 2',
                'link': $location.absUrl(),
                'fr_email': vm.integration.sender_email,
                'fr_name' : vm.integration.sender_name,
                'to_email': vm.integration.sender_email,
                'to_name' : 'Full name'
            };
            
            $http({
                url: config.apiUrl + 'send/test',
                method: 'POST',
                data: data
            }).then(function (response) {
                // this callback will be called asynchronously
                // when the response is available
                
                vm.loaderText2 = "";
                vm.loader = false;
                
                $mdToast.show({
                    template:
                        '<md-toast>' +
                            '<div class="md-toast-content">' +
                                '<strong class="md-accent-fg">Success!</strong>&nbsp;&nbsp;'+
                                'Message sent.' +
                            '</div>' +
                        '</md-toast>',
                    hideDelay: 3000,
                    position: 'top right'
                });
        
            }, function (response) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
                
                vm.loaderText2 = "Try again.";
                vm.loader = false;
                
                $mdToast.show({
                    template: 
                        '<md-toast>' +
                            '<div class="md-toast-content md-red-500-bg">' +
                                'Message sending failed.' +
                            '</div>' +
                        '</md-toast>',
                    position: 'top right',
                    hideDelay: 3000
                });
            });
        }
        
        // Google login function from server side
        vm.doLogin = function() 
        {
            var redirect_uri = config.redirectUri;
            var scope = config.scope;
//            var i_encrypt = vm.integration.i_encrypt;
            
//            var win = PopupCenter('https://accounts.google.com/o/oauth2/auth?scope='+encodeURI(scope)+'&redirect_uri='+encodeURI(redirect_uri)+'&response_type=code&client_id='+config.cliendId+'&access_type=offline&approval_prompt=force&state=integration?' + i_encrypt, null, '600', '600');
//            $rootScope.popupCenter( vm.integration.auth_url + '&state=integration?' + i_encrypt, null, '600', '600');
            $rootScope.popupCenter( vm.integration.auth_url , null, '600', '600');
        };
        
        $window.addEventListener("message", getCode);

        function getCode(event) {
            if (event.origin === config.origin)
            {
                $rootScope.$apply(function(){
                    vm.integration.GAuth = angular.isDefined(event.data.integration) ? event.data.integration.save : false;
                    // for google integration only!
                    if( vm.integration.GAuth )
                    {
                        vm.integration.calendar = 'google';

                        localStorage.setItem('doSyncCalendar', 1);
                    }
                });
            }
         }

        vm.doLogout = function() {
            
            vm.integration.GAuth = false;
            vm.onUpdate({model: 'integration', data: [vm.integration]});
            
        };

        vm.generate_api = function() {
            
            var data = {
                'id' : vm.user.id,
                'access_btn' : vm.user.access_btn,
                'access_token' : vm.user.access_token,
            };
            
            $http({
                url: config.apiUrl + 'user/access',
                method: 'POST',
                data: data
            }).then(function (response) {
                // this callback will be called asynchronously
                // when the response is available
                
                vm.user.access_token = response.data.model.access_token;
                
                if( vm.user.access_btn )
                    $mdToast.show({
                        template:
                            '<md-toast>' +
                                '<div class="md-toast-content">' +
                                    '<strong class="md-accent-fg">Success!</strong>&nbsp;&nbsp;'+
                                    'Access Token Generated.' +
                                '</div>' +
                            '</md-toast>',
                        hideDelay: 3000,
                        position: 'top right'
                    });
        
            }, function (response) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
            });
            
        };
        
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.profile', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, config)
    {
        $stateProvider.state('app.pages_profile', {
            url      : '/profile',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/profile/profile.html',
                    controller : 'ProfileController as vm'
                }
            },
            bodyClass: 'profile'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/profile');

        // Navigation
        msNavigationServiceProvider.saveItem('apps.pages.profile', {
            title : 'Preferences',
            icon  : 'icon-account-outline',
            state : 'app.pages_profile',
            weight: 17
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.profile')
        .controller('ProfileController', ProfileController);

    /** @ngInject */
    function ProfileController($scope, User, Regions, Provinces, Cities, $http, $filter, config, Upload, $mdToast)
    {
        var vm = this;
        vm.crmUrl = config.crmUrl;
        
        // Data
        vm.user = User.data;
        
        vm.employee = vm.user.employee;
        
        vm.employee.date_birth = (vm.employee.date_birth) ? new Date(vm.employee.date_birth) : null;
        vm.employee.date_hire = (vm.employee.date_hire) ? new Date(vm.employee.date_hire) : null;
        
        vm.genders = [
            {value: 'male', name: 'Male'},
            {value: 'female', name: 'Female'}
        ];
        
        // location
        vm.getRegion = function(getAll) {
            if (getAll)
                return;
            else
                return (vm.employee.region_id) ? ($filter('filter')(Regions.data, {id: vm.employee.region_id}))[0]['short_name'] : null;
        };
        vm.getProvince = function(getAll) {
            if (getAll)
                return (vm.employee.region_id) ? ($filter('filter')(Provinces.data, {region_id: vm.employee.region_id})) : [];
            else
                return (vm.employee.province_id) ? ($filter('filter')(Provinces.data, {id: vm.employee.province_id}))[0]['value'] : null;
        };
        vm.getCity = function(getAll) {
            if (getAll)
                return (vm.employee.province_id) ? ($filter('filter')(Cities.data, {province_id: vm.employee.province_id})) : [];
            else
                return (vm.employee.city_id) ? ($filter('filter')(Cities.data, {id: vm.employee.city_id}))[0]['value'] : null;
        };
        vm.getRegionProvinces = function() {
            vm.provinces = vm.getProvince(true);
            vm.cities = [];
            vm.employee.province_id = null;
            vm.employee.city_id = null;
        };
        vm.getProvinceCities = function() {
            vm.cities = vm.getCity(true);
        };
        vm.regions = Regions.data;
        vm.region = vm.getRegion();
        vm.provinces = vm.getProvince(true);
        vm.province = vm.getProvince();
        vm.cities = vm.getCity(true);
        vm.city = vm.getCity();
        vm.phoneCode = '+63';
        
        // Methods

        //////////
        /**
         * saveProfile
         */
        vm.saveUser = function()
        {
            vm.region = vm.getRegion();
            vm.province = vm.getProvince();
            vm.city = vm.getCity();
            
            $http({
                url: config.apiUrl + 'user/update',
                method: 'POST',
                data: vm.user
            }).then(function (response) {
                // this callback will be called asynchronously
                // when the response is available
//                console.log(response, " response is available!");
                
                $mdToast.show({
                    template:
                        '<md-toast>' +
                            '<div class="md-toast-content">' +
                                '<strong class="md-accent-fg">Success!</strong>&nbsp;&nbsp;'+
                                'Profile has been saved.' +
                            '</div>' +
                        '</md-toast>',
                    hideDelay: 3000,
                    position: 'top right'
                });
                
            }, function (response) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
                console.log(response, " error occurs!");
            });
        };
        
        // upload later on form submit or something similar
        vm.uploadFiles = function (files, attachment_id, type) {
            $scope.files = files;
            if (files && files.length) {
                Upload.upload({
                    url: config.apiUrl + 'file/update',
                    data: {
                        files: files,
                        field: type,
                        attachment_id: attachment_id,
                        attachment_type: 'RainLab\\User\\Models\\User'
                    }
                }).then(function (response) {
                    
                    $scope.$evalAsync(function ()
                    {
                        var photo = response.data.return[0];
                        
                        if( type == 'avatar' )
                            vm.employee.user.avatar = photo;
                        else if( type == 'cover' )
                            vm.cover = photo.path;
                    });
                    
                }, function (response) {
//                    // called asynchronously if an error occurs
//                    // or server returns response with an error status.
                    console.log(response, " error occurs!");
                });
            }
        };
        
        vm.cover = (vm.employee.user.cover) ? vm.employee.user.cover.path : '/assets/images/backgrounds/ae-bg.jpg';
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.todo')
        .controller('TodoController', TodoController);

    /** @ngInject */
    function TodoController($stateParams, $state, $document, $mdDialog, $mdSidenav, Tasks, User, Priority, ActivityType, $filter, $http, config, msNavigationService, $mdToast)
    {
        var vm = this;

        // Data
        vm.tasks = Tasks.data;
        vm.activity_type = ActivityType.data;
        vm.completed = [];
        
        vm.selectedFilter = {
            filter : 'Date Deadline',
            dateRange: 'Today'
        };
        
        // change type by url from quick-panel to filter by type
        var type_id = ($stateParams.id) ? $stateParams.id : '';
        
        // Tasks will be filtered against these models
        vm.taskFilters = {
            search   : '',
            completed: false,
            cancelled: '',
            important: '',
            today    : '',
            type_id  : type_id,
            date_deadline: moment().add(3, 'd').format('YYYY-MM-DD HH:MM:SS')
        };
        vm.taskFiltersDefaults = angular.copy(vm.taskFilters);
        vm.showAllTasks = true;

        vm.taskOrder = '';
        vm.taskOrderDescending = false;

        vm.sortableOptions = {
            handle        : '.handle',
            forceFallback : true,
            ghostClass    : 'todo-item-placeholder',
            fallbackClass : 'todo-item-ghost',
            fallbackOnBody: true,
            sort          : true
        };
        vm.msScrollOptions = {
            suppressScrollX: true
        };
        
        vm.user = User.data;
        vm.company = vm.user.company;
        vm.acitivity_status = vm.company.activity_status;
        vm.incompleted_id = ($filter('filter')(vm.acitivity_status, {value: 'Not started'}))[0]['id'];
        vm.completed_id = ($filter('filter')(vm.acitivity_status, {value: 'Completed'}))[0]['id'];
        vm.cancelled_id = ($filter('filter')(vm.acitivity_status, {value: 'Cancelled'}))[0]['id'];
        
        // Methods
        vm.preventDefault = preventDefault;
        vm.openTaskDialog = openTaskDialog;
        vm.toggleCompleted = toggleCompleted;
        vm.toggleImportant = toggleImportant;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleFilter = toggleFilter;
        vm.toggleFilterWithEmpty = toggleFilterWithEmpty;
        vm.filterByType = filterByType;
        vm.resetFilters = resetFilters;

//        init();

        //////////

        /**
         * Initialize the controller
         */
//        function init()
//        {
//            angular.forEach(vm.tasks, function (task)
//            {
//                if ( task.date_deadline )
//                {
//                    task.date_deadline = new Date(task.date_deadline);
////                    task.date_deadlineTimestamp = task.date_deadline.getTime();
//                }
//            });
//        }

        /**
         * Prevent default
         *
         * @param e
         */
        function preventDefault(e)
        {
            e.preventDefault();
            e.stopPropagation();
        }

        /**
         * Open new task dialog
         *
         * @param ev
         * @param task
         */
        function openTaskDialog(ev, task)
        {
            $mdDialog.show({
                controller         : 'TaskDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/todo/dialogs/task/task-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Task : task,
                    Index : vm.tasks.indexOf(task),
                    Tasks: vm.tasks,
                    ActivityType: vm.activity_type,
                    ActivityStatus: vm.acitivity_status,
                    Priority: Priority.data,
                    user_id: User.data.id,
                    completed_id: vm.completed_id,
                    cancelled_id: vm.cancelled_id,
                    event: ev
                }
            });
        }

        /**
         * Toggle completed status of the task
         *
         * @param task
         * @param event
         */
        function toggleCompleted(task, event)
        {
            event.stopPropagation();
            task.status_id = task.status_id === vm.completed_id ? vm.incompleted_id : vm.completed_id;
            task.completed = !task.completed;
            
            vm.saveActivity();
        }

        /**
         * Toggle completed status of the task
         *
         * @param task
         * @param event
         */
        function toggleImportant(task, event)
        {
            event.stopPropagation();
            task.priority_id = task.priority_id === 1 ? 3 : 1;
            task.important = !task.important;
            
            vm.saveActivity();
        }
        
        /**
         * saveActivity
         */
        vm.saveActivity = function()
        {
            $http({
                url: config.apiUrl + 'activity/update',
                method: 'POST',
                data: {tasks: vm.tasks}
            }).then(function (response) {
//                console.log(response);
                
                $mdToast.show({
                    template:
                        '<md-toast>' +
                            '<div class="md-toast-content">' +
                                '<strong class="md-accent-fg">Success!</strong>&nbsp;&nbsp;'+
                                'ToDo has been saved.' +
                            '</div>' +
                        '</md-toast>',
                    hideDelay: 3000,
                    position: 'top right'
                });
                
            }, function (response) {
                console.log(response, " error occurs!");
            });
        };

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Toggles filter with true or false
         *
         * @param filter
         */
        function toggleFilter(filter)
        {
            vm.taskFilters[filter] = !vm.taskFilters[filter];

            checkFilters();
        }

        /**
         * Toggles filter with true or empty string
         * @param filter
         */
        function toggleFilterWithEmpty(filter)
        {
            if ( vm.taskFilters[filter] === '' )
            {
                vm.taskFilters[filter] = true;
            }
            else
            {
                vm.taskFilters[filter] = '';
            }
            
            checkFilters();
        }

        /**
         * Reset filters
         */
        function resetFilters()
        {
            if( $stateParams.id )
                $state.go('app.to-do');
            else
            {
                vm.showAllTasks = true;
                vm.taskFilters = angular.copy(vm.taskFiltersDefaults);
            }
        }

        /**
         * Check filters and mark showAllTasks
         * as true if no filters selected
         */
        function checkFilters()
        {
            vm.showAllTasks = !!angular.equals(vm.taskFiltersDefaults, vm.taskFilters);
        }
        
        /**
         * Filter Due Date
         *
         * @param item
         * @returns {boolean}
         */
        function filterByType(item)
        {
            return vm.taskFilters.type_id = (vm.taskFilters.type_id === item.id) ? '' : item.id;
        }
        
        // Daterange filter
        vm.dateFilter = function (property, endDate) {
            var column = vm.selectedFilter.dateRange;
            var endDate = '';
            
            if (column === 'Today')
            {
                endDate = moment()
                .format('YYYY-MM-DD');
            }
            else if (column === 'Next 3 days')
            {
                endDate = moment()
                .add(3, 'd') //replace 2 with number of days you want to add
                .format('YYYY-MM-DD');
            }
            else if (column === 'Next week')
            {
                endDate = moment()
                .add(7, 'd')
                .format('YYYY-MM-DD');
            }
            else if (column === 'Next 2 weeks')
            {
                endDate = moment()
                .add(14, 'd')
                .format('YYYY-MM-DD');
            }
            else if (column === 'Next month')
            {
                endDate = moment()
                .add(1, 'month')
                .format('YYYY-MM-DD');
            }
            
            return function (item) {
                if( column === 'All Tasks' )
                    return true;
                else
                {
                    if (item[property] === null) return false;

                    var itemDate = moment(item[property]).format('YYYY-MM-DD');
                    var s = moment().format('YYYY-MM-DD');

                    if (itemDate >= s && itemDate <= endDate) return true;

                    return false;
                }
                    
            };
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('ScrumboardController', ScrumboardController);

    /** @ngInject */
    function ScrumboardController($scope, $mdSidenav, $http, config, BoardService, DialogService, User, LeadFilters, role, Regions, Provinces, Cities, Priority, $mdToast)
    {
        var vm = this;
        $scope.role = role;

        // Data
        vm.currentView = 'board';
        vm.board = BoardService.data;
        
        vm.firstStage = vm.board.stages.length !== 0 ? vm.board.stages[0].id : [];
                
        vm.user = User.data;
        vm.company = vm.user.company;

//        vm.boards = vm.user.board_group; // get all user board not from company  vm.company.board
        vm.boards = ( !role.permissions.write ) // no authorize of managing
                   ? vm.user.board_group
                   : vm.company.board;
        vm.stages = vm.boards[0].stages;
                   
        vm.boardsTemplate = vm.company.boards;
        vm.boardSelectorVisible = false;
        vm.addLeadVisible = false;

        // Methods
        vm.toggleHeader = toggleHeader;
        vm.toggleSidenav = toggleSidenav;
        vm.updateBoardUri = updateBoardUri;
        vm.clearFilters = LeadFilters.clear;
        vm.filteringIsOn = LeadFilters.isOn;
        vm.openLeadDialog = DialogService.openLeadDialog;
        
        vm.data = {
            Regions:         Regions.data,
            Provinces:       Provinces.data,
            Cities:          Cities.data,
            Boards:          vm.boards,
            Stages:          vm.stages,
            company:         vm.company,
            Priority:        Priority.data,
            Projects:        vm.user.employee.project,
            role:            role,
            Contacts:        vm.company.contact,
            groups:          vm.user.groups,
            user_id:         vm.user.id
        };
        
        // if permission == 'write' && board.user_id is not for user && permission == 'none' || permission == 'view' not allowed
        vm.isDisabled = (!role.permissions.write && vm.board.user_id === null && vm.board.permission != 'modify');

        ////////

        /**
         * Update Board Uri
         *
         * Once you connect your app to your server,
         * you would do this on your API server.
         */
        function updateBoardUri()
        {
            if ( vm.board.getById(vm.board.id) )
            {
                vm.board.getById(vm.board.id).name = vm.board.name;
                vm.board.getById(vm.board.id).uri = vm.board.uri = encodeURIComponent(vm.board.name).replace(/%20/g, '-').toLowerCase();
            }
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleHeader(button)
        {
            if( button == 'board' )
            {
                vm.boardSelectorVisible = !vm.boardSelectorVisible;
                vm.addLeadVisible = false;
            }
            else if( button == 'lead' )
            {
                vm.addLeadVisible = !vm.addLeadVisible;
                vm.boardSelectorVisible = false;
            }
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        };
        
        /**
         * saveUser
         */
        vm.saveUser = function()
        {
            $http({
                url: config.apiUrl + 'board/update',
                method: 'POST',
                data: {board: vm.board}
            }).then(function (response) {
                // this callback will be called asynchronously
                // when the response is available
//                console.log(response, " response is available!");
                var index = vm.boards.map(function(o) { return o.id; }).indexOf(vm.board.id);
                // change boards title in the scrumboard
                if( response.data.changes.board.title )
                    vm.boards[index].title = response.data.changes.board.title;
                
                $mdToast.show({
                    template:
                        '<md-toast>' +
                            '<div class="md-toast-content">' +
                                '<strong class="md-accent-fg">Success!</strong>&nbsp;&nbsp;'+
                                'Board has been saved.' +
                            '</div>' +
                        '</md-toast>',
                    hideDelay: 3000,
                    position: 'top right'
                });
                
            }, function (response) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
                console.log(response, " error occurs!");
            });
        };

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.imports',
            [
                // 3rd Party Dependencies
                'datatables'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, config, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.imports_import', {
                url      : '/import',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/imports/views/import/import.html',
                        controller : 'ImportsController as vm'
                    }
                },
                resolve  : {
                    User           : function (msApi)
                    {
                        return msApi.resolve('user.import@get');
                    },
                    role  : function ()
                    {
                        var roles = JSON.parse(localStorage.getItem('roles'));
                        if( roles )
                        {
                            var role = roles.filter(function ( obj ) {
                                return obj.url === '/boards/:id';
                            })[0];
                            
                            return role;
                        }
                    }
                },
                bodyClass: 'imports printable'
            })
            .state('app.imports_import.lead', {
                url      : '/lead/:item',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/imports/views/import/lead.html',
                        controller : 'ImportsController as vm'
                    }
                },
                bodyClass: 'imports printable',
                role: {
                    url: '/import'
                }
            })
            .state('app.imports_import.rule', {
                url      : '/rule/:item',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/imports/views/rule/rule.html',
                        controller : 'ImportsController as vm'
                    }
                },
                bodyClass: 'imports printable',
                role: {
                    url: '/import'
                }
            })
            .state('app.imports_import.rule.form', {
                url      : '/form',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/imports/views/rule/form.html',
                        controller : 'ImportsController as vm'
                    }
                },
                bodyClass: 'imports printable',
                role: {
                    url: '/import'
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/imports');

        // Api
        msApiProvider.register('imports', ['app/data/imports/imports.json']);
        msApiProvider.register('user.import', [config.apiUrl + 'import.json']);
        
        // Navigation
        msNavigationServiceProvider.saveItem('apps.pages.settings.imports', {
            title : 'Import',
//            icon  : 'icon-import',
            state : 'app.imports_import',
            weight: 16,
            hidden: function ()
            {
                var roles = JSON.parse(localStorage.getItem('roles'));
                if( roles )
                {
                    var role = roles.filter(function ( obj ) {
                        return obj.url === '/import';
                    })[0];

                    return !role.permissions.write;
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.imports')
        .controller('ImportsController', ImportsController);

    /** @ngInject */
    function ImportsController($scope, User, $state, $location, $filter, config, $http, $mdToast, $timeout, role)
    {
        var vm = this;

        // Data
        vm.user = User.data;
        vm.company = vm.user.company;
        
        // now using the role to get the board
//        vm.board = vm.company.board; // not the board of the company but the user/group board
//        vm.board = vm.user.board_group;
        vm.board = ( !role.permissions.write ) // no authorize of managing
                   ? vm.user.board_group
                   : vm.company.board;
                   
        vm.source = vm.company.source;
        
        vm.gotoOption = gotoOption;
        vm.rules = vm.user.rule;
        
        vm.url = $location.path().split('/');
        vm.item = vm.url[3];
        
        vm.leads = {
            'csv' : "CSV File",
            'cs1' : "Coming soon",
            'cs2' : "Coming soon"
        };
        
        vm.frequencies = {
            0      : "disable",
            60     : "every minute",
            300    : "every 5 minutes",
            3600   : "hourly",
            86400  : "daily",
            604800 : "weekly",
        };
                
        vm.lead = {
            radio : [
                { value: 'csv', label: 'CSV file', desc: 'Import leads from .csv files' },
                { value: 'cv', label: 'Copy/paste from file', desc: 'Copy and paste leads from files' },
                { value: 'integrated', label: 'Integrated services', desc: 'Import leads from services like Facebook and more.' }
            ],
            field : vm.user.field,
            boards : vm.board,
            sources : vm.source
        };
        
        // Methods

        //////////
        
        // upload later on form submit or something similar
        vm.uploadFiles = function (files)
        {
            vm.dataReset();
            
            if (angular.isArray(files)) {
                if ( typeof files[0] !== 'undefined' )
                    getAsText(files[0]);
            }
        };
        
        vm.processData = function (headers, records)
        {
            var fields = {};
            angular.forEach(vm.lead.field, function(field, key) {
                fields[key] = headers;
                if( headers.indexOf(key) === -1 )
                {
                    if( key == 'board_id' )
                    {
                        vm.lead.board = vm.lead.boards[0];
                        var board = {};
                        for (var j in vm.lead.boards)
                        {
                            var k = vm.lead.boards[j];
                            board[k.id] = k.title;
                        }
                        fields[key] = board;
                    }
                    else if( key == 'status_id' )
                    {
                        vm.lead.stages = vm.lead.board.stage;
                        fields[key] = {};
                    }
                    else if( key == 'source_id' )
                    {
                        var source = {};
                        for (var j in vm.lead.sources)
                        {
                            var k = vm.lead.sources[j];
                            source[k.id] = k.value;
                        }
                        fields[key] = source;
                    }
                }
            });
            
            vm.lead.board_stage = (Object.keys(vm.lead.board).length > 0); // using the deafult board_stage
            
            vm.data = {
                field: fields,
                value: records
            };
            
//            console.log(vm.data);
        }
        
        vm.importPreview = function()
        {
            if( vm.lead.board_stage )
            {
                var title;
                var datas = vm.data.value;
                for ( var i = 0; i < datas.length; i++) 
                {
                    var val = datas[i];

                    var ivalue = {}, ipreview = {};
                    for (var j in vm.import.field) 
                    {
                        var key = vm.import.field[j];

                        if( j == 'board_id' || j == 'status_id' || j == 'source_id' )
                        {
                            if( j == 'board_id' )
                                title = vm.lead.board.title;
                            else if( j == 'status_id' )
                                title = vm.lead.stage.value;
                            else if( j == 'source_id' )
                                title = vm.lead.source.value;

                            ivalue[j] = key;
                            ipreview[j] = title;
                        }
                        else
                        {
                            ivalue[j] = val[key];
                            ipreview[j] = val[key];
                        }
                    }
                    
                    vm.import.pview = "true";
                    
                    vm.import.value[i] = ivalue;
                    
                    if( i < 10 ) // limit preview to 10
                        vm.import.preview[i] = ipreview;
                    
//                    console.log(vm.import);
                }
            }
            else
            {
                vm.import.view = "";
                $http({
                    url: config.apiUrl + 'lead/import/preview',
                    method: 'POST',
                    data: {fields: vm.import.field, values: vm.data.value, lead: {'boards' : vm.lead.boards, 'board_stage' : vm.lead.board_stage, 'sources' : vm.lead.sources}}
                }).then(function (response) {

                    vm.import.pview = "true";
                    
                    var csv = response.data.csv;
                    vm.import.value = csv.value;
                    vm.import.preview = csv.preview;

                }, function (response) {
                    console.log(response, " error occurs!");
                });
            }
            
            vm.import.preview_limit = (Object.keys(vm.import.field).length > 6) ? 2 : 1;
        };
        
        vm.importLead = function()
        {
            vm.import.start = "true";
            vm.import.btn_imp = "Processing...";
            vm.import.user_id = vm.user.id;
            
            $http({
                url: config.apiUrl + 'lead/import/save',
                method: 'POST',
                data: vm.import
            }).then(function (response) {
                
                // reset function here;
                vm.dataReset();

                // this callback will be called asynchronously
                // when the response is available
                $mdToast.show({
                    template:
                        '<md-toast>' +
                            '<div class="md-toast-content">' +
                                '<strong class="md-accent-fg">Success!</strong>&nbsp;&nbsp;'+
                                'Importing Done.' +
                            '</div>' +
                        '</md-toast>',
                    hideDelay: 3000,
                    position: 'top right'
                });
                
            }, function (response) {
                console.log(response, " error occurs!");
            });
        };
        
        vm.updateBoard = function (lkey)
        {
            if( vm.lead.board_stage )
            {
                if( lkey === 'board_id' && vm.import.field.board_id )
                {
                    vm.lead.board = $filter('filter')(vm.lead.boards, {id: vm.import.field.board_id})[0];
                    vm.lead.stages = vm.lead.board.stages;
                    
                    var stages = {};
                    for (var j in vm.lead.stages)
                    {
                        var k = vm.lead.stages[j];
                        stages[k.id] = k.value;
                    }
                    vm.data.field['status_id'] = stages;
                }
                else if( lkey === 'status_id' && vm.import.field.status_id )
                {
                    vm.lead.stage = $filter('filter')(vm.lead.stages, {id: vm.import.field.status_id})[0];
                }
                else if( lkey === 'source_id' && vm.import.field.source_id )
                {
                    vm.lead.source = $filter('filter')(vm.lead.sources, {id: vm.import.field.source_id})[0];
                }
            }
        }
        
        vm.btn_next = function(index, trigger)
        {
            if (index === 0 && typeof trigger === 'boolean')
            {
                $timeout(function (){
                    angular.element('.btn-prop.'+vm.item).trigger('click');
                });
            }
            else if (index === 1) // if in properties tab = next button
                    vm.importPreview();
            }

        function getAsText(fileToRead) {
            var reader = new FileReader();
            // Read file into memory as UTF-8      
            reader.readAsText(fileToRead);
            // Handle errors load
            reader.onload = loadHandler;
            reader.onerror = errorHandler;
        }

        function loadHandler(event) {
            var csv = event.target.result;
            
            // split content based on new line
            var csvs = csv.split(/\r\n|\n/);
            var headers = csvs[0].split(',');
            
            var records = [];
            angular.forEach(csvs.slice(1, csvs.length), function(record, i) {
                if( headers.length === record.split(',').length )
                    records[i] = record.split(',');
            });
            
            vm.processData(headers, records);
            
            vm.csv.connected = "true";
            vm.btn_next(0, true);
        }

        function errorHandler(evt) {
            if (evt.target.error.name == "NotReadableError") {
                alert("Canno't read file !");
            }
        }

        /**
         * Go to properties page
         */
        function gotoOption(type, item)
        {
            $state.go('app.imports_import.'+ type, {item: item});
        }
        
        vm.dataReset = function ()
        {
            if( vm.item === 'csv' )
            {
                vm.csv = {
                    connected: ""
                };
            }
            else if( vm.item === 'integrated' || vm.item === 'lists' )
            {
                vm.integration = {
                    page: "",
                    form: "",
                    frequency: "",
                    service: "",
                    preview: ""
                };
            }
            
            vm.lead.board = {};
            vm.lead.stage = {};
            
            vm.import = {
                field   : {},
                value   : [],
                preview : [],
                start   : "",
                btn_imp : "Finish Import"
            };
            
            vm.data = {
                field : {
                    board_id: {},
                    status_id: {}
                },
                value : {},
                import: false
            };
        }

        /*
         * INTEGRATION SERVICES
         */
        // fb connect
        vm.fb_permission = function(data)
        {
            vm.dataReset();
            
            FB.login(function(response){
                    //if permission granted
                    if( response['status'] == "connected" )
                    {
                        vm.integration.service = "Facebook";
                        
                        $http({
                            url: config.crmUrl + 'facebook/extend_access',
                            method: 'POST',
                            data: {token: response.authResponse.accessToken}
                        }).then(function (res) {
//                            var access_token = response.data.access_token;
                            vm.integration.access_token = res.data.access_token;
                            
                            // saveRule if data
                            if( data )
                            {
                                data.access_token = vm.integration.access_token;
                                data.error_token  = 0;
                                
                                vm.saveRule(data);
                            }
                            else
                            {
                                // this is only for form rule
                                FB.api('/me/accounts', function(r) {
                                    vm.lead.pages = r.data;

                                    $timeout(function (){
                                        vm.btn_next(0, true);
                                    });
                                });
                            }
                            
                        }, function (response) {
                            console.log(response, " error occurs!");
                        });
                    }
                    else
                    {
                        alert('Permission denied or not logged in.');
                    }
                },
                {
                    scope: 'manage_pages'
                }

            );
        }
        
        vm.subscribeApp = function()
        {
            vm.integration.preview = "";
            vm.integration.form = "";
            
            var page_id = vm.integration.page.id;
            
            FB.api(
                '/' + page_id + '/leadgen_forms',
                {access_token: vm.integration.page.access_token},
                function(response) {
                    vm.lead.forms = response.data;
            });
        }
        
        vm.getLeads = function()
        {
            vm.integration.preview = "";

            vm.import = {
                field   : {},
                value   : [],
                preview : [],
                start   : "",
                btn_imp : "Finish Import"
            };
            
            vm.data = {
                field : {},
                value : {},
                import: false
            };
            
            var form_id = vm.integration.form.id;
            
            FB.api(
                '/' + form_id + '?fields=id,name,qualifiers,created_time,leads_count,page_id,leads',
//                {access_token: vm.integration.page.access_token},
                {access_token: vm.integration.access_token},
                function(response) {
                    
                    if( vm.item === "integrated" )
                    {
                        if( response.leads_count > 0 )
                        {
                            response.item = vm.item;
                            
                            $http({
                                url: config.apiUrl + 'lead/import/data',
                                method: 'POST',
                                data: response
                            }).then(function (res) {
                                var headers = res.data.field;
                                var records = res.data.value;
                                
                                vm.processData(headers, records);

                            }, function (res) {
                                console.log(res, " error occurs!");
                            });

                            vm.integration.preview = "true";
                        }
                        else
                        {
                            vm.integration.form = "";

                            $mdToast.show({
                                template:
                                    '<md-toast>' +
                                        '<div class="md-toast-content">' +
                                            '<strong class="md-warn-fg">Sorry!</strong>&nbsp;&nbsp;' +
                                            'No leads found.' +
                                        '</div>' +
                                    '</md-toast>',
                                hideDelay: 3000,
                                position: 'top right'
                            });
                        }
                }
                else if( vm.item === "lists" )
                {
                    // for rule
                    vm.processData([], []);
                }
            });
        }
        

        //////////
        /*
         * RULES
         */
        vm.dtInstance = {};
        vm.dtOptions = {
            dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType  : 'simple',
            lengthMenu  : [10, 20, 30, 50, 100],
            pageLength  : 20,
            scrollY     : 'auto',
            responsive  : true
        };
        
        vm.saveRule = function(data)
        {
            vm.loaderText1 = "Saving...";
            vm.integration.board_id  = vm.lead.board.id;
            vm.integration.stage_id  = vm.lead.stage.id;
            vm.integration.source_id = vm.lead.source.id;
            
            $http({
                url: config.apiUrl + 'lead/import/rule',
                method: 'POST',
                data: {integration: ( data ) ? data : vm.integration, user_id: vm.user.id}
            }).then(function (response) {
                // this callback will be called asynchronously
                // when the response is available
                
                // reset function here;
//                vm.loaderText1 = "";
//                vm.dataReset();
                // get all rules
//                vm.rules = response.data.rules;
                
                $mdToast.show({
                    template:
                        '<md-toast>' +
                            '<div class="md-toast-content">' +
                                '<strong class="md-accent-fg">Success!</strong>&nbsp;&nbsp;'+
                                'Rule has been saved.' +
                            '</div>' +
                        '</md-toast>',
                    hideDelay: 3000,
                    position: 'top right'
                });
                
                if( vm.url[4] === 'form' )
                    $state.go('app.imports_import.rule', {item: 'lists'}, {reload: true});
        
            }, function (response) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
                console.log(response, " error occurs!");
            });
        };
        
        /**
         * onDelete
         */
        vm.onDelete = function(data)
        {
            $http({
                url: config.apiUrl + 'model/delete',
                method: 'DELETE',
                headers: {'Content-Type': 'application/json'},
                data: data
            }).then(function (response) {
                // this callback will be called asynchronously
                // when the response is available
//                console.log(response, " response is available!");
                
                vm.rules.splice(vm.rules.indexOf(data), 1);
                
            }, function (response) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
                console.log(response, " error occurs!");
            });
        };
        
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.employees')
        .controller('EmployeesController', EmployeesController);

    /** @ngInject */
    function EmployeesController($scope, $mdSidenav, $http, User, msUtils, $mdDialog, $document, config, $rootScope, $mdToast)
    {

        var vm = this;

        // Data
        vm.user = User.data;
        vm.employees = vm.user.company.employee;
        vm.crmUrl = config.crmUrl;
//        console.log(vm.employees);
//        console.log(vm.user.groups);
        vm.filterIds = null;
        vm.listType = 'all';
        vm.listOrder = 'name';
        vm.listOrderAsc = false;
        vm.selectedEmployees = [];
        vm.newGroupName = '';

        // Methods
        vm.filterChange = filterChange;
        vm.openEmployeeDialog = openEmployeeDialog;
        vm.deleteEmployee = deleteEmployee;
        vm.deleteEmployeeConfirm = deleteEmployeeConfirm;
        vm.deleteSelectedEmployees = deleteSelectedEmployees;
        vm.toggleSelectEmployee = toggleSelectEmployee;
        vm.deselectEmployees = deselectEmployees;
        vm.selectAllEmployees = selectAllEmployees;
        vm.addNewGroup = addNewGroup;
        vm.deleteGroup = deleteGroup;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        vm.groupEmployee = groupEmployee;
        vm.phoneCode = '+63';

        //////////

        /**
         * Change Employees List Filter
         * @param type
         */
        function filterChange(type)
        {

            vm.listType = type;

            if ( type === 'all' )
            {
                vm.filterIds = null;
            }
            else if ( type === 'frequent' )
            {
                vm.filterIds = vm.user.frequentEmployees;
            }
            else if ( type === 'starred' )
            {
                vm.filterIds = vm.user.starred;
            }
            else if ( angular.isObject(type) )
            {
                vm.filterIds = type.users_id;
            }

            vm.selectedEmployees = [];

        }

        /**
         * Open new employee dialog
         *
         * @param ev
         * @param employee
         */
        function openEmployeeDialog(ev, employee)
        {
            $mdDialog.show({
                controller         : 'EmployeeDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/employees/dialogs/employee/employee-dialog.html',
                parent             : angular.element($document.find('#content-container')),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    User     : User,
                    Employee : employee,
                    Employees: vm.employees,
                    role     : $rootScope.role
                }
            });
        }

        /**
         * Delete Employee Confirm Dialog
         */
        function deleteEmployeeConfirm(ev, data, type)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the employee?')
                .htmlContent('<b>' + data.first_name + ' ' + (data.last_name ? data.last_name : '') + '</b>' + ' will be deleted.')
                .ariaLabel('delete employee')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {
                vm.onDelete({model: type, checked: [data.id]});

                vm.employees.splice(vm.employees.indexOf(data), 1);
                
                vm.selectedEmployees = [];
            }, function ()
            {

            });
        }
        
        //////////
        /**
         * onDelete
         */
        vm.onDelete = function(data)
        {
            $http({
                url: config.apiUrl + 'model/delete',
                method: 'DELETE',
                headers: {'Content-Type': 'application/json'},
                data: data
            }).then(function (response) {
                // this callback will be called asynchronously
                // when the response is available
//                console.log(response, " response is available!");
            }, function (response) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
                console.log(response, " error occurs!");
            });
        };

        /**
         * Delete Selected Employees
         */
        function deleteSelectedEmployees(ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the selected employees?')
                .htmlContent('<b>' + vm.selectedEmployees.length + ' selected</b>' + ' will be deleted.')
                .ariaLabel('delete employees')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {
                var employee_ids = [];
                vm.selectedEmployees.forEach(function (employee, i)
                {
                    deleteEmployee(employee);
                    employee_ids[i] = employee.id;
                });
                vm.onDelete({model: 'employee', checked: employee_ids});

                vm.selectedEmployees = [];

            });

        }

        /**
         * Delete Contact
         */
        function deleteEmployee(employee)
        {
            vm.employees.splice(vm.employees.indexOf(employee), 1);
        }

        /**
         * Toggle selected status of the employee
         *
         * @param employee
         * @param event
         */
        function toggleSelectEmployee(employee, event)
        {
            if ( event )
            {
                event.stopPropagation();
            }

            if ( vm.selectedEmployees.indexOf(employee) > -1 )
            {
                vm.selectedEmployees.splice(vm.selectedEmployees.indexOf(employee), 1);
            }
            else
            {
                vm.selectedEmployees.push(employee);
            }
        }

        /**
         * Deselect employees
         */
        function deselectEmployees()
        {
            vm.selectedEmployees = [];
        }

        /**
         * Sselect all employees
         */
        function selectAllEmployees()
        {
            vm.selectedEmployees = $scope.filteredEmployees;
        }

        /**
         *
         */
        function addNewGroup()
        {
            if ( vm.newGroupName === '' )
            {
                return;
            }

            var newGroup = {
                'id'        : msUtils.guidGenerator(),
                'name'      : vm.newGroupName,
                'employeeIds': []
            };

            vm.user.groups.push(newGroup);
            vm.newGroupName = '';
        }
        
        /**
         * Group employee
         */
        function groupEmployee(type, group, employee_id)
        {
            $http({
                url: config.apiUrl + 'group/update',
                method: 'POST',
                data: {type: type, employee_id: employee_id, group: group}
            }).then(function (response) {
                // this callback will be called asynchronously
                // when the response is available
//                console.log(response, " response is available!");
                vm.user.groups = response.data.data.groups;
                
                $mdToast.show({
                    template:
                        '<md-toast>' +
                            '<div class="md-toast-content">' +
                                '<strong class="md-accent-fg">Success!</strong>&nbsp;&nbsp;'+
                                'Employee has been saved.' +
                            '</div>' +
                        '</md-toast>',
                    hideDelay: 3000,
                    position: 'top right'
                });
                
            }, function (response) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
                console.log(response, " error occurs!");
            });
        }

        /**
         * Delete Group
         */
        function deleteGroup(ev)
        {
            var group = vm.listType;

            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the group?')
                .htmlContent('<b>' + group.name + '</b>' + ' will be deleted.')
                .ariaLabel('delete group')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {

                vm.user.groups.splice(vm.user.groups.indexOf(group), 1);

                filterChange('all');
            });

        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.contacts')
        .controller('ContactsController', ContactsController);

    /** @ngInject */
    function ContactsController($scope, $mdSidenav, Contacts, User, msUtils, $mdDialog, $document, Regions, Provinces, Cities, config, $http)
    {

        var vm = this;

        // Data
//        vm.contacts = Contacts.data;
        vm.user = User.data;
        vm.employee = vm.user.employee;
        vm.company = vm.user.company;
        vm.contacts = vm.company.contact;
        // or ???
//        vm.contacts = vm.user.contact;
        vm.filterIds = null;
        vm.listType = 'all';
        vm.listOrder = 'name';
        vm.listOrderAsc = false;
        vm.selectedContacts = [];
        vm.newGroupName = '';
        
        vm.phoneCode = '+63';
        vm.crmUrl = config.crmUrl;

        // Methods
        vm.filterChange = filterChange;
        vm.openContactDialog = openContactDialog;
        vm.deleteContactConfirm = deleteContactConfirm;
        vm.deleteContact = deleteContact;
        vm.deleteSelectedContacts = deleteSelectedContacts;
        vm.toggleSelectContact = toggleSelectContact;
        vm.deselectContacts = deselectContacts;
        vm.selectAllContacts = selectAllContacts;
        vm.deleteContact = deleteContact;
        vm.addNewGroup = addNewGroup;
        vm.deleteGroup = deleteGroup;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;

        //////////

        /**
         * Change Contacts List Filter
         * @param type
         */
        function filterChange(type)
        {

            vm.listType = type;

            if ( type === 'all' )
            {
                vm.filterIds = null;
            }
            else if ( type === 'frequent' )
            {
                vm.filterIds = vm.user.frequentContacts;
            }
            else if ( type === 'starred' )
            {
                vm.filterIds = vm.user.starred;
            }
            else if ( angular.isObject(type) )
            {
                vm.filterIds = type.contactIds;
            }

            vm.selectedContacts = [];

        }
        
        vm.data = {
            Regions:         Regions.data,
            Provinces:       Provinces.data,
            Cities:          Cities.data
        };

        /**
         * Open new contact dialog
         *
         * @param ev
         * @param contact
         */
        function openContactDialog(ev, contact)
        {
            $mdDialog.show({
                controller         : 'ContactDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/contacts/dialogs/contact/contact-dialog.html',
                parent             : angular.element($document.find('#content-container')),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Contact : contact,
                    User    : vm.user,
                    Contacts: vm.contacts,
                    data    : vm.data
                }
            });
        }

        /**
         * Delete Contact Confirm Dialog
         */
        function deleteContactConfirm(contact, ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the contact?')
                .htmlContent('<b>' + contact.first_name + ' ' + contact.last_name + '</b>' + ' will be deleted.')
                .ariaLabel('delete contact')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {

                deleteContact(contact);
                
                vm.onDelete({model: 'contact', checked: [contact.id]});
                
                vm.selectedContacts = [];

            }, function ()
            {

            });
        }

        /**
         * Delete Contact
         */
        function deleteContact(contact)
        {
            vm.contacts.splice(vm.contacts.indexOf(contact), 1);
        }

        /**
         * Delete Selected Contacts
         */
        function deleteSelectedContacts(ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the selected contacts?')
                .htmlContent('<b>' + vm.selectedContacts.length + ' selected</b>' + ' will be deleted.')
                .ariaLabel('delete contacts')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {
                var contact_ids = [];
                vm.selectedContacts.forEach(function (contact, i)
                {
                    deleteContact(contact);
                    contact_ids[i] = contact.id;
                });
                vm.onDelete({model: 'contact', checked: contact_ids});

                vm.selectedContacts = [];

            });

        }
        
        /**
         * onDelete
         */
        vm.onDelete = function(data)
        {
            $http({
                url: config.apiUrl + 'model/delete',
                method: 'DELETE',
                headers: {'Content-Type': 'application/json'},
                data: data
            }).then(function (response) {
                // this callback will be called asynchronously
                // when the response is available
//                console.log(response, " response is available!");
            }, function (response) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
                console.log(response, " error occurs!");
            });
        };

        /**
         * Toggle selected status of the contact
         *
         * @param contact
         * @param event
         */
        function toggleSelectContact(contact, event)
        {
            if ( event )
            {
                event.stopPropagation();
            }

            if ( vm.selectedContacts.indexOf(contact) > -1 )
            {
                vm.selectedContacts.splice(vm.selectedContacts.indexOf(contact), 1);
            }
            else
            {
                vm.selectedContacts.push(contact);
            }
        }

        /**
         * Deselect contacts
         */
        function deselectContacts()
        {
            vm.selectedContacts = [];
        }

        /**
         * Sselect all contacts
         */
        function selectAllContacts()
        {
            vm.selectedContacts = $scope.filteredContacts;
        }

        /**
         *
         */
        function addNewGroup()
        {
            if ( vm.newGroupName === '' )
            {
                return;
            }

            var newGroup = {
                'id'        : msUtils.guidGenerator(),
                'name'      : vm.newGroupName,
                'contactIds': []
            };

            vm.user.groups.push(newGroup);
            vm.newGroupName = '';
        }

        /**
         * Delete Group
         */
        function deleteGroup(ev)
        {
            var group = vm.listType;

            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the group?')
                .htmlContent('<b>' + group.name + '</b>' + ' will be deleted.')
                .ariaLabel('delete group')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {

                vm.user.groups.splice(vm.user.groups.indexOf(group), 1);

                filterChange('all');
            });

        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.companies')
        .controller('CompaniesController', CompaniesController);

    /** @ngInject */
    function CompaniesController($scope, $mdSidenav, User, msUtils, $mdDialog, $document, Regions, Provinces, Cities, config, $http)
    {

        var vm = this;

        // Data
        vm.user = User.data;
        vm.employee = vm.user.employee;
        vm.company = vm.user.company;
        vm.companies = vm.company.company;
        vm.filterIds = null;
        vm.listType = 'all';
        vm.listOrder = 'name';
        vm.listOrderAsc = false;
        vm.selectedCompanies = [];
        vm.newGroupName = '';
        
        vm.phoneCode = '+63';
        vm.crmUrl = config.crmUrl;

        // Methods
        vm.filterChange = filterChange;
        vm.openCompanyDialog = openCompanyDialog;
        vm.deleteCompanyConfirm = deleteCompanyConfirm;
        vm.deleteCompany = deleteCompany;
        vm.deleteSelectedCompanies = deleteSelectedCompanies;
        vm.toggleSelectCompany = toggleSelectCompany;
        vm.deselectCompanies = deselectCompanies;
        vm.selectAllCompanies = selectAllCompanies;
        vm.deleteCompany = deleteCompany;
        vm.addNewGroup = addNewGroup;
        vm.deleteGroup = deleteGroup;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;

        //////////

        /**
         * Change Companies List Filter
         * @param type
         */
        function filterChange(type)
        {

            vm.listType = type;

            if ( type === 'all' )
            {
                vm.filterIds = null;
            }
            else if ( type === 'frequent' )
            {
                vm.filterIds = vm.user.frequentCompanies;
            }
            else if ( type === 'starred' )
            {
                vm.filterIds = vm.user.starred;
            }
            else if ( angular.isObject(type) )
            {
                vm.filterIds = type.companyIds;
            }

            vm.selectedCompanies = [];

        }
        
        vm.data = {
            Regions:         Regions.data,
            Provinces:       Provinces.data,
            Cities:          Cities.data
        };

        /**
         * Open new company dialog
         *
         * @param ev
         * @param company
         */
        function openCompanyDialog(ev, company)
        {
            $mdDialog.show({
                controller         : 'CompanyDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/companies/dialogs/company/company-dialog.html',
                parent             : angular.element($document.find('#content-container')),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Company : company,
                    User    : vm.user,
                    data    : vm.data
                }
            });
        }

        /**
         * Delete Company Confirm Dialog
         */
        function deleteCompanyConfirm(company, ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the company?')
                .htmlContent('<b>' + company.name + '</b>' + ' will be deleted.')
                .ariaLabel('delete company')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {

                deleteCompany(company);
                
                vm.onDelete({model: 'company', checked: [company.id]});
                
                vm.selectedCompanies = [];

            }, function ()
            {

            });
        }

        /**
         * Delete Company
         */
        function deleteCompany(company)
        {
            vm.companies.splice(vm.companies.indexOf(company), 1);
        }

        /**
         * Delete Selected Companies
         */
        function deleteSelectedCompanies(ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the selected companies?')
                .htmlContent('<b>' + vm.selectedCompanies.length + ' selected</b>' + ' will be deleted.')
                .ariaLabel('delete companies')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {
                var company_ids = [];
                vm.selectedCompanies.forEach(function (company, i)
                {
                    deleteCompany(company);
                    company_ids[i] = company.id;
                });
                vm.onDelete({model: 'company', checked: company_ids});

                vm.selectedCompanies = [];

            });

        }
        
        /**
         * onDelete
         */
        vm.onDelete = function(data)
        {
            $http({
                url: config.apiUrl + 'model/delete',
                method: 'DELETE',
                headers: {'Content-Type': 'application/json'},
                data: data
            }).then(function (response) {
                // this callback will be called asynchronously
                // when the response is available
                console.log(response, " response is available!");
            }, function (response) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
                console.log(response, " error occurs!");
            });
        };

        /**
         * Toggle selected status of the company
         *
         * @param company
         * @param event
         */
        function toggleSelectCompany(company, event)
        {
            if ( event )
            {
                event.stopPropagation();
            }

            if ( vm.selectedCompanies.indexOf(company) > -1 )
            {
                vm.selectedCompanies.splice(vm.selectedCompanies.indexOf(company), 1);
            }
            else
            {
                vm.selectedCompanies.push(company);
            }
        }

        /**
         * Deselect companies
         */
        function deselectCompanies()
        {
            vm.selectedCompanies = [];
        }

        /**
         * Sselect all companies
         */
        function selectAllCompanies()
        {
            vm.selectedCompanies = $scope.filteredCompanies;
        }

        /**
         *
         */
        function addNewGroup()
        {
            if ( vm.newGroupName === '' )
            {
                return;
            }

            var newGroup = {
                'id'        : msUtils.guidGenerator(),
                'name'      : vm.newGroupName,
                'companyIds': []
            };

            vm.user.groups.push(newGroup);
            vm.newGroupName = '';
        }

        /**
         * Delete Group
         */
        function deleteGroup(ev)
        {
            var group = vm.listType;

            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the group?')
                .htmlContent('<b>' + group.name + '</b>' + ' will be deleted.')
                .ariaLabel('delete group')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {

                vm.user.groups.splice(vm.user.groups.indexOf(group), 1);

                filterChange('all');
            });

        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.calendar')
        .controller('CalendarController', CalendarController);

    /** @ngInject */
    function CalendarController($mdDialog, $document, Calendar, $http, config, $mdToast, $state)
    {
        var vm = this;
        
        // Data
        vm.user = Calendar.data;
        vm.integration = vm.user.integration;
        vm.calendar = vm.user.calendar;
        vm.event = vm.calendar.events;
        vm.events = [vm.event];
        
        // once here in the calendar sync once
        if( vm.integration.GAuth && localStorage.getItem('doSyncCalendar') == null )
        {
            // run the sync function
            $http({
                url: config.crmUrl + 'google/sync/' + vm.calendar.id
            }).then(function (response) {
                console.log(response);
                
                if( response.data.error == "invalid" )
                {
                    $state.go('app.pages_settings_integration.calendar', {item: 'google'});

                    vm.status1 = '';
                    vm.text1 = 'Please connect to Google Calendar.';
                }
                else
                {
                    if( response.data.data.calendar )
                    {
                        $state.go('app.calendar', {}, {reload: true});
                        
                        vm.event = response.data.data.calendar;
                        vm.events = [vm.event];
                        
                        vm.status1 = '<strong class="md-accent-fg">Success!</strong>&nbsp;&nbsp;';
                        vm.text1 = 'Google Calendar synced.';

                        localStorage.setItem('doSyncCalendar', 1);
                    }
                }
                
                // this callback will be called asynchronously
                // when the response is available
                $mdToast.show({
                    template:
                        '<md-toast>' +
                            '<div class="md-toast-content">' +
                                vm.status1 +
                                vm.text1 +
                            '</div>' +
                        '</md-toast>',
                    hideDelay: 3000,
                    position: 'top right'
                });

            }, function (response) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
                console.log(response, " error occurs!");
            });
        }
        
        vm.calendarUiConfig = {
            calendar: {
                editable          : true,
                eventLimit        : true,
                header            : '',
                handleWindowResize: false,
                aspectRatio       : 1,
                dayNames          : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                dayNamesShort     : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                viewRender        : function (view)
                {
                    vm.calendarView = view;
                    vm.calendar = vm.calendarView.calendar;
                    vm.currentMonthShort = vm.calendar.getDate().format('MMM');
                },
                columnFormat      : {
                    month: 'ddd',
                    week : 'ddd D',
                    day  : 'ddd M'
                },
                eventDrop                : function (event)
                { 
                    var data = {
                        id           : event.id,
                        title        : event.title,
                        start        : event.start,
                        end          : event.end,
                        all_day_event: event.all_day_event,
                        location     : event.location,
                        notes        : event.notes,
                        event_id     : event.event_id
                    };
                    
                    vm.onUpdate({model: 'event', data: data});
                },
                eventClick        : eventDetail,
                selectable        : true,
                selectHelper      : true,
                select            : select
            }
        };

        // Methods
        vm.addEvent = addEvent;
        vm.next = next;
        vm.prev = prev;

        //////////

        /**
         * Go to next on current view (week, month etc.)
         */
        function next()
        {
            vm.calendarView.calendar.next();
        }

        /**
         * Go to previous on current view (week, month etc.)
         */
        function prev()
        {
            vm.calendarView.calendar.prev();
        }

        /**
         * Show event detail
         *
         * @param calendarEvent
         * @param e
         */
        function eventDetail(calendarEvent, e)
        {
            showEventFormDialog('edit', calendarEvent, false, false, e);
        }

        /**
         * Add new event in between selected dates
         *
         * @param start
         * @param end
         * @param e
         */
        function select(start, end, e)
        {
            showEventFormDialog('add', false, start, end, e);
        }

        /**
         * Add event
         *
         * @param e
         */
        function addEvent(e)
        {
            var start = new Date(),
                end = new Date();

            showEventFormDialog('add', false, start, end, e);
        }

        /**
         * Show event detail dialog
         * @param calendarEvent
         * @param e
         */
        function showEventDetailDialog(calendarEvent, e)
        {
            $mdDialog.show({
                controller         : 'EventDetailDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/calendar/dialogs/event-detail/event-detail-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : e,
                clickOutsideToClose: true,
                locals             : {
                    calendarEvent      : calendarEvent,
                    showEventFormDialog: showEventFormDialog,
                    event              : e
                }
            });
        }

        /**
         * Show event add/edit form dialog
         *
         * @param type
         * @param calendarEvent
         * @param start
         * @param end
         * @param e
         */
        function showEventFormDialog(type, calendarEvent, start, end, e)
        {
            var dialogData = {
                type         : type,
                calendarEvent: calendarEvent,
                start        : start,
                end          : end
            };

            $mdDialog.show({
                controller         : 'EventFormDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/calendar/dialogs/event-form/event-form-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : e,
                clickOutsideToClose: true,
                locals             : {
                    dialogData: dialogData
                }
            }).then(function (response)
            {
                switch ( response.type )
                {
                    case 'add':
                                
                        var add = {
                            title        : response.calendarEvent.title,
                            start        : response.calendarEvent.start,
                            end          : response.calendarEvent.end,
                            all_day_event: response.calendarEvent.all_day_event,
                            location     : response.calendarEvent.location,
                            notes        : response.calendarEvent.notes
                        };
                        
                        vm.onUpdate({model: 'event', data: add}, 'add');
                        
                        break;

                    case 'edit':
                        // Edit
                        for ( var i = 0; i < vm.events[0].length; i++ )
                        {
                            // Update
                            if ( vm.events[0][i].id === response.calendarEvent.id )
                            {
                                vm.events[0][i] = {
                                    id           : response.calendarEvent.id,
                                    title        : response.calendarEvent.title,
                                    start        : response.calendarEvent.start,
                                    end          : response.calendarEvent.end,
                                    all_day_event: response.calendarEvent.all_day_event,
                                    location     : response.calendarEvent.location,
                                    notes        : response.calendarEvent.notes,
                                    event_id     : response.calendarEvent.event_id
                                };
                                
                                vm.onUpdate({model: 'event', data: vm.events[0][i]}, 'edit');

                                break;
                            }
                        }
                        break;

                    case 'remove':
                        // Remove
                        for ( var j = 0; j < vm.events[0].length; j++ )
                        {
                            // Update
                            if ( vm.events[0][j].id === response.calendarEvent.id )
                            {
                                vm.events[0].splice(j, 1);
                                
                                var del = {
                                    id           : response.calendarEvent.id,
                                    calendar_id  : vm.user.calendar.calendar_id,
                                    event_id     : response.calendarEvent.event_id
                                };

                                vm.onUpdate({data: del}, 'remove', config.crmUrl + 'calendar/event/delete');
                                
                                break;
                            }
                        }
                        break;
                }
            });
        }

        //////////
        vm.onUpdate = function(data, type, url)
        {
            url = url || config.crmUrl + 'calendar/event/crup';

            $http({
                url: url,
                method: 'POST',
                data: data
            }).then(function (response) {
                
//                console.log(response.data.return);
                
                // Add new
                if( (type == 'add') )
                    vm.events[0].push(response.data.return);
                
                if( response.data.return.delete )
                {
                    vm.status = '<strong class="md-warn-fg">Deleted!</strong>&nbsp;&nbsp;';
                    vm.text = 'Event deleted.';
                }
                else
                {
                    vm.status = '<strong class="md-accent-fg">Success!</strong>&nbsp;&nbsp;';
                    vm.text = 'Event saved.';
                }
                
                // this callback will be called asynchronously
                // when the response is available
                $mdToast.show({
                    template:
                        '<md-toast>' +
                            '<div class="md-toast-content">' +
                                vm.status +
                                vm.text +
                            '</div>' +
                        '</md-toast>',
                    hideDelay: 3000,
                    position: 'top right'
                });
        
            }, function (response) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
                console.log(response, " error occurs!");
            });
        };
    }

})();
(function ()
{
    'use strict';
    
    var env = {};
    // Shared env vars in all environments 
    if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
    {
        env = {
            apiUrl : 'https://aggrego.localhost.com/api/v1/',
            crmUrl : 'https://aggrego.localhost.com/',
            // google calendar api
            origin : 'https://aggrego.localhost.com',
            appId  : '146216699237876'
        };
    }
    else
    {
        env = {
            apiUrl : 'https://api.aggrego.io/api/v1/',
            crmUrl : 'https://api.aggrego.io/',
            // google calendar api
            origin : 'https://api.aggrego.io',
            appId  : '1767117069965251'
        };
    }
    
    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router',
                'satellizer'
        ])
        .constant('config', {
            appName     : 'Crm Api',
            appVersion  : 1.0,
            apiUrl      : env.apiUrl,
            crmUrl      : env.crmUrl,
            // google calendar api
            origin      : env.origin
        })
        .run(function($rootScope) {
            // Load the SDK asynchronously
            (function(d, s, id) {
                var js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) return;
                js = d.createElement(s); js.id = id;
                js.src = "//connect.facebook.net/en_US/sdk.js";
                fjs.parentNode.insertBefore(js, fjs);
            }(document, 'script', 'facebook-jssdk'));

            //fb init
            window.fbAsyncInit = function() {
                FB.init({
                    appId      : env.appId,
                    cookie     : true,  // enable cookies to allow the server to access 
                                                            // the session
                    xfbml      : true,  // parse social plugins on this page
                    version    : 'v2.11' // use graph api version 2.11
                });
            };
            
        })
        .filter('ucfirst', function () {
            return function (input, arg) {
                return input.replace(/(?:^|\s)\S/g, function (a) {
                    return a.toUpperCase();
                });
            }
        })
        .filter('label', function() {
            return function (input, text)
            {
                if (input == null || input == '')
                    return text;

                return input;
            };
        })
        .filter('dateFormat', function($filter) {
            return function (input, text)
            {
                if (input == null)
                    return text;

                var _date = $filter('date')(new Date(input), 'MMMM dd, yyyy');

                return _date;
            };
        })
        .directive('wjValidationError', function () {
            return {
                require: 'ngModel',
                link: function (scope, elm, attrs, ctl) {
                    scope.$watch(attrs['wjValidationError'], function (errorMsg) {
                        elm[0].setCustomValidity(errorMsg);
                        ctl.$setValidity('wjValidationError', errorMsg ? false : true);
                    });
                }
            };
        })
        .directive('ngEnter', function () {
            return function (scope, element, attrs) {
                element.bind("keydown keypress", function (event) {
                    if (event.which === 13) {
                        scope.$apply(function () {
                            scope.$eval(attrs.ngEnter);
                        });

                        event.preventDefault();
                    }
                });
            };
        })
        .filter('tel', function () {
            return function (tel) {
                if (!tel) {
                    return '';
                }

                var value = tel.toString().trim().replace(/^\+/, '');

                if (value.match(/[^0-9]/)) {
                    return tel;
                }

                var country, city, number;

                switch (value.length) {
                    case 8: // +1PPP####### -> C (P) ###-####
                        country = 1;
                        city = value.slice(0, 1);
//                        number = value.slice(4);
                        number = value.slice(1);
                        break;
                        
                    case 10: // +1PPP####### -> C (PPP) ###-####
                        country = 1;
                        city = value.slice(0, 3);
                        number = value.slice(3);
                        break;

                    case 11: // +CPPP####### -> CCC (PP) ###-####
                        country = value[0];
                        city = value.slice(1, 4);
                        number = value.slice(4);
                        break;

                    case 12: // +CCCPP####### -> CCC (PP) ###-####
                        country = value.slice(0, 3);
                        city = value.slice(3, 5);
                        number = value.slice(5);
                        break;

                    default:
                        return tel;
                }

                if (country == 1) {
                    country = "";
                }

                number = number.slice(0, 3) + '-' + number.slice(3);

                return (country + " " + city + "-" + number).trim();
            };
        })
        .directive('formAttr', function($timeout) {
            return {
                restrict: 'A',
                link: function (scope, elm, attrs, ctl) {
                    scope.$watch('selectedIndex', function () {
                        // will use $location later
                        if( attrs['formAttr'] != 'modify' )
                        {
                            $timeout(function () {
                                for (var i = 0; i < elm[0].querySelectorAll('input, button, textarea, md-checkbox').length; i++)
                                {
                                    angular.element(elm).find('input, button, textarea, md-checkbox')[i].setAttribute("disabled", true);
                                }
                            });
                        }
                    });
                }
            };
        })
        ;
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Leads',
                        'icon'       : 'icon-filter',
                        'state'      : 'app.scrumboard.boards',
                        'weight'     : 5,
                        'children'   : [],
                        '_id'        : 'lead',
                        '_path'      : 'apps.sales.leads',
                        'uisref'     : 'app.scrumboard.boards',
                        'hasShortcut': true
                    },
                    {
                        'title'      : 'Contacts',
                        'icon'       : 'icon-account-box',
                        'state'      : 'app.contacts',
                        'weight'     : 10,
                        'children'   : [],
                        '_id'        : 'contacts',
                        '_path'      : 'apps.contacts',
                        'uisref'     : 'app.contacts',
                        'hasShortcut': true
                    }, 
                    {
                        'title'      : 'My Projects',
                        'icon'       : 'icon-dns',
                        'state'      : 'app.employee_project',
                        'weight'     : 11,
                        'children'   : [],
                        '_id'        : 'notes',
                        '_path'      : 'apps.sales.project',
                        'uisref'     : 'app.employee_project',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.verify', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.verify', {
            url  : '/verify',
            views: {
                'content@app': {
                    templateUrl: 'app/main/verify/verify.html',
                    controller : 'VerifyController as vm'
                }
            },
            data: {
                requiredVerify: false
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.verify')
        .controller('VerifyController', VerifyController);

    /** @ngInject */
    function VerifyController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
	'use strict';

	angular
		.module('app.core')
		.controller('RegisterController', RegisterController);

	/** @ngInject */
	function RegisterController($auth, $state, $http, $timeout, $rootScope, $scope)
	{
		var vm = this;
		
		// Data
		vm.registerError = false;
		vm.registerErrorText;

		// Methods
		//////////
		/**
		 * Register
		 */
		vm.register = function() {
                        var data = {
                            'company_name' : vm.company_name,
                            'domain' : vm.domain,
                            'name' : vm.name,
                            'email' : vm.email,
                            'password' : vm.password,
                            'password_confirmation' : vm.password_confirmation,
                            'social_login' : vm.social_login,
                            'social_id' : vm.social_id,
                            'username' : vm.domain
                        };

                        vm.form = data;
                        
			$auth.signup(vm.form)
				.then(function (response) {
						// Redirect user here to login page or perhaps some other intermediate page
						// that requires email address verification before any other part of the site
						// can be accessed.
						// if with token
						var token = response.data.token;
                                                if( token != 'not_exist' )
                                                    localStorage.setItem('satellizer_token', token);
                                                
						return $rootScope.authLogin();
				})
				.catch(function (error) {
					/*
					 *  TODO: validations
					 */
					// Handle errors here.
//					vm.registerError = true;
//					vm.registerErrorText = error.data.error;
                                        vm.errors = error.data;
                                        console.log(vm.errors);
				});
			
		};

		vm.signupByFacebook = function(){
			FB.api('/me?fields=id,email,first_name,last_name', function(response) {
				//autofill his form and assign his info to hidden fields
                                console.log(response);
				//will hide password and confirm password
				vm.isSocialLogin = true;
                                
                                // apply to the form
                                vm.email = response.email;
                                vm.name = response.first_name + ' ' + response.last_name;
                                vm.social_login = 'facebook';
                                vm.social_id = response.id;
                                
				vm.form = response;
				$rootScope.$apply();
			});
		}


		// This is called with the results from from FB.getLoginStatus().
		function statusChangeCallback(response)
                {
			// The response object is returned with a status field that lets the
			// app know the current login status of the person.
			// Full docs on the response object can be found in the documentation
			// for FB.getLoginStatus().
			
			if (response.status === 'connected')
                        {
                            vm.signupByFacebook();
			} 			
		}
                
		if( $rootScope.social_login == 'facebook' )
                {
                    FB.getLoginStatus(function (response) {
                        statusChangeCallback(response);
                    });
                }

		if( $rootScope.social_login == 'google' )
                {
//                    var response = $state.params.response;
                    var response = localStorage.getItem('google_login');
                    response = JSON.parse(response);

                    //will hide password and confirm password
                    vm.isSocialLogin = true;
                    
                    // apply to the form
                    vm.email = response.email;
                    vm.name = response.name;
                    vm.social_login = response.social_login;
                    vm.social_id = response.id;
                }
	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController($auth, $state, $http, $rootScope, $location, Google, config, $window)
    {
        var vm = this;
        
        // Data
        vm.loginError = false;
        vm.loginErrorText;
        
        vm.integration = Google.data.integration;
        
        // Methods
        //////////
        /**
         * Reply
         */
        vm.login = function(response)
        {
            if( response )
            {
                var credentials = {
                    id: response.id,
                    social_login: response.social_login
                };
            }
            else
            {
                var credentials = {
                    email: vm.form.email,
                    password: vm.form.password
                };
            }
            
            $auth.login(credentials).then(function(result) {
                
                    if( result.data.token == 'not_exist' )
                    {
                        $auth.logout(); // no $auth!!! so I use logout func
                        $rootScope.social_login = response.social_login;
                        $state.go('app.register', {response: response});
                    }
                    else
                        return $rootScope.authLogin();

            // Handle errors
            }, function(error) {
//                    vm.loginError = true;
//                    vm.loginErrorText = error.data.error;
                    
                    vm.errors = error.data;
            });
        }

        vm.fb_permission = function(){
            FB.login(function(response){
                    //if permission granted
                    if(response['status'] == "connected")
                    {
                        response.id = response.authResponse.userID;
                        response.social_login = 'facebook';
                        vm.login(response);
                    }
                    else{
                        alert('Permission denied or not logged in.');
                    }
                },
                {
                    scope: 'email'
                }

            );
        }
        
        // Google login function from server side
        vm.doGLogin = function() 
        {
            $rootScope.popupCenter( vm.integration.auth_url , null, '600', '600');
        };
        
        $window.addEventListener("message", getLogin);

        function getLogin(event) {
            if (event.origin === config.origin)
            {
                $rootScope.$apply(function(){
                    var response = event.data.response;
                    response.social_login = 'google';
                    localStorage.setItem('google_login', JSON.stringify(response)); // use local storage for retrieving in other controller

                    vm.login(response);
                });
            }
        }
        
        // user code activation
        vm.params = $rootScope.state.params;
        vm.form = {
            code: vm.params.code
        };
        
//        if( vm.form.code ) 
//        {
            if( vm.params.type == "activation" )
            {
                vm.text = 'Confirmation.';
                $http({
                    url: config.crmUrl + 'user/activation',
                    method: 'POST',
                    data: vm.form
                }).then(function(result) {

                    if( result.data.result )
                        vm.text = result.data.result;
                    else
                    {
                        vm.text = 'Activated.';

                        $auth.setToken(result.data.token);
                        return $rootScope.authLogin();
                    }

                }, function (response) {
                    // called asynchronously if an error occurs
                    // or server returns response with an error status.
                    console.log(response, " error occurs!");
                    vm.text = 'Invalid activation code supplied.';
                });
            }
        
            else if( vm.params.type == "reset" || vm.params.type == "set" )
            {
                vm.reset = false;
                vm.resetButton = function()
                {   
                    $http({
                        url: config.crmUrl + 'user/reset/' + vm.params.type ,
                        method: 'POST',
                        data: vm.form
                    }).then(function(result) {

                        vm.text = 'Password reset complete, you may now sign in.';
                        vm.reset = true;

                    }, function (response) {
                        // called asynchronously if an error occurs
                        // or server returns response with an error status.
                        console.log(response, " error occurs!");
                        vm.errors = response.data;
                    });
                }
            }
//        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('ForgotPasswordController', ForgotPasswordController);

    /** @ngInject */
    function ForgotPasswordController($http, config, $state)
    {
        var vm = this;
        
        // Data

        // Methods

        //////////
                
        vm.resetButton = function()
        {   
            $http({
                url: config.crmUrl + 'user/reset/restore',
                method: 'POST',
                data: vm.form
            }).then(function(result) {
                
                $state.go('app.user', {type: 'reset'});

            }, function (response) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
                console.log(response, " error occurs!");
                vm.text = 'Invalid.';
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboard', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.dashboard', {
                url    : '/dashboard',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/dashboard/dashboard.html',
                        controller : 'DashboardController as vm'
                    }
                }
            });

        // Navigation
        msNavigationServiceProvider.saveItem('dashboard', {
            title    : 'Dashboard',
            icon     : 'icon-tile-four',
            state    : 'app.dashboard'
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboard')
        .controller('DashboardController', DashboardController);

    /** @ngInject */
    function DashboardController()
    {
        var vm = this;

        // Data
        
        // Methods

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
//                fuseTheming.setActiveTheme('default');
                fuseTheming.setActiveTheme('pinkTheme');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
//                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, msApi, api, $q, $state, $timeout, $mdSidenav, $translate, $mdToast, msNavigationService, config, User)
    {
        var vm = this;
        
        vm.user = User.data;
        vm.employee = vm.user.employee;
        
        vm.crmUrl = config.crmUrl;

        // Data
        $rootScope.global = {
            search: ''
        };

        vm.bodyEl = angular.element('body');
        vm.userStatusOptions = [
            {
                'title': 'Online',
                'icon' : 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon' : 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon' : 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];
        vm.languages = {
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'us'
            },
            es: {
                'title'      : 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code'       : 'es',
                'flag'       : 'es'
            },
            tr: {
                'title'      : 'Turkish',
                'translation': 'TOOLBAR.TURKISH',
                'code'       : 'tr',
                'flag'       : 'tr'
            }
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $rootScope.currentUser.notification = 0;
            $mdSidenav(sidenavId).toggle();
        }

        vm.nav = {
            title : 'Tasks',
            icon  : 'icon-view-dashboard',
            state : 'app.to-do',
            weight: 7,
            hidden: function ()
            {
                var roles = JSON.parse(localStorage.getItem('roles'));
                if( roles )
                {
                    var role = roles.filter(function ( obj ) {
                        return obj.url === '/to-do';
                    })[0];

                    return !role.permissions.write;
                }
            }
        };
        
        if( $rootScope.currentUser.notification != 0 )
        {
            vm.nav.badge = {
                content: $rootScope.currentUser.notification,
                        color  : '#F44336'
            };
        }

        // Navigation
        msNavigationService.saveItem('apps.sales.task', vm.nav);

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status)
        {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout()
        {
            $rootScope.authLogout();
        }

        /**
         * Change Language
         */
        function changeLanguage(lang)
        {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            if ( lang.code !== 'en' )
            {
                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template : '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position : 'top right',
                    parent   : '#content'
                });

                return;
            }

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded()
        {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query)
        {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if ( query )
            {
                navigation = navigation.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(query)) > -1 )
                    {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function ()
            {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item)
        {
            // If item has a link
            if ( item.uisref )
            {
                // If there are state params,
                // use them...
                if ( item.stateParams )
                {
                    $state.go(item.state, item.stateParams);
                }
                else
                {
                    $state.go(item.state);
                }
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi, $mdSidenav, $filter, $state, $http, config)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );

        msApi.request('quickPanel.reminder@get', {},
            // Success
            function (response)
            {
                vm.activity_type = response.data;
            }
        );

        msApi.request('api.priority@get', {},
            // Success
            function (response)
            {
                vm.priority = response.data;
            }
        );

        msApi.request('api.priority@get', {},
            // Success
            function (response)
            {
                vm.priority = response.data;
            }
        );

        msApi.request('api.activity_status@get', {},
            // Success
            function (response)
            {
                vm.activity_status = response.data;
            }
        );
        
        /**
         * saveActivity
         */
        vm.saveActivity = function()
        {
            $http({
                url: config.apiUrl + 'activity/update',
                method: 'POST',
                data: {activity_type: vm.activity_type}
            }).then(function (response) {
                console.log(response);
            }, function (response) {
                console.log(response, " error occurs!");
            });
        };

        vm.priorityValue = function(id) {
            if( id != 0 )
                return $filter('filter')(vm.priority, {id: id })[0]['value'];
        };

        // Methods
        vm.gotoTaskType = gotoTaskType;

        //////////

        /**
         * Go to task by type
         *
         * @param id
         */
        function gotoTaskType(id)
        {
            $mdSidenav('quick-panel').toggle();
            $state.go('app.to-do.type', {id: id});
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [

            // Common 3rd Party Dependencies
//            'uiGmapgoogle-maps',
            'textAngular',
            'xeditable',

            // Core
            'app.core',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Quick Panel
            'app.quick-panel',
            
            'app.dashboard',

            // Apps
            'app.company',
            'app.employees',
            'app.contacts',
            'app.companies',
            'app.scrumboard',
            'app.todo',
            'app.calendar',
            'app.imports',

            // Pages
            'app.pages',

            'app.verify'
        ]);
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope, $state, $auth)
    {
        // Data

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $state, msUtils, fuseGenerator, fuseConfig, $http, $auth, config, $filter)
    {   
        
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
        
        // $stateChangeStart is fired whenever the state changes. We can use some parameters
        // such as toState to hook into details about the state as it is changing
        $rootScope.$on('$stateChangeStart', function(event, toState, fromState) {
            
                // Grab the user from local storage and parse it to an object
                var user = JSON.parse(localStorage.getItem('user'));
                
                /* requiredLogin of scope */
                var requiredLogin = ( toState.data && toState.data.requiredLogin !== undefined ) ? toState.data.requiredLogin : true;
                var requiredVerify = ( toState.data && toState.data.requiredVerify !== undefined ) ? toState.data.requiredVerify : true;

                // If there is any user data in local storage then the user is quite
                // likely authenticated. If their token is expired, or if they are
                // otherwise not actually authenticated, they will be redirected to
                // the auth state because of the rejected request anyway
                if(user)
                {
                        // The user's authenticated state gets flipped to
                        // true so we can now show parts of the UI that rely
                        // on the user being logged in
                        $rootScope.authenticated = true;
                
                        // Putting the user's data on $rootScope allows
                        // us to access it anywhere across the app. Here
                        // we are grabbing what is in local storage
                        $rootScope.currentUser = user;
                        var path_url = ( toState.role && toState.role.url ) ? toState.role.url : toState.url;
                        $rootScope.role = $filter('filter')(JSON.parse(localStorage.getItem('roles')), {'url': path_url}, true)[0];
                        
                        if( $rootScope.role )
                            $rootScope.role.permissions.read = ( $rootScope.role.permissions.read === "" && $rootScope.role.permissions.write )
                                                                ? true
                                                                : $rootScope.role.permissions.read;
                }
                
                if ( $auth.isAuthenticated() )
                {
                    // if user is already activated
                    if( $rootScope.currentUser.is_activated )
                    {
                        // this is when you access app.verify and you are verified go to dashboard
                        // or if you hit all not requiredLogin meaning all front-end that no need auth
                        // or the role is no access
                        if ( !requiredLogin || toState.name === 'app.verify' || ($rootScope.role && !$rootScope.role.permissions.read) )
                        {
                            event.preventDefault();

                            $state.go('app.dashboard');
                        }
                    }
                    else
                    {
                        // if this user is not active, redirect him to verify page
                        if( requiredVerify )
                        {
                            event.preventDefault();
                            $state.go('app.verify', {}, {reload: true});
                        }
                    }
                }
                else
                {
                    // if requiredLogin yes and if this user is not logged in, redirect him to login page
                    if ( requiredLogin )
                    {
                        event.preventDefault();
                        $state.go('app.login');
                    }
                }
        });
        
        $rootScope.authLogin = function(token) {
                // Return an $http request for the now authenticated
                // user so that we can flatten the promise chain
//                var paramToken = (token) ? '?token='+ token : '';
                
//                return $http.get(config.apiUrl + 'auth/user' + paramToken).then(function(response) {
                return $http.get(config.apiUrl + 'auth/user').then(function(response) {
                    
                        // Stringify the returned data to prepare it
                        // to go into local storage
                        var user = JSON.stringify(response.data.user);
                        
                        // Set the stringified user data into local storage
                        localStorage.setItem('user', user);

                        // The user's authenticated state gets flipped to
                        // true so we can now show parts of the UI that rely
                        // on the user being logged in
                        $rootScope.authenticated = true;

                        // Putting the user's data on $rootScope allows
                        // us to access it anywhere across the app
                        $rootScope.currentUser = response.data.user;
                        
                        // roles
                        localStorage.setItem('roles', JSON.stringify(response.data.user.roles));
                        
                        // Everything worked out so we can now redirect to
                        // the users state to view the data
                        $state.go('app.dashboard', {}, {reload: true});
                });
        };
        
        $rootScope.authLogout = function() {
                
//                return $http.get(config.apiUrl + 'auth/logout').then(function() {
                    
                    // Do logout here..
                    // Remove the authenticated user from local storage
                    localStorage.removeItem('satellizer_token'); // ???
                    localStorage.removeItem('user');
                    localStorage.removeItem('roles');
                    localStorage.removeItem('doSyncCalendar');

                    // Flip authenticated to false so that we no longer
                    // show UI elements dependant on the user being logged in
                    $rootScope.authenticated = false;

                    // Remove the current user info from rootscope
                    $rootScope.currentUser = null;
                    
                    // Redirect to auth (necessary for Satellizer 0.12.5+)
                    $state.go('app.login');
                    
//                });
        };
        
        $rootScope.popupCenter = function(url, title, w, h)
        {
            // Fixes dual-screen position                         Most browsers      Firefox  
            var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;  
            var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;  

            var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;  
            var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;  

            var left = ((width / 2) - (w / 2)) + dualScreenLeft;  
            var top = ((height / 2) - (h / 2)) + dualScreenTop;  
            var newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);  

            // Puts focus on the newWindow  
            if (window.focus) {  
                newWindow.focus();  
            }  
        };
        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider, $stateProvider, $authProvider, msApiProvider, config)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
        
        $authProvider.loginUrl = config.apiUrl + 'auth/login';
        $authProvider.signupUrl = config.apiUrl + 'auth/register';
        
        msApiProvider.register('user.user', [config.apiUrl + 'user.json']);
        msApiProvider.register('api.regions', [config.apiUrl + 'regions.json']);
        msApiProvider.register('api.provinces', [config.apiUrl + 'provinces.json']);
        msApiProvider.register('api.cities', [config.apiUrl + 'cities.json']);
        msApiProvider.register('api.priority', [config.apiUrl + 'priority.json']);
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, editableThemes)
    {
        // 3rd Party Dependencies
        editableThemes.default.submitTpl = '<md-button class="md-icon-button" type="submit" aria-label="save"><md-icon md-font-icon="icon-checkbox-marked-circle" class="md-accent-fg md-hue-1"></md-icon></md-button>';
        editableThemes.default.cancelTpl = '<md-button class="md-icon-button" ng-click="$form.$cancel()" aria-label="cancel"><md-icon md-font-icon="icon-close-circle" class="icon-cancel"></md-icon></md-button>';
        
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function ()
        {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider, msApiProvider, config)
    {
        $locationProvider.html5Mode(true);

        $urlRouterProvider.otherwise('/dashboard');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar2  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
            },
            horizontalNavigation: {
                main      : 'app/core/layouts/horizontal-navigation.html',
                toolbar   : 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                navigation: ''
            },
            contentWithToolbar  : {
                main      : 'app/core/layouts/content-with-toolbar.html',
                toolbar   : 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController as vm'
                    },
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller : 'QuickPanelController as vm'
                    }
                },
                resolve  : {
                    User      : function (msApi, $auth)
                    {
                        if ( $auth.isAuthenticated() )
                            return msApi.resolve('user.user@get');
                        else
                            return [];
                    },
                    Regions   : function (msApi)
                    {
                        return msApi.resolve('api.regions@get');
                    },
                    Provinces : function (msApi)
                    {
                        return msApi.resolve('api.provinces@get');
                    },
                    Cities    : function (msApi)
                    {
                        return msApi.resolve('api.cities@get');
                    },
                    Priority  : function (msApi)
                    {
                        return msApi.resolve('api.priority@get');
                    }
                }
            });
            
        // Api
        msApiProvider.register('user.user', [config.apiUrl + 'user.json']);
        msApiProvider.register('api.regions', [config.apiUrl + 'regions.json']);
        msApiProvider.register('api.provinces', [config.apiUrl + 'provinces.json']);
        msApiProvider.register('api.cities', [config.apiUrl + 'cities.json']);
        msApiProvider.register('api.priority', [config.apiUrl + 'priority.json']);
    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse');
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config($translateProvider, msApiProvider, config)
    {
        // Put your common app configurations here

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        // Api
//        msApiProvider.register('api.notification', [config.apiUrl + 'notification.json']);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource, msApi)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
//        api.baseUrl = 'app/data/';
        api.baseUrl = '//propertycrm.localhost.com/api/v1/';

        // api.sample = $resource(api.baseUrl + 'sample/sample.json');
        api.user = $resource(api.baseUrl + 'user.json');

//        api.user.get({},
//            // Success
//            function (response)
//            {
//                console.log(response);
//            },
//            // Error
//            function (response)
//            {
//                console.error(response);
//            }
//        );
        
//        msApi.request('user.user@get',
//            // Success
//            function (response)
//            {
//                api.user = response.data;
//                console.log(response);
//            },
//            // Error
//            function (response)
//            {
////                $state.go('app.login');
//                console.error(response);
//            }
//        );

//         api.scrumboard = {
//            boardList: $resource(api.baseUrl + 'scrumboard/boardList.json'),
//            board    : $resource(api.baseUrl + 'scrumboard/boards/:id.json')
//         };
        
        return api;
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.company',
            [
                'app.company.dashboard',
                'app.company.project'
            ]
        )
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider, $translatePartialLoaderProvider)
    {
        // Navigation
        msNavigationServiceProvider.saveItem('apps', {
            title : '',
            group : true,
            weight: 2
        });

        msNavigationServiceProvider.saveItem('apps.contacts', {
            title : 'Contacts',
//            icon  : 'icon-phone-dots',
            group : true,
            weight: 2
        });

        msNavigationServiceProvider.saveItem('apps.pages.settings.dashboard', {
            title: 'Overview',
            state: 'app.company_dashboard',
            weight: 11
        });
        
        msNavigationServiceProvider.saveItem('apps.pages.settings.project', {
            title : 'Projects',
            state : 'app.company_project',
            weight: 14
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/company');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config)
        .filter('spaceless', [function() {
            return function(string) {
                if (!angular.isString(string)) {
                    return string;
                }
                return string.replace(/[\s]/g, '');
            };
        }]);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
                .state('app.register', {
                    url: '/register',
                    params: {
                        response: null
                    },
                    views: {
                        'main@': {
                            templateUrl: 'app/core/layouts/content-only.html',
                            controller: 'MainController as vm'
                        },
                        'content@app.register': {
                            templateUrl: 'app/main/register/register.html',
                            controller: 'RegisterController as vm'
                        }
                    },
                    data: {
                        requiredLogin: false
                    },
                    bodyClass: 'register'
                });
                
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/register');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages', [
            'app.pages.settings',
            'app.pages.profile'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
        msNavigationServiceProvider.saveItem('apps.pages', {
            title : 'ACCOUNT',
            group : true,
            weight: 6
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, config, msApiProvider)
    {
        // Get active layout
        var layoutStyle = (window.location.pathname.split( "/" )[2] == 'activation') // activation or reset
                          ? 'activation'
                          : 'reset';
                          
        $stateProvider
                .state('app.login', {
                    url: '/login',
                    views: {
                        'main@': {
                            templateUrl: 'app/core/layouts/content-only.html',
                            controller: 'MainController as vm'
                        },
                        'content@app.login': {
                            templateUrl: 'app/main/login/login.html',
                            controller: 'LoginController as vm'
                        }
                    },
                    resolve  : {
                        Google           : function (msApi)
                        {
                            return msApi.resolve('google.login@get');
                        }
                    },
                    data: {
                        requiredLogin: false
                    },
                    bodyClass: 'login'
                })
                // Activat User | Reset Password
                .state('app.user', {
                    url  : '/user/:type/:code',
                    views: {
                        'main@': {
                            templateUrl: 'app/core/layouts/content-only.html',
                            controller: 'MainController as vm'
                        },
                        'content@app.user': {
                            templateUrl: 'app/main/login/' + layoutStyle + '.html',
                            controller: 'LoginController as vm'
                        }
                    },
                    resolve  : {
                        Google           : function ()
                        {
                            return {data: {integration: null}};
                        }
                    },
                    data: {
                        requiredLogin: false,
                        requiredVerify: false
                    }
                });
                
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/login');

        msApiProvider.register('google.login', [config.crmUrl + 'google/login']);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.forgot-password', {
            url      : '/forgot-password',
            views    : {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.forgot-password': {
                    templateUrl: 'app/main/forgot-password/forgot-password.html',
                    controller : 'ForgotPasswordController as vm'
                }
            },
            data: {
                requiredLogin: false
            },
            bodyClass: 'forgot-password'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/forgot-password');
    }

})();
angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.TODAY\">TODAY</span></md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/theme-options/theme-options.html","<md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div class=\"ms-theme-options-list\" \nlayout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">Layout Style:</div><md-radio-group \nlayout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" ng-change=\"vm.updateLayoutStyle()\">\n<md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" ng-value=\"layoutStyle.value\"><div layout=\"column\" \nlayout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> <span class=\"text-center font-size-12 mt-8\">\n{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div><md-divider></md-divider><div \nclass=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group layout=\"row\" \nlayout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/main/dashboard/dashboard.html","<div class=\"page-layout blank\"><h1>Dashboard</h1><h3 ng-if=\"authenticated\">\nHi, {{currentUser.name}}, welcome to Aggrego CRM.</h3></div>");
$templateCache.put("app/main/forgot-password/forgot-password.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><img ng-src=\"assets/images/logos/ae-logo.png\"></div><div class=\"title\">\n{{ vm.text || \'Recover your password\' }}</div><form name=\"forgotPasswordForm\" novalidate><md-input-container \nclass=\"md-block\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email address\" \ntranslate translate-attr-placeholder=\"FORGOTPASSWORD.EMAIL_ADRESS\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"forgotPasswordForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"FORGOTPASSWORD.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"FORGOTPASSWORD.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"RESET MY PASSWORD\" \nng-click=\"vm.resetButton();\" ng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine\" \ntranslate=\"FORGOTPASSWORD.SEND_RESET_LINK\" translate-attr-aria-label=\"FORGOTPASSWORD.SEND_RESET_LINK\">SEND RESET LINK\n</md-button></form><div class=\"login\" layout=\"row\" layout-align=\"center center\"><a class=\"link\" ui-sref=\"app.login\" \ntranslate=\"FORGOTPASSWORD.GO_BACK\">Go back to login</a></div></div></div></div>");
$templateCache.put("app/main/login/activation.html","<div id=\"login\" layout=\"row\" layout-align=\"start\"><div id=\"login-intro\" flex hide show-gt-sm><div \nclass=\"logo md-accent-bg\"><img ng-src=\"assets/images/logos/ae-logo.png\"></div><div class=\"title\">{{vm.text}}</div><div \nclass=\"description\" translate=\"LOGIN.INTRO_DESCRIPTION\">\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ullamcorper nisl erat, vel convallis elit fermentum pellentesque. Sed mollis velit facilisis facilisis viverra.\n</div></div></div>");
$templateCache.put("app/main/login/login.html","<div id=\"login\" layout=\"row\" layout-align=\"start\"><div id=\"login-intro\" flex hide show-gt-sm><div \nclass=\"logo md-accent-bg\"><img ng-src=\"assets/images/logos/ae-logo.png\"></div><div class=\"title\" \ntranslate=\"LOGIN.INTRO_TITLE\">Welcome to the AGGREGO!</div><div class=\"description\" \ntranslate=\"LOGIN.INTRO_DESCRIPTION\">Manage, convert your leads into sales effectively.</div></div><div \nid=\"login-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><div id=\"login-form\"><div \nclass=\"logo md-accent-bg\" hide-gt-sm><img ng-src=\"assets/images/logos/ae-logo.png\"></div><div class=\"title\" \ntranslate=\"LOGIN.TITLE\">Log in to your account</div><div class=\"description\" translate=\"LOGIN.DESCRIPTION\">\nEnter your email and password.</div><form name=\"loginForm\" novalidate ng-submit=\"vm.login()\"><small class=\"red-fg\" \nng-if=\"vm.errors\" ng-repeat=\"error in vm.errors\">{{error[0]}}<br></small><md-input-container class=\"md-block\" \nmd-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email\" translate \ntranslate-attr-placeholder=\"LOGIN.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"loginForm.email.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span translate=\"LOGIN.ERRORS.EMAIL_REQUIRED\">\nEmail field is required</span></div><div ng-message=\"pattern\"><span translate=\"LOGIN.ERRORS.EMAIL_MUST_VALID\">\nEmail must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" \nmd-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"LOGIN.PASSWORD\" required><div ng-messages=\"loginForm.password.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div>\n</md-input-container><div class=\"remember-forgot-password\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-between center\"><md-checkbox class=\"remember-me\" ng-model=\"data.cb1\" aria-label=\"Remember Me\"><span\n translate=\"LOGIN.REMEMBER_ME\">Remember Me</span></md-checkbox><a ui-sref=\"app.forgot-password\" \nclass=\"forgot-password md-accent-color\" translate=\"LOGIN.FORGOT_PASSWORD\">Forgot Password?</a></div><md-button \ntype=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"LOGIN.LOG_IN\" \ntranslate-attr-aria-label=\"LOGIN.LOG_IN\">LOG IN</md-button></form><div class=\"separator\"><span class=\"text\" \ntranslate=\"LOGIN.OR\">OR</span></div><div layout=\"column\" layout-align=\"start center\"><md-button \nclass=\"md-raised google\"><div layout=\"row\" layout-align=\"center center\" ng-click=\"vm.doGLogin();\"><span><md-icon \nmd-font-icon=\"icon-google-plus\" class=\"s16\"></md-icon><span translate=\"LOGIN.WITH_GOOGLE\">Log in with Google</span>\n</span></div></md-button><md-button class=\"md-raised facebook\" ng-click=\"vm.fb_permission()\"><div layout=\"row\" \nlayout-align=\"center center\"><span><md-icon md-font-icon=\"icon-facebook\" class=\"s16\"></md-icon><span \ntranslate=\"LOGIN.WITH_FACEBOOK\">Log in with Facebook</span></span></div></md-button></div><div class=\"register\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"LOGIN.DONT_HAVE_ACCOUNT\">\nDon\'t have an account?</span> <a class=\"link\" ui-sref=\"app.register\" translate=\"LOGIN.CREATE_ACCOUNT\">Create an account\n</a></div></div></div></div>");
$templateCache.put("app/main/login/reset.html","<div id=\"reset-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"reset-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"reset-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><img ng-src=\"assets/images/logos/ae-logo.png\"></div><span ng-if=\"!vm.form.code && !vm.reset\">\nPlease check your email.</span><div class=\"title\">{{vm.text || \'Enter the activation code and new password.\'}}</div>\n<form name=\"resetPasswordForm\" novalidate ng-if=\"!vm.reset\"><small class=\"red-fg\" ng-if=\"vm.errors\" \nng-repeat=\"error in vm.errors\">{{error[0]}}<br></small><md-input-container class=\"md-block\" md-no-float><input \ntype=\"text\" name=\"code\" ng-model=\"vm.form.code\" placeholder=\"Code\" required><div \nng-messages=\"registerForm.code.$error\" role=\"alert\"><div ng-message=\"required\"><span>Code field is required</span>\n</div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nname=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"RESETPASSWORD.PASSWORD\" required><div ng-messages=\"registerForm.password.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"RESETPASSWORD.ERRORS.PASSWORD_REQUIRED\">\nPassword field is required</span></div></div></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"UPDATE MY PASSWORD\" ng-click=\"vm.resetButton();\" \nng-disabled=\"resetPasswordForm.$invalid || resetPasswordForm.$pristine\">{{ vm.params.type }} MY PASSWORD</md-button>\n</form><div class=\"login\" layout=\"row\" layout-align=\"center center\" ng-if=\"vm.reset\"><a class=\"link\" \nui-sref=\"app.login\" translate=\"FORGOTPASSWORD.GO_BACK\">Go back to login</a></div></div></div></div>");
$templateCache.put("app/main/register/register.html","<div id=\"register\" layout=\"row\" layout-align=\"start\"><div id=\"register-intro\" flex hide show-gt-sm><div \nclass=\"logo md-accent-bg\"><img ng-src=\"assets/images/logos/ae-logo.png\"></div><div class=\"title\" \ntranslate=\"REGISTER.INTRO_TITLE\">Welcome to the AGGREGO!</div><div class=\"description\" \ntranslate=\"REGISTER.INTRO_DESCRIPTION\">\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ullamcorper nisl erat, vel convallis elit fermentum pellentesque. Sed mollis velit facilisis facilisis viverra.\n</div></div><div id=\"register-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" layout=\"column\" flex ms-scroll>\n<div id=\"register-form\"><div class=\"logo md-accent-bg\" hide-gt-sm><img class=\"image\" \nng-src=\"assets/images/logos/ae-logo.png\" alt=\"Aggrego Logo\"></div><div class=\"title\" translate=\"REGISTER.TITLE\">\nCreate an account</div><div class=\"description\" translate=\"REGISTER.DESCRIPTION\">\nSed mollis velit facilisis facilisis viverra</div><form name=\"registerForm\" novalidate ng-submit=\"vm.register()\"><small\n class=\"red-fg\" ng-if=\"vm.errors\" ng-repeat=\"error in vm.errors\">{{error[0]}}<br></small><md-input-container \nclass=\"md-block\"><input name=\"company_name\" ng-model=\"vm.company_name\" ng-trim=\"true\" placeholder=\"Company name\" \nng-blur=\"vm.domain = (vm.company_name | spaceless | lowercase)\" required><div \nng-messages=\"registerForm.company_name.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.COMPANY_NAME_REQUIRED\"></span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><input name=\"domain\" ng-model=\"vm.domain\" placeholder=\"Domain\" \nng-value=\"vm.company_name | spaceless | lowercase\" required><div ng-messages=\"registerForm.domain.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.DOMAIN_REQUIRED\">Domain field is required</span></div>\n</div></md-input-container><md-input-container class=\"md-block\"><input name=\"name\" ng-model=\"vm.name\" \nplaceholder=\"Name\" required><div ng-messages=\"registerForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.NAME_REQUIRED\">Name field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><input type=\"email\" name=\"email\" ng-model=\"vm.email\" placeholder=\"Email\" \nng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"registerForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"REGISTER.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div \nng-message=\"pattern\"><span translate=\"REGISTER.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span>\n</div></div></md-input-container><md-input-container class=\"md-block\" ng-hide=\"vm.isSocialLogin\"><input \nplaceholder=\"Password\" name=\"password\" ng-model=\"vm.password\" ng-model-options=\"{ updateOn: \'blur\' }\" \nng-required=\"!vm.isSocialLogin\" type=\"password\" pattern=\".{4,14}\"><br><small class=\"error-message h6 md-warn-fg\" \nng-show=\"registerForm.password.$invalid && !registerForm.password.$pristine\">Passwords must have at least 4 chars.\n</small></md-input-container><md-input-container class=\"md-block\" ng-hide=\"vm.isSocialLogin\"><input \nplaceholder=\"Confirm Password\" name=\"password_confirmation\" ng-model=\"vm.password_confirmation\" \nng-required=\"!vm.isSocialLogin\" type=\"password\" \nwj-validation-error=\"vm.password && vm.password_confirmation != vm.password\"><br><small \nclass=\"error-message h6 md-warn-fg\" \nng-show=\"registerForm.password_confirmation.$invalid && !registerForm.password_confirmation.$pristine\">\nSorry, the passwords don\'t match.</small></md-input-container><div class=\"terms\" layout=\"row\" \nlayout-align=\"center center\"><md-checkbox name=\"terms\" ng-model=\"data.cb1\" aria-label=\"I read and accept\" required>\n<span translate=\"REGISTER.READ_ACCEPT\">I read and accept</span></md-checkbox><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"start center\"><a href=\"#\" class=\"md-accent-color\" translate=\"REGISTER.TERMS_COND\">terms and conditions\n</a></div></div><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"CREATE MY ACCOUNT\" \nng-disabled=\"registerForm.$invalid || registerForm.$pristine\" translate=\"REGISTER.CREATE_ACCOUNT\" \ntranslate-attr-aria-label=\"REGISTER.CREATE_ACCOUNT\">CREATE MY ACCOUNT</md-button><input type=\"hidden\" \nname=\"social_login\" ng-model=\"vm.social_login\" value=\"\"> <input type=\"hidden\" name=\"social_id\" ng-model=\"vm.social_id\" \nvalue=\"\"></form><div class=\"login\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><span class=\"text\" \ntranslate=\"REGISTER.ALREADY_HAVE\">Already have an account?</span> <a class=\"link\" ui-sref=\"app.login\" \ntranslate=\"REGISTER.LOGIN\">Log in</a></div></div></div></div>");
$templateCache.put("app/main/verify/verify.html","<div class=\"page-layout blank\" layout=\"row\"><h2>Verify first!!!</h2></div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-sortable=\"MsShortcuts.sortableOptions\"><div ng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" \nui-sref=\"{{shortcut.uisref}}\"><md-icon ng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\">\n</md-icon><div ng-if=\"!shortcut.icon\" class=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip \nmd-direction=\"bottom\">{{shortcut.title}}</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" \nclass=\"shortcut-menu hide show-gt-xs\"><md-button class=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\">\n</md-icon><md-tooltip md-direction=\"bottom\">Click to add/remove shortcut</md-tooltip></md-button><md-menu-content><div \nid=\"ms-shortcut-add-menu\"><div class=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"search-icon\" layout=\"row\" layout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon \nmd-menu-align-target md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" \nlayout=\"row\" layout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/main/apps/calendar/calendar.html","<div id=\"calendar\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header\" \nng-class=\"vm.currentMonthShort\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"header-top\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span \nclass=\"logo-text\" translate=\"CALENDAR.CALENDAR\">Calendar</span></div><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" aria-label=\"Search\" translate \ntranslate-attr-aria-label=\"CALENDAR.SEARCH\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip><span \ntranslate=\"CALENDAR.SEARCH\">Search</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.today()\" aria-label=\"Today\" translate translate-attr-aria-label=\"CALENDAR.TODAY\"><md-icon \nmd-font-icon=\"icon-calendar-today\"></md-icon><md-tooltip><span translate=\"CALENDAR.TODAY\">Today</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaDay\')\" aria-label=\"Day\" \ntranslate translate-attr-aria-label=\"CALENDAR.DAY\"><md-icon md-font-icon=\"icon-view-day\"></md-icon><md-tooltip><span \ntranslate=\"CALENDAR.DAY\">Day</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.changeView(\'agendaWeek\')\" aria-label=\"Week\" translate translate-attr-aria-label=\"CALENDAR.WEEK\">\n<md-icon md-font-icon=\"icon-view-week\"></md-icon><md-tooltip><span translate=\"CALENDAR.WEEK\">Week</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'month\')\" aria-label=\"Month\" translate \ntranslate-attr-aria-label=\"CALENDAR.MONTH\"><md-icon md-font-icon=\"icon-view-module\"></md-icon><md-tooltip><span \ntranslate=\"CALENDAR.MONTH\">Month</span></md-tooltip></md-button></div></div><div class=\"header-bottom\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-icon-button arrow\" ng-click=\"vm.calendar.prev()\" \naria-label=\"Previous\" translate translate-attr-aria-label=\"CALENDAR.PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><div class=\"title\">{{vm.calendarView.title}}</div><md-button \nclass=\"md-icon-button arrow\" ng-click=\"vm.calendar.next()\" aria-label=\"Next\" translate \ntranslate-attr-aria-label=\"CALENDAR.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div>\n<md-button class=\"add-event-button md-fab md-warn\" ng-click=\"vm.addEvent($event)\" aria-label=\"Add event\" translate \ntranslate-attr-aria-label=\"CALENDAR.ADD_EVENT\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div \nclass=\"content\"><div id=\"calendarView\" ui-calendar=\"vm.calendarUiConfig.calendar\" ng-model=\"vm.events\" calendar=\"main\">\n</div></div></div>");
$templateCache.put("app/main/apps/companies/companies.html","<div id=\"companies\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div ng-hide=\"vm.selectedCompanies.length > 0\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" hide-gt-md \nng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" translate \ntranslate-attr-aria-label=\"COMPANIES.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\"></md-icon>\n</md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\" hide-xs><md-icon \nmd-font-icon=\"icon-sitemap white-fg\" class=\"s24\"></md-icon></span><span class=\"logo-text\" \ntranslate=\"COMPANIES.COMPANIES\">Companies</span></div></div><div ng-hide=\"vm.selectedCompanies.length > 0\" \nclass=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\" hide-xs><label for=\"search\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float class=\"m-0\"><input id=\"search\" \nplaceholder=\"Search for anyone\" type=\"text\" ng-model=\"vm.search\" translate \ntranslate-attr-placeholder=\"COMPANIES.SEARCH_FOR_ANYONE\"></md-input-container></div><div \nng-hide=\"vm.selectedCompanies.length > 0\"><md-button class=\"md-accent md-raised md-hue-2 header-boards-button\" \nng-click=\"vm.openCompanyDialog($event)\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon><span class=\"ph-8\">Create\n</span></md-button></div></div><div ng-show=\"vm.selectedCompanies.length > 0\" \nclass=\"selected-bar header animate-slide-down md-accent-bg white-fg\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"close-button-wrapper\" ng-click=\"vm.selectedCompanies =[]\"><md-button layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-arrow-left\" class=\"mr-8\"></md-icon><span translate=\"COMPANIES.BACK\">Back</span></md-button>\n</div><div flex layout=\"row\" layout-align=\"space-between center\"><div><span class=\"selected-companies-count\"><span>\n{{vm.selectedCompanies.length}}</span> <span translate=\"COMPANIES.SELECTED\">selected</span></span><md-menu \nclass=\"select-menu\" ng-if=\"!vm.currentThread\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" \naria-label=\"multi select toggle\" translate translate-attr-aria-label=\"COMPANIES.MULTI_SELECT_TOGGLE\"><md-icon \nmd-font-icon=\"icon-menu-down\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.selectAllCompanies()\" translate=\"COMPANIES.SELECT_ALL\">Select all</md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"vm.deselectCompanies()\" translate=\"COMPANIES.SELECT_NONE\">Select none</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class=\"multi-select-actions\"><md-button class=\"md-icon-button\" \nng-click=\"vm.deleteSelectedCompanies($event)\" aria-label=\"delete selected\" translate \ntranslate-attr-label=\"COMPANIES.DELETE_SELECTED\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></div>\n</div><div class=\"content\" md-background-bg layout=\"row\" layout-align=\"start start\"><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" ms-scroll md-is-locked-open=\"$mdMedia(\'gt-md\')\" layout=\"column\" flex=\"100\" \nmd-component-id=\"sidenav\" ms-sidenav-helper ng-include=\"\'app/main/apps/companies/sidenavs/main/main-sidenav.html\'\">\n</md-sidenav><div class=\"main scrollable\" ms-scroll><md-list class=\"companies-list\"><md-subheader \nclass=\"md-no-sticky md-white-bg\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"list-title\" \nlayout=\"row\" layout-align=\"start center\" ng-hide=\"editGroupForm.$visible\"><span ng-if=\"vm.listType === \'all\'\" \ntranslate=\"COMPANIES.ALL_COMPANIES\">All companies</span> <span ng-if=\"vm.listType === \'frequent\'\" \ntranslate=\"COMPANIES.FREQUENTLY_COMPANYED\">Frequnetly companyed</span> <span ng-if=\"vm.listType === \'starred\'\" \ntranslate=\"COMPANIES.STARRED_COMPANIES\">Starred companies</span> <span ng-if=\"vm.listType.name\">{{vm.listType.name}}\n</span> <span ng-if=\"filteredCompanies.length\" class=\"secondary-text companies-count\">({{filteredCompanies.length}})\n</span></div><div class=\"edit-group-form\" ng-show=\"vm.listType.name\" layout=\"row\" layout-align=\"start center\"><span \nng-show=\"editGroupForm.$visible\" editable-text=\"vm.listType.name\" e-form=\"editGroupForm\" onaftersave=\"vm.editGroup()\">\n</span><md-button class=\"md-icon-button edit-group-button\" ng-click=\"editGroupForm.$show()\" \nng-hide=\"editGroupForm.$visible\" aria-label=\"edit group name\" translate \ntranslate-attr-label=\"COMPANIES.EDIT_GROUP_NAME\"><md-icon md-font-icon=\"icon-pencil s18\"></md-icon></md-button>\n<md-button class=\"md-icon-button edit-group-button\" ng-click=\"vm.deleteGroup($event)\" ng-hide=\"editGroupForm.$visible\" \naria-label=\"delete group\" translate translate-attr-label=\"COMPANIES.DELETE_GROUP\"><md-icon \nmd-font-icon=\"icon-delete s18\"></md-icon></md-button></div><div flex></div><md-menu><md-button class=\"md-icon-button\" \naria-label=\"Sort\" translate translate-attr-aria-label=\"COMPANIES.SORT\"><md-icon md-font-icon=\"icon-sort-alphabetical\" \nng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.listOrder = \'name\';vm.listOrderAsc = false\" \nng-style=\"vm.listOrder === \'name\' && vm.listOrderAsc=== false && {\'font-weight\':\'500\'}\"><span \ntranslate=\"COMPANIES.FIRST_NAME\">First Name</span> <small translate=\"COMPANIES.A_TO_Z\">(A to Z)</small></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.listOrder = \'name\'; vm.listOrderAsc = true\" \nng-style=\"vm.listOrder === \'name\' && vm.listOrderAsc=== true && {\'font-weight\':\'500\'}\"><span \ntranslate=\"COMPANIES.FIRST_NAME\">First Name</span> <small translate=\"COMPANIES.Z_TO_A\">(Z to A)</small></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.listOrder = \'lastName\';vm.listOrderAsc = false\" \nng-style=\"vm.listOrder === \'lastName\' && vm.listOrderAsc=== false && {\'font-weight\':\'500\'}\"><span \ntranslate=\"COMPANIES.LAST_NAME\">Last Name</span> <small translate=\"COMPANIES.A_TO_Z\">(A to Z)</small></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.listOrder = \'lastName\'; vm.listOrderAsc = true\" \nng-style=\"vm.listOrder === \'lastName\' && vm.listOrderAsc=== true && {\'font-weight\':\'500\'}\"><span \ntranslate=\"COMPANIES.LAST_NAME\">Last Name</span> <small translate=\"COMPANIES.Z_TO_A\">(Z to A)</small></md-button>\n</md-menu-item></md-menu-content></md-menu></div></md-subheader><md-list-item class=\"company-item md-white-bg\" \nmd-ink-ripple \nng-repeat=\"company in vm.companies | filter: vm.search | filter: global.search | filterByIds:vm.filterIds |  orderBy: vm.listOrder :vm.listOrderAsc | filter:query as filteredCompanies track by company.id \" \nng-click=\"vm.openCompanyDialog($event, company)\" \nng-style=\"{\'transform\': \'translate3d(0px, \'+$index * 100+\'%, 0px)\', \'z-index\': filteredCompanies.length - $index}\" \nng-class=\"{\'selected\': vm.isSelected(company)}\"><md-checkbox ng-checked=\"vm.exists(company, vm.selectedCompanies)\" \nng-click=\"vm.toggleSelectCompany(company, $event)\" \naria-label=\"{{vm.exists(company, vm.selectedCompanies) ? \'Deselect\' : \'Select\'}}\"></md-checkbox>\n{{avatar = (company.avatar.path || vm.crmUrl + \'storage/app/media/company.png\');\"\" }} <img class=\"md-avatar\" \nng-if=\"avatar\" alt=\"{{company.name}}\" ng-src=\"{{avatar}}\"><p class=\"text-truncate font-weight-600\">{{company.name}}</p>\n<p class=\"email text-truncate hide show-gt-sm\">{{company.email}}</p><p class=\"email text-truncate hide show-gt-md\">\n{{company.domain}}</p><p class=\"email text-truncate hide show-gt-md\">{{company.contact_person}}</p><p \nclass=\"phone text-truncate hide show-gt-md\"><span ng-if=\"company.telephone\">{{vm.phoneCode}}</span>\n {{company.telephone}}</p><div class=\"actions\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button hide show-gt-xs\" \nng-click=\"$event.stopPropagation();vm.toggleInArray(company.id, vm.user.starred)\" aria-label=\"Toggle starred\" \ntranslate translate-attr-aria-label=\"COMPANIES.TOGGLE_STARRED\"></md-button><md-menu><md-button class=\"md-icon-button\" \naria-label=\"More\" translate translate-attr-aria-label=\"COMPANIES.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" \nng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.deleteCompanyConfirm(company, ev)\" translate=\"COMPANIES.DELETE_COMPANY\">Delete Company</md-button>\n</md-menu-item></md-menu-content></md-menu></div></md-list-item></md-list><md-list-item class=\"no-results md-white-bg\" \nng-show=\"filteredCompanies.length === 0\"><p translate=\"COMPANIES.NO_RESULTS\">No results..</p></md-list-item></div>\n</div></div>");
$templateCache.put("app/main/apps/contacts/contacts.html","<div id=\"contacts\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div ng-hide=\"vm.selectedContacts.length > 0\" class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" hide-gt-md \nng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" translate \ntranslate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\"></md-icon>\n</md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\" hide-xs><md-icon \nmd-font-icon=\"icon-account-box white-fg\" class=\"s24\"></md-icon></span><span class=\"logo-text\" \ntranslate=\"CONTACTS.CONTACTS\">Contacts</span></div></div><div ng-hide=\"vm.selectedContacts.length > 0\" \nclass=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\" hide-xs><label for=\"search\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float class=\"m-0\"><input id=\"search\" \nplaceholder=\"Search for anyone\" type=\"text\" ng-model=\"vm.search\" translate \ntranslate-attr-placeholder=\"CONTACTS.SEARCH_FOR_ANYONE\"></md-input-container></div><div \nng-hide=\"vm.selectedContacts.length > 0\"><md-button class=\"md-accent md-raised md-hue-2 header-boards-button\" \nng-click=\"vm.openContactDialog($event)\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon><span class=\"ph-8\">Create\n</span></md-button></div></div><div ng-show=\"vm.selectedContacts.length > 0\" \nclass=\"selected-bar header animate-slide-down md-accent-bg white-fg\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"close-button-wrapper\" ng-click=\"vm.selectedContacts =[]\"><md-button layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-arrow-left\" class=\"mr-8\"></md-icon><span translate=\"CONTACTS.BACK\">Back</span></md-button>\n</div><div flex layout=\"row\" layout-align=\"space-between center\"><div><span class=\"selected-contacts-count\"><span>\n{{vm.selectedContacts.length}}</span> <span translate=\"CONTACTS.SELECTED\">selected</span></span><md-menu \nclass=\"select-menu\" ng-if=\"!vm.currentThread\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" \naria-label=\"multi select toggle\" translate translate-attr-aria-label=\"CONTACTS.MULTI_SELECT_TOGGLE\"><md-icon \nmd-font-icon=\"icon-menu-down\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.selectAllContacts()\" translate=\"CONTACTS.SELECT_ALL\">Select all</md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"vm.deselectContacts()\" translate=\"CONTACTS.SELECT_NONE\">Select none</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class=\"multi-select-actions\"><md-button class=\"md-icon-button\" \nng-click=\"vm.deleteSelectedContacts($event)\" aria-label=\"delete selected\" translate \ntranslate-attr-label=\"CONTACTS.DELETE_SELECTED\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></div>\n</div><div class=\"content\" md-background-bg layout=\"row\" layout-align=\"start start\"><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" ms-scroll md-is-locked-open=\"$mdMedia(\'gt-md\')\" layout=\"column\" flex=\"100\" \nmd-component-id=\"sidenav\" ms-sidenav-helper ng-include=\"\'app/main/apps/contacts/sidenavs/main/main-sidenav.html\'\">\n</md-sidenav><div class=\"main scrollable\" ms-scroll><md-list class=\"contacts-list\"><md-subheader \nclass=\"md-no-sticky md-white-bg\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"list-title\" \nlayout=\"row\" layout-align=\"start center\" ng-hide=\"editGroupForm.$visible\"><span ng-if=\"vm.listType === \'all\'\" \ntranslate=\"CONTACTS.ALL_CONTACTS\">All contacts</span> <span ng-if=\"vm.listType === \'frequent\'\" \ntranslate=\"CONTACTS.FREQUENTLY_CONTACTED\">Frequnetly contacted</span> <span ng-if=\"vm.listType === \'starred\'\" \ntranslate=\"CONTACTS.STARRED_CONTACTS\">Starred contacts</span> <span ng-if=\"vm.listType.name\">{{vm.listType.name}}\n</span> <span ng-if=\"filteredContacts.length\" class=\"secondary-text contacts-count\">({{filteredContacts.length}})\n</span></div><div class=\"edit-group-form\" ng-show=\"vm.listType.name\" layout=\"row\" layout-align=\"start center\"><span \nng-show=\"editGroupForm.$visible\" editable-text=\"vm.listType.name\" e-form=\"editGroupForm\" onaftersave=\"vm.editGroup()\">\n</span><md-button class=\"md-icon-button edit-group-button\" ng-click=\"editGroupForm.$show()\" \nng-hide=\"editGroupForm.$visible\" aria-label=\"edit group name\" translate \ntranslate-attr-label=\"CONTACTS.EDIT_GROUP_NAME\"><md-icon md-font-icon=\"icon-pencil s18\"></md-icon></md-button>\n<md-button class=\"md-icon-button edit-group-button\" ng-click=\"vm.deleteGroup($event)\" ng-hide=\"editGroupForm.$visible\" \naria-label=\"delete group\" translate translate-attr-label=\"CONTACTS.DELETE_GROUP\"><md-icon \nmd-font-icon=\"icon-delete s18\"></md-icon></md-button></div><div flex></div><md-menu><md-button class=\"md-icon-button\" \naria-label=\"Sort\" translate translate-attr-aria-label=\"CONTACTS.SORT\"><md-icon md-font-icon=\"icon-sort-alphabetical\" \nng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.listOrder = \'name\';vm.listOrderAsc = false\" \nng-style=\"vm.listOrder === \'name\' && vm.listOrderAsc=== false && {\'font-weight\':\'500\'}\"><span \ntranslate=\"CONTACTS.FIRST_NAME\">First Name</span> <small translate=\"CONTACTS.A_TO_Z\">(A to Z)</small></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.listOrder = \'name\'; vm.listOrderAsc = true\" \nng-style=\"vm.listOrder === \'name\' && vm.listOrderAsc=== true && {\'font-weight\':\'500\'}\"><span \ntranslate=\"CONTACTS.FIRST_NAME\">First Name</span> <small translate=\"CONTACTS.Z_TO_A\">(Z to A)</small></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.listOrder = \'lastName\';vm.listOrderAsc = false\" \nng-style=\"vm.listOrder === \'lastName\' && vm.listOrderAsc=== false && {\'font-weight\':\'500\'}\"><span \ntranslate=\"CONTACTS.LAST_NAME\">Last Name</span> <small translate=\"CONTACTS.A_TO_Z\">(A to Z)</small></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.listOrder = \'lastName\'; vm.listOrderAsc = true\" \nng-style=\"vm.listOrder === \'lastName\' && vm.listOrderAsc=== true && {\'font-weight\':\'500\'}\"><span \ntranslate=\"CONTACTS.LAST_NAME\">Last Name</span> <small translate=\"CONTACTS.Z_TO_A\">(Z to A)</small></md-button>\n</md-menu-item></md-menu-content></md-menu></div></md-subheader><md-list-item class=\"contact-item md-white-bg\" \nmd-ink-ripple \nng-repeat=\"contact in vm.contacts | filter: vm.search | filter: global.search | filterByIds:vm.filterIds |  orderBy: vm.listOrder :vm.listOrderAsc | filter:query as filteredContacts track by contact.id \" \nng-click=\"vm.openContactDialog($event, contact)\" \nng-style=\"{\'transform\': \'translate3d(0px, \'+$index * 100+\'%, 0px)\', \'z-index\': filteredContacts.length - $index}\" \nng-class=\"{\'selected\': vm.isSelected(contact)}\"><md-checkbox ng-checked=\"vm.exists(contact, vm.selectedContacts)\" \nng-click=\"vm.toggleSelectContact(contact, $event)\" \naria-label=\"{{vm.exists(contact, vm.selectedContacts) ? \'Deselect\' : \'Select\'}}\"></md-checkbox>\n{{avatar = (contact.avatar.path || vm.crmUrl + \'storage/app/media/profile.jpg\');\"\" }} <img class=\"md-avatar\" \nng-if=\"avatar\" alt=\"{{contact.first_name}} {{contact.last_name}}\" ng-src=\"{{avatar}}\"><p \nclass=\"text-truncate font-weight-600\">{{contact.first_name}} {{contact.last_name}}</p><p \nclass=\"email text-truncate hide show-gt-sm\">{{contact.email}}</p><p class=\"phone text-truncate hide show-gt-md\"><span \nng-if=\"contact.mobile_phone1\">{{vm.phoneCode}}</span> {{contact.mobile_phone1 | tel}}</p><p \nclass=\"phone text-truncate hide show-gt-md\"><span ng-if=\"contact.mobile_phone2\">{{vm.phoneCode}}</span>\n {{contact.mobile_phone2 | tel}}</p><p class=\"company text-truncate hide show-gt-lg\">{{contact.company}}</p><div \nclass=\"actions\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button hide show-gt-xs\" \nng-click=\"$event.stopPropagation();vm.toggleInArray(contact.id, vm.user.starred)\" aria-label=\"Toggle starred\" \ntranslate translate-attr-aria-label=\"CONTACTS.TOGGLE_STARRED\"></md-button><md-menu><md-button class=\"md-icon-button\" \naria-label=\"More\" translate translate-attr-aria-label=\"CONTACTS.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" \nng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.deleteContactConfirm(contact, ev)\" translate=\"CONTACTS.DELETE_CONTACT\">Delete Contact</md-button>\n</md-menu-item></md-menu-content></md-menu></div></md-list-item></md-list><md-list-item class=\"no-results md-white-bg\" \nng-show=\"filteredContacts.length === 0\"><p translate=\"CONTACTS.NO_RESULTS\">No results..</p></md-list-item></div></div>\n</div>");
$templateCache.put("app/main/apps/employees/employees.html","<div id=\"employees\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div ng-hide=\"vm.selectedEmployees.length > 0\" class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" hide-gt-md \nng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" translate \ntranslate-attr-aria-label=\"EMPLOYEES.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\"></md-icon>\n</md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\" hide-xs><md-icon \nmd-font-icon=\"icon-account-box\" class=\"s24\"></md-icon></span><span class=\"logo-text\" translate=\"EMPLOYEES.EMPLOYEES\">\nEmployees</span></div></div><div ng-hide=\"vm.selectedEmployees.length > 0\" class=\"search-input-wrapper\" layout=\"row\" \nlayout-align=\"start center\" hide-xs><label for=\"search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label>\n<md-input-container md-no-float class=\"m-0\"><input id=\"search\" placeholder=\"Search for anyone\" type=\"text\" \nng-model=\"vm.search\" translate translate-attr-placeholder=\"EMPLOYEES.SEARCH_FOR_ANYONE\"></md-input-container></div><div\n ng-hide=\"vm.selectedEmployees.length > 0\" ng-if=\"role.permissions.write\"><md-button \nclass=\"md-accent md-raised md-hue-2 header-boards-button\" ng-click=\"vm.openEmployeeDialog($event)\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon><span class=\"ph-8\">Create</span></md-button></div></div><div \nng-show=\"vm.selectedEmployees.length > 0\" class=\"selected-bar header animate-slide-down md-accent-bg white-fg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"close-button-wrapper\" ng-click=\"vm.selectedEmployees =[]\">\n<md-button layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"mr-8\"></md-icon>\n<span translate=\"EMPLOYEES.BACK\">Back</span></md-button></div><div flex layout=\"row\" \nlayout-align=\"space-between center\"><div><span class=\"selected-contacts-count\"><span>{{vm.selectedEmployees.length}}\n</span> <span translate=\"EMPLOYEES.SELECTED\">selected</span></span><md-menu class=\"select-menu\" \nng-if=\"!vm.currentThread\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" \naria-label=\"multi select toggle\" translate translate-attr-aria-label=\"EMPLOYEES.MULTI_SELECT_TOGGLE\"><md-icon \nmd-font-icon=\"icon-menu-down\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.selectAllEmployees()\" translate=\"EMPLOYEES.SELECT_ALL\">Select all</md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"vm.deselectEmployees()\" translate=\"EMPLOYEES.SELECT_NONE\">Select none</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class=\"multi-select-actions\"><md-button class=\"md-icon-button\" \nng-click=\"vm.deleteSelectedEmployees($event)\" aria-label=\"delete selected\" translate \ntranslate-attr-label=\"EMPLOYEES.DELETE_SELECTED\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></div>\n</div><div class=\"content\" md-background-bg layout=\"row\" layout-align=\"start start\"><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" ms-scroll md-is-locked-open=\"$mdMedia(\'gt-md\')\" layout=\"column\" flex=\"100\" \nmd-component-id=\"sidenav\" ms-sidenav-helper ng-include=\"\'app/main/apps/employees/sidenavs/main/main-sidenav.html\'\">\n</md-sidenav><div class=\"main scrollable\" ms-scroll><md-list class=\"employees-list\"><md-subheader \nclass=\"md-no-sticky md-white-bg\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"list-title\" \nlayout=\"row\" layout-align=\"start center\" ng-hide=\"editGroupForm.$visible\"><span ng-if=\"vm.listType === \'all\'\" \ntranslate=\"EMPLOYEES.ALL_EMPLOYEES\">All employees</span> <span ng-if=\"vm.listType === \'frequent\'\" \ntranslate=\"EMPLOYEES.FREQUENTLY_ADDED\">Frequnetly added</span> <span ng-if=\"vm.listType === \'starred\'\" \ntranslate=\"EMPLOYEES.STARRED_EMPLOYEES\">Starred employees</span> <span ng-if=\"vm.listType.name\">{{vm.listType.name}}\n</span> <span ng-if=\"filteredEmployees.length\" class=\"secondary-text employees-count\">({{filteredEmployees.length}})\n</span></div><div flex></div><md-menu><md-button class=\"md-icon-button\" aria-label=\"Sort\" translate \ntranslate-attr-aria-label=\"EMPLOYEES.SORT\"><md-icon md-font-icon=\"icon-sort-alphabetical\" \nng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.listOrder = \'name\';vm.listOrderAsc = false\" \nng-style=\"vm.listOrder === \'name\' && vm.listOrderAsc=== false && {\'font-weight\':\'500\'}\"><span \ntranslate=\"EMPLOYEES.FIRST_NAME\">First Name</span> <small translate=\"EMPLOYEES.A_TO_Z\">(A to Z)</small></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.listOrder = \'name\'; vm.listOrderAsc = true\" \nng-style=\"vm.listOrder === \'name\' && vm.listOrderAsc=== true && {\'font-weight\':\'500\'}\"><span \ntranslate=\"EMPLOYEES.FIRST_NAME\">First Name</span> <small translate=\"EMPLOYEES.Z_TO_A\">(Z to A)</small></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.listOrder = \'lastName\';vm.listOrderAsc = false\" \nng-style=\"vm.listOrder === \'lastName\' && vm.listOrderAsc=== false && {\'font-weight\':\'500\'}\"><span \ntranslate=\"EMPLOYEES.LAST_NAME\">Last Name</span> <small translate=\"EMPLOYEES.A_TO_Z\">(A to Z)</small></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.listOrder = \'lastName\'; vm.listOrderAsc = true\" \nng-style=\"vm.listOrder === \'lastName\' && vm.listOrderAsc=== true && {\'font-weight\':\'500\'}\"><span \ntranslate=\"EMPLOYEES.LAST_NAME\">Last Name</span> <small translate=\"EMPLOYEES.Z_TO_A\">(Z to A)</small></md-button>\n</md-menu-item></md-menu-content></md-menu><md-menu><md-button class=\"md-icon-button\" aria-label=\"Groups\" \ntitle=\"Groups\" translate translate-attr-aria-label=\"EMPLOYEES.SORT\"><md-icon md-font-icon=\"icon-account-switch\" \nng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.filterChange(\'all\')\" ng-style=\"vm.listType.name === \'all\' && {\'font-weight\':\'500\'}\"><span \ntranslate=\"EMPLOYEES.ALL_EMPLOYEES\">All employees</span></md-button></md-menu-item><md-menu-item \nng-if=\"vm.user.groups\" ng-repeat=\"group in vm.user.groups\"><md-button ng-click=\"vm.filterChange(group)\" \nng-style=\"vm.listType.name === group.name && {\'font-weight\':\'500\'}\"><span>{{group.name}}</span></md-button>\n</md-menu-item></md-menu-content></md-menu></div></md-subheader><md-list-item class=\"employee-item md-white-bg\" \nmd-ink-ripple \nng-repeat=\"employee in vm.employees | filter: vm.search | filter: global.search | filterByIds:vm.filterIds |  orderBy: vm.listOrder :vm.listOrderAsc | filter:query as filteredEmployees track by employee.id \" \nng-click=\"vm.openEmployeeDialog($event, employee)\" ng-style=\"{\'z-index\': filteredEmployees.length - $index}\" \nng-class=\"{\'selected\': vm.isSelected(employee)}\"><md-checkbox ng-if=\"role.permissions.write\" \nng-checked=\"vm.exists(employee, vm.selectedEmployees)\" ng-click=\"vm.toggleSelectEmployee(employee, $event)\" \naria-label=\"{{vm.exists(employee, vm.selectedEmployees) ? \'Deselect\' : \'Select\'}}\"></md-checkbox>\n{{vm.employee.user.avatar.path = (employee.user.avatar.path || vm.crmUrl + \'storage/app/media/profile.jpg\');\"\"}} <img \nng-src=\"{{vm.employee.user.avatar.path}}\" class=\"md-avatar\" alt=\"{{employee.first_name}} {{employee.last_name}}\"><p \nclass=\"text-truncate font-weight-600\">{{employee.first_name}} {{employee.last_name}}</p><p \nclass=\"email text-truncate hide show-gt-sm\">{{employee.email}}</p><p class=\"phone text-truncate hide show-gt-md\"><span \nng-if=\"employee.mobile_phone1\">{{vm.phoneCode}}</span> {{employee.mobile_phone1 | tel}}</p><p \nclass=\"phone text-truncate hide show-gt-md\"><span ng-if=\"employee.mobile_phone2\">{{vm.phoneCode}}</span>\n {{employee.mobile_phone2 | tel}}</p><div class=\"actions\" layout=\"row\" layout-align=\"start center\" \nng-if=\"role.permissions.write\"><md-menu><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"EMPLOYEES.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdOpenMenu($event)\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.deleteEmployeeConfirm(ev, employee, \'employee\')\" translate=\"EMPLOYEES.DELETE_EMPLOYEE\">Delete Employee\n</md-button></md-menu-item><md-divider ng-if=\"vm.user.groups\"></md-divider><md-subheader class=\"md-no-sticky\" \nng-if=\"vm.user.groups\">Groups</md-subheader><md-list-item ng-if=\"vm.user.groups\" ng-repeat=\"group in vm.user.groups\" \nng-click=\"vm.toggleInArray(employee.id,group.users_id);vm.groupEmployee(vm.exists(employee.id,group.users_id), group, employee.id)\">\n<p class=\"pl-8\" ng-class=\"{\'md-accent-fg font-weight-700\': vm.exists(employee.id,group.users_id)}\">{{group.name}}</p>\n</md-list-item></md-menu-content></md-menu></div></md-list-item></md-list><md-list-item class=\"no-results md-white-bg\" \nng-show=\"filteredEmployees.length === 0\"><p translate=\"EMPLOYEES.NO_RESULTS\">No results..</p></md-list-item></div>\n</div></div>");
$templateCache.put("app/main/apps/scrumboard/scrumboard.html","<div id=\"scrumboard\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header md-accent-bg\" \nng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\" layout=\"column\"><div class=\"header-content\" layout=\"row\" \nlayout-align=\"space-between\" layout-wrap flex><div class=\"board\" layout=\"row\" layout-align=\"center center\" \nflex-order=\"1\" flex-order-xs=\"2\"><md-button class=\"md-accent md-raised md-hue-2 header-boards-button\" \nng-class=\"\'md-\'+vm.board.settings.color+\'-700-bg\'\" ng-click=\"vm.toggleHeader(\'board\')\" aria-label=\"boards button\" \ntranslate translate-attr-aria-label=\"SB.BOARDS_BUTTON\"><md-icon md-font-icon=\"icon-trello\" class=\"icon\"></md-icon><span\n translate=\"SB.BOARDS\">BOARDS</span></md-button></div><div class=\"header-board-name\" layout=\"row\" \nlayout-align=\"center center\" flex-order=\"3\" flex-order-xs=\"1\" flex-xs=\"100\"><span editable-text=\"vm.board.title\" \nonaftersave=\"vm.saveUser()\" edit-disabled=\"vm.isDisabled\" data-e-id=\"title\">{{vm.board.title}}</span><md-tooltip><span>\nTitle of the board</span></md-tooltip></div><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nflex-order=\"4\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'filters-sidenav\')\" \naria-label=\"Filter Leads\" translate translate-attr-aria-label=\"SB.FILTER_LEADS\"><md-icon \nmd-font-icon=\"icon-filter-variant\"></md-icon><md-tooltip><span translate=\"SB.FILTER_LEADS\">Filter Leads</span>\n</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'settings-sidenav\')\" \naria-label=\"Settings\" translate translate-attr-aria-label=\"SB.SETTINGS\"><md-icon md-font-icon=\"icon-cog\"></md-icon>\n<md-tooltip><span translate=\"SB.SETTINGS\">Settings</span></md-tooltip></md-button><md-button \nclass=\"md-accent md-raised md-hue-2 header-boards-button ms-sb-add-lead-button\" \nng-class=\"\'md-\'+vm.board.settings.color+\'-700-bg\'\" ng-click=\"vm.openLeadDialog($event, null, vm.data)\" \naria-label=\"Calendar\" translate translate-attr-aria-label=\"SB.CALENDAR\" ng-disabled=\"vm.board.stages.length === 0\">\n<md-icon md-font-icon=\"icon-playlist-plus\"></md-icon><span>Add Lead</span></md-button></div></div></div><div \nng-show=\"vm.boardSelectorVisible\" id=\"board-selector\" \nclass=\"md-accent-bg animate-slide-down board-stage md-whiteframe-3dp\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\" \nlayout=\"row\" layout-align=\"start center\" ms-scroll><div class=\"board-stage-item\" ng-repeat=\"board in vm.boards\" \nui-sref=\"app.scrumboard.boards.board({id:board.id, uri:board.uri, isNew: false, newLeadId: null})\" layout=\"column\" \nlayout-align=\"space-between center\"><div class=\"board-icon\"><i class=\"icon-trello s64\"></i></div><div flex \nclass=\"board-name\">{{board.title}}</div><div class=\"board-options\"><i class=\"icon-dots-horizontal\"></i></div><div \nng-if=\"board.id === vm.board.id\" class=\"selected-icon green-bg\"><i class=\"icon-check s24\"></i></div></div><md-menu \nmd-offset=\"0 150\"><div class=\"board-stage-item add-new-board\" layout=\"column\" layout-align=\"space-between center\" \nng-click=\"$mdOpenMenu()\"><div class=\"board-icon\"><i class=\"icon-plus-circle s64\"></i></div><div flex \nclass=\"board-name\" translate=\"SB.ADD_NEW_BOARD\">Add New Board</div></div><md-menu-content width=\"3\"><md-menu-item>\n<md-button disabled=\"disabled\">Choose from existing layout</md-button></md-menu-item><md-menu-item \nng-repeat=\"(value, boards) in vm.boardsTemplate\" \nui-sref=\"app.scrumboard.boards.addBoard({template:value, company_id:vm.company.id})\" \nui-sref-opts=\"{reload: true, notify: true}\"><md-button aria-label=\"value\">{{value | ucfirst}}</md-button>\n</md-menu-item></md-menu-content></md-menu></div><md-backdrop \nclass=\"board-selector-backdrop md-dialog-backdrop md-opaque\" ng-show=\"vm.boardSelectorVisible\" \nng-click=\"vm.boardSelectorVisible = false\" aria-hidden=\"true\"></md-backdrop><div ng-show=\"vm.addLeadVisible\" \nid=\"board-selector\" class=\"md-accent-bg animate-slide-down board-stage md-whiteframe-3dp\" \nng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\" layout=\"row\" layout-align=\"start center\"><div class=\"stage-footer\">\n<ms-sb-add-lead ms-stage-id=\"vm.firstStage\"></ms-sb-add-lead></div><md-button class=\"cancel-button md-icon-button\" \naria-label=\"cancel\" ng-click=\"vm.toggleHeader(\'lead\')\" translate-attr-aria-label=\"SB.CANCEL\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><md-backdrop \nclass=\"board-selector-backdrop md-dialog-backdrop md-opaque\" ng-show=\"vm.addLeadVisible\" \nng-click=\"vm.addLeadVisible = false\" aria-hidden=\"true\"></md-backdrop><md-content class=\"content\" flex layout=\"column\" \nui-view=\"scrumboardContent\"></md-content><md-sidenav class=\"settings-sidenav md-sidenav-right\" \nmd-component-id=\"settings-sidenav\" ng-include=\"\'app/main/apps/scrumboard/sidenavs/settings/settings-sidenav.html\'\" \nng-controller=\"SettingsSidenavController as vm\" ms-sidenav-helper></md-sidenav><md-sidenav \nclass=\"filters-sidenav md-sidenav-right\" md-component-id=\"filters-sidenav\" \nng-include=\"\'app/main/apps/scrumboard/sidenavs/filters/filters-sidenav.html\'\" \nng-controller=\"FiltersSidenavController as vm\" ms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/main/apps/todo/todo.html","<div id=\"todo\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><md-sidenav \nclass=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/apps/todo/sidenavs/main/main-sidenav.html\'\" ms-scroll ms-sidenav-helper></md-sidenav><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"search-wrapper md-whiteframe-4dp\" flex layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" hide-gt-md \naria-label=\"Toggle sidenav\" translate translate-attr-aria-label=\"TODO.TOGGLE_SIDENAV\"><md-icon \nmd-font-icon=\"icon-apps\" class=\"icon\"></md-icon></md-button><div class=\"search\" flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex \nng-model=\"vm.taskFilters.search\" type=\"text\" placeholder=\"Search for a task\" translate \ntranslate-attr-placeholder=\"TODO.SEARCH\"></div></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><md-select class=\"simplified\" \nng-model=\"vm.selectedFilter.dateRange\" ng-change=\"vm.dateFilter(\'date_deadline\', \'\')\" placeholder=\"Due Date\"><md-option\n value=\"Today\">Today</md-option><md-option value=\"Next 3 days\" translate=\"TODO.NEXT_3_DAYS\">Next 3 days</md-option>\n<md-option value=\"Next week\" translate=\"TODO.NEXT_WEEK\">Next week</md-option><md-option value=\"Next month\" \ntranslate=\"TODO.NEXT_MONTH\">Next month</md-option><md-option value=\"All Tasks\">All Tasks</md-option></md-select><div \nlayout=\"row\" layout-align=\"start center\"><md-select class=\"simplified\" ng-model=\"vm.taskOrder\" placeholder=\"Order\" \nng-change=\"vm.taskOrderDescending = vm.taskOrder === \'\' ? false : vm.taskOrderDescending\"><md-option \nvalue=\"date_deadline\">Due Date</md-option><md-option ng-value=\"\'\'\" translate=\"TODO.MANUAL\">Manual</md-option><md-option\n value=\"subject\">Subject</md-option></md-select><md-button class=\"md-icon-button\" ng-disabled=\"vm.taskOrder === \'\'\" \nng-click=\"vm.taskOrderDescending = !vm.taskOrderDescending\" aria-label=\"Sort Direction\" translate \ntranslate-attr-aria-label=\"TODO.SORT_DIRECTION\"><md-icon md-font-icon=\"icon-sort-ascending\" \nng-if=\"vm.taskOrderDescending === false\"></md-icon><md-icon md-font-icon=\"icon-sort-descending\" \nng-if=\"vm.taskOrderDescending === true\"></md-icon></md-button></div></div><div class=\"content\" layout=\"row\" flex>\n<md-content class=\"todo-list-pane\" flex ng-include=\"\'app/main/apps/todo/views/list/list-view.html\'\" \nms-scroll=\"vm.msScrollOptions\"></md-content></div></div></div></div>");
$templateCache.put("app/main/pages/profile/profile.html","<div id=\"profile\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\" \nng-style=\"{\'background\': \'url(\' + vm.cover + \') no-repeat 0 45%\'}\"><div class=\"user-info\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><button \nngf-select=\"vm.uploadFiles($files, vm.employee.id, \'avatar\')\" accept=\"image/*\">\n{{vm.employee.user.avatar.path = (vm.employee.user.avatar.path || vm.crmUrl + \'storage/app/media/profile.jpg\');\"\"}} \n<img ng-src=\"{{vm.employee.user.avatar.path}}\" class=\"profile-image avatar huge\" \nalt=\"{{vm.employee.first_name}} {{vm.employee.last_name}}\"><md-tooltip>Click to change profile</md-tooltip></button>\n<div class=\"name\"><span ng-bind=\"vm.employee.first_name\"></span> <span ng-bind=\"vm.employee.last_name\"></span></div>\n</div><md-button class=\"md-icon-button md-button\" aria-label=\"Cover\" \nngf-select=\"vm.uploadFiles($files, vm.employee.id, \'cover\')\" accept=\"image/*\"><md-icon class=\"white-fg\" \nmd-font-icon=\"icon-view-day\"></md-icon><md-tooltip>Click to change cover photo</md-tooltip></md-button></div><div \nclass=\"content\" flex><md-tabs md-dynamic-height><md-tab><md-tab-label><span translate=\"PROFILE.ABOUT\">About</span>\n</md-tab-label><md-tab-body><md-content class=\"about-tab\" ng-include=\"\'app/main/pages/profile/tabs/about/about.html\'\">\n</md-content></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"employee.unread\" class=\"md-accent-bg unread-message-count\">{{employee.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"employee md-3-line\" ng-repeat=\"employee in vm.employees.recent\" ng-click=\"vm.toggleChat(employee)\"><img \nng-src=\"{{employee.avatar}}\" class=\"md-avatar\" alt=\"{{employee.name}}\"><div class=\"status {{employee.status}}\"></div>\n<div ng-if=\"employee.unread\" class=\"md-accent-bg unread-message-count\">{{employee.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{employee.name}}</h3><p class=\"last-message\">{{employee.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"employee\" \nng-repeat=\"employee in vm.employees.all\" ng-click=\"vm.toggleChat(employee)\"><img ng-src=\"{{employee.avatar}}\" \nclass=\"md-avatar\" alt=\"{{employee.name}}\"><div class=\"status {{employee.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{employee.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.employee.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.employee.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'employee\'\" ng-src=\"{{vm.chat.employee.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.employee.name}}\"> \n<img ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab md-mini\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></form>\n</div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\"><div class=\"secondary-text\"><div>{{vm.date | date:\'EEEE\'}}</div><div \nlayout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> <span class=\"md-subhead\">th</span> <span>\n{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list><md-divider></md-divider><md-list \nng-model=\"vm.lead.activity_type\" class=\"section\" ng-repeat=\"task in vm.activity_type\"><md-subheader \nclass=\"md-no-sticky\"><span>{{task.type}}</span></md-subheader><md-list-item ng-if=\"task.activity_items.length === 0\"><p\n class=\"secondary-text\">No results found.</p></md-list-item><div ng-repeat=\"checkItem in task.activity_items\">\n<md-list-item><h3><md-icon class=\"cursor-pointer\" md-font-icon=\"icon-label\" \nng-class=\"checkItem.priority.color +\'-500-fg\'\"><md-tooltip>\n{{vm.priorityValue(checkItem.priority_id) | uppercase}} Priority</md-tooltip></md-icon>{{checkItem.subject}}</h3>\n<md-select ng-model=\"checkItem.status_id\" ng-change=\"vm.saveActivity()\" class=\"simplified md-secondary\" \naria-label=\"select\" placeholder=\"Type\" ng-required><md-option ng-repeat=\"obj in vm.activity_status\" \nng-value=\"{{obj.id}}\">{{obj.value}}</md-option></md-select></md-list-item><p \nclass=\"secondary-text ph-16 pb-10 no-margin\">{{checkItem.date_deadline}}</p></div><div layout=\"column\"><button \nng-click=\"vm.gotoTaskType(task.id)\" class=\"md-accent md-button md-default-theme md-ink-ripple md-secondary-container\" \ntype=\"button\"><span>See more tasks</span><div class=\"md-ripple-container\"></div></button></div><md-divider>\n</md-divider></md-list>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\"><img class=\"image\" \nng-src=\"assets/images/logos/ae-32x32.png\" alt=\"Aggrego Logo\"></span><span class=\"logo-text\">AGGREGO</span></div>\n<md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm \nng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" \nms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><img ng-src=\"assets/images/logos/ae-logo.png\"></div><div \nclass=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><img ng-src=\"assets/images/logos/ae-logo.png\"></div></div><div layout=\"row\" \nlayout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><ms-shortcuts></ms-shortcuts>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><md-menu id=\"language-menu\" \nmd-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-shortcuts></ms-shortcuts><div \nclass=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\"></md-progress-circular>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\">\n{{vm.employee.user.avatar.path = (vm.employee.user.avatar.path || vm.crmUrl + \'storage/app/media/profile.jpg\');\"\"}} \n<img md-menu-align-target class=\"avatar\" ng-src=\"{{vm.employee.user.avatar.path}}\"><md-icon md-font-icon \nng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span \nclass=\"username\" hide show-gt-sm>{{currentUser.name}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" \nhide-xs></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.company_dashboard\"><md-icon \nmd-font-icon=\"icon-city\" class=\"icon\"></md-icon><md-button>My Company</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.scrumboard.boards\"><md-icon md-font-icon=\"icon-filter\" class=\"icon\"></md-icon>\n<md-button>Leads</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_settings_general\">\n<md-icon md-font-icon=\"icon-server-network\" class=\"icon\"></md-icon><md-button>Settings</md-button></md-menu-item>\n<md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\">\n</md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar>\n<div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon><span class=\"badge\" \nng-if=\"currentUser.notification != 0\">{{ currentUser.notification }}</span></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><img ng-src=\"assets/images/logos/ae-logo.png\"></div><div \nclass=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\r\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\r\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\r\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/main/apps/company/dashboard/company-dashboard.html","<div id=\"company-dashboard\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll>\n<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"space-between\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><button \nngf-select=\"vm.uploadFiles($files, vm.company.id)\" ng-disabled=\"!role.permissions.write\" accept=\"image/*\">\n{{vm.company.avatar.path = (vm.company.avatar.path || vm.crmUrl + \'storage/app/media/company.png\');\"\"}} <img \nng-src=\"{{vm.company.avatar.path}}\" class=\"profile-image avatar huge\" alt=\"{{vm.company.name}}\"><md-tooltip>\nClick to change logo</md-tooltip></button> <span class=\"logo-text\">{{vm.company.name}}</span></div><div \nclass=\"toolbar\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md \naria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\"></md-icon></md-button></div></div></div><div\n class=\"content\"><md-tabs md-dynamic-height><md-tab><md-tab-label><span translate=\"PROFILE.ABOUT\">About</span>\n</md-tab-label><md-tab-body><div id=\"profile\"><md-content class=\"about-tab\" \nng-include=\"\'app/main/apps/company/dashboard/tabs/about.html\'\"></md-content></div></md-tab-body></md-tab><md-tab>\n<md-tab-label><span>Settings - Lead</span></md-tab-label><md-tab-body><md-content \nng-include=\"\'app/main/apps/company/dashboard/tabs/setting-lead.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span>Settings - Group</span></md-tab-label><md-tab-body><md-content \nng-include=\"\'app/main/apps/company/dashboard/tabs/setting-group.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</div></div><md-sidenav class=\"sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nmd-component-id=\"sidenav\" ms-scroll ms-sidenav-helper \nng-include=\"\'app/main/apps/company/dashboard/sidenavs/main/main-sidenav.html\'\"></md-sidenav></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \ndata-step=\"{{step.stepNumber}}\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\">\n{{step.stepNumber}}<div class=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/main/apps/calendar/dialogs/event-form/event-form-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-block\"><label translate=\"CALENDAR.TITLE\">Title</label><input name=\"title\" ng-model=\"vm.calendarEvent.title\" \nrequired md-autofocus></md-input-container><div class=\"pb-20\" layout=\"row\" layout-align=\"start center\"><md-switch \nng-model=\"vm.calendarEvent.all_day_event\">All day</md-switch></div><div layout=\"row\" layout-align=\"start center\" \nclass=\"date-row\"><div flex class=\"md-block\" moment-picker=\"vm.start\" ng-if=\"!vm.calendarEvent.all_day_event\" \nchange=\"vm.onChange(newValue, oldValue)\" format=\"LLL\" min-view=\"year\" max-view=\"hour\" start-view=\"month\" \nmin-date=\"vm.today\"><md-input-container flex md-no-float><label>Start Date</label><md-icon \nmd-font-icon=\"icon-calendar\" class=\"md-hue-2\"></md-icon>{{vm.calendarEvent.start = vm.start;\"\"}} <input \nng-model=\"vm.calendarEvent.start\" md-placeholder=\"Start Date\"></md-input-container></div><div flex class=\"md-block\" \nmoment-picker=\"vm.start\" ng-if=\"vm.calendarEvent.all_day_event\" change=\"vm.onChange(newValue, oldValue)\" format=\"LL\" \nmin-view=\"year\" max-view=\"hour\" start-view=\"month\" min-date=\"vm.today\"><md-input-container flex md-no-float><label>\nStart Date</label><md-icon md-font-icon=\"icon-calendar\" class=\"md-hue-2\"></md-icon>\n{{vm.calendarEvent.start = vm.start;\"\"}} <input ng-model=\"vm.calendarEvent.start\" md-placeholder=\"Start Date\">\n</md-input-container></div></div><div layout=\"row\" layout-align=\"start center\" class=\"date-row\"><div class=\"md-block\" \nmoment-picker=\"vm.end\" ng-if=\"!vm.calendarEvent.all_day_event\" format=\"LLL\" min-view=\"year\" max-view=\"hour\" \nstart-view=\"month\" min-date=\"vm.start=vm.start\"><md-input-container flex><label>End Date</label><md-icon \nmd-font-icon=\"icon-calendar\" class=\"md-hue-2\"></md-icon>{{vm.calendarEvent.end = vm.end;\"\"}} <input name=\"end1\" \nlayout=\"row\" ng-model=\"vm.calendarEvent.end\" md-placeholder=\"End Date\"></md-input-container></div><div \nclass=\"md-block\" moment-picker=\"vm.end\" ng-if=\"vm.calendarEvent.all_day_event\" format=\"LL\" min-view=\"year\" \nmax-view=\"hour\" start-view=\"month\" min-date=\"vm.end=vm.end\"><md-input-container flex><label>End Date</label><md-icon \nmd-font-icon=\"icon-calendar\" class=\"md-hue-2\"></md-icon>{{vm.calendarEvent.end = vm.end;\"\"}} <input name=\"end2\" \nlayout=\"row\" ng-model=\"vm.calendarEvent.end\" md-placeholder=\"End Date\"></md-input-container></div></div>\n<md-input-container class=\"md-block pv-20\" flex><label translate=\"CALENDAR.LOCATION\">Location</label><input \nng-model=\"vm.calendarEvent.location\"></md-input-container><md-input-container flex \nclass=\"md-block pb-20 textarea-container\"><label translate=\"CALENDAR.NOTES\">Notes</label><textarea \nng-model=\"vm.calendarEvent.notes\" md-maxlength=\"250\" max-rows=\"4\"></textarea></md-input-container></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button ng-click=\"vm.saveEvent()\" \nclass=\"save-button md-accent md-raised\" aria-label=\"SAVE\" translate=\"CALENDAR.SAVE\" \ntranslate-attr-aria-label=\"CALENDAR.SAVE\">SAVE</md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.removeEvent()\" aria-label=\"Delete\" translate translate-attr-aria-label=\"CALENDAR.DELETE\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"CALENDAR.DELETE\">Delete</span></md-tooltip>\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/calendar/dialogs/event-detail/event-detail-dialog.html","<md-dialog class=\"event-detail-dialog\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\"><span class=\"title\">{{vm.calendarEvent.title}}</span> <span flex></span><md-button \nclass=\"edit-event-button md-fab md-warn\" ng-click=\"vm.editEvent(vm.calendarEvent)\" aria-label=\"Edit event\" translate \ntranslate-attr-aria-label=\"CALENDAR.EDIT_EVENT\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"event-details\" layout=\"column\"><div class=\"event-detail-row\" \nlayout=\"row\" layout-align=\"start start\"><md-icon md-font-icon=\"icon-clock\"></md-icon><div layout=\"column\" flex><span \nclass=\"h4\">{{vm.calendarEvent.start.format(\'MMMM Do YYYY, h:mm:ss a\')}} <span ng-if=\"vm.calendarEvent.end\">-</span>\n {{vm.calendarEvent.end.format(\'MMMM Do YYYY, h:mm:ss a\')}}</span> <span class=\"secondary-text\">\n{{vm.calendarEvent.repeat || \'Does not repeat\'}}</span></div></div><div class=\"event-detail-row\" layout=\"row\" \nlayout-align=\"start start\"><md-icon md-font-icon=\"icon-bell-ring-outline\"></md-icon><div layout=\"column\" flex><span \nclass=\"h4\" translate=\"CALENDAR.30_MIN_BEFORE\">30 minutes before</span> <span class=\"h4\" \ntranslate=\"CALENDAR.15_MIN_BEFORE\">15 minutes before</span> <span class=\"h4\" translate=\"CALENDAR.30_MIN_LATER\">\n30 minutes later</span></div></div><div class=\"event-detail-row\" layout=\"row\" layout-align=\"start start\" \nng-if=\"vm.calendarEvent.location\"><md-icon md-font-icon=\"icon-map-marker\"></md-icon><div layout=\"column\" flex><span \nclass=\"h4\">{{vm.calendarEvent.location}}</span></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/companies/dialogs/company/company-dialog.html","<md-dialog class=\"company-dialog\" aria-label=\"New Task\"><form name=\"companyForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent\" ng-class=\"{\'md-tall\': !vm.newCompany}\" ng-attr-id=\"{{vm.newCompany ? \'md-new\': \'\'}}\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"COMPANIES.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><div ng-if=\"!vm.newCompany\" \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\"><div \nlayout=\"column\" layout-align=\"center center\"><button type=\"button\" ngf-select=\"vm.uploadFiles($files, vm.company.id)\" \naccept=\"image/*\">{{avatar = (vm.company.avatar.path || vm.crmUrl + \'storage/app/media/profile.jpg\');\"\" }} <img \nng-src=\"{{avatar}}\" class=\"add-img-button md-avatar avatar employee-avatar huge\" alt=\"{{company.name}}\"><md-tooltip>\nClick to change profile</md-tooltip></button><div class=\"company-name\">{{vm.company.name}}</div></div></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-icon-float md-block\"><label>Name (required)\n</label><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><input name=\"name\" ng-model=\"vm.company.name\" \ntype=\"text\" ng-required md-autofocus></md-input-container><md-input-container class=\"md-icon-float md-block\"><label>\nDomain</label><md-icon md-font-icon=\"icon-google-earth\" class=\"name\"></md-icon><input name=\"domain\" \nng-model=\"vm.company.domain\" type=\"text\"></md-input-container><md-input-container class=\"md-icon-float md-block\">\n<md-icon md-font-icon=\"icon-email\" class=\"email\"></md-icon><input name=\"email\" ng-model=\"vm.company.email\" \ntype=\"email\" placeholder=\"Email\" required></md-input-container><div ng-if=\"!vm.allFields\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent\" ng-click=\"vm.allFields = true\" \ntranslate=\"EMPLOYEES.SHOW_ALL_FIELDS\">Show All Fields</md-button></div><div ng-if=\"vm.allFields\"><md-input-container \nclass=\"md-icon-float md-block\"><label>General Manager</label><md-icon md-font-icon=\"icon-account\" class=\"name\">\n</md-icon><input name=\"general_manager\" ng-model=\"vm.company.general_manager\" type=\"text\"></md-input-container>\n<md-input-container class=\"md-icon-float md-block\"><label>Contact Person</label><md-icon></md-icon><input \nname=\"contact_person\" ng-model=\"vm.company.contact_person\" type=\"text\"></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"SB.TELEPHONE\">Telephone</label><md-icon md-font-icon=\"icon-phone\" class=\"email\">\n</md-icon><input type=\"text\" name=\"telephone\" ui-mask=\"{{vm.phoneCode}} 9-999-9999\" restrict=\"reject\" \nng-model=\"vm.company.telephone\" placeholder=\"{{vm.phoneCode}} _-___-____\"></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"SB.MOBILE_1\">Mobile phone 1</label><md-icon></md-icon><input type=\"text\" \nname=\"mobile_phone1\" ui-mask=\"{{vm.phoneCode}} 999-999-9999\" restrict=\"reject\" ng-model=\"vm.company.mobile_phone1\" \nplaceholder=\"{{vm.phoneCode}} ___-___-____\"></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"SB.MOBILE_2\">Mobile phone 2</label><md-icon></md-icon><input type=\"text\" name=\"mobile_phone2\" \nui-mask=\"{{vm.phoneCode}} 999-999-9999\" restrict=\"reject\" ng-model=\"vm.company.mobile_phone2\" \nplaceholder=\"{{vm.phoneCode}} ___-___-____\"></md-input-container><md-input-container class=\"md-block\"><label>Address\n</label><md-icon md-font-icon=\"icon-city\"></md-icon><textarea name=\"address\" ng-model=\"vm.company.address\" columns=\"1\" \nmax-rows=\"4\"></textarea></md-input-container><md-input-container class=\"md-block\"><md-icon></md-icon><md-select \nng-model=\"vm.company.region_id\" ng-change=\"vm.getRegionProvinces()\" name=\"country\" id=\"country\" aria-label=\"select\" \nplaceholder=\"Region\"><md-option ng-repeat=\"region in vm.regions\" ng-value=\"{{region.id}}\">{{region.short_name}}\n</md-option></md-select></md-input-container><md-input-container class=\"mt-25 md-block\"><md-icon></md-icon><md-select \nng-model=\"vm.company.province_id\" ng-change=\"vm.getProvinceCities()\" ng-required=\"!companyForm.country.$pristine\" \nname=\"province\" id=\"province\" aria-label=\"select\" placeholder=\"Province\" md-no-asterisk=\"false\"><md-option \nng-repeat=\"obj in vm.provinces\" ng-value=\"{{obj.id}}\">{{obj.value}}</md-option></md-select></md-input-container>\n<md-input-container class=\"mt-25 md-block\"><md-icon></md-icon><md-select ng-model=\"vm.company.city_id\" \nng-required=\"!companyForm.province.$pristine\" name=\"city\" id=\"city\" aria-label=\"select\" placeholder=\"City\" \nmd-no-asterisk=\"false\"><md-option ng-repeat=\"obj in vm.cities\" ng-value=\"{{obj.id}}\">{{obj.value}}</md-option>\n</md-select></md-input-container><md-input-container class=\"mt-50 md-block\"><label>Website</label><md-icon \nmd-font-icon=\"icon-web\"></md-icon><input name=\"website\" ng-model=\"vm.company.website\"></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"SB.FACEBOOK\">Facebook</label><md-icon></md-icon><input \nname=\"facebook\" ng-model=\"vm.company.facebook\"></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"SB.TWITTER\">Twitter</label><md-icon></md-icon><input name=\"twitter\" ng-model=\"vm.company.twitter\">\n</md-input-container><md-input-container class=\"md-block\"><label translate=\"SB.GOOGLE\">Google</label><md-icon>\n</md-icon><input name=\"google\" ng-model=\"vm.company.google\"></md-input-container><md-input-container class=\"md-block\">\n<label translate=\"SB.LINKEDIN\">Linked In</label><md-icon></md-icon><input name=\"linkedin\" \nng-model=\"vm.company.linkedin\"></md-input-container><md-input-container class=\"md-block\"><label translate=\"SB.SKYPE\">\nSkype</label><md-icon></md-icon><input name=\"skype\" ng-model=\"vm.company.skype\"></md-input-container>\n<md-input-container class=\"md-block\"><label>Description</label><md-icon md-font-icon=\"icon-document\"></md-icon>\n<textarea name=\"description\" ng-model=\"vm.contact.description\" type=\"text\" max-rows=\"4\"></textarea>\n</md-input-container><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent\" \nng-click=\"vm.allFields = false\" translate=\"EMPLOYEES.FEWER_FIELDS\">Fewer Fields</md-button></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"submit\" ng-if=\"!vm.newCompany\" ng-click=\"vm.saveCompany()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"companyForm.$invalid || companyForm.$pristine\" aria-label=\"SAVE\" \ntranslate=\"COMPANIES.SAVE\" translate-attr-aria-label=\"COMPANIES.SAVE\">SAVE</md-button><md-button type=\"submit\" \nng-if=\"vm.newCompany\" ng-click=\"vm.addNewCompany()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"companyForm.$invalid || companyForm.$pristine\" aria-label=\"Add Task\" translate=\"COMPANIES.ADD_COMPANY\" \ntranslate-attr-aria-label=\"COMPANIES.ADD_COMPANY\">ADD COMPANY</md-button></div><div layout=\"row\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.deleteCompanyConfirm($event)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"COMPANIES.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"COMPANIES.DELETE\">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/companies/sidenavs/main/main-sidenav.html","<div class=\"header md-padding\" layout=\"row\" layout-align=\"start center\">\n{{vm.company.avatar.path = (vm.company.avatar.path || vm.crmUrl + \'storage/app/media/company.png\');\"\"}} <img \nng-src=\"{{vm.company.avatar.path}}\" class=\"md-avatar avatar mr-16\" alt=\"{{vm.company.name}}\"> <span \nclass=\"font-weight-500 font-size-14\">{{vm.company.name}}</span></div><md-divider></md-divider><div ms-scroll \nclass=\"content scrollable\"><md-list><md-subheader class=\"md-no-sticky\">List of companies.</md-subheader></md-list>\n</div>");
$templateCache.put("app/main/apps/company/dashboard/tabs/about.html","<div layout=\"row\" layout-wrap><div class=\"about\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"65\"><form \neditable-form name=\"$general_info\" onaftersave=\"vm.saveUser()\" novalidate><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"title\" translate=\"PROFILE.GENERAL_INFORMATION\">General Information\n</div><div class=\"secondary-text\" ng-if=\"role.permissions.write\"><md-button class=\"md-icon-button\" type=\"button\" \naria-label=\"edit\" ng-click=\"$general_info.$show()\" ng-show=\"!$general_info.$visible\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"md-accent-fg md-hue-1\"></md-icon></md-button><span ng-show=\"$general_info.$visible\">\n<md-button class=\"md-icon-button\" type=\"submit\" aria-label=\"save\" \nng-disabled=\"$general_info.$waiting || ($general_info.$invalid && $general_info.password.$dirty)\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"md-accent-fg md-hue-1\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" type=\"button\" aria-label=\"cancel\" ng-disabled=\"$general_info.$waiting\" \nng-click=\"$general_info.$cancel()\"><md-icon md-font-icon=\"icon-close-circle\" class=\"icon-cancel\"></md-icon></md-button>\n</span></div></header><div class=\"content\"><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.NAME\">Name\n</div><div class=\"info\" editable-text=\"vm.company.name\">{{vm.company.name | label:\'-\'}}</div></div><div \nclass=\"info-line\"><div class=\"title\" translate=\"PROFILE.GENERAL_MANAGER\">General Manager</div><div class=\"info\" \neditable-text=\"vm.company.general_manager\">{{vm.company.general_manager | label:\'-\'}}</div></div><div \nclass=\"info-line\"><div class=\"title\" translate=\"PROFILE.EMAIL\">Email</div><div class=\"info\" \neditable-email=\"vm.company.email\">{{vm.company.email | label:\'-\'}}</div></div><div class=\"info-line\"><div \nclass=\"title\">Website</div><div class=\"info\" editable-text=\"vm.company.website\">{{vm.company.website | label:\'-\'}}\n</div></div></div></div></form><form editable-form name=\"$contact\" onaftersave=\"vm.saveUser()\"><div \nclass=\"profile-box info-box work md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"title\">Contact details</div><div class=\"secondary-text\" \nng-if=\"role.permissions.write\"><md-button class=\"md-icon-button\" type=\"button\" aria-label=\"edit\" \nng-click=\"$contact.$show()\" ng-show=\"!$contact.$visible\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"md-accent-fg md-hue-1\"></md-icon></md-button><span ng-show=\"$contact.$visible\"><md-button \nclass=\"md-icon-button\" type=\"submit\" aria-label=\"save\" ng-disabled=\"$contact.$waiting || ($contact.$invalid)\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"md-accent-fg md-hue-1\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" type=\"button\" aria-label=\"cancel\" ng-disabled=\"$contact.$waiting\" ng-click=\"$contact.$cancel()\">\n<md-icon md-font-icon=\"icon-close-circle\" class=\"icon-cancel\"></md-icon></md-button></span></div></header><div \nclass=\"content\"><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.TELEPHONE\">Telephone</div><div \nclass=\"info\" editable-text=\"vm.company.telephone\" e-placeholder=\"{{vm.phoneCode}} _-___-____\" \ne-ui-mask=\"{{vm.phoneCode}} 9-999-9999\">{{vm.phoneCode}} {{vm.company.telephone | label:\'-\' | tel}}</div></div><div \nclass=\"info-line\"><div class=\"title\" translate=\"PROFILE.MOBILE_1\">Mobile phone 1</div><div class=\"info\" \neditable-text=\"vm.company.mobile_phone1\" e-placeholder=\"{{vm.phoneCode}} ___-___-____\" \ne-ui-mask=\"{{vm.phoneCode}} 999-999-9999\">{{vm.phoneCode}} {{vm.company.mobile_phone1 | label:\'-\' | tel}}</div></div>\n<div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.MOBILE_2\">Mobile phone 2</div><div class=\"info\" \neditable-text=\"vm.company.mobile_phone2\" e-placeholder=\"{{vm.phoneCode}} ___-___-____\" \ne-ui-mask=\"{{vm.phoneCode}} 999-999-9999\">{{vm.phoneCode}} {{vm.company.mobile_phone2 | label:\'-\' | tel}}</div></div>\n<div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.ADDRESS\">Address</div><div class=\"info\" \neditable-textarea=\"vm.company.address\" e-rows=\"7\" e-cols=\"40\">{{vm.company.address | label:\'-\'}}</div></div><div \nclass=\"info-line\"><div class=\"title\" translate=\"PROFILE.REGION\">Region</div><div class=\"info\"><span \nng-show=\"!$contact.$visible\">{{vm.region | label:\'-\'}}</span> <span ng-show=\"$contact.$visible\"><md-select \nng-model=\"vm.company.region_id\" ng-change=\"vm.getRegionProvinces()\" class=\"form-control width-200\" name=\"country\" \nid=\"country\" aria-label=\"select\" placeholder=\"Please select region\"><md-option ng-repeat=\"region in vm.regions\" \nng-value=\"{{region.id}}\">{{region.short_name}}</md-option></md-select></span></div></div><div class=\"info-line\"><div \nclass=\"title\" translate=\"PROFILE.PROVINCE\">Province</div><div class=\"info\"><span ng-show=\"!$contact.$visible\">\n{{vm.province | label:\'-\'}}</span> <span ng-show=\"$contact.$visible\"><md-select ng-model=\"vm.company.province_id\" \nng-change=\"vm.getProvinceCities()\" ng-required=\"!$contact.country.$pristine\" \nclass=\"form-control width-200 md-no-underline\" name=\"province\" id=\"province\" aria-label=\"select\" \nplaceholder=\"Please select province\" md-no-asterisk=\"false\"><md-option ng-repeat=\"obj in vm.provinces\" \nng-value=\"{{obj.id}}\">{{obj.value}}</md-option></md-select></span></div></div><div class=\"info-line\"><div \nclass=\"title\" translate=\"PROFILE.CITY\">City</div><div class=\"info\"><span ng-show=\"!$contact.$visible\">\n{{vm.city | label:\'-\'}}</span> <span ng-show=\"$contact.$visible\"><md-select ng-model=\"vm.company.city_id\" \nng-required=\"!$contact.province.$pristine\" class=\"form-control width-200 md-no-underline\" name=\"city\" id=\"city\" \naria-label=\"select\" placeholder=\"Please select city\" md-no-asterisk=\"false\"><md-option ng-repeat=\"obj in vm.cities\" \nng-value=\"{{obj.id}}\">{{obj.value}}</md-option></md-select></span></div></div></div></div></form></div><div \nclass=\"about-sidebar\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"35\"><form editable-form name=\"$social\" \nonaftersave=\"vm.saveUser()\"><div class=\"profile-box info-box work md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title\" translate=\"PROFILE.SOCIAL\">\nSocial</div><div class=\"secondary-text\" ng-if=\"role.permissions.write\"><md-button class=\"md-icon-button\" type=\"button\" \naria-label=\"edit\" ng-click=\"$social.$show()\" ng-show=\"!$social.$visible\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"md-accent-fg md-hue-1\"></md-icon></md-button><span ng-show=\"$social.$visible\"><md-button class=\"md-icon-button\" \ntype=\"submit\" aria-label=\"save\" ng-disabled=\"$social.$waiting\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" \nclass=\"md-accent-fg md-hue-1\"></md-icon></md-button><md-button class=\"md-icon-button\" type=\"button\" \naria-label=\"cancel\" ng-disabled=\"$social.$waiting\" ng-click=\"$social.$cancel()\"><md-icon \nmd-font-icon=\"icon-close-circle\" class=\"icon-cancel\"></md-icon></md-button></span></div></header><div class=\"content\">\n<div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.FACEBOOK\">Facebook</div><div class=\"info\" \neditable-text=\"vm.company.facebook\"><a href=\"{{vm.company.facebook}}\"><md-icon md-font-icon=\"icon-facebook-box\" \nclass=\"md-accent-fg md-hue-1\"></md-icon></a></div></div><div class=\"info-line\"><div class=\"title\" \ntranslate=\"PROFILE.TWITTER\">Twitter</div><div class=\"info\" editable-text=\"vm.company.twitter\"><a \nhref=\"{{vm.company.twitter}}\"><md-icon md-font-icon=\"icon-twitter-box\" class=\"md-accent-fg md-hue-1\"></md-icon></a>\n</div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.GOOGLE\">Google</div><div class=\"info\" \neditable-text=\"vm.company.google\"><a href=\"{{vm.company.google}}\"><md-icon md-font-icon=\"icon-google-plus-box\" \nclass=\"md-accent-fg md-hue-1\"></md-icon></a></div></div><div class=\"info-line\"><div class=\"title\" \ntranslate=\"PROFILE.LINKEDIN\">LinkedIn</div><div class=\"info\" editable-text=\"vm.company.linkedIn\"><a \nhref=\"{{vm.company.linkedIn}}\"><md-icon md-font-icon=\"icon-linkedin-box\" class=\"md-accent-fg md-hue-1\"></md-icon></a>\n</div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.SKYPE\">Skype</div><div class=\"info\" \neditable-text=\"vm.company.skype\"><a href=\"{{vm.company.skype}}\"><md-icon md-font-icon=\"icon-skype\" \nclass=\"md-accent-fg md-hue-1\"></md-icon></a></div></div></div></div></form></div></div>");
$templateCache.put("app/main/apps/company/dashboard/tabs/setting-group.html","<div id=\"setting-group\" class=\"setting-pane\"><div class=\"widget-group\" layout=\"row\" layout-wrap><ms-widget \nng-if=\"group.name != \'Admin\'\" flippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-md=\"50\" \nng-repeat=\"(key, group) in vm.groups\"><ms-widget-front class=\"white-bg\"><md-list><md-subheader class=\"md-no-sticky\">\n{{group.name}}</md-subheader><div class=\"ph-16\" layout=\"row\" layout-align=\"end center\" layout-wrap><span></span> <span \nclass=\"md-secondary ph-5\">Read </span><span class=\"md-secondary ph-30\">Write </span><span class=\"md-secondary\">Limit\n</span></div><md-list-item ng-if=\"roles.id != 1\" ng-repeat=\"(r, roles) in group.roles\"><p>{{roles.name}}</p>\n<md-checkbox class=\"md-secondary width-50\" aria-label=\"Read\" ng-model=\"roles.permissions.read\" \nng-change=\"vm.rolesUpdate(roles);\" ng-disabled=\"!role.permissions.write || roles.permissions.read === \'\'\">\n</md-checkbox><md-checkbox class=\"md-secondary width-55\" aria-label=\"Write\" ng-model=\"roles.permissions.write\" \nng-change=\"vm.rolesUpdate(roles);\" ng-disabled=\"!role.permissions.write\"></md-checkbox><span \nclass=\"md-secondary width-24 text-center\" editable-text=\"roles.permissions.limit\" onaftersave=\"vm.rolesUpdate(role)\" \nedit-disabled=\"!role.permissions.write\">{{roles.permissions.limit}}</span><md-divider></md-divider></md-list-item>\n</md-list></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/apps/company/dashboard/tabs/setting-lead.html","<div id=\"setting-lead\" class=\"setting-pane\"><div class=\"widget-group\" layout=\"row\" layout-xs=\"column\" flex=\"100\">\n<ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-md=\"50\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 pv-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"h3\">Lead Source</span></div></div><div id=\"lead_sorce\" \nclass=\"setting-items sortable\" ng-model=\"vm.lead_source\" ng-sortable=\"vm.sortableOptions\"><div \nclass=\"ph-16 pv-15 border-bottom setting-item\" layout=\"row\" layout-align=\"start center\" \nng-class=\"{\'ignore\':lead_source.initial === 1}\" ng-repeat=\"(key, lead_source) in vm.lead_source\">\n{{vm.type.lead_source = (lead_source.initial === 0) ? key + 1 : vm.type.lead_source;\"\"}}<div class=\"item mr-16\" \nng-class=\"{\'handle\':lead_source.initial === 0 && role.permissions.write}\"><i class=\"icon pr-16 border-right\" \nng-class=\"{\'icon-trending-neutral\':lead_source.initial === 1, \'icon-drag-vertical\':lead_source.initial === 0}\"></i>\n</div><div class=\"h4 text-bold\" editable-text=\"lead_source.value\" onaftersave=\"vm.saveUser()\" flex \nng-class=\"{\'green-fg\':lead_source.default === 1}\" edit-disabled=\"!role.permissions.write\">{{lead_source.value}}</div>\n<md-menu ng-if=\"role.permissions.write\"><md-button class=\"md-icon-button\" aria-label=\"More\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" ng-click=\"$mdOpenMenu($event)\" ng-class=\"{\'green-fg\':lead_source.default === 1}\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-model=\"lead_source.default\" \nng-class=\"{\'green-bg white-fg\':lead_source.default === 1}\" \nng-click=\"lead_source.default||vm.defaultSettingConfirm($event, vm.lead_source, key, \'lead_source\')\">\n{{lead_source.default ? \'Default\' : \'Set as default\'}}</md-button></md-menu-item><md-menu-item \nng-if=\"lead_source.initial === 0\"><md-button ng-click=\"vm.deleteDataConfirm(ev, lead_source, \'lead_source\')\">\nDelete Setting</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"ph-16 pv-15 border-bottom\" \nlayout=\"row\" layout-align=\"start center\" ng-show=\"newListForm.$visible\"><p class=\"pl-8\" \neditable-text=\"vm.newSettingName\" e-form=\"newListForm\" \nonaftersave=\"vm.addNewSetting(\'lead_source\', vm.type.lead_source)\"></p></div><div \nclass=\"ph-16 pv-15 border-bottom editable editable-click\" layout=\"row\" layout-align=\"start center\" \nng-click=\"newListForm.$show()\" ng-hide=\"newListForm.$visible\" ng-if=\"role.permissions.write\"><div class=\"item mr-16\"><i\n class=\"icon pr-16 border-right icon-plus\"></i></div><div class=\"h4 text-bold\">New Lead Source</div></div></div>\n</ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-md=\"50\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-16 pv-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><span class=\"h3\">Opportunity Status</span></div></div><div \nid=\"opportunity_status\" class=\"setting-items sortable\" ng-model=\"vm.opportunity_status\" \nng-sortable=\"vm.sortableOptions\"><div class=\"ph-16 pv-15 border-bottom setting-item\" layout=\"row\" \nlayout-align=\"start center\" ng-class=\"{\'ignore\':opportunity_status.initial === 1}\" \nng-repeat=\"(key, opportunity_status) in vm.opportunity_status\">\n{{vm.type.opportunity_status = (opportunity_status.initial === 0) ? key + 1 : vm.type.opportunity_status;\"\"}}<div \nclass=\"item mr-16\" ng-class=\"{\'handle\':opportunity_status.initial === 0 && role.permissions.write}\"><i \nclass=\"icon pr-16 border-right\" \nng-class=\"{\'icon-trending-neutral\':opportunity_status.initial === 1, \'icon-drag-vertical\':opportunity_status.initial === 0}\">\n</i></div><div class=\"h4 text-bold\" editable-text=\"opportunity_status.value\" onaftersave=\"vm.saveUser()\" flex \nng-class=\"{\'green-fg\':opportunity_status.default === 1}\" edit-disabled=\"!role.permissions.write\">\n{{opportunity_status.value}}</div><md-menu ng-if=\"role.permissions.write\"><md-button class=\"md-icon-button\" \naria-label=\"More\"><md-icon md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdOpenMenu($event)\" \nng-class=\"{\'green-fg\':opportunity_status.default === 1}\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button ng-model=\"opportunity_status.default\" \nng-class=\"{\'green-bg white-fg\':opportunity_status.default === 1}\" \nng-click=\"opportunity_status.default||vm.defaultSettingConfirm($event, vm.opportunity_status, key, \'opportunity_status\')\">\n{{opportunity_status.default ? \'Default\' : \'Set as default\'}}</md-button></md-menu-item><md-menu-item \nng-if=\"opportunity_status.initial === 0\"><md-button \nng-click=\"vm.deleteDataConfirm(ev, opportunity_status, \'opportunity_status\')\">Delete Setting</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class=\"ph-16 pv-15 border-bottom\" layout=\"row\" layout-align=\"start center\" \nng-show=\"newListForm.$visible\"><p class=\"pl-8\" editable-text=\"vm.newSettingName\" e-form=\"newListForm\" \nonaftersave=\"vm.addNewSetting(\'opportunity_status\', vm.type.opportunity_status)\"></p></div><div \nclass=\"ph-16 pv-15 border-bottom editable editable-click\" layout=\"row\" layout-align=\"start center\" \nng-click=\"newListForm.$show()\" ng-hide=\"newListForm.$visible\" ng-if=\"role.permissions.write\"><div class=\"item mr-16\"><i\n class=\"icon pr-16 border-right icon-plus\"></i></div><div class=\"h4 text-bold\">New Opportunity Status</div></div></div>\n</ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\"><ms-widget flippable=\"false\" \nlayout=\"row\" flex=\"100\" flex-gt-md=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-16 border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">\nActivity Status</span></div></div><div id=\"activity_status\" class=\"setting-items sortable\" \nng-model=\"vm.activity_status\" ng-sortable=\"vm.sortableOptions\"><div class=\"ph-16 pv-15 border-bottom setting-item\" \nlayout=\"row\" layout-align=\"start center\" ng-class=\"{\'ignore\':activity_status.initial === 1}\" \nng-repeat=\"(key, activity_status) in vm.activity_status\">\n{{vm.type.activity_status = (activity_status.initial === 0) ? key + 1 : vm.type.activity_status;\"\"}}<div \nclass=\"item mr-16\" ng-class=\"{\'handle\':activity_status.initial === 0 && role.permissions.write}\"><i \nclass=\"icon pr-16 border-right\" \nng-class=\"{\'icon-trending-neutral\':activity_status.initial === 1, \'icon-drag-vertical\':activity_status.initial === 0}\">\n</i></div><div class=\"h4 text-bold\" editable-text=\"activity_status.value\" onaftersave=\"vm.saveUser()\" flex \nng-class=\"{\'green-fg\':activity_status.default === 1}\" edit-disabled=\"!role.permissions.write\">{{activity_status.value}}\n</div><md-menu ng-if=\"role.permissions.write\"><md-button class=\"md-icon-button\" aria-label=\"More\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" ng-click=\"$mdOpenMenu($event)\" ng-class=\"{\'green-fg\':activity_status.default === 1}\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-model=\"activity_status.default\" \nng-class=\"{\'green-bg white-fg\':activity_status.default === 1}\" \nng-click=\"activity_status.default||vm.defaultSettingConfirm($event, vm.activity_status, key, \'activity_status\')\">\n{{activity_status.default ? \'Default\' : \'Set as default\'}}</md-button></md-menu-item><md-menu-item \nng-if=\"activity_status.initial === 0\"><md-button \nng-click=\"vm.deleteDataConfirm(ev, activity_status, \'activity_status\')\">Delete Setting</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class=\"ph-16 pv-15 border-bottom\" layout=\"row\" layout-align=\"start center\" \nng-show=\"newListForm.$visible\"><p class=\"pl-8\" editable-text=\"vm.newSettingName\" e-form=\"newListForm\" \nonaftersave=\"vm.addNewSetting(\'activity_status\', vm.type.activity_status)\"></p></div><div \nclass=\"ph-16 pv-15 border-bottom editable editable-click\" layout=\"row\" layout-align=\"start center\" \nng-click=\"newListForm.$show()\" ng-hide=\"newListForm.$visible\" ng-if=\"role.permissions.write\"><div class=\"item mr-16\"><i\n class=\"icon pr-16 border-right icon-plus\"></i></div><div class=\"h4 text-bold\">New Activity Status</div></div></div>\n</ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/apps/imports/views/import/csv.html","<ms-form-wizard flex><md-tabs class=\"form-wizard\" md-dynamic-height md-selected=\"msWizard.selectedIndex\" \nmd-center-tabs=\"true\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\"></span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check text-bold s16\"></i> \n</span><span class=\"ms-form-wizard-step-text\">Upload</span></span></md-tab-label><md-tab-body><form name=\"wizardStep1\" \nclass=\"md-inline-form\" ms-form-wizard-form novalidate><ms-widget class=\"h-300\" layout=\"column\" flex=\"100\">\n<ms-widget-front class=\"p-16 white-fg drop-box\" layout=\"row\" flex ngf-drop=\"vm.uploadFiles($files)\" \nngf-select=\"vm.uploadFiles($files)\" ngf-drag-over-class=\"\'dragover\'\" ngf-pattern=\"\'.csv,.txt\'\"><div layout=\"column\" \nlayout-align=\"center center\" flex><div class=\"h1 md-accent-fg\">Drop CSV file here</div><div class=\"h3 m-10 grey-fg\">or\n</div><md-button class=\"md-accent md-raised md-hue-1 white-fg\">Select file to Upload</md-button></div><div \nclass=\"background-image-center\"><md-icon md-font-icon=\"icon-upload\" class=\"s256 faint-text\"></md-icon></div>\n</ms-widget-front></ms-widget><input type=\"text\" name=\"csv\" ng-model=\"vm.csv.connected\" class=\"hidden\" required></form>\n</md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i \nclass=\"icon-check text-bold s16\"></i> </span><span class=\"ms-form-wizard-step-text\">Properties</span></span>\n</md-tab-label><md-tab-body><form name=\"wizardStep2\" ng-submit=\"submitForm()\" ms-form-wizard-form novalidate><div \nclass=\"mb-25\"><span class=\"h2\">Now let\'s match the columns in your uploaded file.</span><br><small>\nThese columns matches some standard properties. If one of these properties was incorrectly mapped, just map it to a different property.\n</small></div><div layout=\"row\" layout-xs=\"column\" layout-align=\"center\" class=\"mb-15\"><div flex flex-lg=\"40\" \nflex-gt-lg=\"40\" layout=\"row\" layout-align=\"space-between start\"><u>Standard (CRM)</u> <u>Header (CSV)</u></div></div>\n<div layout=\"row\" layout-xs=\"column\" layout-align=\"center\" class=\"field\" ng-repeat=\"(lkey, lfield) in vm.lead.field\">\n<div flex flex-lg=\"40\" flex-gt-lg=\"40\" layout=\"row\" layout-align=\"space-between start\"><label>{{lfield.name}}</label>\n<md-select ng-model=\"vm.import.field[lkey]\" placeholder=\"Field\" class=\"md-no-underline\" ng-required=\"lfield.required\" \nng-change=\"vm.updateBoard(lkey)\" ng-if=\"vm.data\"><md-option value=\"\">- select column -</md-option><md-option \nng-repeat=\"(f, field) in vm.data.field[lkey]\" value=\"{{f}}\" \nng-selected=\"{{field == lkey ? \'true\' : (lkey == \'board_id\' || lkey == \'status_id\') && $index == 0 ? \'true\' : \'false\'}}\">\n{{field}}</md-option></md-select></div><input type=\"text\" ng-model=\"vm.import.field[lkey]\" class=\"hidden w-0\" \nng-required=\"lfield.required\"></div></form></md-tab-body></md-tab><md-tab \nng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\" ng-click=\"vm.btn_next(1);\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i>\n </span><span class=\"ms-form-wizard-step-text\">Preview</span></span></md-tab-label><md-tab-body><form \nname=\"wizardStep3\" ms-form-wizard-form novalidate><div class=\"container\" ng-if=\"vm.import.pview !== \'true\'\"><h3>\nPreview is processing.</h3><p>Please wait.</p><md-progress-linear md-mode=\"query\"></md-progress-linear></div><div \nclass=\"simple-table-container md-whiteframe-4dp\" ng-if=\"vm.import.pview === \'true\'\"><table class=\"simple\" \nms-responsive-table><thead><tr><th ng-repeat=\"(h, header) in vm.import.field\" \nng-if=\"$index % vm.import.preview_limit == 0\">{{ h }}</th></tr></thead><tbody><tr \nng-repeat=\"record in vm.import.preview\"><td ng-repeat=\"cell in record\" ng-if=\"$index % vm.import.preview_limit == 0\">\n{{cell}}</td></tr></tbody></table></div><input type=\"text\" ng-model=\"vm.import.pview\" class=\"hidden w-0\" \nrequired=\"required\"></form></md-tab-body></md-tab><md-tab \nng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid || wizardStep3.$invalid\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep4.$invalid\">\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep4.$valid\"><i class=\"icon-check s16\"></i>\n </span><span class=\"ms-form-wizard-step-text\">Import</span></span></md-tab-label><md-tab-body><form \nname=\"wizardStep4\" ms-form-wizard-form novalidate><h2 class=\"md-title\">HTML Ipsum Presents</h2><p>\nPellentesque habitant morbi tristique\n senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet quam egestas semper.\n</p><p>&nbsp;</p><div class=\"container\" ng-if=\"vm.import.start === \'true\'\"><h3>Your import is processing.</h3><p>\nWe\'ll notify you when your import is finished.</p><md-progress-linear md-mode=\"query\"></md-progress-linear></div><p>\n&nbsp;</p><input type=\"text\" ng-model=\"vm.import.start\" class=\"hidden w-0\" required></form></md-tab-body></md-tab>\n</md-tabs><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.previousStep();\" ng-disabled=\"msWizard.isFirstStep()\">Back</md-button>\n<div class=\"steps ph-40\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.btn_next(msWizard.selectedIndex); msWizard.nextStep();\" \nng-hide=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.currentStepInvalid()\" \nng-class=\"{\'btn-prop csv\':msWizard.selectedIndex === 0}\">Next</md-button><md-button class=\"md-raised md-primary\" \nng-click=\"vm.importLead();\" ng-show=\"msWizard.isLastStep()\" ng-disabled=\"vm.import.start === \'true\'\">\n{{vm.import.btn_imp}}</md-button></div></ms-form-wizard>");
$templateCache.put("app/main/apps/imports/views/import/import.html","<div id=\"imports\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-cog\" class=\"mr-16\"></md-icon><span>Import</span>\n</div></div><div></div></div><div class=\"content\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget class=\"h-350\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"50\"><ms-widget-front \nclass=\"p-16 cyan-bg white-fg\" layout=\"row\" flex><div class=\"pb-30\" layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\" layout-align=\"start center\"><md-icon class=\"m-0 mr-8\" md-font-icon=\"icon-data\"></md-icon><div \nclass=\"h1\">Lead <span class=\"h4 ml-5 ng-scope\">Let\'s start by importing your existing leads</span></div></div></div>\n<div class=\"ml-30\" layout=\"column\" layout-gt-xs=\"row\" flex><md-radio-group class=\"md-primary\" \nng-model=\"vm.lead.choose\" name=\"choose\" required><md-radio-button ng-repeat=\"l in vm.lead.radio\" ng-value=\"l.value\" \nng-click=\"vm.gotoOption(\'lead\', l.value)\"><span class=\"h2\">{{ l.label }}</span><br><span>{{ l.desc }}</span>\n</md-radio-button></md-radio-group></div><div class=\"background-image-center\"><md-icon md-font-icon=\"icon-data\" \nclass=\"s256 faint-text\"></md-icon></div></ms-widget-front></ms-widget><ms-widget class=\"h-350 cursor-pointer\" \nlayout=\"column\" flex=\"100\" flex-gt-md=\"50\" ng-click=\"vm.gotoOption(\'rule\', \'lists\')\"><ms-widget-front \nclass=\"p-16 light-blue-bg white-fg\" layout=\"row\" flex><div layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-icon class=\"m-0 mr-8\" md-font-icon=\"icon-view-list\"></md-icon><div \nclass=\"h1\">Rules</div></div></div><div layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"md-display-3 pb-8\">{{vm.rules.length}}</div><span>Total rules</span><div class=\"h3 font-weight-500\">\nImport Rules from 3rd parties: Connect Aggrego with Facebook, and other systems.</div></div><div \nclass=\"background-image-center\"><md-icon md-font-icon=\"icon-view-list\" class=\"s256 faint-text\"></md-icon></div>\n</ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/apps/imports/views/import/integrated.html","<ms-form-wizard flex><md-tabs class=\"form-wizard\" md-dynamic-height md-selected=\"msWizard.selectedIndex\" \nmd-center-tabs=\"true\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\"></span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check text-bold s16\"></i> \n</span><span class=\"ms-form-wizard-step-text\">{{vm.integration.service || \'Services\'}} Connect</span></span>\n</md-tab-label><md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div \nclass=\"\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"33\"><ms-widget-front class=\"p-16 blue-grey-bg white-fg cursor-pointer\" layout=\"row\" flex \nng-click=\"vm.fb_permission();\"><div class=\"pt-8 pb-8\" layout=\"row\" layout-align=\"space-between center\" flex><div \nclass=\"pl-8\" layout=\"column\" layout-align=\"center start\"><span class=\"md-display-1 pb-8\">Facebook</span> <span \nclass=\"font-weight-500 secondary-text\">here</span></div><div><md-icon md-font-icon=\"icon-facebook-box\" \nclass=\"s48 hint-text\"></md-icon></div></div></ms-widget-front></ms-widget><ms-widget class=\"h-140\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\"><ms-widget-front class=\"p-16 blue-grey-bg white-fg cursor-pointer\" \nlayout=\"row\" flex><div class=\"pt-8 pb-8\" layout=\"row\" layout-align=\"space-between center\" flex><div class=\"pl-8\" \nlayout=\"column\" layout-align=\"center start\"><span class=\"md-display-1 pb-8\"></span> <span \nclass=\"font-weight-500 secondary-text\"></span></div><div><md-icon md-font-icon=\"icon-question-mark-circle\" \nclass=\"s48 hint-text\"></md-icon></div></div></ms-widget-front></ms-widget><ms-widget class=\"h-140\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\"><ms-widget-front class=\"p-16 blue-grey-bg white-fg cursor-pointer\" \nlayout=\"row\" flex><div class=\"pt-8 pb-8\" layout=\"row\" layout-align=\"space-between center\" flex><div class=\"pl-8\" \nlayout=\"column\" layout-align=\"center start\"><span class=\"md-display-1 pb-8\"></span> <span \nclass=\"font-weight-500 secondary-text\"></span></div><div><md-icon md-font-icon=\"icon-question-mark-circle\" \nclass=\"s48 hint-text\"></md-icon></div></div></ms-widget-front></ms-widget></div><input type=\"text\" \nng-model=\"vm.integration.service\" class=\"hidden\" required></form></md-tab-body></md-tab><md-tab \nng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\"></span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check text-bold s16\"></i> \n</span><span class=\"ms-form-wizard-step-text\">Properties</span></span></md-tab-label><md-tab-body><form \nname=\"wizardStep2\" ng-submit=\"submitForm()\" ms-form-wizard-form novalidate><div class=\"mb-25\"><span class=\"h2\">\nWhatever text.</span><br><small>Pellentesque habitant morbi tristique\n senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet quam egestas semper.\n</small></div><div class=\"mb-15\" layout=\"row\" layout-xs=\"column\" layout-align=\"center\"><div flex flex-lg=\"40\" \nflex-gt-lg=\"40\" layout=\"row\" layout-align=\"space-between start\"><u>{{vm.integration.service}}</u></div></div><div \nclass=\"field\" layout=\"row\" layout-xs=\"column\" layout-align=\"center\"><div flex flex-lg=\"40\" flex-gt-lg=\"40\" \nlayout=\"row\" layout-align=\"space-between start\"><label>Page</label><md-select ng-model=\"vm.integration.page\" \nplaceholder=\"Select page\" class=\"md-no-underline\" ng-change=\"vm.subscribeApp()\" required><md-option value=\"\">\n- select column -</md-option><md-option ng-repeat=\"page in vm.lead.pages\" ng-value=\"{{page}}\">{{page.name}}</md-option>\n</md-select></div></div><div class=\"field\" layout=\"row\" layout-xs=\"column\" layout-align=\"center\" \nng-if=\"vm.integration.page\"><div flex flex-lg=\"40\" flex-gt-lg=\"40\" layout=\"row\" layout-align=\"space-between start\">\n<label>Form</label><md-select ng-model=\"vm.integration.form\" placeholder=\"Select form\" class=\"md-no-underline\" \nng-change=\"vm.getLeads()\" required><md-option value=\"\">- select column -</md-option><md-option \nng-repeat=\"form in vm.lead.forms\" ng-value=\"{{form}}\">{{form.name}}</md-option></md-select></div></div><div \nclass=\"mt-40\" ng-if=\"vm.integration.page && vm.integration.form\"><div class=\"mb-15\" layout=\"row\" layout-xs=\"column\" \nlayout-align=\"center\"><div flex flex-lg=\"40\" flex-gt-lg=\"40\" layout=\"row\" layout-align=\"space-between start\"><u>\nStandard (CRM)</u> <u>Header (CSV)</u></div></div><div layout=\"row\" layout-xs=\"column\" layout-align=\"center\" \nclass=\"field\" ng-repeat=\"(lkey, lfield) in vm.lead.field\" \nng-class=\"{\'hidden h-0\':lkey != \'board_id\' && lkey != \'status_id\' && lkey != \'source_id\'}\"><div flex flex-lg=\"40\" \nflex-gt-lg=\"40\" layout=\"row\" layout-align=\"space-between start\"><label>{{lfield.name}}</label><md-select \nng-model=\"vm.import.field[lkey]\" placeholder=\"Field\" class=\"md-no-underline\" ng-required=\"lfield.required\" \nng-change=\"vm.updateBoard(lkey)\" ng-if=\"vm.data\"><md-option value=\"\">- select column -</md-option><md-option \nng-repeat=\"(f, field) in vm.data.field[lkey]\" value=\"{{f}}\" \nng-selected=\"{{field == lkey ? \'true\' : (lkey == \'board_id\' || lkey == \'status_id\' || lkey == \'source_id\') && $index == 0 ? \'true\' : \'false\'}}\">\n{{field}}</md-option></md-select></div><input type=\"text\" ng-model=\"vm.import.field[lkey]\" class=\"hidden w-0\" \nng-required=\"lfield.required\"></div></div><input type=\"text\" ng-model=\"vm.integration.preview\" class=\"hidden\" required>\n</form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\" \nng-click=\"vm.btn_next(1);\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\"></span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\">Preview</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" \nms-form-wizard-form novalidate><div class=\"container\" ng-if=\"vm.import.pview !== \'true\'\"><h3>Preview is processing.\n</h3><p>Please wait.</p><md-progress-linear md-mode=\"query\"></md-progress-linear></div><div \nclass=\"simple-table-container md-whiteframe-4dp\" ng-if=\"vm.import.pview === \'true\'\"><table class=\"simple\" \nms-responsive-table><thead><tr><th ng-repeat=\"(h, header) in vm.import.field\" \nng-if=\"$index % vm.import.preview_limit == 0\">{{ h }}</th></tr></thead><tbody><tr \nng-repeat=\"record in vm.import.preview\"><td ng-repeat=\"cell in record\" ng-if=\"$index % vm.import.preview_limit == 0\">\n{{cell}}</td></tr></tbody></table></div><input type=\"text\" ng-model=\"vm.import.pview\" class=\"hidden w-0\" \nrequired=\"required\"></form></md-tab-body></md-tab><md-tab \nng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid || wizardStep3.$invalid\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep4.$invalid\">\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep4.$valid\"><i class=\"icon-check s16\"></i>\n </span><span class=\"ms-form-wizard-step-text\">Import</span></span></md-tab-label><md-tab-body><form \nname=\"wizardStep4\" ms-form-wizard-form novalidate><h2 class=\"md-title\">HTML Ipsum Presents</h2><p>\nPellentesque habitant morbi tristique\n senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet quam egestas semper.\n</p><p>&nbsp;</p><div class=\"container\" ng-if=\"vm.import.start === \'true\'\"><h3>Your import is processing.</h3><p>\nWe\'ll notify you when your import is finished.</p><md-progress-linear md-mode=\"query\"></md-progress-linear></div><p>\n&nbsp;</p><input type=\"text\" ng-model=\"vm.import.start\" class=\"hidden w-0\" required></form></md-tab-body></md-tab>\n</md-tabs><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.previousStep();\" ng-disabled=\"msWizard.isFirstStep()\">Back</md-button>\n<div class=\"steps ph-40\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.btn_next(msWizard.selectedIndex); msWizard.nextStep();\" \nng-hide=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.currentStepInvalid()\" \nng-class=\"{\'btn-prop integrated\':msWizard.selectedIndex === 0}\">Next</md-button><md-button \nclass=\"md-raised md-primary\" ng-click=\"vm.importLead();\" ng-show=\"msWizard.isLastStep()\" \nng-disabled=\"vm.import.start === \'true\'\">{{vm.import.btn_imp}}</md-button></div></ms-form-wizard>");
$templateCache.put("app/main/apps/imports/views/import/lead.html","<div id=\"imports\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"md-icon-button\" aria-label=\"Go to projects\" \nui-sref=\"app.imports_import\" translate translate-attr-aria-label=\"PR.GO_TO_PROJECTS\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div class=\"h2\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-data\" class=\"mr-16\"></md-icon><span>Import Lead {{vm.item}}</span></div></div><div></div></div><div \nclass=\"content\"><md-content ng-include=\"\'app/main/apps/imports/views/import/\'+vm.item+\'.html\'\"></md-content></div>\n</div></div>");
$templateCache.put("app/main/apps/imports/views/rule/form.html","<div id=\"imports\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"md-icon-button\" aria-label=\"Go to projects\" \nui-sref=\"app.imports_import.rule\" translate translate-attr-aria-label=\"PR.GO_TO_PROJECTS\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div class=\"h2\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-data\" class=\"mr-16\"></md-icon><span>Services Connect</span></div></div><div></div></div><div \nclass=\"content\"><md-content><ms-form-wizard flex><md-tabs class=\"form-wizard\" md-dynamic-height \nmd-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i \nclass=\"icon-check text-bold s16\"></i> </span><span class=\"ms-form-wizard-step-text\">\n{{vm.integration.service || \'Services\'}} Connect</span></span></md-tab-label><md-tab-body><form name=\"wizardStep1\" \nclass=\"md-inline-form\" ms-form-wizard-form novalidate><div class=\"\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nclass=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\"><ms-widget-front \nclass=\"p-16 blue-grey-bg white-fg cursor-pointer\" layout=\"row\" flex ng-click=\"vm.fb_permission();\"><div \nclass=\"pt-8 pb-8\" layout=\"row\" layout-align=\"space-between center\" flex><div class=\"pl-8\" layout=\"column\" \nlayout-align=\"center start\"><span class=\"md-display-1 pb-8\">Facebook</span> <span \nclass=\"font-weight-500 secondary-text\">here</span></div><div><md-icon md-font-icon=\"icon-facebook-box\" \nclass=\"s48 hint-text\"></md-icon></div></div></ms-widget-front></ms-widget><ms-widget class=\"h-140\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\"><ms-widget-front class=\"p-16 blue-grey-bg white-fg cursor-pointer\" \nlayout=\"row\" flex><div class=\"pt-8 pb-8\" layout=\"row\" layout-align=\"space-between center\" flex><div class=\"pl-8\" \nlayout=\"column\" layout-align=\"center start\"><span class=\"md-display-1 pb-8\"></span> <span \nclass=\"font-weight-500 secondary-text\"></span></div><div><md-icon md-font-icon=\"icon-question-mark-circle\" \nclass=\"s48 hint-text\"></md-icon></div></div></ms-widget-front></ms-widget><ms-widget class=\"h-140\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\"><ms-widget-front class=\"p-16 blue-grey-bg white-fg cursor-pointer\" \nlayout=\"row\" flex><div class=\"pt-8 pb-8\" layout=\"row\" layout-align=\"space-between center\" flex><div class=\"pl-8\" \nlayout=\"column\" layout-align=\"center start\"><span class=\"md-display-1 pb-8\"></span> <span \nclass=\"font-weight-500 secondary-text\"></span></div><div><md-icon md-font-icon=\"icon-question-mark-circle\" \nclass=\"s48 hint-text\"></md-icon></div></div></ms-widget-front></ms-widget></div><input type=\"text\" \nng-model=\"vm.integration.service\" class=\"hidden\" required></form></md-tab-body></md-tab><md-tab \nng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\"></span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check text-bold s16\"></i> \n</span><span class=\"ms-form-wizard-step-text\">Save Rule</span></span></md-tab-label><md-tab-body><form \nname=\"wizardStep2\" ng-submit=\"submitForm()\" ms-form-wizard-form novalidate><div class=\"mb-25\"><span class=\"h2\">\nWhatever text.</span><br><small>Pellentesque habitant morbi tristique\n senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet quam egestas semper.\n</small></div><div class=\"mb-15\" layout=\"row\" layout-xs=\"column\" layout-align=\"center\"><div flex flex-lg=\"40\" \nflex-gt-lg=\"40\" layout=\"row\" layout-align=\"space-between start\"><u>{{vm.integration.service}}</u></div></div><div \nclass=\"field\" layout=\"row\" layout-xs=\"column\" layout-align=\"center\"><div flex flex-lg=\"40\" flex-gt-lg=\"40\" \nlayout=\"row\" layout-align=\"space-between start\"><label>Page</label><md-select ng-model=\"vm.integration.page\" \nplaceholder=\"Select page\" class=\"md-no-underline\" ng-change=\"vm.subscribeApp()\" required><md-option value=\"\">\n- select page -</md-option><md-option ng-repeat=\"page in vm.lead.pages\" ng-value=\"{{page}}\">{{page.name}}</md-option>\n</md-select></div></div><div class=\"field\" layout=\"row\" layout-xs=\"column\" layout-align=\"center\" \nng-if=\"vm.integration.page\"><div flex flex-lg=\"40\" flex-gt-lg=\"40\" layout=\"row\" layout-align=\"space-between start\">\n<label>Form</label><md-select ng-model=\"vm.integration.form\" placeholder=\"Select form\" class=\"md-no-underline\" \nng-change=\"vm.getLeads()\" required><md-option value=\"\">- select form -</md-option><md-option \nng-repeat=\"form in vm.lead.forms\" ng-value=\"{{form}}\">{{form.name}}</md-option></md-select></div></div><div \nclass=\"mt-40\" ng-if=\"vm.integration.page && vm.integration.form\"><div class=\"mb-15\" layout=\"row\" layout-xs=\"column\" \nlayout-align=\"center\"><div flex flex-lg=\"40\" flex-gt-lg=\"40\" layout=\"row\" layout-align=\"space-between start\"><u>\nStandard (CRM)</u> <u>Settings</u></div></div><div layout=\"row\" layout-xs=\"column\" layout-align=\"center\" class=\"field\" \nng-repeat=\"(lkey, lfield) in vm.lead.field\" \nng-class=\"{\'hidden h-0\':lkey != \'board_id\' && lkey != \'status_id\' && lkey != \'source_id\'}\"><div flex flex-lg=\"40\" \nflex-gt-lg=\"40\" layout=\"row\" layout-align=\"space-between start\"><label>{{lfield.name}}</label><md-select \nng-model=\"vm.import.field[lkey]\" placeholder=\"Field\" class=\"md-no-underline\" ng-required=\"lfield.required\" \nng-change=\"vm.updateBoard(lkey)\" ng-if=\"vm.data\"><md-option value=\"\">- select column -</md-option><md-option \nng-repeat=\"(f, field) in vm.data.field[lkey]\" value=\"{{f}}\" \nng-selected=\"{{field == lkey ? \'true\' : (lkey == \'board_id\' || lkey == \'status_id\' || lkey == \'source_id\') && $index == 0 ? \'true\' : \'false\'}}\">\n{{field}}</md-option></md-select></div><input type=\"text\" ng-model=\"vm.import.field[lkey]\" class=\"hidden w-0\" \nng-required=\"lfield.required\"></div></div><div class=\"field\" layout=\"row\" layout-xs=\"column\" layout-align=\"center\" \nng-if=\"vm.integration.page && vm.integration.form\"><div flex flex-lg=\"40\" flex-gt-lg=\"40\" layout=\"row\" \nlayout-align=\"space-between start\"><label>Frequency</label><md-select ng-model=\"vm.integration.frequency\" \nplaceholder=\"Select form\" class=\"md-no-underline\" required><md-option value=\"\">- select frequency -</md-option>\n<md-option ng-repeat=\"(freq, frequency) in vm.frequencies\" ng-value=\"{{freq}}\">{{frequency}}</md-option></md-select>\n</div></div><input type=\"text\" ng-model=\"vm.integration.preview\" class=\"hidden\" required></form></md-tab-body></md-tab>\n</md-tabs><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.previousStep();\" ng-disabled=\"msWizard.isFirstStep()\">Back</md-button>\n<div class=\"steps ph-40\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.btn_next(msWizard.selectedIndex); msWizard.nextStep();\" \nng-hide=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.currentStepInvalid()\" \nng-class=\"{\'btn-prop lists\':msWizard.selectedIndex === 0}\">Next</md-button><md-button class=\"md-raised md-primary\" \nng-click=\"vm.saveRule();\" ng-show=\"msWizard.isLastStep()\" \nng-disabled=\"vm.integration.page === \'\' || vm.integration.form === \'\' || vm.integration.frequency === \'\'\"><span>\n{{ vm.loaderText1 || \"Save\" }}</span></md-button></div></ms-form-wizard></md-content></div></div></div>");
$templateCache.put("app/main/apps/imports/views/rule/rule.html","<div id=\"rule\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-view-list\"></md-icon><span>Rules</span></div><div class=\"total-count secondary-text\"><span>\nTotal rules:</span> <span>{{vm.rules.length}}</span></div></div><div><md-button \nclass=\"md-accent md-raised md-hue-2 header-boards-button\" ui-sref=\"app.imports_import.rule.form\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><span class=\"ph-8\">Create</span></md-button></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-bproject hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Service</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Form Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Frequency</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Created</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"rule in vm.rules\"><td>{{rule.service}}</td><td>{{rule.form_name}}</td><td><md-select \nng-model=\"rule.frequency\" placeholder=\"Field\" class=\"md-no-underline no-margin\" ng-change=\"vm.saveRule(rule)\">\n<md-option value=\"\">- select frequency -</md-option><md-option ng-repeat=\"(f, frequency) in vm.frequencies\" \nvalue=\"{{f}}\" ng-selected=\"{{f == rule.frequency ? \'true\' : \'false\'}}\">{{frequency}}</md-option></md-select></td><td \nclass=\"date\">{{rule.created_at}}</td><td class=\"action\"><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.onDelete({model: \'rule\', checked: [rule.id]})\" aria-label=\"Property delete\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s16\"></md-icon></md-button><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.fb_permission(rule);\" aria-label=\"Reresh Token\" ng-if=\"rule.error_token\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16 md-warn-fg\"></md-icon><md-tooltip md-direction=\"right\">\nToken Expired. Click to refresh.</md-tooltip></md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/apps/contacts/dialogs/contact/contact-dialog.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"contactForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent\" ng-class=\"{\'md-tall\': !vm.newContact}\" ng-attr-id=\"{{vm.newContact ? \'md-new\': \'\'}}\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><div ng-if=\"!vm.newContact\" \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\"><div \nlayout=\"column\" layout-align=\"center center\"><button type=\"button\" ngf-select=\"vm.uploadFiles($files, vm.contact.id)\" \naccept=\"image/*\">{{avatar = (vm.contact.avatar.path || vm.crmUrl + \'storage/app/media/profile.jpg\');\"\" }} <img \nng-src=\"{{avatar}}\" class=\"add-img-button md-avatar avatar employee-avatar huge\" alt=\"Profile\"><md-tooltip>\nClick to change profile</md-tooltip></button><div class=\"contact-name\">\n{{vm.contact.first_name}} {{vm.contact.last_name}}</div></div></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"pb-20\" ng-if=\"vm.errors\"><small class=\"red-fg md-block\" ng-repeat=\"error in vm.errors\">{{error[0]}}<br></small>\n</div><md-input-container class=\"md-icon-float md-block\"><label>First Name (required)</label><md-icon \nmd-font-icon=\"icon-account\" class=\"name\" required></md-icon><input name=\"first_name\" ng-model=\"vm.contact.first_name\" \ntype=\"text\" ng-required md-autofocus></md-input-container><md-input-container class=\"md-icon-float md-block\"><label \ntranslate=\"CONTACTS.LAST_NAME\">Last name</label><md-icon></md-icon><input name=\"last_name\" \nng-model=\"vm.contact.last_name\" type=\"text\"></md-input-container><md-input-container class=\"md-icon-float md-block\">\n<md-icon md-font-icon=\"icon-email\" class=\"email\"></md-icon><input name=\"email\" ng-model=\"vm.contact.email\" \ntype=\"email\" placeholder=\"Email\" required></md-input-container><div ng-if=\"!vm.allFields\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent\" ng-click=\"vm.allFields = true\" \ntranslate=\"EMPLOYEES.SHOW_ALL_FIELDS\">Show All Fields</md-button></div><div ng-if=\"vm.allFields\"><md-input-container \nclass=\"md-block\"><label>Secondary Email</label><md-icon></md-icon><input type=\"email\" name=\"secondary_email\" \nng-model=\"vm.contact.secondary_email\"></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"SB.TELEPHONE\">Telephone</label><md-icon md-font-icon=\"icon-phone\" class=\"email\"></md-icon><input \ntype=\"text\" name=\"telephone\" ui-mask=\"{{vm.phoneCode}} 9-999-9999\" restrict=\"reject\" ng-model=\"vm.contact.telephone\" \nplaceholder=\"{{vm.phoneCode}} _-___-____\"></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"SB.MOBILE_1\">Mobile phone 1</label><md-icon></md-icon><input type=\"text\" name=\"mobile_phone1\" \nui-mask=\"{{vm.phoneCode}} 999-999-9999\" restrict=\"reject\" ng-model=\"vm.contact.mobile_phone1\" \nplaceholder=\"{{vm.phoneCode}} ___-___-____\"></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"SB.MOBILE_2\">Mobile phone 2</label><md-icon></md-icon><input type=\"text\" name=\"mobile_phone2\" \nui-mask=\"{{vm.phoneCode}} 999-999-9999\" restrict=\"reject\" ng-model=\"vm.contact.mobile_phone2\" \nplaceholder=\"{{vm.phoneCode}} ___-___-____\"></md-input-container><div flex class=\"members\"><div class=\"section-header\" \nlayout=\"row\" layout-align=\"start center\"><i class=\"icon-sitemap s18 mr-16\"></i>\n {{name = (vm.newContact) ? vm.title : vm.contact.first_name +\" \"+ vm.contact.last_name + \"\'s\";\"\" }} <span \nclass=\"section-title\">{{name}} Company</span></div><div class=\"section-content\"><md-chips class=\"member-chips\" \nng-model=\"vm.contactCompany\" md-autocomplete-snap md-max-chips=\"1\" md-require-match=\"true\" \nmd-transform-chip=\"$chip.id\"><md-autocomplete md-input-id=\"autoCompleteId\" md-input-name=\"autoCompleteId\" \nmd-selected-item=\"vm.selectedEmployee\" md-search-text=\"vm.searchText\" \nmd-items=\"company in vm.companyQuerySearch(vm.searchText)\" md-item-text=\"company.name\" \nng-disabled=\"vm.contactCompany.length >= 1\" ng-hide=\"vm.contactCompany.length >= 1\" \nplaceholder=\"Search for a company...\" md-selected-item-change=\"contactForm.$invalid = false\"><span \nmd-highlight-text=\"vm.searchText\">{{company.name}}</span></md-autocomplete><md-chip-template class=\"employee-chip\">\n{{vm.company.avatar.path = (vm.companies.getById($chip).avatar.path || vm.crmUrl + \'storage/app/media/company.png\');\"\"}} \n<img class=\"employee-chip-avatar\" ng-src=\"{{vm.company.avatar.path}}\"> <small>{{vm.companies.getById($chip).name}}\n</small><md-tooltip>{{vm.companies.getById($chip).name}}</md-tooltip></md-chip-template><button md-chip-remove \nclass=\"md-primary\" ng-click=\"vm.setFocus()\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon></button>\n</md-chips>{{vm.contact.associate_id = vm.contactCompany[0];\"\"}} <input name=\"associate_id\" type=\"hidden\" \nng-model=\"vm.contact.associate_id\"> <input name=\"user_id\" type=\"hidden\" ng-model=\"vm.contact.user_id\" \nng-value=\"{{vm.user.id}}\"></div></div><md-input-container class=\"md-block\"><label>Job title</label><md-icon \nmd-font-icon=\"icon-worker\"></md-icon><input name=\"job_title\" ng-model=\"vm.contact.job_title\" type=\"text\">\n</md-input-container><md-input-container class=\"md-block\"><md-icon></md-icon><md-datepicker class=\"birthday-input\" \nng-model=\"vm.contact.date_birth\" md-placeholder=\"Birthday\" ng-required=\"false\"></md-datepicker></md-input-container>\n<md-input-container class=\"md-block\"><label>Address</label><md-icon md-font-icon=\"icon-home\"></md-icon><textarea \nname=\"address\" ng-model=\"vm.contact.address\" columns=\"1\" max-rows=\"4\"></textarea></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-city\"></md-icon><md-select \nng-model=\"vm.contact.region_id\" ng-change=\"vm.getRegionProvinces()\" name=\"country\" id=\"country\" aria-label=\"select\" \nplaceholder=\"Region\"><md-option ng-repeat=\"region in vm.regions\" ng-value=\"{{region.id}}\">{{region.short_name}}\n</md-option></md-select></md-input-container><md-input-container class=\"mt-25 md-block\"><md-icon></md-icon><md-select \nng-model=\"vm.contact.province_id\" ng-change=\"vm.getProvinceCities()\" ng-required=\"!contactForm.country.$pristine\" \nname=\"province\" id=\"province\" aria-label=\"select\" placeholder=\"Province\" md-no-asterisk=\"false\"><md-option \nng-repeat=\"obj in vm.provinces\" ng-value=\"{{obj.id}}\">{{obj.value}}</md-option></md-select></md-input-container>\n<md-input-container class=\"mt-25 md-block\"><md-icon></md-icon><md-select ng-model=\"vm.contact.city_id\" \nng-required=\"!contactForm.province.$pristine\" name=\"city\" id=\"city\" aria-label=\"select\" placeholder=\"City\" \nmd-no-asterisk=\"false\"><md-option ng-repeat=\"obj in vm.cities\" ng-value=\"{{obj.id}}\">{{obj.value}}</md-option>\n</md-select></md-input-container><md-input-container class=\"mt-50 md-block\"><label>Website</label><md-icon \nmd-font-icon=\"icon-web\"></md-icon><input name=\"website\" ng-model=\"vm.contact.website\"></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"SB.FACEBOOK\">Facebook</label><md-icon></md-icon><input \nname=\"facebook\" ng-model=\"vm.contact.facebook\"></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"SB.TWITTER\">Twitter</label><md-icon></md-icon><input name=\"twitter\" ng-model=\"vm.contact.twitter\">\n</md-input-container><md-input-container class=\"md-block\"><label translate=\"SB.GOOGLE\">Google</label><md-icon>\n</md-icon><input name=\"google\" ng-model=\"vm.contact.google\"></md-input-container><md-input-container class=\"md-block\">\n<label translate=\"SB.LINKEDIN\">Linked In</label><md-icon></md-icon><input name=\"linkedin\" \nng-model=\"vm.contact.linkedin\"></md-input-container><md-input-container class=\"md-block\"><label translate=\"SB.SKYPE\">\nSkype</label><md-icon></md-icon><input name=\"skype\" ng-model=\"vm.contact.skype\"></md-input-container><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent\" ng-click=\"vm.allFields = false\" \ntranslate=\"EMPLOYEES.FEWER_FIELDS\">Fewer Fields</md-button></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ntype=\"submit\" ng-if=\"!vm.newContact\" ng-click=\"vm.saveContact()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"contactForm.$invalid || contactForm.$pristine\" aria-label=\"SAVE\" translate=\"CONTACTS.SAVE\" \ntranslate-attr-aria-label=\"CONTACTS.SAVE\">SAVE</md-button><md-button type=\"submit\" ng-if=\"vm.newContact\" \nng-click=\"vm.addNewContact()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"contactForm.$invalid || contactForm.$pristine\" aria-label=\"Add Task\" translate=\"CONTACTS.ADD_CONTACT\" \ntranslate-attr-aria-label=\"CONTACTS.ADD_CONTACT\">ADD CONTACT</md-button></div><div layout=\"row\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.deleteContactConfirm($event)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"CONTACTS.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"CONTACTS.DELETE\">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/contacts/sidenavs/main/main-sidenav.html","<div class=\"header md-padding\" layout=\"row\" layout-align=\"start center\">\n{{vm.user.employee.user.avatar.path = (vm.user.employee.user.avatar.path || vm.crmUrl + \'storage/app/media/profile.jpg\');\"\"}} \n<img ng-src=\"{{vm.user.employee.user.avatar.path}}\" class=\"md-avatar avatar mr-16\" alt=\"{{vm.user.name}}\"> <span \nclass=\"font-weight-500 font-size-14\">{{vm.user.name}}</span></div><md-divider></md-divider><div ms-scroll \nclass=\"content scrollable\"><md-list><md-subheader class=\"md-no-sticky\">List of contacts associated to the companies.\n</md-subheader></md-list></div>");
$templateCache.put("app/main/apps/employees/dialogs/employee/employee-dialog.html","<md-dialog class=\"employee-dialog\" aria-label=\"New Task\"><form name=\"employeeForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent\" ng-class=\"{\'md-tall\': !vm.newEmployee}\" ng-attr-id=\"{{vm.newEmployee ? \'md-new\': \'\'}}\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"EMPLOYEES.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><div ng-if=\"!vm.newEmployee\" \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\"><div \nlayout=\"column\" layout-align=\"center center\"><button type=\"button\" \nngf-select=\"vm.uploadFiles($files, vm.employee.user.id)\" ng-disabled=\"!role.permissions.write\" accept=\"image/*\">\n{{vm.employee.user.avatar.path = (vm.employee.user.avatar.path || vm.crmUrl + \'storage/app/media/profile.jpg\');\"\"}} \n<img ng-src=\"{{vm.employee.user.avatar.path}}\" class=\"add-img-button md-avatar avatar employee-avatar huge\" \nalt=\"{{vm.employee.first_name}} {{vm.employee.last_name}}\"><md-tooltip>Click to change profile</md-tooltip></button>\n<div class=\"employee-name\">{{vm.employee.first_name}} {{vm.employee.last_name}}</div></div></div><div \nng-if=\"!vm.newEmployee\" class=\"md-toolbar-tools md-toolbar-tools-bottom\" layout=\"row\" layout-align=\"center center\"><div\n flex layout=\"row\" layout-align=\"center center\"><md-menu ng-if=\"!vm.newEmployee && role.permissions.write\"><md-button \nclass=\"md-icon-button\" aria-label=\"More\" translate translate-attr-aria-label=\"TODO.MORE\"><md-icon \nmd-font-icon=\"icon-account-multiple-plus\" ng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-list-item ng-if=\"vm.user.groups\" ng-repeat=\"group in vm.user.groups\" \nng-click=\"vm.toggleInArray(employee.id,group.users_id);vm.groupEmployee(vm.exists(vm.employee.id,group.users_id), group)\">\n<p class=\"pl-8\" ng-class=\"{\'md-accent-fg font-weight-700\': vm.exists(vm.employee.id,group.users_id)}\">{{group.name}}\n</p></md-list-item></md-menu-content></md-menu></div></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"pb-20\" ng-if=\"vm.errors\"><small class=\"red-fg md-block\" ng-repeat=\"error in vm.errors\">{{error[0]}}<br></small>\n</div><md-input-container class=\"md-icon-float md-block\"><label translate=\"EMPLOYEES.FIRST_NAME_REQUIRED\">\nFirst Name (required)</label><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><input \nng-model=\"vm.employee.first_name\" type=\"text\" required md-autofocus ng-readonly=\"!role.permissions.write\">\n</md-input-container><md-input-container class=\"md-icon-float md-block\"><label translate=\"EMPLOYEES.LAST_NAME\">\nLast name</label><md-icon></md-icon><input ng-model=\"vm.employee.last_name\" type=\"text\" \nng-readonly=\"!role.permissions.write\"></md-input-container><md-input-container class=\"md-icon-float md-block\"><md-icon \nmd-font-icon=\"icon-email\" class=\"email\"></md-icon><input ng-model=\"vm.employee.email\" type=\"email\" placeholder=\"Email\" \nng-readonly=\"!role.permissions.write\" required></md-input-container><div ng-if=\"!vm.allFields\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent\" ng-click=\"vm.allFields = true\" \ntranslate=\"EMPLOYEES.SHOW_ALL_FIELDS\">Show All Fields</md-button></div><div ng-if=\"vm.allFields\"><md-input-container \nclass=\"md-block\"><label translate=\"SB.TELEPHONE\">Telephone</label><md-icon md-font-icon=\"icon-phone\"></md-icon><input \ntype=\"text\" name=\"telephone\" ui-mask=\"{{vm.phoneCode}} 9-999-9999\" restrict=\"reject\" ng-model=\"vm.employee.telephone\" \nplaceholder=\"{{vm.phoneCode}} _-___-____\" ng-readonly=\"!role.permissions.write\"></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"SB.MOBILE_1\">Mobile phone 1</label><md-icon></md-icon><input \ntype=\"text\" name=\"mobile_phone1\" ui-mask=\"{{vm.phoneCode}} 999-999-9999\" restrict=\"reject\" \nng-model=\"vm.employee.mobile_phone1\" placeholder=\"{{vm.phoneCode}} ___-___-____\" ng-readonly=\"!role.permissions.write\">\n</md-input-container><md-input-container class=\"md-block\"><label translate=\"SB.MOBILE_2\">Mobile phone 2</label>\n<md-icon></md-icon><input type=\"text\" name=\"mobile_phone2\" ui-mask=\"{{vm.phoneCode}} 999-999-9999\" restrict=\"reject\" \nng-model=\"vm.employee.mobile_phone2\" placeholder=\"{{vm.phoneCode}} ___-___-____\" ng-readonly=\"!role.permissions.write\">\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-worker\"></md-icon><input \nng-model=\"vm.employee.job_title\" type=\"text\" placeholder=\"Job title\" ng-readonly=\"!role.permissions.write\">\n</md-input-container><md-input-container class=\"md-block\"><md-datepicker class=\"birthday-input\" \nng-model=\"vm.employee.date_birth\" md-placeholder=\"Birthday\" ng-disabled=\"!role.permissions.write\" ng-required=\"false\">\n</md-datepicker></md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-home\"></md-icon>\n<input ng-model=\"vm.employee.address\" type=\"text\" placeholder=\"Address\" ng-readonly=\"!role.permissions.write\">\n</md-input-container><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent\" \nng-click=\"vm.allFields = false\" translate=\"EMPLOYEES.FEWER_FIELDS\">Fewer Fields</md-button></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\" ng-if=\"role.permissions.write\">\n<div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-if=\"!vm.newEmployee\" \nng-click=\"vm.saveEmployee()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"employeeForm.$invalid || employeeForm.$pristine\" aria-label=\"SAVE\" translate=\"EMPLOYEES.SAVE\" \ntranslate-attr-aria-label=\"EMPLOYEES.SAVE\">SAVE</md-button><md-button type=\"submit\" ng-if=\"vm.newEmployee\" \nng-click=\"vm.addNewEmployee()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"employeeForm.$invalid || employeeForm.$pristine\" aria-label=\"Add Task\" translate=\"EMPLOYEES.ADD_EMPLOYEE\" \ntranslate-attr-aria-label=\"EMPLOYEES.ADD_EMPLOYEE\">ADD EMPLOYEE</md-button></div><div ng-if=\"!vm.newEmployee\" \nlayout=\"row\"><md-button class=\"md-icon-button\" ng-click=\"vm.deleteEmployeeConfirm($event, vm.employee, \'employee\')\" \naria-label=\"Delete\" translate translate-attr-aria-label=\"EMPLOYEES.DELETE\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon><md-tooltip><span translate=\"EMPLOYEES.DELETE\">DELETE</span></md-tooltip></md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/employees/sidenavs/main/main-sidenav.html","<div class=\"header md-padding\" layout=\"row\" layout-align=\"start center\">\n{{vm.user.employee.user.avatar.path = (vm.user.employee.user.avatar.path || vm.crmUrl + \'storage/app/media/profile.jpg\');\"\"}} \n<img ng-src=\"{{vm.user.employee.user.avatar.path}}\" class=\"md-avatar avatar mr-16\" alt=\"{{vm.user.name}}\"> <span \nclass=\"font-weight-500 font-size-14\">{{vm.user.name}}</span></div><md-divider></md-divider><div ms-scroll \nclass=\"content scrollable\"><md-list><md-subheader class=\"md-no-sticky\">\nEmployees are users from your company with access to Aggrego.</md-subheader></md-list></div>");
$templateCache.put("app/main/apps/scrumboard/dialogs/lead/lead-dialog.html","<md-dialog class=\"lead-dialog\" aria-label=\"Lead Dialog\"><md-toolbar class=\"md-medium-tall\" \nng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\" layout=\"column\"><div class=\"md-accent-bg md-toolbar-tools\"><div \nclass=\"h4 text-semibold mr-10 lead-breadcrumb\" layout=\"row\" layout-align=\"start center\"><span>{{vm.board.title}}</span>\n <i class=\"icon-menu-right s14 m-5\"></i> <span>{{vm.stage.value}}</span> <i class=\"icon-menu-right s14 m-5\" hide-xs>\n</i> <span hide-xs>{{vm.lead.name}}</span></div><span flex></span><md-menu md-offset=\"0 48\" class=\"labels\"><md-button \nclass=\"md-icon-button\" aria-label=\"Label\" translate translate-attr-aria-label=\"SB.LABEL\" \nng-click=\"vm.labelTabIndex = 0;$mdOpenMenu($event)\" hide-xs><md-icon md-menu-origin md-font-icon=\"icon-label-outline\">\n</md-icon></md-button><md-menu-content class=\"labels-menu-content\" width=\"4\" ms-scroll><md-tabs \nmd-selected=\"vm.labelTabIndex\" md-dynamic-height><md-tab><md-tab-body><md-menu-item class=\"label\" \nng-repeat=\"priority in vm.priority | filter: vm.filterLabel\"><md-button ng-disabled=\"vm.isDisabled\" \nclass=\"label-toggle-button\" ng-class=\"vm.lead.priority_id == priority.id ? \'md-\'+ priority.color +\'-bg white-fg\' : \'\'\" \nng-model=\"vm.lead.priority_id\" ng-click=\"vm.lead.priority_id = priority.id; vm.saveLead();$mdCloseMenu()\" \naria-label=\"Toggle Label\" translate translate-attr-aria-label=\"SB.TOGGLE_LABEL\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex><span>{{priority.value}}</span></div></md-button></md-menu-item></md-tab-body>\n</md-tab></md-tabs></md-menu-content></md-menu><md-menu md-offset=\"0 48px\" class=\"options\"><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"Options\" translate \ntranslate-attr-aria-label=\"SB.OPTIONS\"><md-icon md-menu-origin md-font-icon=\"icon-dots-horizontal\"></md-icon>\n</md-button><md-menu-content class=\"options-menu-content\" width=\"4\"><md-menu-item><md-button \nng-disabled=\"vm.isDisabled\" ng-click=\"vm.removeLead(ev, \'lead\')\" aria-label=\"Remove Lead\" translate \ntranslate-attr-aria-label=\"SB.REMOVE_LEAD\"><md-icon md-font-icon=\"icon-delete\" md-menu-align-target></md-icon><span \ntranslate=\"SB.REMOVE_LEAD\">Remove Lead</span></md-button></md-menu-item></md-menu-content></md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close Dialog\" translate \ntranslate-attr-aria-label=\"SB.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><md-tabs \nmd-stretch-tabs class=\"md-primary md-medium-tall\" md-selected=\"selectedIndex\"><md-tab id=\"tab1\" \naria-controls=\"tab1-content\" ng-click=\"btnSave=\'yes0\'\" ng-init=\"btnSave=\'yes0\'\"><span translate=\"SB.DETAILS\">Details\n</span></md-tab><md-tab id=\"tab2\" aria-controls=\"tab2-content\" ng-click=\"btnSave=\'yes1\'\" ng-disabled=\"!vm.lead.id\">\n<span translate=\"SB.OPPORTUNITY\">Opportunity</span></md-tab><md-tab id=\"tab3\" aria-controls=\"tab3-content\" \nng-click=\"btnSave=\'\'\" ng-disabled=\"!vm.lead.id\"><span translate=\"SB.TODO\">To-Do</span></md-tab><md-tab id=\"tab4\" \naria-controls=\"tab4-content\" ng-click=\"btnSave=\'\'\" ng-disabled=\"!vm.lead.id\"><span translate=\"SB.HISTORY\">History\n</span></md-tab><md-tab id=\"tab5\" aria-controls=\"tab5-content\" ng-click=\"btnSave=\'yes5\'\" ng-disabled=\"!vm.lead.id\">\n<span>Remarks</span></md-tab></md-tabs></md-toolbar><form editable-form name=\"leadForm\" class=\"md-inline-form\" \nnovalidate data-form-attr=\"{{vm.board.permission}}\"><md-dialog-content ms-scroll><md-content flex md-scroll-y><ui-view \nlayout=\"column\" layout-fill layout-padding><ng-switch on=\"selectedIndex\" class=\"tabpanel-container\"><div \nrole=\"tabpanel\" id=\"tab1-content\" aria-labelledby=\"tab1\" ng-switch-when=\"0\" md-swipe-left=\"next()\" \nmd-swipe-right=\"previous()\"><div layout-xs=\"column\" layout=\"row\"><div flex><md-input-container \nclass=\"md-block hide-error-msg\" md-no-float><input name=\"lead_name\" ng-model=\"vm.lead.name\" placeholder=\"Name\" \nrequired md-autofocus=\"!vm.lead.id\"></md-input-container></div></div><div layout-xs=\"column\" layout=\"row\" class=\"mt-8\">\n<div flex><div class=\"section-header pt-20 pb-15\" layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon-link-variant s18\"></i> <span class=\"section-title\">Source</span></div><div class=\"section-content\">\n<md-input-container class=\"md-block\"><label>Source</label><md-select ng-model=\"vm.lead.source_id\" name=\"source_id\" \nid=\"source_id\" placeholder=\"Please select source\" ng-disabled=\"vm.isDisabled\"><md-option \nng-repeat=\"source in vm.sources\" ng-value=\"{{source.id}}\">{{source.value}}</md-option></md-select></md-input-container>\n<div class=\"h-15\"></div><md-input-container class=\"md-block\"><label translate=\"SB.SOURCE_DESCRIPTION\">\nSource Description</label><input name=\"source_desc\" type=\"text\" ng-model=\"vm.lead.source_desc\"></md-input-container>\n</div></div><div flex=\"5\" hide-xs hide-sm></div><div flex><div class=\"section-header pt-20 pb-15\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon-trello s18\"></i> <span class=\"section-title\">Board / Stage</span></div><div \nclass=\"section-content\"><md-input-container class=\"md-block\"><label>Board</label><md-select \nng-model=\"vm.lead.board_id\" ng-change=\"vm.updateBoard()\" name=\"board_id\" id=\"board_id\" aria-label=\"select\" \nplaceholder=\"Please select board\" ng-disabled=\"vm.isDisabled\"><md-option ng-repeat=\"board in vm.boards\" \nng-value=\"{{board.id}}\">{{board.title}}</md-option></md-select></md-input-container><div class=\"h-15\"></div>\n<md-input-container class=\"md-block\"><label>Stage</label><md-select ng-model=\"vm.lead.status_id\" name=\"status_id\" \nid=\"status_id\" aria-label=\"select\" placeholder=\"Please select stage\" md-no-asterisk=\"false\" \nng-disabled=\"vm.isDisabled\"><md-option ng-repeat=\"obj in vm.stagesOptions\" ng-value=\"{{obj.id}}\">{{obj.value}}\n</md-option></md-select></md-input-container></div></div></div><div class=\"sections pb-5 pb-15\"><div \nlayout-xs=\"column\" layout=\"row\" class=\"section\"><div flex class=\"contacts\"><div class=\"section-header\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon-account-multiple s18\"></i> <span class=\"section-title\">Contacts</span></div>\n<div class=\"section-content\"><div layout-xs=\"column\" layout=\"row\" class=\"mt-8\" \nng-hide=\"vm.lead.email === null && vm.lead.phone_number === \'\' && vm.lead.idContact.length != 0 || vm.lead.idContact.length != 0\">\n<div flex><md-input-container class=\"md-block\"><label>Email</label><input name=\"lead_email\" ng-model=\"vm.lead.email\" \nplaceholder=\"Email\"></md-input-container></div><div flex><md-input-container class=\"md-block\"><label>Phone Number\n</label><input type=\"text\" name=\"lead_phone_number\" ui-mask=\"{{vm.phoneCode}} 999-999-9999\" restrict=\"reject\" \nng-model=\"vm.lead.phone_number\" placeholder=\"{{vm.phoneCode}} ___-___-____\"></md-input-container></div><div flex \nlayout=\"column\" layout-align=\"start center\"><md-button class=\"md-primary md-raised mt-0 float-right\" \nng-click=\"vm.addContact($event, {\'email\' : vm.lead.email, \'phone_number\' : vm.lead.phone_number});\"><md-icon \nmd-font-icon=\"icon-rotate-3d\"></md-icon>Convert to Contact</md-button></div></div><md-chips class=\"contact-chips\" \nng-model=\"vm.lead.idContact\" md-autocomplete-snap md-require-match=\"true\" md-transform-chip=\"$chip.id\" \nng-hide=\"vm.lead.idContact.length == 0\"><md-autocomplete id=\"contactId\" ng-enter=\"return false;\" \nmd-input-id=\"contactId\" md-selected-item=\"vm.selectedContact\" md-search-text=\"vm.searchContact\" \nmd-items=\"contact in vm.contactQuerySearch(vm.searchContact)\" md-item-text=\"contact.name\" \nplaceholder=\"Add a contact...\"><span md-highlight-text=\"vm.searchContact\">{{contact.email}}</span><md-not-found><a \nng-click=\"vm.closeList(); vm.addContact($event, {\'email\' : vm.searchContact});\">Create Contact \"{{vm.searchContact}}\".\n</a></md-not-found></md-autocomplete><md-chip-template class=\"contact-chip\">\n{{vm.contact.avatar.path = (vm.contacts.getById($chip).avatar.path || vm.crmUrl + \'storage/app/media/profile.jpg\');\"\"}} \n<img class=\"contact-chip-avatar\" ng-src=\"{{vm.contact.avatar.path}}\"><div class=\"contact-text compact\"><h3>\n{{vm.contacts.getById($chip).name}}</h3><p>{{vm.contacts.getById($chip).email}}<br><span \nng-if=\"vm.contacts.getById($chip).mobile_phone1\">{{vm.phoneCode}} {{vm.contacts.getById($chip).mobile_phone1}}</span>\n</p></div></md-chip-template></md-chips></div></div></div></div><div class=\"description\"><md-input-container \nclass=\"md-block\"><label translate=\"SB.DESCRIPTION\">Description</label><textarea name=\"lead_description\" \nng-model=\"vm.lead.description\" columns=\"1\" max-rows=\"4\"></textarea></md-input-container></div></div><div \nrole=\"tabpanel\" id=\"tab2-content\" aria-labelledby=\"tab2\" ng-switch-when=\"1\" md-swipe-left=\"next()\" \nmd-swipe-right=\"previous()\"><md-content><md-card><md-toolbar class=\"md-table-toolbar md-default\" \nng-hide=\"vm.options.rowSelection && vm.selectedProperty.length\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-icon-button md-primary\" aria-label=\"property button\" ng-click=\"vm.toggleWidget(\'property\')\" \nng-if=\"vm.widgetProject\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"icon\"></md-icon><md-tooltip>\nBack to Property List</md-tooltip><md-icon md-font-icon=\"icon-home-variant\" class=\"md-accent-fg icon\" \nng-if=\"vm.widgetProperty\"></md-icon></md-button><md-button class=\"md-icon-button md-accent\" \naria-label=\"property button\" ng-if=\"vm.widgetProperty\"><md-icon md-font-icon=\"icon-home-variant\" class=\"icon\">\n</md-icon></md-button><div class=\"section-header layout-align-start-center layout-row md-primary-fg\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"section-title md-accent-fg text-uppercase\">\n{{vm.project.name || \'All\'}} Properties</span> <span class=\"ml-15 grey-fg\" ng-if=\"vm.project.name\" hide-xs>\n( Please select a property )</span></div><div flex></div><md-menu md-offset=\"0 52\" class=\"mr-10\"><md-button \nclass=\"md-primary\" aria-label=\"property button\" ng-click=\"$mdOpenMenu()\"><md-icon md-font-icon=\"icon-chevron-down\">\n</md-icon><span translate=\"SB.ADD_PROPERTY\" class=\"text-capitalize\">Add Property</span></md-button><md-menu-content \nwidth=\"3\" ms-scroll><md-menu-item><md-input-container class=\"no-errors-spacer\" md-no-float><input \nplaceholder=\"Search project...\" autocomplete=\"off\" type=\"text\" ng-model=\"vm.projectSearchText\" translate \ntranslate-attr-placeholder=\"SB.PROJECT\"></md-input-container></md-menu-item><md-menu-item class=\"member\" \nng-repeat=\"project in vm.projects | filter: vm.filterProject\"><md-button aria-label=\"toggle project\" translate \ntranslate-attr-aria-label=\"SB.PROJECT\" ng-click=\"vm.toggleWidget(\'project\', project.id)\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex><div layout=\"row\" layout-align=\"start center\"><p class=\"member-name\">\n{{ project.name }}</p></div></div></md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar><div \nng-show=\"vm.widgetProperty\"><md-toolbar class=\"md-table-toolbar alternate\" \nng-show=\"vm.options.rowSelection && vm.selectedProperty.length\"><div class=\"md-toolbar-tools\"><span>\n{{vm.selectedProperty.length}} {{vm.selectedProperty.length > 1 ? \'items\' : \'item\'}} selected</span><div flex></div>\n<md-button class=\"md-icon-button\" ng-click=\"vm.deleteSelectedProperties($event)\" aria-label=\"delete selected\" \ntranslate translate-attr-label=\"SB.DELETE_SELECTED\"><md-icon md-font-icon=\"icon-delete white-fg\"></md-icon></md-button>\n</div></md-toolbar><md-table-container ms-scroll><table md-table \nmd-row-select=\"vm.property.length ? vm.options.rowSelection: \'\'\" \nmultiple=\"{{vm.property.length ? vm.options.multiSelect: \'\'}}\" ng-model=\"vm.selectedProperty\" md-progress=\"vm.promise\">\n<thead ng-if=\"!vm.options.decapitate\" md-head md-order=\"vm.query.order\"><tr md-row><th md-column><span>Image</span>\n</th><th md-column md-order-by=\"name\"><span>Name</span></th><th md-column md-order-by=\"project\"><span>Project</span>\n</th><th md-column md-numeric md-order-by=\"discount\"><span>Discount (%)</span></th><th md-column md-numeric \nmd-order-by=\"price\"><span>Price</span></th></tr></thead><tbody md-body><tr md-row md-select=\"property\" \nmd-auto-select=\"vm.options.autoSelect\" \nng-repeat=\"property in vm.property | filter: filter.search | orderBy: vm.query.order | limitTo: vm.query.limit : (vm.query.page -1) * vm.query.limit\" \nng-disabled=\"vm.isDisabled\"><td md-cell>{{vm.plength = (property.photos.length-1);\"\"}} <img class=\"avatar\" \nng-src=\"{{property.photos[vm.plength].path || vm.crmUrl + \'storage/app/media/product-image-placeholder.png\'}}\"></td><td\n md-cell class=\"width-150\"><span>{{property.name}}</span></td><td md-cell class=\"width-120\">\n{{vm.projectName(property.project_id)}}</td><td md-cell><md-input-container class=\"md-block\"><input ui-number-mask \naria-label=\"label\" ng-model=\"property.pivot.discount\" repeat=\"5\"></md-input-container></td><td md-cell>\n<md-input-container class=\"md-block\"><input ui-number-mask aria-label=\"label\" ng-model=\"property.pivot.price\">\n</md-input-container></td></tr><tr md-row ng-if=\"vm.property.length === 0\"><td md-cell colspan=\"5\" align=\"center\"><div \nclass=\"text-italic text-center\">No results found</div></td></tr></tbody></table></md-table-container><div \nclass=\"due-date\" layout=\"row\" layout-align=\"start center\"><label>Due Date</label><md-datepicker name=\"date_close\" \nmd-position-mode=\"target-left target\" ms-datepicker-fix ng-model=\"vm.lead.opportunity.date_close\" \nmd-placeholder=\"Due Date\"></md-datepicker></div><md-table-pagination md-limit=\"vm.query.limit\" \nmd-limit-options=\"vm.limitOptions\" md-page=\"vm.query.page\" md-total=\"{{vm.property.length}}\" \nmd-page-select=\"vm.options.pageSelect\" md-boundary-links=\"vm.options.boundaryLinks\"></md-table-pagination></div><div \nng-show=\"vm.widgetProject\"><md-toolbar class=\"md-table-toolbar alternate\" \nng-show=\"vm.options.rowSelection && vm.selectedProperty.length\"><div class=\"md-toolbar-tools\"><span>\n{{vm.selectedProperty.length}} {{vm.selectedProperty.length > 1 ? \'items\' : \'item\'}} selected</span><div flex></div>\n<md-button class=\"md-accent-bg\" ng-click=\"vm.addSelectedProperties($event)\" aria-label=\"add selected\" translate \ntranslate-attr-label=\"SB.ADD_PROPERTY\"><md-icon md-font-icon=\"icon-plus white-fg\"></md-icon><span \ntranslate=\"SB.ADD_PROPERTY\" class=\"text-capitalize\">Add Property</span></md-button></div></md-toolbar>\n<md-table-container><table md-table md-row-select=\"vm.project.property.length ? vm.options.rowSelection: \'\'\" \nmultiple=\"{{vm.project.property.length ? vm.options.multiSelect: \'\'}}\" ng-model=\"vm.selectedProperty\" \nmd-progress=\"vm.promise\" ng-disabled=\"vm.isDisabled\"><thead ng-if=\"!vm.options.decapitate\" md-head \nmd-order=\"vm.query.order\"><tr md-row><th md-column><span>Image</span></th><th md-column md-order-by=\"name\"><span>Name\n</span></th><th md-column md-numeric md-order-by=\"discount\"><span>Discount (%)</span></th><th md-column md-numeric \nmd-order-by=\"price\"><span>Price</span></th></tr></thead><tbody md-body><tr md-row md-select=\"property\" \nmd-auto-select=\"vm.options.autoSelect\" \nng-repeat=\"property in vm.project.property | filter: filter.search | orderBy: vm.query.order | limitTo: vm.query.limit : (vm.query.page -1) * vm.query.limit\" \nng-disabled=\"vm.isSelected(property.id)\"><td md-cell>{{vm.plength = (property.photos.length-1);\"\"}} <img \nclass=\"avatar\" \nng-src=\"{{property.photos[vm.plength].path || vm.crmUrl + \'storage/app/media/product-image-placeholder.png\'}}\"></td><td\n md-cell>{{property.name}}</td><td md-cell>{{property.discount}}%</td><td md-cell>{{property.price}}</td></tr><tr \nmd-row ng-if=\"vm.project.property.length === 0\"><td md-cell colspan=\"5\" align=\"center\"><div \nclass=\"text-italic text-center\">No results found</div></td></tr></tbody></table></md-table-container>\n<md-table-pagination md-limit=\"vm.query.limit\" md-limit-options=\"vm.limitOptions\" md-page=\"vm.query.page\" \nmd-total=\"{{vm.project.property.length}}\" md-page-select=\"vm.options.pageSelect\" \nmd-boundary-links=\"vm.options.boundaryLinks\"></md-table-pagination></div></md-card></md-content><div class=\"mt-30\" \nlayout=\"row\" layout-align=\"space-between start\"><div flex><md-input-container class=\"md-accent-fg md-block\"><label \ntranslate=\"SB.PRICE\">Price</label><md-icon md-font-icon=\"icon-tag-text-outline\" class=\"md-accent-fg icon\"></md-icon>\n<input name=\"price\" ui-number-mask aria-label=\"label\" ng-model=\"vm.lead.opportunity.price\" class=\"md-accent-fg\" \ndisabled=\"disabled\"></md-input-container></div><div flex><md-input-container class=\"md-block\"><label \ntranslate=\"SB.STATUS\">Status</label><md-icon md-font-icon=\"icon-information-outline\" class=\"md-accent-fg icon\">\n</md-icon><md-select ng-model=\"vm.lead.opportunity.status_id\" class=\"md-accent-fg\" name=\"status_id\" id=\"province\" \naria-label=\"select\" placeholder=\"Please select status\" md-no-asterisk=\"false\" ng-disabled=\"vm.isDisabled\"><md-option \nng-repeat=\"obj in vm.opportunity_status\" ng-value=\"{{obj.id}}\">{{obj.value}}</md-option></md-select>\n</md-input-container></div></div><div layout-xs=\"column\" layout=\"row\"><div flex><md-input-container class=\"md-block\">\n<label translate=\"SB.DESCRIPTION\">Description</label><textarea ng-model=\"vm.lead.opportunity.description\" \nname=\"description\" columns=\"1\" max-rows=\"4\"></textarea></md-input-container></div><div flex><md-input-container \nclass=\"md-block\"><label translate=\"SB.REASON\">Reason</label><textarea ng-model=\"vm.lead.opportunity.reason\" \nname=\"reason\" columns=\"1\" max-rows=\"4\"></textarea></md-input-container></div></div><div id=\"invoice\" \nclass=\"compact page-layout blank\" layout=\"row\"><div class=\"invoice-container\"><div class=\"card md-whiteframe-8dp\" \nmd-scroll-y><div class=\"header\"><div class=\"invoice-date\">{{vm.invoice.date}}</div><div layout=\"row\" \nlayout-align=\"space-between stretch\"><div class=\"client\"><div class=\"invoice-number\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"title\">INVOICE</span> <span class=\"number\">{{vm.invoice.number}}</span></div>\n<div class=\"due-date\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">DUE DATE</span> <span class=\"date\">\n{{vm.invoice.dueDate}}</span></div><div class=\"info\"><div class=\"title\">{{vm.invoice.client.title}}</div><div \nng-if=\"vm.invoice.client.address\" class=\"address\">{{vm.invoice.client.address}}</div><div \nng-if=\"vm.invoice.client.phone\" class=\"phone\">{{vm.invoice.client.phone}}</div><div ng-if=\"vm.invoice.client.email\" \nclass=\"email\">{{vm.invoice.client.email}}</div><div ng-if=\"vm.invoice.client.website\" class=\"website\">\n{{vm.invoice.client.website}}</div></div></div><div class=\"issuer md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"center center\">AE</div><div class=\"info\"><div \nclass=\"title\">{{vm.invoice.from.title}}</div><div ng-if=\"vm.invoice.from.address\" class=\"address\">\n{{vm.invoice.from.address}}</div><div ng-if=\"vm.invoice.from.phone\" class=\"phone\">{{vm.invoice.from.phone}}</div><div \nng-if=\"vm.invoice.from.email\" class=\"email\">{{vm.invoice.from.email}}</div><div ng-if=\"vm.invoice.from.website\" \nclass=\"website\">{{vm.invoice.from.website}}</div></div></div></div></div><div class=\"content\"><table \nclass=\"simple invoice-table\"><thead><th class=\"width-100\">Image</th><th>Name</th><th>Project</th><th \nclass=\"text-right\">Discount (%)</th><th class=\"text-right\">Price</th></thead><tbody><tr \nng-repeat=\"property in vm.property | filter: filter.search | orderBy: vm.query.order | limitTo: vm.query.limit : (vm.query.page -1) * vm.query.limit\">\n<td>{{vm.plength = (property.photos.length-1);\"\"}} <img class=\"avatar\" \nng-src=\"{{property.photos[vm.plength].path || vm.crmUrl + \'storage/app/media/product-image-placeholder.png\'}}\"></td>\n<td><div class=\"title\">{{property.name}}</div></td><td>{{vm.projectName(property.project_id)}}</td><td \nclass=\"text-right\">{{property.pivot.discount}}</td><td class=\"text-right\">{{property.pivot.price}}</td></tr></tbody>\n</table><table class=\"simple invoice-table-footer\"><tbody><tr class=\"subtotal\"><td>SUBTOTAL</td><td>\n₱ {{vm.invoice.subtotal}}</td></tr><tr class=\"tax\"><td>TAX</td><td>₱ {{vm.invoice.tax}}</td></tr><tr class=\"discount\">\n<td>DISCOUNT</td><td>- ₱ {{vm.invoice.discount}}</td></tr><tr class=\"total\"><td>TOTAL</td><td>₱ {{vm.invoice.total}}\n</td></tr></tbody></table></div><div class=\"footer\"><div class=\"note\">\nPlease pay within 15 days. Thank you for your business.</div><div layout=\"row\" layout-align=\"start start\"><div \nclass=\"logo md-accent-bg\" layout=\"row\" layout-align=\"center center\"><div>AE</div></div><div class=\"small-note\">\nIn condimentum malesuada efficitur. Mauris volutpat placerat auctor. Ut ac congue dolor. Quisque scelerisque lacus sed feugiat fermentum. Cras aliquet facilisis pellentesque. Nunc hendrerit quam at leo commodo, a suscipit tellus dapibus. Etiam at felis volutpat est mollis lacinia. Mauris placerat sem sit amet velit mollis, in porttitor ex finibus. Proin eu nibh id libero tincidunt lacinia et eget eros.\n</div></div></div></div><div class=\"page-break\"></div></div></div></div><div role=\"tabpanel\" id=\"tab3-content\" \naria-labelledby=\"tab3\" ng-switch-when=\"2\" md-swipe-left=\"next()\" md-swipe-right=\"previous()\"><div \nng-if=\"vm.lead.activity_type\" ng-model=\"vm.lead.activity_type\" class=\"section\" \nng-repeat=\"(key, checklist) in vm.lead.activity_type\"><div class=\"checklist\"><div class=\"section-header\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"s18\" ng-class=\"checklist.icon\"></i> <span flex class=\"section-title\">\n{{checklist.type}}</span></div><div class=\"pb-10\" id=\"activity-style__01\"><div class=\"check-items\"><div \nclass=\"check-item ph-16\" ng-repeat=\"checkItem in checklist.activity_items\" layout=\"row\" \nlayout-align=\"space-between center\" ng-class=\"{\'grey-200-bg\':(checkItem.status_id==vm.completed_id)}\">\n{{vm.checked = (checkItem.status_id==vm.completed_id);\"\"}} {{status_id = checkItem.status_id === vm.completed_id ? vm.incompleted_id : vm.completed_id;\"\"}}\n<md-checkbox ng-model=\"vm.checked\" \nng-change=\"vm.updateCheckedCount(checklist); checkItem.status_id=status_id; vm.saveActivity()\" \naria-label=\"{{checkItem.subject}}\" ng-hide=\"editCheckItemForm.$visible\">{{checkItem.subject}}</md-checkbox><span flex \neditable-text=\"checkItem.subject\" onaftersave=\"vm.saveActivity()\" ng-show=\"editCheckItemForm.$visible\" \ne-form=\"editCheckItemForm\"></span><md-select ng-model=\"checkItem.status_id\" ng-change=\"vm.saveActivity()\" \nclass=\"simplified\" aria-label=\"select\" placeholder=\"Please select status\" ng-disabled=\"vm.isDisabled\"><md-option \nng-repeat=\"obj in vm.acitivity_status\" ng-value=\"{{obj.id}}\">{{obj.value}}</md-option></md-select><md-datepicker \nmd-position-mode=\"target-left target\" ms-datepicker-fix ng-model=\"checkItem.date_deadline\" \nng-change=\"vm.saveActivity()\" md-placeholder=\"Reminder\"></md-datepicker><md-menu \nmd-position-mode=\"target-right target\" class=\"options\" ms-scroll><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\" aria-label=\"options\" translate translate-attr-aria-label=\"SB.OPTIONS\"><md-icon \nmd-menu-origin md-font-icon=\"icon-dots-vertical\" class=\"s20\"></md-icon></md-button><md-menu-content \nclass=\"options-menu-content\"><md-menu-item><md-button \nng-click=\"vm.removeChecklistItem(checkItem, checklist.activity_items, \'activity\');\" aria-label=\"Remove\" translate \ntranslate-attr-aria-label=\"SB.REMOVE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span translate=\"SB.REMOVE\">Remove\n</span></md-button></md-menu-item><md-menu-divider role=\"separator\"></md-menu-divider><md-menu-item class=\"label\" \nng-repeat=\"priority in vm.priority | filter: vm.filterLabel\"><md-button class=\"label-toggle-button\" \nng-class=\"\'md-\'+ priority.color +\'-bg\'\" ng-model=\"checkItem.priority_id\" \nng-click=\"checkItem.priority_id = priority.id; vm.saveActivity();$mdCloseMenu()\" aria-label=\"Toggle Label\" translate \ntranslate-attr-aria-label=\"SB.TOGGLE_LABEL\"><md-icon md-font-icon=\"icon-label\" ng-class=\"color +\'-500-fg\'\" \nng-if=\"priority.id === checkItem.priority_id\"></md-icon><md-icon md-font-icon=\"icon-label-outline\" \nng-if=\"priority.id !== checkItem.priority_id\"></md-icon><span ng-class=\"color +\'-500-fg\'\" \nng-if=\"priority.id === checkItem.priority_id\">{{priority.value}}</span> <span \nng-if=\"priority.id !== checkItem.priority_id\">{{priority.value}}</span></md-button></md-menu-item></md-menu-content>\n</md-menu></div></div><div class=\"pv-10\" layout=\"row\" layout-align=\"start center\"><md-input-container \nclass=\"no-errors-spacer\" flex><label><i class=\"icon-plus s18\"></i> <span>Create {{checklist.type}}</span></label><input\n type=\"text\" autocomplete=\"off\" ng-model=\"vm[checklist.id].newCheckItem\"></md-input-container><md-button \nclass=\"md-raised md-accent\" aria-label=\"Add\" translate translate-attr-aria-label=\"SB.ADD\" \nng-click=\"vm.addCheckItem(vm[checklist.id].newCheckItem, key);vm[checklist.id].newCheckItem = \'\'\"><span \ntranslate=\"SB.ADD\">Create</span></md-button></div></div></div></div></div><div role=\"tabpanel\" id=\"tab4-content\" \naria-labelledby=\"tab4\" ng-switch-when=\"3\" md-swipe-left=\"next()\" md-swipe-right=\"previous()\"><div \nng-if=\"vm.lead.revision_history[0]\" class=\"section\"><div class=\"activities\"><div class=\"section-header\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon-format-list-bulleted s18\"></i> <span class=\"section-title\" \ntranslate=\"SB.HISTORY\">History</span></div><div class=\"section-content\"><div class=\"activity\" layout=\"row\" \nlayout-align=\"start center\" ng-repeat=\"history in vm.lead.revision_history\"><i class=\"icon-blur s18\"></i><div \nclass=\"activity-member-name\">{{vm.board.members.getById(history.idMember).name}}</div><div class=\"activity-message\">\n{{history.field}} = {{history.old_value}} to {{history.new_value}}</div><div class=\"activity-time secondary-text\">\n{{history.time}}</div></div></div></div></div></div><div role=\"tabpanel\" id=\"tab5-content\" aria-labelledby=\"tab5\" \nng-switch-when=\"4\" md-swipe-left=\"next()\" md-swipe-right=\"previous()\"><div class=\"form-content\" \nng-if=\"vm.board.is_remark\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon-twitch s18\"></i> <span class=\"section-title\">Add Remark</span></div><div layout=\"column\" \nng-repeat=\"customfield in vm.customfields\"><md-input-container class=\"md-block\"><label>{{customfield.field_label}}\n</label><input name=\"{{customfield.field_name}}\" type=\"{{customfield.field_type}}\" \nng-if=\"customfield.field_type == \'text\' || customfield.field_type == \'email\'\" ng-model=\"vm.remark[customfield.id]\" \nstep=\"0.00\"> <input name=\"{{customfield.field_name}}\" ui-number-mask aria-label=\"label\" \nng-if=\"customfield.field_type == \'number\'\" ng-model=\"vm.remark[customfield.id]\"><textarea \nname=\"{{customfield.field_name}}\" ng-if=\"customfield.field_type == \'textarea\'\" ng-model=\"vm.remark[customfield.id]\">\n</textarea></md-input-container></div></div><div ng-if=\"vm.lead.remarks[0]\" class=\"section\"><div class=\"activities\">\n<div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-format-list-bulleted s18\"></i> \n<span class=\"section-title\">History</span></div><table class=\"simple font-size-12\"><thead><tr><th>Date</th><th>Board\n</th><th>Status</th><th>Remarks</th></tr></thead><tbody><tr ng-repeat=\"remark in vm.lead.remarks\"><td>\n{{remark.created_at}}</td><td>{{remark.board_title}}</td><td>{{remark.status_title}}</td><td><span \nng-repeat=\"value in remark.values\"><span class=\"activity-message\"><b>{{value.field_name}}</b>: {{value.value}}</span>\n&nbsp;&nbsp;</span></td></tr></tbody></table></div></div></div></ng-switch></ui-view></md-content></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n</div><div layout=\"row\"><md-button type=\"submit\" ng-click=\"vm.saveLead();\" class=\"send-button md-accent md-raised\" \nng-disabled=\"(leadForm.$invalid || leadForm.$pristine)\" aria-label=\"SAVE\" ng-if=\"btnSave === \'yes0\'\" \nui-sref-opts=\"{reload: true}\"><md-icon md-menu-origin md-font-icon=\"icon-share\"></md-icon>SAVE</md-button><md-button \ntype=\"submit\" ng-click=\"vm.saveLead(); vm.addActivity($event, btnSave);\" class=\"send-button md-accent md-raised\" \nng-disabled=\"(leadForm.price.$invalid || leadForm.price.$pristine) && (leadForm.status_id.$invalid || leadForm.status_id.$pristine) && (leadForm.description.$invalid || leadForm.description.$pristine) && (leadForm.reason.$invalid || leadForm.reason.$pristine) && (leadForm.date_close.$invalid || leadForm.date_close.$pristine)\" \naria-label=\"SAVE\" ng-if=\"btnSave === \'yes1\'\"><md-icon md-menu-origin md-font-icon=\"icon-share\"></md-icon>SAVE\n</md-button><md-button type=\"submit\" ng-click=\"vm.saveRemark(vm.remark);\" class=\"send-button md-accent md-raised\" \naria-label=\"SAVE\" ng-if=\"btnSave === \'yes5\'\"><md-icon md-menu-origin md-font-icon=\"icon-share\"></md-icon>SAVE\n</md-button></div></md-dialog-actions></form></md-dialog><script type=\"text/ng-template\" id=\"dialog.html\">\n<md-dialog style=\"width: 300px;\">\r\n        <md-toolbar>\r\n            <div class=\"md-toolbar-tools\">Would you like to add To-Do Task?</div>\r\n        </md-toolbar>\r\n        \r\n        <form name=\"taskForm\" ng-submit=\"dialog.submit(vm.task.name, vm.task.activity_type, vm.task);\">\r\n            <md-dialog-content layout-padding>\r\n\r\n                <div class=\"form-content\">\r\n                    <br />\r\n\r\n                    <div layout=\"column\">\r\n\r\n                        <md-input-container class=\"no-margin mt-10\">\r\n                            <label>Task Name</label>\r\n                            <input name=\"title\" ng-model=\"vm.task.name\" required md-autofocus>\r\n                        </md-input-container>\r\n\r\n                    </div>\r\n\r\n                    <div layout=\"column\">\r\n\r\n                        <md-input-container class=\"md-block\">\r\n                            <md-select ng-model=\"vm.task.activity_type\"\r\n                                    class=\"simplified\"\r\n                                    aria-label=\"select\"\r\n                                    placeholder=\"Select type\"\r\n                                    required>\r\n                                <md-option ng-repeat=\"(key, obj) in dialog.activity_type\" ng-value=\"{{key}}\">\r\n                                    {{obj.type}}\r\n                                </md-option>\r\n                            </md-select>\r\n                        </md-input-container>\r\n\r\n                    </div>\r\n\r\n                    <div layout=\"column\">\r\n\r\n                        <md-input-container class=\"md-block\">\r\n                            <md-datepicker ms-datepicker-fix ng-model=\"vm.task.date_deadline\"\r\n                                           md-placeholder=\"Reminder\"\r\n                                           class=\"no-margin\">\r\n                            </md-datepicker>\r\n                        </md-input-container>\r\n\r\n                    </div>\r\n\r\n                </div>\r\n\r\n            </md-dialog-content>\r\n\r\n            <div class=\"md-actions\">\r\n                <md-button aria-label=\"Close dialog\" ng-click=\"dialog.close()\" class=\"md-primary\">\r\n                    Cancel\r\n                </md-button>\r\n        \r\n                <md-button class=\"md-accent md-raised\" type=\"submit\"\r\n                           ng-disabled=\"taskForm.$invalid || taskForm.$pristine\" aria-label=\"Add\">\r\n                    Add\r\n                </md-button>\r\n            </div>\r\n\r\n        </form>\r\n    </md-dialog>\n</script><script type=\"text/ng-template\" id=\"contact.html\">\n<md-dialog style=\"z-index:5001; width: 300px;\">\r\n        <md-toolbar>\r\n            <div class=\"md-toolbar-tools\">{{contact.dContact.id ? \"Merge contact\": \"Add a contact\"}}</div>\r\n        </md-toolbar>\r\n        \r\n        <form name=\"contactForm\" ng-submit=\"contact.submit(contact.dContact);\">\r\n            <md-dialog-content layout-padding>\r\n\r\n                <div class=\"form-content\">\r\n                    <br />\r\n\r\n                    <div layout=\"column\">\r\n\r\n                        <md-input-container class=\"no-margin mt-10\">\r\n                            <label>First name</label>\r\n                            <input name=\"first_name\" ng-model=\"contact.dContact.first_name\" required>\r\n                        </md-input-container>\r\n\r\n                    </div>\r\n\r\n                    <div layout=\"column\">\r\n\r\n                        <md-input-container class=\"no-margin mt-10\">\r\n                            <label>Last name</label>\r\n                            <input name=\"last_name\" ng-model=\"contact.dContact.last_name\">\r\n                        </md-input-container>\r\n\r\n                    </div>\r\n\r\n                    <div layout=\"column\">\r\n\r\n                        <md-input-container class=\"no-margin mt-10\">\r\n                            <label>Email</label>\r\n                            <input name=\"email\" id=\"email\" ng-model=\"contact.dContact.email\" required md-autofocus>\r\n                        </md-input-container>\r\n\r\n                    </div>\r\n            \r\n                    <div layout=\"column\">\r\n                \r\n                        <md-input-container class=\"md-block\">\r\n                            <label translate=\"SB.MOBILE_1\">Mobile phone 1</label>\r\n                            <input type=\"text\" name=\"mobile_phone1\" ui-mask=\"{{contact.phoneCode}} 999-999-9999\" restrict=\"reject\" ng-model=\"contact.dContact.mobile_phone1\" placeholder=\"{{contact.phoneCode}} ___-___-____\">\r\n                        </md-input-container>\r\n\r\n                    </div>\r\n            \r\n                    <div layout=\"column\">\r\n                \r\n                        <md-input-container class=\"md-block\">\r\n                            <label translate=\"SB.MOBILE_2\">Mobile phone 2</label>\r\n                            <input type=\"text\" name=\"mobile_phone2\" ui-mask=\"{{contact.phoneCode}} 999-999-9999\" restrict=\"reject\" ng-model=\"contact.dContact.mobile_phone2\" placeholder=\"{{contact.phoneCode}} ___-___-____\">\r\n                        </md-input-container>\r\n\r\n                    </div>\r\n\r\n                </div>\r\n\r\n            </md-dialog-content>\r\n\r\n            <div class=\"md-actions\">\r\n                <md-button aria-label=\"Close dialog\" ng-click=\"contact.close()\" class=\"md-primary\">\r\n                    Cancel\r\n                </md-button>\r\n                \r\n                <md-button class=\"md-accent md-raised\" type=\"submit\"\r\n                           ng-disabled=\"contactForm.$invalid || contactForm.$pristine\" aria-label=\"Add\">\r\n                    {{contact.dContact.id ? \"Merge\": \"Add\"}}\r\n                </md-button>\r\n            </div>\r\n\r\n        </form>\r\n    </md-dialog>\n</script>");
$templateCache.put("app/main/apps/scrumboard/directives/ms-sb-add-lead/ms-sb-add-lead.html","<div class=\"ms-sb-add-lead-form-wrapper\"><form ng-submit=\"vm.addNewLead()\" class=\"ms-sb-add-lead-form\" layout=\"column\" \nnovalidate><md-input-container flex md-no-float><input placeholder=\"Lead title\" type=\"text\" autocomplete=\"off\" \nng-model=\"vm.newLeadName\" translate-attr-placeholder=\"SB.LEAD_TITLE\" required autofocus></md-input-container><div \nlayout=\"row\" layout-align=\"space-between center\"><md-button type=\"submit\" class=\"add-button md-accent md-raised\" \naria-label=\"add\" translate-attr-aria-label=\"SB.ADD\"><span translate=\"SB.ADD\">Add</span></md-button></div></form></div>");
$templateCache.put("app/main/apps/scrumboard/sidenavs/filters/filters-sidenav.html","<md-toolbar class=\"md-accent\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><span flex \nclass=\"menu-title\" translate=\"SB.FILTER_LEADS\">Filter Leads</span><md-button ng-if=\"vm.filteringIsOn()\" \nng-click=\"vm.clearFilters()\" class=\"md-icon-button\" aria-label=\"clear filters\"><md-icon \nmd-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip><span translate=\"SB.CLEAR_FILTER\">Clear Filters</span>\n</md-tooltip></md-button></div></md-toolbar><md-content class=\"\" ms-scroll><md-list><md-subheader class=\"md-no-sticky\" \ntranslate=\"SB.FILTER_BY_LEAD_NAME\">Filter by Lead Name</md-subheader><md-list-item><input flex \nplaceholder=\"Type Lead Name\" type=\"text\" ng-model=\"vm.leadFilters.name\" translate \ntranslate-attr-placeholder=\"SB.TYPE_LEAD_NAME\"></md-list-item><md-divider></md-divider></md-list></md-content>");
$templateCache.put("app/main/apps/scrumboard/sidenavs/settings/settings-sidenav.html","<md-toolbar class=\"md-accent\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><md-button \nng-hide=\"vm.selectedMenu === \'Settings\'\" class=\"md-icon-button\" ng-click=\"vm.selectedMenu = \'Settings\'\" \naria-label=\"back\" translate translate-attr-aria-label=\"SB.BACK\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon>\n</md-button><span flex class=\"menu-title\">{{vm.selectedMenu}}</span></div></md-toolbar><md-content \nng-show=\"vm.selectedMenu === \'Settings\'\" class=\"animate-slide-right settings\" ms-scroll ms-sidenav-helper>\n{{vm.isDisabled = (!role.permissions.write && vm.board.user_id === null && vm.board.permission != \'modify\'); \"\"}}\n<md-list><md-list-item class=\"item\" ng-click=\"vm.selectedMenu = \'Stages\'\" aria-label=\"inbox\" \nng-disabled=\"vm.isDisabled\" ng-class=\"{\'grey-fg\': vm.isDisabled}\"><md-icon md-font-icon=\"icon-poll\" class=\"s18\">\n</md-icon><p class=\"title\" translate=\"SB.STAGES\">Stages</p></md-list-item><md-list-item class=\"item\" \naria-label=\"inbox\" ng-click=\"vm.selectedMenu = \'Groups\'\" ng-disabled=\"vm.isDisabled\" \nng-class=\"{\'grey-fg\': vm.isDisabled}\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"s18\" \nng-class=\"{\'grey-fg\': vm.isDisabled}\"></md-icon><p class=\"title\">Groups</p></md-list-item><md-list-item sclass=\"item\" \nng-click=\"vm.board.is_remark = !vm.board.is_remark; vm.saveUser();\" ng-disabled=\"vm.isDisabled\" \nng-class=\"{\'grey-fg\': vm.isDisabled}\"><md-icon md-font-icon=\"icon-twitch\" class=\"s18\" \nng-class=\"{\'grey-fg\': vm.isDisabled}\"></md-icon><p flex class=\"title\">Add Remark</p><md-icon \nng-show=\"vm.board.is_remark\" md-font-icon=\"icon-check\" class=\"s18\"></md-icon></md-list-item><md-divider></md-divider>\n<md-list-item sclass=\"item\" ui-sref=\"app.scrumboard.boards.board.rules\" ng-disabled=\"vm.isDisabled\" \nng-class=\"{\'grey-fg\': vm.isDisabled}\"><md-icon md-font-icon=\"icon-clipboard-text\" class=\"s18\" \nng-class=\"{\'grey-fg\': !role.permissions.write}\"></md-icon><p flex class=\"title\">Lead Assignment Rules</p>\n</md-list-item><md-divider></md-divider><md-list-item class=\"item\" \nng-click=\"vm.deleteDataConfirm(ev, vm.board, \'boards\')\" ng-disabled=\"vm.isDisabled\" \nng-class=\"{\'grey-fg\': vm.isDisabled}\"><md-icon md-font-icon=\"icon-delete\" class=\"s18\" \nng-class=\"{\'grey-fg\': vm.isDisabled}\"></md-icon><p class=\"title\" translate=\"SB.DELETE_BOARD\">Delete Board</p>\n</md-list-item></md-list></md-content><md-content ng-if=\"!vm.isDisabled\" ng-show=\"vm.selectedMenu === \'Stages\'\" \nclass=\"animate-slide-left stages\"><div layout=\"column\" layout-fill \nng-include=\"\'app/main/apps/scrumboard/sidenavs/settings/menus/stages/stages-menu.html\'\" \nng-controller=\"StagesMenuController as vm\"></div></md-content><md-content ng-if=\"!vm.isDisabled\" \nng-show=\"vm.selectedMenu === \'Groups\'\" class=\"animate-slide-left groups\"><div layout=\"column\" layout-fill \nng-include=\"\'app/main/apps/scrumboard/sidenavs/settings/menus/groups/groups-menu.html\'\" \nng-controller=\"GroupsMenuController as vm\"></div></md-content>");
$templateCache.put("app/main/apps/scrumboard/views/assignment-rule/assignment-rule.html","<div id=\"assignment-rule\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"center\" layout=\"column\" flex>\n<div class=\"header\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button md-button m-0 p-0\" \nui-sref=\"app.scrumboard.boards.board({isNew: false, newLeadId: null})\" ui-sref-opts=\"{reload: true}\" \naria-label=\"Back To Board\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><span class=\"h3\">\nAssignment Rules</span></div><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-bproject hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" \ndt-options=\"vm.dtOptions\" md-progress=\"promise\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Board Stages</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Rule Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Action</span></div></th></tr></thead><tbody><tr ng-repeat=\"stage in vm.board.stages\"><td>\n{{stage.value}}</td><td>{{stage.rule ? stage.rule.name:\"---\"}}</td><td class=\"action\"><md-button \nng-if=\"stage.rule != null\" ui-sref=\"app.scrumboard.boards.board.rules.rule({ruleId:stage.rule.id})\" \nclass=\"md-raised md-hue-2 md-accent\" ng-class=\"\'md-\'+vm.board.settings.color+\'-700-bg\'\" aria-label=\"Edit Rule\" \ntranslate><md-icon md-font-icon=\"icon-pencil\"></md-icon><span class=\"ph-8\">Edit</span></md-button><md-button \nng-if=\"stage.rule == null\" class=\"md-raised md-primary\" \nui-sref=\"app.scrumboard.boards.board.rules.createUpdate({userId:vm.data.id,boardId: vm.board.id,boardStatusId:stage.id})\" \naria-label=\"add rule\"><md-icon md-font-icon=\"icon-plus\"></md-icon><span class=\"ph-8\">Add</span></md-button></td></tr>\n</tbody></table></div></div></div></div>");
$templateCache.put("app/main/apps/scrumboard/views/board/board-view.html","<textarea>{{vm.board}}</textarea><div id=\"board\" ng-class=\"vm.board.settings.color+\'-100-bg\'\" ng-model=\"vm.stages\" \nlayout=\"row\"><div class=\"stage-wrapper\" ng-repeat=\"stage in vm.stages track by stage.id\"><div \nclass=\"stage md-whiteframe-1dp\" layout=\"column\"><div class=\"stage-header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"stage-header-name\"><span editable-text=\"stage.value\" \nonaftersave=\"vm.saveUser()\" edit-disabled=\"vm.isDisabled\">{{stage.value}}</span></div><md-menu md-offset=\"0 48px\" \nclass=\"options stage-header-option-button\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" \naria-label=\"Options\" translate translate-attr-aria-label=\"SB.OPTIONS\"><md-icon md-menu-origin \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content class=\"options-menu-content\" width=\"4\">\n<md-menu-item><md-button ng-click=\"vm.removeStage($event, stage, \'board_status\')\" aria-label=\"Remove Stage\" translate \ntranslate-attr-aria-label=\"SB.REMOVE_STAGES\" ng-disabled=\"vm.isDisabled\"><md-icon md-font-icon=\"icon-delete\" \nmd-menu-align-target></md-icon><span translate=\"SB.REMOVE_STAGES\">Remove Stage</span></md-button></md-menu-item>\n<md-menu-item ng-if=\"stage.rule\" ng-show=\"role.permissions.write\"><md-button \nng-click=\"vm.clickEditRule(\'edit\',stage.rule.id)\" aria-label=\"Edit Rule\"><md-icon md-font-icon=\"icon-pencil\" \nmd-menu-align-target></md-icon><span>{{stage.rule.name}}</span></md-button></md-menu-item><md-menu-item \nng-if=\"!stage.rule\" ng-show=\"role.permissions.write\"><md-button ng-click=\"vm.clickEditRule(\'add\',stage.id)\" \naria-label=\"Add Rule\"><md-icon md-font-icon=\"icon-plus\" md-menu-align-target></md-icon><span>Add Rule</span>\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"stage-content\" layout=\"column\"><div \nclass=\"stage-leads\" ui-sortable=\"vm.sortableLeadOptions\" ng-model=\"stage.idLeads\" data-id=\"{{stage.id}}\" ms-scroll><div\n ng-if=\"leadId\" class=\"stage-lead md-whiteframe-2dp\" \nng-repeat=\"leadId in stage.idLeads | filter: vm.leadFilter track by $index\" data-id=\"{{$index}}\"><div \nng-if=\"vm.board.settings.leadCoverImages && vm.board.leads.getById(leadId).idAttachmentCover\" class=\"stage-lead-cover\">\n<img \nng-src=\"{{vm.board.leads.getById(leadId).attachments.getById(vm.board.leads.getById(leadId).idAttachmentCover).src}}\">\n</div><div class=\"stage-lead-details\" ng-click=\"vm.openLeadDialog($event, leadId, vm.data, [])\"><div \nclass=\"stage-lead-sort-handle\"><md-icon md-font-icon=\"icon-cursor-move\" class=\"icon s16\"></md-icon></div>\n{{vm.lead = vm.board.leads.getById(leadId);\"\"}}<div ng-if=\"vm.lead.priority_id\" class=\"stage-lead-labels\" layout=\"row\" \nlayout-wrap>{{color = (vm.lead.priority_id == 1) ? \'red\' : (vm.lead.priority_id == 2) ? \'orange\' : \'blue\'; \"\" }} <span \nclass=\"stage-lead-label\" ng-class=\"\'md-\'+ color +\'-bg\'\"><md-tooltip>\n{{ vm.priorityValue(vm.board.leads.getById(leadId).priority_id) | uppercase}} Priority</md-tooltip></span></div><div \nclass=\"stage-lead-name\">{{vm.board.leads.getById(leadId).name}}</div><div \nng-if=\"vm.board.leads.getById(leadId).idMembers.length > 0\" class=\"stage-lead-members\" layout=\"row\"><div \nclass=\"stage-lead-member\" ng-repeat=\"memberId in vm.board.leads.getById(leadId).idMembers\"><img \nclass=\"stage-lead-member-avatar\" src=\"assets/images/avatars/profile.jpg\"><md-tooltip><div class=\"name\">\n{{ vm.board.members.getById(memberId).name}}</div></md-tooltip></div></div></div><div class=\"stage-lead-footer\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span \nng-if=\"vm.board.leads.getById(leadId).subscribed\" class=\"stage-lead-footer-item\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon-eye s18\"></i></span></div><div layout=\"row\" layout-align=\"end center\"><span \nng-if=\"vm.board.leads.getById(leadId).description !== \'\'\" class=\"stage-lead-footer-item\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-document\" class=\"s18\"></md-icon></span><span \nclass=\"stage-lead-footer-item\" ng-if=\"vm.board.is_remark\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-twitch\" class=\"s18\"></md-icon><md-tooltip><span>\n{{vm.board.leads.getById(leadId).remarks_count}} Remarks</span></md-tooltip></span><span \nclass=\"stage-lead-footer-item\" ng-if=\"vm.board.leads.getById(leadId).attachments\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon-attachment s18\"></i> <span class=\"value\">\n{{vm.board.leads.getById(leadId).attachments.length}}</span> </span><span class=\"stage-lead-footer-item\" \nng-if=\"vm.board.leads.getById(leadId).comments\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-comment s18\">\n</i> <span class=\"value\">{{vm.board.leads.getById(leadId).comments.length}}</span></span></div></div></div></div></div>\n</div></div><div class=\"new-stage-wrapper\" ng-if=\"!vm.isDisabled\"><div class=\"stage new-stage md-whiteframe-1dp\"><span \neditable-text=\"vm.newStageName\" e-form=\"newStageForm\" onaftersave=\"vm.addNewStage(\'stage\')\"></span><md-button \nclass=\"new-stage-form-button\" ng-click=\"newStageForm.$show()\" ng-hide=\"newStageForm.$visible\"><div layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon-plus md-red-bg\"></i> <span translate=\"SB.ADD_A_STAGES\">Add a stages</span>\n</div></md-button></div></div></div>");
$templateCache.put("app/main/apps/scrumboard/views/boards/boards-view.html","<div id=\"boards\" class=\"md-accent-bg\" layout=\"column\" flex><div id=\"board-selector\" layout=\"column\" \nlayout-align=\"start center\" flex><h1 translate=\"SB.BOARD_APP\">Leads</h1><div class=\"board-stage\" layout=\"row\" \nlayout-align=\"center center\" layout-wrap><div class=\"board-stage-item\" ng-repeat=\"board in vm.boards\" \nng-if=\"board.permission != \'none\'\" ui-sref=\"app.scrumboard.boards.board({id:board.id, isNew: false, newLeadId: null})\" \nlayout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-trello\" class=\"icon s64\"></md-icon><div \nclass=\"board-name\">{{board.title}}</div></div><md-menu md-offset=\"160 80\"><div class=\"board-stage-item add-new-board\" \nlayout=\"column\" layout-align=\"center center\" ng-click=\"$mdOpenMenu()\"><md-icon md-font-icon=\"icon-plus-circle\" \nclass=\"icon s64\"></md-icon><div class=\"board-name\" translate=\"SB.ADD_NEW_BOARD\">Add new board</div></div>\n<md-menu-content width=\"3\"><md-menu-item><md-button disabled=\"disabled\">Choose from existing layout</md-button>\n</md-menu-item><md-menu-item ng-repeat=\"(value, boards) in vm.boardsTemplate\" \nui-sref=\"app.scrumboard.boards.addBoard({template:value, company_id:vm.company.id})\"><md-button aria-label=\"value\">\n{{value | ucfirst}}</md-button></md-menu-item></md-menu-content></md-menu></div></div></div>");
$templateCache.put("app/main/apps/scrumboard/views/calendar/calendar-view.html","<div id=\"board-calendar\" class=\"page-layout simple right-sidenav\" flex layout=\"row\" \nng-class=\"vm.board.settings.color+\'-100-bg\'\"><md-sidenav class=\"sidenav scheduled-tasks-sidenav md-sidenav-left\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"scheduled-tasks-sidenav\" \nng-include=\"\'app/main/apps/scrumboard/views/calendar/sidenavs/scheduled-tasks/scheduled-tasks-sidenav.html\'\" ms-scroll \nms-sidenav-helper></md-sidenav><div id=\"calendar\" class=\"md-whiteframe-2dp\" flex layout=\"column\" \nng-class=\"vm.currentMonthShort\"><div class=\"calendar-header\" layout=\"row\" layout-align=\"space-between center\" \nlayout-xs=\"column\"><md-button hide-gt-md class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'scheduled-tasks-sidenav\')\" \naria-label=\"Scheduled Leads Sidenav\"><md-icon md-font-icon=\"icon-calendar-clock\"></md-icon><md-tooltip><span \ntranslate=\"SB.SCHEDULED_LEADS\">Scheduled Leads</span></md-tooltip></md-button><div class=\"\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button arrow\" ng-click=\"vm.calendar.prev()\" \naria-label=\"Previous\" translate translate-attr-aria-label=\"SB.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon></md-button><div class=\"title\">{{vm.calendarView.title}}</div><md-button class=\"md-icon-button arrow\" \nng-click=\"vm.calendar.next()\" aria-label=\"Next\" translate translate-attr-aria-label=\"SB.NEXT\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div><div><md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.today()\" aria-label=\"Today\" translate translate-attr-aria-label=\"SB.TODAY\"><md-icon \nmd-font-icon=\"icon-calendar-today\"></md-icon><md-tooltip><span translate=\"SB.TODAY\">Today</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaDay\')\" aria-label=\"Day\" \ntranslate translate-attr-aria-label=\"SB.DAY\"><md-icon md-font-icon=\"icon-view-day\"></md-icon><md-tooltip><span \ntranslate=\"SB.DAY\">Day</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.changeView(\'agendaWeek\')\" aria-label=\"Week\" translate translate-attr-aria-label=\"SB.WEEK\">\n<md-icon md-font-icon=\"icon-view-week\"></md-icon><md-tooltip><span translate=\"SB.WEEK\">Week</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'month\')\" aria-label=\"Month\" translate \ntranslate-attr-aria-label=\"SB.MONTH\"><md-icon md-font-icon=\"icon-view-module\"></md-icon><md-tooltip><span \ntranslate=\"SB.MONTH\">Month</span></md-tooltip></md-button></div></div><div class=\"calendar-main\" ms-scroll flex \nui-calendar=\"vm.calendarUiConfig.calendar\" ng-model=\"vm.eventSources\" calendar=\"main\"></div></div></div>");
$templateCache.put("app/main/apps/todo/dialogs/task/task-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><md-input-container class=\"md-block\"><label translate=\"TODO.TITLE\">Title</label><input name=\"title\" \nng-model=\"vm.task.subject\" required md-autofocus><div ng-messages=\"taskForm.title.$error\" \nng-show=\"taskForm.title.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"TODO.ERRORS.TITLE_REQUIRED\">\nTitle field is required</span></div></div></md-input-container><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex layout=\"row\" layout-align=\"space-between center\">\n<md-datepicker ms-datepicker-fix ng-model=\"vm.task.date_deadline\" md-placeholder=\"Reminder\"></md-datepicker></div><div \nclass=\"input-block\" flex><md-input-container flex class=\"width-250\"><label>Type</label><md-select \nng-model=\"vm.task.type_id\" ng-required=\"!vm.task.type_id\" class=\"simplified\" aria-label=\"select\" placeholder=\"Type\">\n<md-option ng-repeat=\"obj in vm.activity_type\" ng-value=\"{{obj.id}}\">{{obj.type}}</md-option></md-select>\n</md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div \nclass=\"input-block\" flex><md-input-container flex class=\"width-250\"><label>Status</label><md-select \nng-model=\"vm.task.status_id\" class=\"simplified\" aria-label=\"select\" placeholder=\"Status\"><md-option \nng-repeat=\"obj in vm.activity_status\" ng-value=\"{{obj.id}}\">{{obj.value}}</md-option></md-select></md-input-container>\n</div><div class=\"input-block\" flex layout=\"row\" layout-align=\"space-between center\"><md-input-container flex \nclass=\"width-250\"><label>Priority</label><md-select ng-model=\"vm.task.priority_id\" class=\"simplified\" \naria-label=\"select\" placeholder=\"Priority\"><md-option ng-repeat=\"obj in vm.priority\" class=\"white-fg\" \nng-class=\"\'md-\'+ obj.color +\'-bg\'\" ng-value=\"{{obj.id}}\">{{obj.value}}</md-option></md-select></md-input-container>\n</div></div><div class=\"notes\"><md-input-container class=\"md-block\"><label translate=\"TODO.NOTES\">Notes</label>\n<textarea ng-model=\"vm.task.description\" max-rows=\"4\"></textarea></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button type=\"submit\" ng-if=\"!vm.newTask\" ng-click=\"vm.saveTask()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"taskForm.$invalid || taskForm.$pristine\" aria-label=\"SAVE\" translate=\"TODO.SAVE\" \ntranslate-attr-aria-label=\"TODO.SAVE\">SAVE</md-button><md-button type=\"submit\" ng-if=\"vm.newTask\" \nng-click=\"vm.addNewTask()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"taskForm.$invalid || taskForm.$pristine\" aria-label=\"Add Task\" translate=\"TODO.ADD_TASK\" \ntranslate-attr-aria-label=\"TODO.ADD_TASK\">ADD TASK</md-button></div><div layout=\"row\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.deleteTask($event, \'activity\')\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"TODO.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"TODO.DELETE\">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/todo/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-checkbox-marked\" class=\"s24\"></md-icon>\n</span><span class=\"logo-text\" translate=\"TODO.TO_DO\">To-Do</span></div><div class=\"add-task-button\"><md-button \nclass=\"md-raised\" ng-click=\"vm.openTaskDialog($event)\" aria-label=\"ADD TASK\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon>ADD TASK</md-button></div></div><md-content class=\"content\" flex ms-scroll><div class=\"navigation-simple\" \nlayout=\"column\"><md-button class=\"item\" aria-label=\"All Tasks\" translate translate-attr-aria-label=\"TODO.OPEN_TASKS\" \nng-class=\"{\'selected\':vm.showAllTasks}\" ng-click=\"vm.resetFilters();\"><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-view-headline\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.OPEN_TASKS\">\nOpen Tasks</span></div></md-button><div class=\"item subheader\" translate=\"TODO.FILTERS\">Filters</div><md-button \nclass=\"item\" aria-label=\"Priority\" translate translate-attr-aria-label=\"TODO.PRIORITY\" \nng-click=\"vm.toggleFilterWithEmpty(\'important\')\" ng-class=\"{\'selected\':vm.taskFilters.important}\"><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"s16\"></md-icon><span class=\"title\">Important</span></md-button><md-button \nclass=\"item\" aria-label=\"Done\" translate translate-attr-aria-label=\"TODO.DONE\" ng-click=\"vm.toggleFilter(\'completed\')\" \nng-class=\"{\'selected\':vm.taskFilters.completed}\"><md-icon md-font-icon=\"icon-checkbox-marked-outline\" class=\"s16\">\n</md-icon><span class=\"title\">Completed</span></md-button><md-button class=\"item\" aria-label=\"Deleted\" translate \ntranslate-attr-aria-label=\"TODO.DELETED\" ng-click=\"vm.toggleFilterWithEmpty(\'cancelled\')\" \nng-class=\"{\'selected\':vm.taskFilters.cancelled}\"><md-icon md-font-icon=\"icon-minus-circle-outline\" class=\"s16\">\n</md-icon><span class=\"title\">Cancelled</span></md-button><div class=\"item subheader\">Types</div><md-button \nclass=\"tag item\" aria-label=\"tag {{activity_type.type}}\" ng-repeat=\"activity_type in vm.activity_type\" \nng-click=\"vm.filterByType(activity_type);\" ng-class=\"{\'selected\':vm.taskFilters.type_id == activity_type.id}\"><md-icon \nmd-font-icon=\"icon-label\" class=\"s16\" ng-style=\"{\'color\' : activity_type.color}\"></md-icon><span class=\"title\">\n{{activity_type.type}}</span></md-button></div></md-content>");
$templateCache.put("app/main/apps/todo/views/list/list-view.html","<div class=\"todo-items\" ng-model=\"vm.tasks\"><div class=\"todo-item\" md-ink-ripple layout=\"row\" \nlayout-align=\"start center\" ng-click=\"vm.openTaskDialog($event, task)\" \nng-repeat=\"task in vm.tasks | orderBy:vm.taskOrder:vm.taskOrderDescending | filter:global.search | filter:vm.taskFilters.search | filter:{\'today\': vm.taskFilters.today} | filter:{\'important\': vm.taskFilters.important} | filter:{\'completed\': vm.taskFilters.completed} | filter:{\'cancelled\': vm.taskFilters.cancelled} | filter:{\'type_id\': vm.taskFilters.type_id} | filter: vm.dateFilter(\'date_deadline\', vm.taskFilters.date_deadline) track by $index\" \nng-class=\"{\'selected\': task.selected, \'completed\': (task.status_id==vm.completed_id)}\">\n{{vm.checked = (task.status_id==vm.completed_id);\"\"}}<md-checkbox class=\"no-label\" ng-checked=\"vm.checked\" \nng-click=\"vm.toggleCompleted(task, $event)\" aria-label=\"{{vm.checked ? \'Not completed\' : \'Completed\'}}\"></md-checkbox>\n<div layout=\"row\" layout-align=\"start center\" flex><div class=\"info\" flex><div class=\"title\">{{task.subject}}</div><div\n class=\"notes\">{{task.date_deadline | date:\'yyyy-MM-dd HH:mm:ss\'}}<br>{{task.description}}</div><div class=\"tags\" \nlayout=\"row\" layout-align=\"start center\" layout-wrap><div class=\"tag\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"tag-color\" ng-style=\"{\'background-color\': task.type.color}\"></div><div class=\"tag-label\">{{task.type.type}}\n</div></div></div></div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"is-important red-600-fg\" ng-if=\"task.important\"></md-icon><md-menu><md-button \nclass=\"md-icon-button\" aria-label=\"More\" translate translate-attr-aria-label=\"TODO.MORE\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" ng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button ng-click=\"vm.toggleCompleted(task, $event)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"TODO.TOGGLE_DONE\"><md-icon ng-class=\"vm.checked === false ? \'grey-fg\' : \'blue-fg\'\" \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"s18\"></md-icon><span ng-show=\"!vm.checked\" \ntranslate=\"TODO.MARK_AS_DONE\">Mark as done</span> <span ng-show=\"vm.checked\" translate=\"TODO.MARK_AS_UNDONE\">\nMark as undone</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.toggleImportant(task, $event)\" \naria-label=\"Toggle important\" translate-attr-aria-label=\"TODO.TOGGLE_IMPORTANT\"><md-icon \nng-class=\"task.important === false ? \'grey-fg\' : \'red-600-fg\'\" md-font-icon=\"icon-alert-circle\" class=\"s18\"></md-icon>\n<span ng-show=\"!task.important\" translate=\"TODO.MARK_AS_IMPORTANT\">Mark as important</span> <span \nng-show=\"task.important\" translate=\"TODO.REMOVE_IMPORTANT\">Remove important</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div></div></div>");
$templateCache.put("app/main/pages/profile/tabs/about/about.html","<div layout=\"row\" layout-wrap><div class=\"about\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"65\"><form \neditable-form name=\"$general_info\" onaftersave=\"vm.saveUser()\" novalidate><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"title\" translate=\"PROFILE.GENERAL_INFORMATION\">General Information\n</div><div class=\"secondary-text\"><md-button class=\"md-icon-button\" type=\"button\" aria-label=\"edit\" \nng-click=\"$general_info.$show()\" ng-show=\"!$general_info.$visible\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"md-accent-fg md-hue-1\"></md-icon></md-button><span ng-show=\"$general_info.$visible\"><md-button \nclass=\"md-icon-button\" type=\"submit\" aria-label=\"save\" \nng-disabled=\"$general_info.$waiting || ($general_info.$invalid && $general_info.password.$dirty)\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"md-accent-fg md-hue-1\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" type=\"button\" aria-label=\"cancel\" ng-disabled=\"$general_info.$waiting\" \nng-click=\"$general_info.$cancel()\"><md-icon md-font-icon=\"icon-close-circle\" class=\"icon-cancel\"></md-icon></md-button>\n</span></div></header><div class=\"content\"><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.FIRST_NAME\">\nFirst Name</div><div class=\"info\" editable-text=\"vm.employee.first_name\">{{vm.employee.first_name | label:\'-\'}}</div>\n</div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.LAST_NAME\">Last Name</div><div class=\"info\" \neditable-text=\"vm.employee.last_name\">{{vm.employee.last_name | label:\'-\'}}</div></div><div class=\"info-line\" \nng-show=\"$general_info.$visible\"><div class=\"title\" translate=\"PROFILE.PASSWORD\">Password</div><input \nplaceholder=\"Password\" name=\"password\" ng-model=\"vm.user.password\" ng-model-options=\"{ updateOn: \'blur\' }\" required \ntype=\"password\" pattern=\".{4,14}\"><br><small class=\"hljs-comment\">\nTo reset this users password, enter a new password here.</small><br><small class=\"error-message h6 md-warn-fg\" \nng-show=\"$general_info.password.$invalid && !$general_info.password.$pristine\">Passwords must have at least 4 chars.\n</small><p></p><input placeholder=\"Confirm Password\" name=\"cpassword\" ng-model=\"cpassword\" type=\"password\" \nwj-validation-error=\"vm.user.password && cpassword != vm.user.password\"><br><small class=\"error-message h6 md-warn-fg\" \nng-show=\"$general_info.cpassword.$invalid && !$general_info.cpassword.$pristine\">Sorry, the passwords don\'t match.\n</small></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.GENDER\">Gender</div><div class=\"info\"><span \nng-show=\"!$general_info.$visible\">{{vm.employee.gender | ucfirst}}</span> <span ng-show=\"$general_info.$visible\">\n<md-select aria-label=\"select\" ng-model=\"vm.employee.gender\" class=\"width-180\"><md-option \nng-repeat=\"gender in vm.genders\" value=\"{{gender.value}}\">{{gender.name}}</md-option></md-select></span></div></div>\n<div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.BIRTHDAY\">Birthday</div><div class=\"info\"><span \nng-show=\"!$general_info.$visible\">{{vm.employee.date_birth | dateFormat:\'-\'}}</span> <span \nng-show=\"$general_info.$visible\"><md-datepicker flex ng-model=\"vm.employee.date_birth\" md-placeholder=\"Birthday\">\n</md-datepicker></span></div></div></div></div></form><form editable-form name=\"$work\" onaftersave=\"vm.saveUser()\"><div\n class=\"profile-box info-box work md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"title\" translate=\"PROFILE.WORK\">Work</div><div class=\"secondary-text\">\n<md-button class=\"md-icon-button\" type=\"button\" aria-label=\"edit\" ng-click=\"$work.$show()\" ng-show=\"!$work.$visible\">\n<md-icon md-font-icon=\"icon-pencil\" class=\"md-accent-fg md-hue-1\"></md-icon></md-button><span ng-show=\"$work.$visible\">\n<md-button class=\"md-icon-button\" type=\"submit\" aria-label=\"save\" ng-disabled=\"$work.$waiting\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"md-accent-fg md-hue-1\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" type=\"button\" aria-label=\"cancel\" ng-disabled=\"$work.$waiting\" ng-click=\"$work.$cancel()\">\n<md-icon md-font-icon=\"icon-close-circle\" class=\"icon-cancel\"></md-icon></md-button></span></div></header><div \nclass=\"content\"><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.COMPANY\">Company</div><div class=\"info\">\n{{vm.employee.company.name}}</div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.JOB_TITLE\">\nJob title</div><div class=\"info\" editable-text=\"vm.employee.job_title\">{{vm.employee.job_title | label:\'-\'}}</div>\n</div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.HIREDAY\">Date of hire</div><div class=\"info\"><span \nng-show=\"!$work.$visible\">{{vm.employee.date_hire | dateFormat:\'-\'}}</span> <span ng-show=\"$work.$visible\">\n<md-datepicker flex ng-model=\"vm.employee.date_hire\" md-placeholder=\"Date of hire\"></md-datepicker></span></div></div>\n</div></div></form><form editable-form name=\"$contact\" onaftersave=\"vm.saveUser()\"><div \nclass=\"profile-box info-box work md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"title\" translate=\"PROFILE.CONTACT\">Employee</div><div \nclass=\"secondary-text\"><md-button class=\"md-icon-button\" type=\"button\" aria-label=\"edit\" ng-click=\"$contact.$show()\" \nng-show=\"!$contact.$visible\"><md-icon md-font-icon=\"icon-pencil\" class=\"md-accent-fg md-hue-1\"></md-icon></md-button>\n<span ng-show=\"$contact.$visible\"><md-button class=\"md-icon-button\" type=\"submit\" aria-label=\"save\" \nng-disabled=\"$contact.$waiting || ($contact.$invalid)\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" \nclass=\"md-accent-fg md-hue-1\"></md-icon></md-button><md-button class=\"md-icon-button\" type=\"button\" \naria-label=\"cancel\" ng-disabled=\"$contact.$waiting\" ng-click=\"$contact.$cancel()\"><md-icon \nmd-font-icon=\"icon-close-circle\" class=\"icon-cancel\"></md-icon></md-button></span></div></header><div class=\"content\">\n<div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.SECONDARY_EMAIL\">Secondary Email</div><div class=\"info\" \neditable-email=\"vm.employee.secondary_email\">{{vm.employee.secondary_email | label:\'-\'}}</div></div><div \nclass=\"info-line\"><div class=\"title\" translate=\"PROFILE.TELEPHONE\">Telephone</div><div class=\"info\" \neditable-text=\"vm.employee.telephone\" e-placeholder=\"{{vm.phoneCode}} _-___-____\" \ne-ui-mask=\"{{vm.phoneCode}} 9-999-9999\">{{vm.phoneCode}} {{vm.employee.telephone | label:\'-\' | tel}}</div></div><div \nclass=\"info-line\"><div class=\"title\" translate=\"PROFILE.MOBILE_1\">Mobile phone 1</div><div class=\"info\" \neditable-text=\"vm.employee.mobile_phone1\" e-placeholder=\"{{vm.phoneCode}} ___-___-____\" \ne-ui-mask=\"{{vm.phoneCode}} 999-999-9999\">{{vm.phoneCode}} {{vm.employee.mobile_phone1 | label:\'-\' | tel}}</div></div>\n<div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.MOBILE_2\">Mobile phone 2</div><div class=\"info\" \neditable-text=\"vm.employee.mobile_phone2\" e-placeholder=\"{{vm.phoneCode}} ___-___-____\" \ne-ui-mask=\"{{vm.phoneCode}} 999-999-9999\">{{vm.phoneCode}} {{vm.employee.mobile_phone2 | label:\'-\' | tel}}</div></div>\n<div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.ADDRESS\">Address</div><div class=\"info\" \neditable-textarea=\"vm.employee.address\" e-rows=\"7\" e-cols=\"40\">{{vm.employee.address | label:\'-\'}}</div></div><div \nclass=\"info-line\"><div class=\"title\" translate=\"PROFILE.REGION\">Region</div><div class=\"info\"><span \nng-show=\"!$contact.$visible\">{{vm.region | label:\'-\'}}</span> <span ng-show=\"$contact.$visible\"><md-select \nng-model=\"vm.employee.region_id\" ng-change=\"vm.getRegionProvinces()\" class=\"form-control width-200\" name=\"country\" \nid=\"country\" aria-label=\"select\" placeholder=\"Please select region\"><md-option ng-repeat=\"region in vm.regions\" \nng-value=\"{{region.id}}\">{{region.short_name}}</md-option></md-select></span></div></div><div class=\"info-line\"><div \nclass=\"title\" translate=\"PROFILE.PROVINCE\">Province</div><div class=\"info\"><span ng-show=\"!$contact.$visible\">\n{{vm.province | label:\'-\'}}</span> <span ng-show=\"$contact.$visible\"><md-select ng-model=\"vm.employee.province_id\" \nng-change=\"vm.getProvinceCities()\" ng-required=\"!$contact.country.$pristine\" \nclass=\"form-control width-200 md-no-underline\" name=\"province\" id=\"province\" aria-label=\"select\" \nplaceholder=\"Please select province\" md-no-asterisk=\"false\"><md-option ng-repeat=\"obj in vm.provinces\" \nng-value=\"{{obj.id}}\">{{obj.value}}</md-option></md-select></span></div></div><div class=\"info-line\"><div \nclass=\"title\" translate=\"PROFILE.CITY\">City</div><div class=\"info\"><span ng-show=\"!$contact.$visible\">\n{{vm.city | label:\'-\'}}</span> <span ng-show=\"$contact.$visible\"><md-select ng-model=\"vm.employee.city_id\" \nng-required=\"!$contact.province.$pristine\" class=\"form-control width-200 md-no-underline\" name=\"city\" id=\"city\" \naria-label=\"select\" placeholder=\"Please select city\" md-no-asterisk=\"false\"><md-option ng-repeat=\"obj in vm.cities\" \nng-value=\"{{obj.id}}\">{{obj.value}}</md-option></md-select></span></div></div></div></div></form></div><div \nclass=\"about-sidebar\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"35\"><form editable-form name=\"$social\" \nonaftersave=\"vm.saveUser()\"><div class=\"profile-box info-box work md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title\" translate=\"PROFILE.SOCIAL\">\nSocial</div><div class=\"secondary-text\"><md-button class=\"md-icon-button\" type=\"button\" aria-label=\"edit\" \nng-click=\"$social.$show()\" ng-show=\"!$social.$visible\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"md-accent-fg md-hue-1\"></md-icon></md-button><span ng-show=\"$social.$visible\"><md-button class=\"md-icon-button\" \ntype=\"submit\" aria-label=\"save\" ng-disabled=\"$social.$waiting\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" \nclass=\"md-accent-fg md-hue-1\"></md-icon></md-button><md-button class=\"md-icon-button\" type=\"button\" \naria-label=\"cancel\" ng-disabled=\"$social.$waiting\" ng-click=\"$social.$cancel()\"><md-icon \nmd-font-icon=\"icon-close-circle\" class=\"icon-cancel\"></md-icon></md-button></span></div></header><div class=\"content\">\n<div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.FACEBOOK\">Facebook</div><div class=\"info\" \neditable-text=\"vm.employee.facebook\"><a href=\"{{vm.employee.facebook}}\"><md-icon md-font-icon=\"icon-facebook-box\" \nclass=\"md-accent-fg md-hue-1\"></md-icon></a></div></div><div class=\"info-line\"><div class=\"title\" \ntranslate=\"PROFILE.TWITTER\">Twitter</div><div class=\"info\" editable-text=\"vm.employee.twitter\"><a \nhref=\"{{vm.employee.twitter}}\"><md-icon md-font-icon=\"icon-twitter-box\" class=\"md-accent-fg md-hue-1\"></md-icon></a>\n</div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.GOOGLE\">Google</div><div class=\"info\" \neditable-text=\"vm.employee.google\"><a href=\"{{vm.employee.google}}\"><md-icon md-font-icon=\"icon-google-plus-box\" \nclass=\"md-accent-fg md-hue-1\"></md-icon></a></div></div><div class=\"info-line\"><div class=\"title\" \ntranslate=\"PROFILE.LINKEDIN\">LinkedIn</div><div class=\"info\" editable-text=\"vm.employee.linkedIn\"><a \nhref=\"{{vm.employee.linkedIn}}\"><md-icon md-font-icon=\"icon-linkedin-box\" class=\"md-accent-fg md-hue-1\"></md-icon></a>\n</div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.SKYPE\">Skype</div><div class=\"info\" \neditable-text=\"vm.employee.skype\"><a href=\"{{vm.employee.skype}}\"><md-icon md-font-icon=\"icon-skype\" \nclass=\"md-accent-fg md-hue-1\"></md-icon></a></div></div></div></div></form></div></div>");
$templateCache.put("app/main/pages/profile/tabs/photos-videos/photos-videos.html","<div class=\"photos-videos\"><div class=\"period\" data-ng-repeat=\"period in vm.photosVideos\"><div class=\"period-title\">\n<span class=\"name\">{{period.name}}</span> <span class=\"info\">{{period.info}}</span></div><div class=\"period-media\" \nlayout=\"row\" layout-wrap><div class=\"media\" ng-repeat=\"media in period.media\"><img class=\"preview\" \nng-src=\"{{media.preview}}\" title=\"{{media.title}}\"><div class=\"title\">{{media.title}}</div></div></div></div></div>");
$templateCache.put("app/main/pages/profile/tabs/timeline/timeline.html","<div layout=\"row\" layout-wrap><div class=\"timeline\" layout=\"column\" flex=\"100\" flex-gt-sm=\"55\" flex-gt-md=\"65\" \nflex-order=\"2\" flex-order-gt-sm=\"1\"><div class=\"profile-box add-post md-whiteframe-1dp\"><div class=\"form\" flex>\n<textarea placeholder=\"Write something..\" translate translate-attr-placeholder=\"PROFILE.WRITE_SOMETHING\"></textarea>\n<footer layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button\" aria-label=\"insert photo\" translate translate-attr-aria-label=\"PROFILE.INSERT_PHOTO\"><md-icon \nmd-font-icon=\"icon-file-image-box\"></md-icon><md-tooltip><span translate=\"PROFILE.INSERT_PHOTO\">insert photo</span>\n</md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"add person\" translate \ntranslate-attr-aria-label=\"PROFILE.ADD_PERSON\"><md-icon md-font-icon=\"icon-person-plus\"></md-icon><md-tooltip><span \ntranslate=\"PROFILE.ADD_PERSON\">add person</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \naria-label=\"add location\" translate translate-attr-aria-label=\"PROFILE.LOCATION\"><md-icon \nmd-font-icon=\"icon-map-marker\"></md-icon><md-tooltip><span translate=\"PROFILE.LOCATION\">add location</span>\n</md-tooltip></md-button></div><md-button ng-click=\"\" class=\"post-button md-accent md-raised\" aria-label=\"POST\" \ntranslate=\"PROFILE.POST\" translate-attr-aria-label=\"PROFILE.POST\">POST</md-button></footer></div></div><md-divider>\n</md-divider><div class=\"timeline-item md-whiteframe-1dp\" ng-repeat=\"post in vm.posts\"><header layout=\"row\" \nlayout-align=\"space-between start\"><div class=\"user\" layout=\"row\" layout-align=\"start center\"><img class=\"avatar\" \nng-src=\"{{post.user.avatar}}\"><div layout=\"column\"><div class=\"title\"><span class=\"username md-accent-color\">\n{{post.user.name}}</span> <span ng-if=\"post.type == \'post\'\" translate=\"PROFILE.TYPE_POST\">posted on your timeline\n</span> <span ng-if=\"post.type == \'something\'\" translate=\"PROFILE.TYPE_SOMETHING\">shared something with you</span> \n<span ng-if=\"post.type == \'video\'\" translate=\"PROFILE.TYPE_VIDEO\">shared a video with you</span> <span \nng-if=\"post.type == \'article\'\" translate=\"PROFILE.TYPE_ARTICLE\">shared an article with you</span></div><div \nclass=\"time\">{{post.time}}</div></div></div><md-button class=\"md-icon-button\" aria-label=\"more\" translate \ntranslate-attr-aria-label=\"PROFILE.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></header><div\n class=\"content\"><div ng-if=\"post.message\" class=\"message\">{{post.message}}</div><div ng-if=\"post.media\" class=\"media\">\n<img ng-if=\"post.media.type === \'image\'\" ng-src=\"{{post.media.preview}}\"><div ng-if=\"post.media.type === \'video\'\" \nng-bind-html=\"post.media.embed | toTrusted\"></div></div><div ng-if=\"post.article\" layout=\"column\" class=\"article\"><div \nclass=\"media\"><img ng-src=\"{{post.article.media.preview}}\"></div><div class=\"title\">{{post.article.title}}</div><div \nclass=\"subtitle\">{{post.article.subtitle}}</div><div class=\"excerpt\">{{post.article.excerpt}}</div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"like-button\"><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-heart-outline\" class=\"s16\"></md-icon><span translate=\"PROFILE.LIKE\">Like</span>&nbsp;<span>\n({{post.like}})</span></div></md-button><md-button class=\"share-button\"><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-share\" class=\"s16\"></md-icon><span translate=\"PROFILE.SHARE\">Share</span>&nbsp;<span>\n({{post.share}})</span></div></md-button></div></div><footer class=\"\" layout=\"column\" layout-align=\"start start\"><div \nng-if=\"post.comments\" class=\"comment-count\">{{post.comments.length}} comments<md-icon \nmd-font-icon=\"icon-keyboard_arrow_down\"></md-icon></div><div class=\"comment\" layout=\"row\" layout-fill \nng-repeat=\"comment in post.comments\"><img ng-src=\"{{comment.user.avatar}}\" class=\"avatar\"><div flex layout=\"column\">\n<div layout=\"row\" layout-align=\"start center\"><span class=\"username\">{{comment.user.name}}</span> <span class=\"time\">\n{{comment.time}}</span></div><div class=\"message\">{{comment.message}}</div><div class=\"actions\" layout=\"row\" \nlayout-align=\"space-between center\"><a href=\"#\" class=\"reply-button md-accent-color\" translate=\"PROFILE.REPLY\">Reply\n</a><md-icon flex md-font-icon=\"icon-flag\" class=\"report-button s16\"></md-icon></div></div></div><div class=\"reply\" \nlayout=\"row\" layout-fill><img src=\"assets/images/avatars/profile.jpg\" class=\"avatar\"><form flex><textarea \nplaceholder=\"Add a comment...\" translate translate-attr-placeholder=\"PROFILE.ADD_COMMENT\"></textarea><md-button \nng-click=\"\" class=\"post-comment-button md-accent md-raised\" aria-label=\"Post Comment\" translate=\"PROFILE.POST_COMMENT\" \ntranslate-aria-label=\"PROFILE.POST_COMMENT\">Post Comment</md-button></form></div></footer></div></div><div \nclass=\"timeline-sidebar\" layout=\"column\" flex=\"100\" flex-gt-sm=\"45\" flex-gt-md=\"35\" flex-order=\"1\" \nflex-order-gt-sm=\"2\"><div class=\"profile-box latest-activity md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title\" \ntranslate=\"PROFILE.LATEST_ACTIVITY\">Latest Activity</div><div class=\"more secondary-text\" translate=\"PROFILE.SEE_ALL\">\nSee All</div></header><div class=\"content\" layout=\"row\" layout-wrap><div class=\"activities\"><div class=\"activity\" \nlayout=\"row\" layout-align=\"start start\" ng-repeat=\"activity in vm.activities\"><img ng-src=\"{{activity.user.avatar}}\" \nclass=\"avatar\" alt=\"{{activity.user.name}}\"><div layout=\"column\"><div><span class=\"username md-accent-color\">\n{{activity.user.name}}</span> <span class=\"message\">{{activity.message}}</span></div><span class=\"time secondary-text\">\n{{activity.time}}</span></div></div></div></div></div></div></div>");
$templateCache.put("app/main/pages/settings/views/general/general.html","<div id=\"general\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-cog\" class=\"mr-16\"></md-icon><span>\nGeneral Settings</span></div></div></div><div class=\"content\"><md-tabs md-dynamic-height><md-tab><md-tab-label><span>\nUser</span></md-tab-label><md-tab-body><div class=\"p-24 md-background-bg md-whiteframe-1dp\"><form><div \nlayout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex class=\"md-block md-input-has-placeholder\">\n<label>Generate Access Token</label><md-switch ng-model=\"vm.user.access_btn\" ng-change=\"vm.generate_api();\" \naria-label=\"Switch 1\"><small>Flick this switch to get/generate access_token</small></md-switch><div \nng-if=\"vm.user.access_btn\"><textarea ng-model=\"vm.user.access_token\" columns=\"1\" max-rows=\"5\" placeholder=\"&nbsp;\">\n{{vm.user.access_token}}</textarea><small class=\"help-block\">Copy Access Token</small></div></md-input-container></div>\n</form></div></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/settings/views/integration/calendar.html","<div id=\"settings\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"md-icon-button\" aria-label=\"Go to projects\" ui-sref=\"app.pages_settings_integration\" translate \ntranslate-attr-aria-label=\"PR.GO_TO_PROJECTS\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nclass=\"h2\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-calendar-today\" class=\"mr-16\">\n</md-icon><span>Calendar Settings</span></div></div><div><md-button \nclass=\"md-accent md-raised md-hue-2 header-boards-button\" \nng-click=\"vm.onUpdate({model: \'integration\', data: [vm.integration]});\"><md-icon md-font-icon=\"icon-share\"></md-icon>\n<span>{{ vm.loaderText1 || \"Save \" + vm.item }}</span></md-button></div></div><div class=\"content\"><md-tabs \nmd-dynamic-height md-selected=\"selectedIndex\"><md-tab><md-tab-label><span>Google</span></md-tab-label><md-tab-body><div\n class=\"p-24 md-background-bg md-whiteframe-1dp\"><form name=\"f1\"><div layout-gt-sm=\"row\" layout-align=\"start center\" \nclass=\"mb-20\"><div id=\"authorize-div\" ng-if=\"!vm.integration.GAuth\"><span>Authorize access to Google Calendar API\n</span><br><br><md-button id=\"authorize-button\" class=\"md-raised md-accent md-background no-margin\" \nng-click=\"vm.doLogin();\"><span>Connect with Google Calendar</span></md-button></div><div id=\"signout-div\" \nng-if=\"vm.integration.GAuth\"><span class=\"green-500-fg\">Google Calendar is connected.</span><br><br><md-button \nid=\"signout-button\" class=\"md-raised md-primary md-background no-margin\" ng-click=\"vm.doLogout();\"><span>Disconnect\n</span></md-button></div></div></form></div></md-tab-body></md-tab><md-tab><md-tab-label><span>Coming soon</span>\n</md-tab-label><md-tab-body>...</md-tab-body></md-tab><md-tab><md-tab-label><span>Coming soon</span></md-tab-label>\n<md-tab-body>...</md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/settings/views/integration/integration.html","<div id=\"settings\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-cog\" class=\"mr-16\"></md-icon><span>Settings</span>\n</div></div><div></div></div><div class=\"content\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget class=\"h-300\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"p-16 blue-grey-bg white-fg\" layout=\"row\" flex><div class=\"pb-24\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon class=\"m-0 mr-8\" \nmd-font-icon=\"icon-email\"></md-icon><div class=\"h1\">Mail</div></div></div><div ng-repeat=\"(key, mail) in vm.mails\" \nclass=\"layout-align-start-center layout-row pb-20 cursor-pointer\" ng-click=\"vm.gotoOption(\'mail\', key)\" ng-value=\"key\" \nng-class=\"{\'md-display-1\': vm.integration.mail === key}\"><i class=\"white-fg mr-8 icon-radiobox-blank\" \nng-class=\"{\'icon-radiobox-blank\': vm.integration.mail !== key, \'icon-radiobox-marked\': vm.integration.mail === key}\">\n</i> {{mail}}</div><div class=\"background-image-center\"><md-icon md-font-icon=\"icon-email\" class=\"s256 faint-text\">\n</md-icon></div></ms-widget-front></ms-widget><ms-widget class=\"h-300\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"25\"><ms-widget-front class=\"p-16 cyan-bg white-fg\" layout=\"row\" flex><div class=\"pb-24\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon class=\"m-0 mr-8\" \nmd-font-icon=\"icon-calendar-today\"></md-icon><div class=\"h1\">Calendar</div></div></div><div \nng-repeat=\"(key, calendar) in vm.calendars\" class=\"layout-align-start-center layout-row pb-20 cursor-pointer\" \nng-click=\"vm.gotoOption(\'calendar\', key)\" ng-value=\"key\" ng-class=\"{\'md-display-1\': vm.integration.calendar === key}\">\n<i class=\"white-fg mr-8 icon-radiobox-blank\" \nng-class=\"{\'icon-radiobox-blank\': vm.integration.calendar !== key, \'icon-radiobox-marked\': vm.integration.calendar === key}\">\n</i> {{calendar}}</div><div class=\"background-image-center\"><md-icon md-font-icon=\"icon-calendar-today\" \nclass=\"s256 faint-text\"></md-icon></div></ms-widget-front></ms-widget><ms-widget class=\"h-300\" layout=\"column\" \nflex=\"100\" flex-gt-md=\"50\"><ms-widget-front class=\"p-16 light-blue-bg white-fg\" layout=\"row\" flex><div layout=\"column\" \nlayout-align=\"center center\" flex><div class=\"md-display-3 pb-8\">{{vm.widget11.value}}</div><div \nclass=\"h3 font-weight-500\">{{vm.widget11.title}}</div></div><div class=\"background-image-center\"><md-icon \nmd-font-icon=\"icon-dots-horizontal\" class=\"s256 faint-text\"></md-icon></div></ms-widget-front></ms-widget></div></div>\n</div>");
$templateCache.put("app/main/pages/settings/views/integration/mail.html","<div id=\"settings\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"md-icon-button\" aria-label=\"Go to projects\" ui-sref=\"app.pages_settings_integration\" translate \ntranslate-attr-aria-label=\"PR.GO_TO_PROJECTS\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nclass=\"h2\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-email\" class=\"mr-16\"></md-icon><span>\nMail Settings</span></div></div><div><md-button class=\"md-accent md-raised md-hue-2 header-boards-button\" \nng-click=\"vm.onUpdate({model: \'integration\', data: [vm.integration]});\"><md-icon md-font-icon=\"icon-share\"></md-icon>\n<span class=\"pr-8\">{{ vm.loaderText1 || \"Save \" + vm.item }}</span></md-button></div></div><div class=\"content\">\n<md-tabs md-dynamic-height md-selected=\"selectedIndex\"><md-tab ng-click=\"vm.gotoOption(\'mail\', \'smtp\')\"><md-tab-label>\n<span>SMTP</span></md-tab-label><md-tab-body><div class=\"p-24 md-background-bg md-whiteframe-1dp\"><form><div \nlayout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block\" flex-gt-sm><label>Sender name\n</label><input type=\"text\" ng-model=\"vm.integration.sender_name\" required></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm><label>Sender email</label><input type=\"email\" ng-model=\"vm.integration.sender_email\" \nng-blur=\"vm.integration.smtp_user = vm.integration.sender_email\" required></md-input-container></div><div \nlayout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block\" flex-gt-sm><label>SMTP address\n</label><input type=\"text\" ng-model=\"vm.integration.smtp_address\"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><label>SMTP port</label><input type=\"text\" \nng-model=\"vm.integration.smtp_port\"></md-input-container><md-input-container flex><label>SMTP encryption protocol\n</label><md-select ng-model=\"vm.integration.smtp_encryption\"><md-option \nng-repeat=\"(key, range) in vm.smtp_encryptions\" value=\"{{key}}\">{{range}}</md-option></md-select></md-input-container>\n</div><div class=\"mb-30\"><md-input-container class=\"md-block no-margin\" flex>\n{{vm.checked = (vm.integration.smtp_authorization==1);\"\"}}<md-checkbox ng-model=\"vm.checked\" \nng-change=\"vm.integration.smtp_authorization=!vm.integration.smtp_authorization\" class=\"mb-24\" flex>\nSMTP authorization required</md-checkbox><div class=\"input-hint ml-30\">\nUse this checkbox if your SMTP server requires authorization.</div></md-input-container></div><div layout-gt-sm=\"row\" \nlayout-align=\"start center\"><md-input-container class=\"md-block\" flex-gt-sm><label>Username</label><input type=\"text\" \nng-model=\"vm.integration.smtp_user\" ng-value=\"vm.integration.sender_email\" \nng-init=\"vm.integration.smtp_user = vm.integration.sender_email\" \nng-blur=\"vm.integration.smtp_user = vm.integration.sender_email\"></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm><label>Password</label><input type=\"password\" ng-model=\"vm.integration.smtp_password\">\n</md-input-container></div></form><div class=\"layout-align-start-center layout-row\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"white-fg layout-align-start-center layout-row flex\" layout=\"row\" \nlayout-align=\"start center\" flex=\"\"></div><div><md-button class=\"md-raised md-primary md-background no-margin md-icon\" \nng-click=\"vm.onUpdate({model: \'integration\', data: [vm.integration]}, true);\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\" md-diameter=\"20px\" ng-show=\"vm.loader\"></md-progress-circular><span>\n{{ vm.loaderText2 || \"Send test email\" }}</span></md-button></div></div></div></md-tab-body></md-tab><md-tab \nng-click=\"vm.gotoOption(\'mail\', \'cs1\')\"><md-tab-label><span>Coming soon</span></md-tab-label><md-tab-body>...\n</md-tab-body></md-tab><md-tab ng-click=\"vm.gotoOption(\'mail\', \'cs2\')\"><md-tab-label><span>Coming soon</span>\n</md-tab-label><md-tab-body>...</md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");
$templateCache.put("app/main/apps/company/dashboard/sidenavs/main/main-sidenav.html","<div class=\"widget-group\"><ms-widget flippable=\"false\" class=\"sidenav-widget\"><ms-widget-front><div \nclass=\"pl-16 pr-8 pv-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{vm.nowWidget.now.weekDay}}, {{vm.nowWidget.now.hour}}:{{vm.nowWidget.now.minute}}:{{vm.nowWidget.now.second}}</div>\n<md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" md-menu-origin md-menu-align-target \naria-label=\"Options\"><md-icon md-font-icon=\"icon-dots-vertical\" class=\"icon\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button ng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-refresh\" \nclass=\"icon\"></md-icon>Refresh</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\"></md-icon>Settings</md-button>\n</md-menu-item></md-menu-content></md-menu></div><div class=\"p-16 pb-24\" layout=\"column\" layout-align=\"center center\">\n<div class=\"h1 secondary-text\"><span>{{vm.nowWidget.now.month}}</span></div><div \nclass=\"font-size-72 line-height-88 secondary-text font-weight-400\">{{vm.nowWidget.now.day}}</div><div \nclass=\"h1 secondary-text\"><span>{{vm.nowWidget.now.year}}</span></div></div><md-divider></md-divider></ms-widget-front>\n</ms-widget><ms-widget flippable=\"false\" class=\"sidenav-widget\"><ms-widget-front><div class=\"pl-16 pr-8 pv-16\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h4\"><md-icon md-font-icon=\"icon-map-marker\" \nclass=\"icon mr-8\"></md-icon>{{vm.weatherWidget.location.country}}</div></div><div class=\"p-16 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div layout=\"row\" layout-align=\"center center\"><md-icon \nmd-font-icon=\"icon-weather-windy-variant\" class=\"icon s40 mr-16\"></md-icon><span \nclass=\"md-display-2 font-weight-300 secondary-text\">{{vm.weatherWidget.item.condition.temp}} </span><span \nclass=\"font-size-48 font-weight-300 hint-text text-super ml-8\">&deg;</span> <span \nclass=\"md-display-2 font-weight-300 hint-text\">{{vm.weatherWidget.units.temperature}}</span></div></div><div \nclass=\"grey-300-bg p-16\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-weather-windy\" class=\"icon mr-8 s20\"></md-icon><span>\n{{vm.weatherWidget.wind.speed}} </span><span class=\"secondary-text ml-5\">{{vm.weatherWidget.units.speed}}</span></div>\n<div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-compass-outline\" class=\"icon mr-8 s20\">\n</md-icon><span>{{vm.weatherWidget.wind.direction}}</span></div><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-umbrella\" class=\"icon mr-8 s20\"></md-icon><span>{{vm.weatherWidget.wind.chill}}%</span></div></div>\n<div class=\"pv-16\"><div class=\"pv-16 ph-24\" layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"day in vm.forecast\"><span class=\"h4\">{{day.day}}</span><div layout=\"row\" layout-align=\"start center\">\n<md-icon class=\"mr-16 icon\" md-font-icon=\"icon-weather-windy-variant\"></md-icon><span class=\"h2\">{{day.high}}&deg;\n</span> <span class=\"h2 font-weight-300 secondary-text text-super ml-10\">{{day.low}}&deg;</span></div></div></div>\n<md-divider></md-divider></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/apps/company/project/dialogs/property/property-dialog.html","<md-dialog class=\"property-dialog\" aria-label=\"New Task\"><form name=\"propertyForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"PR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-icon-float md-block\"><label translate=\"PR.PROPERTY_NAME\">Property Name (required)</label><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><input ng-model=\"vm.property.name\" type=\"text\" required \nmd-autofocus></md-input-container><md-input-container class=\"md-block md-icon-float\"><label translate=\"PR.PRICE\">Price\n</label><md-icon md-font-icon=\"icon icon-tag\"></md-icon><input name=\"price\" ui-number-mask aria-label=\"label\" \nng-model=\"vm.property.price\"></md-input-container><md-input-container class=\"md-block md-icon-float\"><label \ntranslate=\"PR.DISCOUNT\">Discount</label><md-icon md-font-icon=\"icon icon-percent\"></md-icon><input type=\"number\" \nstep=\"0.01\" ng-model=\"vm.property.discount\"></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-click=\"vm.addNewProperty()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"propertyForm.$invalid || propertyForm.$pristine\" aria-label=\"Add Task\" translate=\"PR.ADD_PROPERTY\" \ntranslate-attr-aria-label=\"PR.ADD_PROPERTY\">ADD PROPERTY</md-button></div><div ng-if=\"!vm.newProperty\" layout=\"row\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.deletePropertyConfirm($event)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"PR.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"PR.DELETE\">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/company/project/views/project/project.html","<div id=\"project-project\" class=\"page-layout carded fullwidth\" layout=\"row\" flex ms-scroll><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"goto-projects-button md-icon-button\" aria-label=\"Go to projects\" ng-click=\"vm.gotoProjects()\" translate \ntranslate-attr-aria-label=\"PR.GO_TO_PROJECTS\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><button ngf-select=\"vm.uploadFiles($files, vm.project.id)\" \nng-disabled=\"!role.permissions.write\" accept=\"image/*\">\n{{vm.project.photo.path = (vm.project.photo.path || vm.crmUrl + \'storage/app/media/product-image-placeholder.png\');\"\"}} \n<img ng-src=\"{{vm.project.photo.path}}\" class=\"profile-image avatar\" alt=\"{{vm.project.name}}\"><md-tooltip>\nClick to change image</md-tooltip></button> <span class=\"logo-text h2\">{{vm.project.name}}</span></div></div><div \nng-if=\"role.permissions.write\"><md-button class=\"md-accent md-raised md-hue-2 header-boards-button\" \nng-click=\"vm.saveProject()\"><md-icon md-font-icon=\"icon-share\"></md-icon><span class=\"ph-8\">Save</span></md-button>\n</div></div><div class=\"content\"><div class=\"project-detail-form-container md-background-bg md-whiteframe-1dp\"><form>\n<md-input-container class=\"md-block\"><label translate=\"PR.PROJECT_NAME\">Project Name</label><input type=\"text\" \nng-model=\"vm.project.name\" ng-readonly=\"!role.permissions.write\"></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"PR.PROJECT_DESCRIPTION\">Project Description</label><textarea \nng-model=\"vm.project.description\" max-rows=\"7\" ng-readonly=\"!role.permissions.write\"></textarea></md-input-container>\n<div class=\"section\" layout=\"row\"><div flex class=\"employees\"><div class=\"section-header\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"section-title\">Employees</span>&nbsp; <i class=\"icon-account-multiple s18\">\n</i></div><div class=\"section-content\"><md-chips class=\"employee-chips\" ng-model=\"vm.project.idEmployees\" \nmd-autocomplete-snap md-require-match=\"true\" md-transform-chip=\"$chip.id\" readonly=\"!role.permissions.write\">\n<md-autocomplete md-selected-item=\"vm.selectedEmployee\" md-search-text=\"vm.searchText\" \nmd-items=\"employee in vm.employeeQuerySearch(vm.searchText)\" md-item-text=\"employee.user.name\" \nplaceholder=\"Search for an employee\"><span md-highlight-text=\"vm.searchText\">{{employee.user.name}}</span>\n</md-autocomplete><md-chip-template class=\"employee-chip\">\n{{vm.employee.user.avatar.path = (vm.employees.getById($chip).user.avatar.path || vm.crmUrl + \'storage/app/media/profile.jpg\');\"\"}} \n<img class=\"employee-chip-avatar\" ng-src=\"{{vm.employee.user.avatar.path}}\"><md-tooltip>\n{{vm.employees.getById($chip).user.name}}</md-tooltip></md-chip-template><button md-chip-remove class=\"md-primary\">\n<md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon></button></md-chips></div></div></div></form></div><div \nng-if=\"vm.project.id != 0\"><header class=\"md-accent-bg layout-align-space-between-center layout-row\"><div \nclass=\"title ng-scope\" translate=\"PR.PROPERTIES\">Properties</div><div class=\"secondary-text\" \nng-if=\"role.permissions.write\"><md-button class=\"md-accent md-raised md-hue-2 header-boards-button\" \nng-click=\"vm.openPropertyDialog($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon><span class=\"ph-8\">Create</span>\n</md-button></div></header><div class=\"property-detail-form-container products md-background-bg md-whiteframe-1dp\">\n<table class=\"dataTable row-bproject hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Image</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Price</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Discount</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"property in vm.properties\"><td>{{vm.plength = (property.photos.length-1);\"\"}} <img \nclass=\"property-image\" \nng-src=\"{{property.photos[vm.plength].path || vm.crmUrl + \'storage/app/media/product-image-placeholder.png\'}}\"></td>\n<td>{{property.name}}</td><td>{{property.price}}</td><td>{{property.discount}}%</td><td class=\"action\"><md-button \nclass=\"edit-button md-icon-button\" ng-click=\"vm.gotoPropertyDetail(property.id)\" aria-label=\"Property details\" \ntranslate translate-attr-aria-label=\"PR.PROPERTY_DETAILS\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\" \nng-if=\"role.permissions.write\"></md-icon><md-icon md-font-icon=\"icon-magnify\" class=\"s16\" \nng-if=\"!role.permissions.write\"></md-icon></md-button><md-button class=\"edit-button md-icon-button\" \nng-if=\"role.permissions.write\" ng-click=\"vm.deleteDataConfirm(ev, property, \'properties\')\" \naria-label=\"Property delete\"><md-icon md-font-icon=\"icon-delete\" class=\"s16\"></md-icon></md-button></td></tr></tbody>\n</table></div></div></div></div></div>");
$templateCache.put("app/main/apps/company/project/views/property/property.html","<div id=\"project-property\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button\n class=\"goto-properties-button md-icon-button\" aria-label=\"Go to properties\" \nng-click=\"vm.gotoProperties(vm.property.project_id)\" translate translate-attr-aria-label=\"PR.GO_TO_PROPERTIES\"><md-icon\n md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"property-image\" hide-xs>{{vm.plength = (vm.property.photos.length-1);\"\"}} <img \nng-src=\"{{vm.property.photos[vm.plength].path || vm.crmUrl + \'storage/app/media/product-image-placeholder.png\'}}\">\n</div><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{vm.property.name}}</div><div \nclass=\"subtitle secondary-text\"><span translate=\"PR.PROPERTY_DETAIL\">Property Detail</span></div></div></div></div><div\n ng-if=\"role.permissions.write\"><md-button class=\"md-accent md-raised md-hue-2 header-boards-button\" \nng-click=\"vm.saveProject()\"><md-icon md-font-icon=\"icon-share\"></md-icon><span class=\"ph-8\">Save</span></md-button>\n</div></div><div class=\"content\"><md-tabs md-dynamic-height><md-tab><md-tab-label><span translate=\"PR.BASIC_INFO\">\nBasic Info</span></md-tab-label><md-tab-body><div \nclass=\"property-detail-form-container md-background-bg md-whiteframe-1dp\"><form><md-input-container class=\"md-block\">\n<label translate=\"PR.PROPERTY_NAME\">Property Name</label><input type=\"text\" ng-model=\"vm.property.name\" \nng-readonly=\"!role.permissions.write\"></md-input-container><md-input-container class=\"md-block md-icon-float\"><label \ntranslate=\"PR.PRICE\">Price</label><md-icon md-font-icon=\"icon icon-tag\"></md-icon><input type=\"number\" step=\"0.01\" \nng-model=\"vm.property.price\" ng-readonly=\"!role.permissions.write\"></md-input-container><md-input-container \nclass=\"md-block md-icon-float\"><label translate=\"PR.DISCOUNT\">Discount</label><md-icon \nmd-font-icon=\"icon icon-percent\"></md-icon><input type=\"number\" step=\"0.01\" ng-model=\"vm.property.discount\" \nng-readonly=\"!role.permissions.write\"></md-input-container></form></div></md-tab-body></md-tab><md-tab><md-tab-label>\n<span translate=\"PR.PROPERTY_IMAGES\">Property Images</span></md-tab-label><md-tab-body><div \nclass=\"property-detail-form-container md-background-bg md-whiteframe-1dp\"><div id=\"property-image-uploader\"><ms-widget \nclass=\"h-300\" layout=\"column\" flex=\"100\" ng-if=\"role.permissions.write\"><ms-widget-front \nclass=\"p-16 white-fg drop-box\" layout=\"row\" flex ngf-multiple=\"true\" ngf-drop=\"vm.uploadFiles($files, vm.property.id)\" \nngf-select=\"vm.uploadFiles($files, vm.property.id)\" ngf-drag-over-class=\"\'dragover\'\" ngf-pattern=\"\'image/*\'\"><div \nlayout=\"column\" layout-align=\"center center\" flex><div class=\"h1 md-accent-fg\">Drop Image file here</div><div \nclass=\"h3 m-10 grey-fg\">or</div><md-button class=\"md-accent md-raised md-hue-1 white-fg\">Select file to Upload\n</md-button></div><div class=\"background-image-center\"><md-icon md-font-icon=\"icon-upload\" class=\"s256 faint-text\">\n</md-icon></div></ms-widget-front><span class=\"secondary-text mt-8\">\nclick to upload images here. Only PNG, JPG - Max. 8MB</span></ms-widget><div layout=\"row\" layout-align=\"start start\" \nlayout-wrap><div ng-if=\"vm.property.photos.length == 0\">No photos...</div><div ng-repeat=\"photo in vm.property.photos\" \nng-switch=\"photo.field\"><div class=\"property-image\" ng-switch-when=\"photos\" layout=\"row\" layout-align=\"center center\">\n<img class=\"media\" ng-src=\"{{photo.path}}\"><md-button class=\"md-icon-button delete\" ng-click=\"vm.deleteFile(photo)\" \naria-label=\"Delete\" translate translate-attr-aria-label=\"EMPLOYEES.DELETE\" ng-if=\"role.permissions.write\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"EMPLOYEES.DELETE\">DELETE</span></md-tooltip>\n</md-button></div></div></div></div></div></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/apps/company/project/views/projects/projects.html","<div id=\"project-projects\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-domain\"></md-icon><span translate=\"PR.PROJECTS\">Projects</span></div><div \nclass=\"project-count secondary-text\"><span translate=\"PR.TOTAL_PROJECTS\">Total projects:</span> <span>\n{{vm.projects.length}}</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex hide-xs>\n<md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input \nid=\"project-properties-search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"PR.SEARCH\" flex></div><div ng-if=\"role.permissions.write\" layout-xs=\"column\"><md-button \nclass=\"md-accent md-raised md-hue-2 header-boards-button\" ng-click=\"vm.gotoProjectDetail(\'add\')\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><span class=\"ph-8\">Create</span></md-button></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-bproject hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Image</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Description</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Date Added</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"project in vm.projects\"><td><img class=\"property-image\" \nng-src=\"{{project.photo.path || vm.crmUrl + \'storage/app/media/product-image-placeholder.png\'}}\"></td><td>\n{{project.name}}</td><td>{{project.description}}</td><td class=\"date\">{{project.created_at}}</td><td class=\"action\">\n<md-button class=\"edit-button md-icon-button\" ng-click=\"vm.gotoProjectDetail(project.id)\" aria-label=\"Project details\" \ntranslate translate-attr-aria-label=\"PR.PROJECT_DETAILS\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\" \nng-if=\"role.permissions.write\"></md-icon><md-icon md-font-icon=\"icon-magnify\" class=\"s16\" \nng-if=\"!role.permissions.write\"></md-icon></md-button><md-button class=\"edit-button md-icon-button\" \nng-if=\"role.permissions.write\" ng-click=\"vm.deleteDataConfirm(ev, project, \'projects\')\" aria-label=\"Property delete\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s16\"></md-icon></md-button></td></tr></tbody></table></div></div></div>\n</div>");
$templateCache.put("app/main/apps/employees/project/dialogs/property/property-dialog.html","<md-dialog class=\"property-dialog\" aria-label=\"New Task\"><form name=\"propertyForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"PR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex \nlayout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><img \nng-src=\"{{vm.property.image}}\" class=\"md-avatar avatar property-avatar huge\" \nalt=\"{{vm.property.first_name}} {{vm.property.last_name}}\"><div class=\"property-name\">\n{{vm.property.first_name}} {{vm.property.last_name}}</div></div></div></md-toolbar><md-dialog-content ms-scroll>\n<md-input-container class=\"md-icon-float md-block\"><label translate=\"PR.PROPERTY_NAME\">Property Name (required)</label>\n<md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><input ng-model=\"vm.property.name\" type=\"text\" required \nmd-autofocus></md-input-container><md-input-container class=\"md-block md-icon-float\"><label translate=\"PR.PRICE\">Price\n</label><md-icon md-font-icon=\"icon icon-tag\"></md-icon><input name=\"price\" ui-number-mask aria-label=\"label\" \nng-model=\"vm.property.price\"></md-input-container><md-input-container class=\"md-block md-icon-float\"><label \ntranslate=\"PR.DISCOUNT\">Discount</label><md-icon md-font-icon=\"icon icon-percent\"></md-icon><input type=\"number\" \nstep=\"0.01\" ng-model=\"vm.property.discount\"></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-click=\"vm.addNewProperty()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"propertyForm.$invalid || propertyForm.$pristine\" aria-label=\"Add Task\" translate=\"PR.ADD_PROPERTY\" \ntranslate-attr-aria-label=\"PR.ADD_PROPERTY\">ADD PROPERTY</md-button></div><div ng-if=\"!vm.newProperty\" layout=\"row\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.deletePropertyConfirm($event)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"PR.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"PR.DELETE\">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/employees/project/views/projects/projects.html","<div id=\"project-projects\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-domain\"></md-icon><span translate=\"PR.PROJECTS\">Projects</span></div><div \nclass=\"project-count secondary-text\"><span translate=\"PR.TOTAL_PROJECTS\">Total projects:</span> <span>\n{{vm.projects.length}}</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"project-properties-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"PR.SEARCH\" flex></div>\n</div><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<table class=\"dataTable row-bproject hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Image</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Description</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Date Added</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"project in vm.projects\"><td><img class=\"property-image\" \nng-src=\"{{project.photo.path || vm.crmUrl + \'storage/app/media/product-image-placeholder.png\'}}\"></td><td>\n{{project.name}}</td><td>{{project.description}}</td><td class=\"date\">{{project.created_at}}</td></tr></tbody></table>\n</div></div></div></div>");
$templateCache.put("app/main/apps/scrumboard/views/assignment-rule/add-entry/add-entry.html","<div id=\"add-entry\" class=\"page-layout carded fullwidth animate-slide-left scrollable\" layout=\"row\" flex ms-scroll><div\n class=\"center\" layout=\"column\" flex class=\"scrollable\" ms-scroll><div class=\"header\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button md-button m-0 p-0\" \nui-sref=\"app.scrumboard.boards.board.rules.rule\" aria-label=\"Back To Rule Entries\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><span class=\"h3\">Rule Entry Details</span></div><div \nclass=\"content-card\" layout=\"column\" layout-fill class=\"scrollable\" ms-scroll><form editable-form name=\"addEntryForm\" \nclass=\"md-inline-form\" novalidate><div class=\"maxWidth\"><md-icon md-font-icon=\"icon-filter-variant\"></md-icon><span \nclass=\"h3 ph-8\">Criteria</span><div layout-padding><div ng-repeat=\"criteria in vm.entryCriterias\" layout=\"column\" \nflex-gt-md=\"75\" flex><div class=\"mb-15\" layout=\"row\" layout-align=\"center center\" \nng-if=\"criteria.logical_operator_id != 0\"><span ng-if=\"criteria.logical_operator_id != 1\" name=\"logicalOperator\" \nng-model=\"criteria.logical_operator_id\" aria-label=\"Logical Operator\" class=\"logicalOperator\" \nng-click=\"vm.changeLogicalOperatorId(criteria)\">{{ criteria.logical_operator_id == 2 ? \'AND\': \'OR\' }}</span></div><div \nlayout=\"row\" layout-align=\"start start\"><div><span class=\"custom-fab md-primary-bg\" aria-label=\"criteria number\" \nlayout=\"row\" layout-align=\"center center\">{{ $index + 1}}</span></div><div layout=\"row\" layout-xs=\"column\" \nid=\"criteriaForm\"><md-input-container class=\"md-block\" ng-class=\"{\'mr-16\' : $mdMedia(\'(min-width: 768px)\')}\" flex>\n<md-select ng-model=\"criteria.field_id\" aria-label=\"Criteria Property\" ng-change=\"vm.changeProperty($index)\" required \nplaceholder=\"Field Name\"><md-option ng-repeat=\"property in vm.criteria_property\" ng-value=\"{{property.id}}\">\n{{ property.name }}</md-option></md-select></md-input-container>{{criteria.field_id = criteria.field_id - 0;\"\"}}\n<md-input-container ng-if=\"vm.fields.getById(criteria.field_id).is_numeric == 0\" class=\"md-block\" \nng-class=\"{\'mr-16\' : $mdMedia(\'(min-width: 768px)\')}\" flex><md-select ng-model=\"criteria.relational_operator_id\" \naria-label=\"Relational operator\" placeholder=\"Relational Operator\" required><md-option \nng-selected=\"criteria.relational_operator_id == operator.id\" ng-if=\"operator.is_numeric == 0\" \nng-repeat=\"operator in vm.relationalOperators\" ng-value=\"{{operator.id}}\">{{operator.name}}</md-option></md-select>\n</md-input-container><md-input-container ng-if=\"vm.fields.getById(criteria.field_id).is_numeric == 1\" class=\"md-block\" \nng-class=\"{\'mr-16\' : $mdMedia(\'(min-width: 768px)\')}\" flex><md-select ng-model=\"criteria.relational_operator_id\" \naria-label=\"Relational operator\" placeholder=\"Relational Operator\" required><md-option \nng-selected=\"criteria.relational_operator_id == operator.id\" \nng-if=\"operator.is_numeric == 1 && (operator.id == 1 || operator.id == 2)\" \nng-repeat=\"operator in vm.relationalOperators\" ng-value=\"{{operator.id}}\">{{operator.name}}</md-option></md-select>\n</md-input-container><md-input-container ng-if=\"vm.fields.getById(criteria.field_id).is_numeric == 1\" \nclass=\"no-spacer md-block\" flex><label>Value</label><md-select aria-label=\"Criteria Value\" ng-model=\"criteria.value\" \nrequired><md-option ng-repeat=\"source in vm.fields.getById(criteria.field_id).sources\" ng-value=\"source.id\">\n{{source.value}}</md-option></md-select></md-input-container><md-input-container \nng-if=\"vm.fields.getById(criteria.field_id).is_numeric == 0\" class=\"no-spacer md-block\" flex><label>Value</label><input\n type=\"text\" aria-label=\"Criteria Value\" required ng-model=\"criteria.value\"></md-input-container><div layout=\"row\" \nlayout-align=\"center center\"><md-button criteria-row class=\"md-icon-button\" aria-label=\"Add Criteria\" \nng-click=\"vm.addCriteriaForm()\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Remove Criteria\" ng-click=\"vm.removeCriteriaForm($index)\"><md-icon \nmd-font-icon=\"icon-minus\"></md-icon></md-button></div></div></div></div></div></div><div class=\"mt-10\"><md-icon \nmd-font-icon=\"icon-map-marker-radius\"></md-icon><span class=\"h3 ph-8\">Lead Destination</span><div layout-padding \nlayout-xs=\"column\"><md-input-container class=\"w-192\"><md-select ng-model=\"vm.selectedBoard\" \nng-selected=\"criteria.relational_operator.id == operator.id\" class=\"m-0\" placeholder=\"Board\" required><md-option \nng-value=\"board\" ng-repeat=\"board in vm.boards\" ng-selected=\"vm.ruleEntry.board_id == board.id\" \naria-label=\"Select Board\">{{ board.title }}</md-option></md-select></md-input-container><md-input-container \nclass=\"w-192\"><md-select ng-model=\"vm.selectedStage\" class=\"m-0\" placeholder=\"Stage\" required><md-option \nng-if=\"!vm.selectedBoard\" ng-disabled=\"true\">Select a board first</md-option><md-option ng-value=\"stage.id\" \nng-repeat=\"stage in vm.selectedBoard.stages\" aria-label=\"Select Stages\" \nng-selected=\"vm.ruleEntry.board_status_id == stage.id\">{{stage.value}}</md-option></md-select></md-input-container>\n</div></div><div class=\"mt-10 mb-16\"><md-icon md-font-icon=\"icon-account-key\"></md-icon><span class=\"h3 ph-8\">\nLead Ownership</span><div layout-padding><md-radio-group ng-model=\"vm.assignTo\" ng-change=\"vm.leadOwnershipChanged()\" \nlayout-xs=\"column\" layout=\"row\" class=\"m-0\"><md-radio-button value=\"users\" class=\"md-accent\">Assign to Specified User/s\n</md-radio-button><md-radio-button value=\"group\" class=\"md-accent\">Assign to Group/s</md-radio-button></md-radio-group>\n<div class=\"content mb-10\" ng-if=\"vm.assignTo == \'users\'\"><md-chips class=\"member-chips\" ng-model=\"vm.addedUsersId\" \nmd-autocomplete-snap md-require-match=\"true\" md-transform-chip=\"$chip.id\"><md-input-container><label>Username</label>\n<input type=\"text\" ng-model=\"user.name\"></md-input-container><md-autocomplete md-input-id=\"autoCompleteId\" \nmd-selected-item=\"vm.selectedEmployee\" md-search-text=\"vm.searchText\" \nmd-items=\"employee in vm.employeeQuerySearch(vm.searchText)\" md-item-text=\"employee.first_name\" \nplaceholder=\"Search for an employee...\"><span md-highlight-text=\"vm.searchText\">{{employee.first_name}}</span>\n</md-autocomplete><md-chip-template class=\"employee-chip\">\n{{vm.listEmployee.user.avatar.path = (vm.listEmployee.getById($chip).user.avatar.path || vm.crmUrl + \'storage/app/media/profile.jpg\');\"\"}} \n<img class=\"employee-chip-avatar\" ng-src=\"{{vm.listEmployee.user.avatar.path}}\"> <small>\n{{vm.listEmployee.getById($chip).first_name}}</small><md-tooltip>{{vm.listEmployee.getById($chip).email}}</md-tooltip>\n</md-chip-template><button md-chip-remove class=\"md-primary\" ng-click=\"vm.setFocus()\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s18\"></md-icon></button></md-chips></div><div class=\"content w-192\" \nng-if=\"vm.assignTo == \'group\'\"><div layout-xs=\"column\" layout=\"column\" flex-gt-md=\"50\" flex><md-input-container \nlayout=\"row\" class=\"i-1 mb-0 h-40 w-192\"><md-select ng-model=\"vm.groupId\" ng-change=\"vm.changeSelectedGroup()\" flex \naria-label=\"Select Groups\" multiple=\"multiple\" placeholder=\"Group/s\"><md-optgroup><md-option \nng-if=\"group.name != \'Owner\' && group.name != \'Everyone\'\" ng-value=\"group.id\" ng-repeat=\"group in vm.board.groups\">\n{{ group.name }}</md-option></md-optgroup></md-select></md-input-container></div></div></div></div><div class=\"mt-10\">\n<md-icon md-font-icon=\"icon-checkbox-marked-circle-outline\"></md-icon><span class=\"h3 ph-8\">Rule Status</span><div \nlayout-padding><md-switch ng-model=\"vm.is_active\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\" \nng-change=\"vm.changeStatus(ruleEntry.id)\" aria-label=\"Rule Activation\">{{vm.is_active == 1? \"Active\":\"Inactive\"}}\n</md-switch></div></div><div class=\"mt-10\"><h4><em>Note: Leads will be distributed in a <b>Round Robin</b> pattern</em>\n</h4></div><div layout=\"row\" layout-xs=\"column\"><md-button class=\"md-raised md-hue-2 md-accent\" \nng-click=\"vm.saveCriteria(ev)\" layout-align=\"end end\" aria-label=\"Save\" \nng-disabled=\"addEntryForm.$invalid || addEntryForm.$pristine || (vm.addedUsersId.length == 0 && vm.assignTo == \'users\') || angular.equals(vm.addedUsersId, vm.tempUsersId) || (vm.groupId.length == 0 && vm.assignTo == \'group\') \">\n<md-icon md-font-icon=\"icon-share\"></md-icon><span class=\"ph-8\">Save</span></md-button><md-button \nclass=\"md-primary md-raised\" ui-sref=\"app.scrumboard.boards.board.rules.rule\" aria-label=\"Cancel\" \nlayout-align=\"end end\"><md-icon md-font-icon=\"icon-close\"></md-icon><span class=\"ph-8\">Cancel</span></md-button></div>\n</form></div></div></div>");
$templateCache.put("app/main/apps/scrumboard/views/assignment-rule/rule-entries/rule-entries.html","<div id=\"assignment-rule\" class=\"page-layout carded fullwidth animate-slide-left\" layout=\"row\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\"><div layout=\"row\" layout-align=\"space-between center\" flex><div \nclass=\"col\" layout=\"row\" layout-align=\"start center\" flex-xs=\"100\" flex=\"70\"><md-button \nclass=\"md-icon-button md-button m-0 p-0\" ui-sref=\"app.scrumboard.boards.board.rules\" aria-label=\"Back To Rules\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\" flex><div \nflex=\"40\"><span class=\"h3\" editable-text=\"vm.rule.name\" onaftersave=\"vm.updateRule()\" hide-xs>{{vm.rule.name}}</span>\n<md-tooltip><span>Rule Name</span></md-tooltip></div><md-input-container class=\"md-icon-float md-block mb-0\" \nflex-xs=\"100\" flex=\"40\"><label>Trigger for this rule</label><md-select ng-change=\"vm.updateRule()\" required \nng-model=\"vm.rule.action\" class=\"md-no-underline\"><md-option ng-repeat=\"action in vm.action\" value=\"{{action.id}}\">\n{{action.name}}</md-option></md-select></md-input-container></div></div><div class=\"col\"><div ng-if=\"vm.rule.id != 0 \" \nhide-xs layout=\"row\" layout-align=\"end end\" flex><md-button class=\"md-raised md-hue-2 md-accent\" \nng-class=\"\'md-\'+vm.board.settings.color+\'-700-bg\'\" \nui-sref=\"app.scrumboard.boards.board.rules.rule.add-entry({ruleId:vm.rule.id, entryId: 0})\" layout-align=\"end end\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon><span class=\"ph-8\">Create</span></md-button></div><div \nng-if=\"vm.rule.id != 0 \" show-xs hide layout=\"row\" layout-align=\"end end\" flex><md-button \nclass=\"md-fab md-mini md-raised md-hue-2 md-accent\" ng-class=\"\'md-\'+vm.board.settings.color+\'-700-bg\'\" \nui-sref=\"app.scrumboard.boards.board.rules.rule.add-entry({ruleId:vm.rule.id, entryId: 0})\" layout-align=\"end end\" \naria-label=\"Add Rule add-entry\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div></div></div><div \nng-if=\"vm.rule.id != 0\" class=\"content-card\" layout=\"column\" flex><div class=\"fullpage-datatable p-0\" layout=\"column\" \nflex><div class=\"table-title\" layout=\"row\" layout-align=\"center center\"><span class=\"h3\">\n{{vm.board.stages.getById(vm.rule.board_status_id).value}}</span></div><table class=\"dataTable row-bproject hover\" \nng-cloak datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" md-progress=\"promise\" name=\"table\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Criteria</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header text-center\"><span class=\"column-title\">Active/Inactive</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Assign To</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"ruleEntry in vm.ruleEntries\"><td><p ng-repeat=\"criteria in ruleEntry.rule_criterias\" \nng-init=\"vm.text\"><span><b ng-if=\"criteria.logical_operator.value !=\'BASE\'\">{{criteria.logical_operator.value}}</b> \n</span><span>{{criteria.field.name}}</span> <span>{{criteria.relational_operator.name}}</span> <span \nng-if=\"criteria.field_id != 1\">\n{{vm.user.fields.getById(criteria.field_id - 0).sources.getById(criteria.value - 0).value}} </span><span \nng-if=\"criteria.field_id == 1\">{{criteria.value}}</span></p></td><td layout=\"row\" layout-align=\"center center\">\n<md-switch ng-model=\"ruleEntry.is_active\" aria-label=\"Rule Activation\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\" \nng-change=\"vm.changeStatus(ruleEntry.id)\"></md-switch><md-tooltip><span>\n{{ruleEntry.is_active == 1? \"Active\":\"Inactive\"}}</span></md-tooltip></td><td><div \nng-if=\"ruleEntry.groups.length > 0 \"><span ng-repeat=\"group in ruleEntry.groups\">\n{{vm.user.groups.getById(group).name}}&ensp;</span><md-menu><md-button aria-label=\"View Users\" class=\"md-icon-button\" \nng-click=\"vm.openMenu($mdOpenMenu, $event)\"><md-icon md-menu-origin md-font-icon=\"icon-dots-horizontal\"></md-icon>\n</md-button><md-menu-content width=\"4\"><md-menu-item ng-if=\"ruleEntry.users.length > 0\" class=\"pl-10 h-25\" \nng-repeat=\"user in ruleEntry.users\">{{user.name}}</md-menu-item><md-menu-item ng-if=\"ruleEntry.users.length === 0\" \nclass=\"pl-10 h-25\">Currently no users in this group</md-menu-item></md-menu-content></md-menu></div><div \nng-if=\"ruleEntry.groups.length == 0\"><span>{{ruleEntry.users.length}} <span>\n{{ruleEntry.users.length > 1? \"people\":\"person\" }}</span></span><md-menu><md-button aria-label=\"View Users\" \nclass=\"md-icon-button\" ng-click=\"vm.openMenu($mdOpenMenu, $event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item class=\"pl-10 h-25\" \nng-repeat=\"user in ruleEntry.users\">{{user.name}}</md-menu-item></md-menu-content></md-menu></div></td><td \nclass=\"action\"><md-button \nui-sref=\"app.scrumboard.boards.board.rules.rule.add-entry({ruleId:vm.rule.id, entryId: ruleEntry.id})\" \nclass=\"md-icon-button\" aria-label=\"Edit Rule\" translate><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip>\n<span>Update Rule Entry</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Delete Rule\" \nng-click=\"vm.showConfirm($event,$index,ruleEntry.id)\" translate><md-icon md-font-icon=\"icon-trash\"></md-icon>\n<md-tooltip><span>Delete Rule Entry</span></md-tooltip></md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/apps/scrumboard/sidenavs/settings/menus/color/color-menu.html","<div class=\"header md-whiteframe-2dp\"><md-list><md-list-item class=\"selected-color\"><p class=\"title\" flex>\nSelected Color:</p><div ng-if=\"!vm.board.settings.color\" class=\"preview md-background-bg md-hue-1\"></div><div \nng-if=\"vm.board.settings.color\" class=\"preview\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\">\n{{vm.board.settings.color}}</div><md-button class=\"md-icon-button\" ng-click=\"vm.board.settings.color = \'\'\" \naria-label=\"Default Color\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon></md-button></md-list-item></md-list>\n</div><div flex class=\"content\" ms-scroll ms-sidenav-helper><md-list><md-list-item class=\"color\" \nng-repeat=\"(paletteName, palette) in vm.palettes\" ng-click=\"vm.board.settings.color = paletteName\" \nng-class=\"\'md-\'+paletteName+\'-bg\'\" aria-label=\"color select\"><p flex>{{paletteName}}</p><i class=\"icon-check s16\" \nng-if=\"paletteName === vm.board.settings.color\"></i></md-list-item></md-list></div>");
$templateCache.put("app/main/apps/scrumboard/sidenavs/settings/menus/labels/labels-menu.html","<md-list><md-subheader class=\"md-no-sticky\">Add New Label</md-subheader><md-list-item class=\"label\"><div layout=\"row\" \nlayout-align=\"start center\"><md-menu md-offset=\"0 52px\"><md-button class=\"md-icon-button label-color-button\" \nng-click=\"$mdOpenMenu($event)\" aria-label=\"label color\"><md-icon md-font-icon=\"icon-label\" \nng-class=\"vm.newLabelColor+\'-fg\'\" class=\"label-icon\"></md-icon></md-button><md-menu-content \nclass=\"labels-settings-menu-content\" width=\"3\"><div class=\"new-label-color-pick\" layout=\"row\" layout-wrap><label \nclass=\"color\" ng-repeat=\"(palette, hues) in vm.palettes\" \nng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\" layout=\"column\" \nlayout-align=\"center center\"><input class=\"ng-hide\" type=\"radio\" ng-model=\"vm.newLabelColor\" ng-value=\"palette\" \naria-label=\"{{palette}}\" ng-click=\"$mdMenu.hide()\"> <i class=\"icon-check s18\" ng-if=\"label.color === palette\"></i>\n</label></div></md-menu-content></md-menu><span editable-text=\"vm.newLabelName\" e-form=\"newLabelForm\" \nonaftersave=\"vm.addNewLabel()\"></span><p flex class=\"title new-label-form-button\" ng-click=\"newLabelForm.$show()\" \nng-hide=\"newLabelForm.$visible\">Enter New Label Name</p></div></md-list-item><md-divider></md-divider><md-list-item \nclass=\"label\" ng-repeat=\"label in vm.board.labels\"><div layout=\"row\" layout-align=\"start center\" flex><md-menu \nmd-offset=\"0 52px\"><md-button class=\"md-icon-button label-color-button\" ng-click=\"$mdOpenMenu($event)\" \naria-label=\"label color\"><md-icon md-font-icon=\"icon-label\" ng-class=\"label.color+\'-fg\'\" class=\"label-icon\"></md-icon>\n</md-button><md-menu-content class=\"labels-settings-menu-content\" width=\"3\"><div class=\"new-label-color-pick\" \nlayout=\"row\" layout-wrap><label class=\"color\" ng-repeat=\"(palette, hues) in vm.palettes\" \nng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\" layout=\"column\" \nlayout-align=\"center center\"><input class=\"ng-hide\" type=\"radio\" ng-model=\"label.color\" ng-value=\"palette\" \naria-label=\"{{palette}}\" ng-click=\"$mdMenu.hide()\"> <i class=\"icon-check s18\" ng-if=\"label.color === palette\"></i>\n</label></div></md-menu-content></md-menu><p flex class=\"title\" editable-text=\"label.name\">{{label.name}}</p><md-button\n ng-click=\"vm.removeLabel($event, label.id);\" class=\"remove-button md-icon-button\" aria-label=\"remove\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></div></md-list-item></md-list>");
$templateCache.put("app/main/apps/scrumboard/sidenavs/settings/menus/groups/groups-menu.html","<md-list><md-list-item class=\"noright\"><p class=\"group-name\">Everyone</p><md-select class=\"simplified\" \nplaceholder=\"No access\" ng-model=\"vm.everyone\"><md-option ng-repeat=\"(p, permission) in vm.permissions\" value=\"{{p}}\" \nng-selected=\"{{p == \'none\' ? \'true\' : \'false\'}}\" ng-click=\"vm.addNewGroup(-1, p)\">{{permission}}</md-option>\n</md-select><md-button class=\"remove-button md-icon-button\" aria-label=\"remove\"><md-icon \nmd-font-icon=\"icon-keyboard-caps\"></md-icon></md-button></md-list-item><md-menu layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" aria-label=\"Add New Group\" \nng-click=\"$mdOpenMenu($event)\">Add Group</md-button><md-menu-content width=\"3\"><md-subheader class=\"md-no-sticky\" \nng-if=\"vm.groups\">Groups</md-subheader><md-list-item ng-if=\"vm.groups && group.id != -1\" \nng-repeat=\"group in vm.groups\" ng-disabled=\"vm.board.groups.getById(group.id)\" \nng-click=\"!vm.board.groups.getById(group.id) && vm.addNewGroup(group.id, \'modify\', \'add\')\"><p class=\"pl-8\" \nng-class=\"{\'grey-fg\': vm.board.groups.getById(group.id)}\">{{group.name}}</p></md-list-item></md-menu-content></md-menu>\n<md-divider></md-divider><md-list-item ng-if=\"group.id != -1\" class=\"group noright\" \nng-repeat=\"group in vm.board.groups\"><p class=\"group-name\">{{ group.name }}</p><md-select class=\"simplified\" \nplaceholder=\"No access\" ng-model=\"vm.permission[group.id]\" \nng-change=\"vm.addNewGroup(group.id, vm.permission[group.id])\"><md-option ng-repeat=\"(p, permission) in vm.permissions\" \nvalue=\"{{p}}\" ng-selected=\"{{p == group.pivot.permission ? \'true\' : p == \'modify\' ? \'true\' : \'false\'}}\">{{permission}}\n</md-option></md-select><md-button ng-click=\"vm.removeGroup($event, group.id);\" class=\"remove-button md-icon-button\" \naria-label=\"remove\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></md-list-item></md-list>");
$templateCache.put("app/main/apps/scrumboard/sidenavs/settings/menus/members/members-menu.html","<md-list><md-subheader class=\"md-no-sticky\">Add New Member</md-subheader><md-list-item class=\"add-new-member\"><form \nng-submit=\"vm.newMember()\" layout=\"row\" layout-align=\"start center\"><input flex placeholder=\"Type Member Name\" \ntype=\"text\" ng-model=\"vm.newMemberSearchInput\"><md-button type=\"submit\" class=\"md-accent md-raised\" \naria-label=\"Add New Member\">Add</md-button></form></md-list-item><md-divider></md-divider><md-list-item class=\"member\" \nng-repeat=\"member in vm.board.members\"><img alt=\"{{ member.name }}\" ng-src=\"{{ member.avatar }}\" class=\"md-avatar\"><p \nclass=\"member-name\">{{ member.name }}</p><md-button ng-click=\"vm.removeMember($event, member.id);\" \nclass=\"remove-button md-icon-button\" aria-label=\"remove\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button>\n</md-list-item></md-list>");
$templateCache.put("app/main/apps/scrumboard/sidenavs/settings/menus/stages/stages-menu.html","<md-list><md-subheader class=\"md-no-sticky\">Add New Stage</md-subheader><md-list-item class=\"add-new-member\"><form \nng-submit=\"vm.addNewStage(\'board_status\')\" layout=\"row\" layout-align=\"start center\"><input flex \nplaceholder=\"Type Stage Name\" type=\"text\" ng-model=\"vm.newStageName\"><md-button type=\"submit\" \nclass=\"md-accent md-raised\" aria-label=\"Add New Stage\">Add</md-button></form></md-list-item><md-divider></md-divider>\n<div id=\"stages\" class=\"data-items sortable\" ng-model=\"vm.stages\" ng-sortable=\"vm.sortableOptions\"><div \nclass=\"ph-16 pv-15 border-bottom data-item\" layout=\"row\" layout-align=\"start center\" \nng-repeat=\"(key, stage) in vm.stages\"><div class=\"item mr-16 handle\"><i \nclass=\"icon pr-16 border-right icon-drag-vertical\"></i></div><div class=\"h4 text-bold\" editable-text=\"stage.value\" \nonaftersave=\"vm.saveUser()\" flex>{{stage.value}}</div><md-button \nng-click=\"vm.deleteDataConfirm(ev, stage, \'board_status\');\" class=\"remove-button md-icon-button\" aria-label=\"remove\">\n<md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></div></md-list>");
$templateCache.put("app/main/apps/scrumboard/views/calendar/dialogs/event/event-dialog.html","<md-dialog class=\"event-calendar-dialog\" aria-label=\"Event Dialog\" ng-cloak><md-toolbar class=\"md-accent\" \nng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><h2 class=\"title\">\n{{vm.dueDate | date:\'mediumDate\':\'UTC\'}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"close dialog\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-tabs md-dynamic-height><md-tab><md-tab-label>\n<span translate=\"SB.ADD_LEAD\">lead</span></md-tab-label><md-tab-body><div class=\"new-lead\" layout=\"column\"><form \nname=\"newLeadForm\" novalidate><md-input-container class=\"new-lead-name md-block\" md-no-float><input name=\"name\" \nng-model=\"vm.newLead.name\" placeholder=\"Lead name\" required><div ng-messages=\"newLeadForm.name.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"SB.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div>\n</md-input-container><div class=\"stages\"><p>Select a stage:</p><md-radio-group ng-model=\"vm.newLead.stageId\" required>\n<md-radio-button ng-repeat=\"stage in vm.board.stages\" ng-value=\"stage.id\">{{stage.name}}</md-radio-button>\n</md-radio-group></div><md-dialog-actions><md-button class=\"md-accent md-raised\" ng-click=\"vm.addNewLead()\" \nng-disabled=\"newLeadForm.$invalid || newLeadForm.$pristine\">Add</md-button></md-dialog-actions></form></div>\n</md-tab-body></md-tab><md-tab><md-tab-label><span translate=\"SB.ASSIGN_THE_DATE_TO_LEADS\">Assign the date to leads\n</span></md-tab-label><md-tab-body><div class=\"assign-due-date\"><md-list class=\"leads\"><md-content \nclass=\"leads-content\" flex ms-scroll><md-list-item class=\"lead\" ng-repeat=\"lead in vm.board.leads\" \nng-click=\"vm.toggleInArray(lead.id, vm.selectedLeads)\" aria-label=\"lead\"><p layout=\"column\" layout-align=\"start start\">\n<span class=\"lead-name\">{{lead.name}}</span> <span ng-if=\"lead.due\" class=\"lead-date\">{{lead.due | date}}</span></p>\n<md-checkbox ng-checked=\"vm.exists(lead.id, vm.selectedLeads)\" ng-click=\"vm.toggleInArray(lead.id, vm.selectedLeads)\" \nclass=\"md-secondary\" aria-label=\"lead\"></md-checkbox></md-list-item></md-content></md-list><md-dialog-actions>\n<md-button ng-disabled=\"!vm.selectedLeads[0]\" ng-click=\"vm.assignDueDate()\" class=\"md-accent md-raised\">Assign\n</md-button></md-dialog-actions></div></md-tab-body></md-tab></md-tabs></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/scrumboard/views/calendar/sidenavs/scheduled-tasks/scheduled-tasks-sidenav.html","<div class=\"md-title sidenav-title\">Scheduled Leads</div><div class=\"leads\"><div ng-if=\"vm.leads.length <= 0\"><span \ntranslate=\"SB.NO_SCHEDULED_LEAD\">There is no scheduled lead.</span></div><div class=\"lead\" layout=\"row\" \nng-repeat=\"lead in vm.leads\"><md-button class=\"md-raised lead-date\" ng-click=\"vm.goToDate(lead.start)\"><div \nclass=\"day-in-week\">{{lead.due | date:\'EEEE\'}}</div><div class=\"day\">{{lead.due | date:\'d\' }}</div><div \nclass=\"month-year\">{{lead.due | date:\'MMM yyyy\'}}</div></md-button><div class=\"lead-title\" flex layout=\"column\" \nlayout-align=\"center start\" ng-click=\"vm.openLeadDialog($event, lead.idLead)\"><span>{{lead.title}}</span></div></div>\n</div>");}]);